//
//  Record Types
//
import * as _ from 'lodash'
import {TextUtils} from "./Basic/Text"
import {ESRecord} from './lib/ESRecord'
import * as RowIF from "./PAdbSchemaRowsIF";
import {
    DateRangePropertyBW,
    getBelongsToProperty,
    getBooleanIndicator,
    getBWDateProperty,
    getBWDateTsProperty,
    getBWDateTsSplitProperty,
    getDateStringFormat,
    getHasManyProperty,
    getHasOneProperty,
    getJSONProperty,
    getTimeStringFormat,
    setBelongsToProperty,
    setBooleanIndicator,
    setBWDateProperty,
    setBWDateTsProperty,
    setBWDateTsSplitProperty,
    setHasOneProperty,
    setJSONProperty
} from './lib/RowProperties'

import {
    Domain_getDefaultOrFirstItem,
    EventType_getDefaultOrFirstItem,
    Meta_getDefaultOrFirstItem,
    SpendType_getDefaultOrFirstItem
} from "./PAdbUtils"
import {PAdbContext} from "./PAdbContext";
import {PAEnvironment} from "./PAEnvironment";
import {PAusrContext} from "./PAusrContext";
import {IUsrContext} from "./PA.Core.IF.User";
import {DateUtils} from './Basic/Dates';
import {JSONUtils} from "./Basic/JSON";
import {
    AppFinderPolicy,
    LaunchPolicy,
    ModulebarPolicy,
    StartupPolicy,
    TaskbarPolicy
} from "../PA.UIM.Core/PA.UIM.Core.IF.Framework";
import * as TPMConstants from "../PA.TPM.Core/TPM.Constants"
import {ICubePerspectiveOptions} from "../PA.HyperRectangle.Core/PA.HyperRectangle.IF";
import {DimensionType} from "./PA.Core.IF.Hierarchy";
import {IHRTableModelOptions} from "../../client-ui5/PA-Controls/HyperRectangleTableModels";
import {DimensionPlacement} from "../PA.Reporting.Core/PA.Reporting.IF";
import {NumberUtils} from "./Basic/Numbers";
import {esWB_Domain, esWB_Domain_Item, esWB_User} from "./PAdbSchema";
import {LanguageText} from './Basic/LanguageText';


export const defaultRowValues = {
    Created_Dt: () => {
        return '18000101'
    },
    Created_DtTs: () => {
        return DateUtils.convertToSAPBWTs(new Date())
    },
    Modified_DtTs: () => {
        return DateUtils.convertToSAPBWTs(new Date())
    },
    Modified_Dt: () => {
        return '18000101'
    },
    Modified_By: () => {
        return 'NA'
    }, // Todo, lookup Current User.
    Deleted_Dt: () => {
        return '18000101'
    },
    Deleted_Ind: () => {
        return '0'
    },
    Integration_Ind: () => {
        return '1'
    },
    Min_Dt: () => {
        return '18000101'
    },
    Max_Dt: () => {
        return '99991231'
    },
    Blank_Dt: () => {
        return '00000000'
    },
    False_Ind: () => {
        return '0'
    },
    True_Ind: () => {
        return '1'
    },
    Currency: () => {
        return 'USD'
    },
    CurrentUserWbId: () => {
        let usrCtx: IUsrContext = PAEnvironment.getValue(PAEnvironment.UserContext)

        if (usrCtx && usrCtx.User) {
            return usrCtx.User.cif.WB_AUTHUSR_ID
        }
        return 0
    },
    CurrentUserId: () => {
        let usrCtx: IUsrContext = PAEnvironment.getValue(PAEnvironment.UserContext)

        if (usrCtx && usrCtx.User) {
            return usrCtx.User.cif.AUTHUSR_ID
        }
        return ""
    },
}

// Source
export class WB_MasterDataSetRow
    extends ESRecord
    implements RowIF.IwbMasterDataSet {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    async afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this

        let dbContext: PAdbContext = <any>self.dataStore()
        if (_.isEmpty(dbContext)) {
            return
        }

        self.setDefaults()
        let newKey: number = this.cif.WB_MDSET_ID
        let sNewId = TextUtils.padStart(newKey.toString(36), 12, '0').toUpperCase()
        self.cif.MDSET_ID = sNewId
        self.cif.MDSET_NAME = "New Master Data Set"
    }

    get cif(): RowIF.IwbMasterDataSet {
        return this
    }

    get WB_SourceRows(): WB_SourceRow[] {
        return getHasManyProperty(this, 'Sources')
    }

    get WB_SetsRows(): WB_SetsRow[] {
        return getHasManyProperty(this, 'Sets')
    }

    get WB_DivisionRows(): WB_DivisionRow[] {
        return getHasManyProperty(this, 'Divisions')
    }

    get WB_DistribChannelRows(): WB_DistribChannelRow[] {
        return getHasManyProperty(this, 'DistribChannels')
    }

    get WB_CompanyRows(): WB_CompanyRow[] {
        return getHasManyProperty(this, 'Companies')
    }

}


// Source
export class WB_SourceRow
    extends ESRecord
    implements RowIF.IwbSource {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.SOURCE_ID = "New Source Id"
        this.cif.SOURCE_NAME = "Source Name"
    }

    get cif(): RowIF.IwbSource {
        return this
    }

    get WB_MasterDataSetRow(): WB_MasterDataSetRow {
        return getBelongsToProperty(this, 'MDSet');
    }

    set WB_MasterDataSetRow(value) {
        setBelongsToProperty(this, 'MDSet', value);
    }

    get WB_SourceSetTypeRow(): WB_SourceSetTypeRow[] {
        return getHasManyProperty(this, 'SourceSetTypes')
    }

    get WB_SourceAppRows(): WB_SourceAppRow[] {
        return getHasManyProperty(this, 'SourceApps')
    }

}

export class WB_SourceSetTypeRow
    extends ESRecord
    implements RowIF.IwbSourceSetType {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbSourceSetType {
        return this
    }

    get WB_SourceRow(): WB_SourceRow {
        return getBelongsToProperty(this, 'Source');
    }

    set WB_SourceRow(value) {
        setBelongsToProperty(this, 'Source', value);
    }

}


export class WB_SourceAppRow
    extends ESRecord
    implements RowIF.IwbSourceApp {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbSourceApp {
        return this
    }

    get WB_SourceRow(): WB_SourceRow {
        return getBelongsToProperty(this, 'Source');
    }

    set WB_SourceRow(value) {
        setBelongsToProperty(this, 'Source', value);
    }


}


//
// Sets

export class WB_SetsRow
    extends ESRecord
    implements RowIF.IwbSets {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbSets {
        return this
    }

    get WB_MasterDataSetRow(): WB_MasterDataSetRow {
        return getBelongsToProperty(this, 'MDSet');
    }

    set WB_MasterDataSetRow(value) {
        setBelongsToProperty(this, 'MDSet', value);
    }

}

// Entity / Attribute
export class WB_EntityRow
    extends ESRecord
    implements RowIF.IwbEntity {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbEntity {
        return this
    }

    get WB_MasterDataSetRow(): WB_MasterDataSetRow {
        return getBelongsToProperty(this, 'MasterDataSet');
    }

    set WB_MasterDataSetRow(value) {
        setBelongsToProperty(this, 'MasterDataSet', value);
    }

    get WB_DataObjectRow(): WB_DataObjectRow {
        return getBelongsToProperty(this, 'DataObject');
    }

    set WB_DataObjectRow(value) {
        setBelongsToProperty(this, 'DataObject', value);
    }

    get WB_UIAppExecutableRow(): WB_UIAppExecutableRow {
        return getBelongsToProperty(this, 'UIAppExec');
    }

    set WB_UIAppExecutableRow(value) {
        setBelongsToProperty(this, 'UIAppExec', value);
    }

    get WB_EntityAttributeTypeRows(): WB_EntityAttributeTypeRow[] {
        return getHasManyProperty(this, 'AttributeTypeRels')
    }

}

export class WB_EntityAttributeTypeRow
    extends ESRecord
    implements RowIF.IwbEntityAttributeType {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbEntityAttributeType {
        return this
    }

    get WB_EntityRow(): WB_EntityRow {
        return getBelongsToProperty(this, 'Entity');
    }

    set WB_EntityRow(value) {
        setBelongsToProperty(this, 'Entity', value);
    }

    get WB_AttributeTypeRow(): WB_AttributeTypeRow {
        return getBelongsToProperty(this, 'AttributeType');
    }

    set WB_AttributeTypeRow(value) {
        setBelongsToProperty(this, 'AttributeType', value);
    }

}

export class WB_AttributeTypeRow
    extends ESRecord
    implements RowIF.IwbAttributeType {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbAttributeType {
        return this
    }

    get WB_MasterDataSetRow(): WB_MasterDataSetRow {
        return getBelongsToProperty(this, 'MasterDataSet');
    }

    set WB_MasterDataSetRow(value) {
        setBelongsToProperty(this, 'MasterDataSet', value);
    }

    get WB_EntityRow_Target(): WB_EntityRow {
        return getBelongsToProperty(this, 'TargetEntity')
    }

    set WB_EntityRow_Target(value: WB_EntityRow) {
        setBelongsToProperty(this, 'TargetEntity', value)
    }

    get bSalesAreaInd(): boolean {
        return getBooleanIndicator(this, "SALESAREA_IND", false)
    }

    set bSalesAreaInd(value: boolean) {
        setBooleanIndicator(this, "bSalesAreaInd", "SALESAREA_IND", value)
    }

    get bCoreInd(): boolean {
        return getBooleanIndicator(this, "CORE_IND", false)
    }

    set bCoreInd(value: boolean) {
        setBooleanIndicator(this, "bCoreInd", "CORE_IND", value)
    }

    get bEffectiveDateInd(): boolean {
        return getBooleanIndicator(this, "EFFECTIVE_DT_IND", false)
    }

    set bEffectiveDateInd(value: boolean) {
        setBooleanIndicator(this, "bEffectiveDateInd", "EFFECTIVE_DT_IND", value)
    }


}


export class WB_DivisionRow
    extends ESRecord
    implements RowIF.IwbDivision {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbDivision {
        return this
    }

    get WB_MasterDataSetRow(): WB_MasterDataSetRow {
        return getBelongsToProperty(this, 'MDSet');
    }

    set WB_MasterDataSetRow(value) {
        setBelongsToProperty(this, 'MDSet', value);
    }

    get WB_DivisionTextRows(): WB_DivisionTextRow[] {
        return getHasManyProperty(this, 'DivisionTexts')
    }

    get bManualInd(): boolean {
        return getBooleanIndicator(this, 'MANUAL_IND', false)
    }
}

export class WB_DivisionTextRow
    extends ESRecord
    implements RowIF.IwbDivisionText {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbDivisionText {
        return this
    }

    get WB_DivisionRow(): WB_DivisionRow {
        return getBelongsToProperty(this, 'Division');
    }

    set WB_DivisionRow(value) {
        setBelongsToProperty(this, 'Division', value);
    }

}

export class WB_DistribChannelRow
    extends ESRecord
    implements RowIF.IwbDistribChannel {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbDistribChannel {
        return this
    }

    get WB_MasterDataSetRow(): WB_MasterDataSetRow {
        return getBelongsToProperty(this, 'MDSet');
    }

    set WB_MasterDataSetRow(value) {
        setBelongsToProperty(this, 'MDSet', value);
    }

    get WB_DistribChannelTextRows(): WB_DistribChannelTextRow[] {
        return getHasManyProperty(this, 'DistribChannelTexts')
    }

    get bManualInd(): boolean {
        return getBooleanIndicator(this, 'MANUAL_IND', false)
    }
}

export class WB_DistribChannelTextRow
    extends ESRecord
    implements RowIF.IwbDistribChannelText {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbDistribChannelText {
        return this
    }

    get WB_DistribChannelRow(): WB_DistribChannelRow {
        return getBelongsToProperty(this, 'DistribChannel');
    }

    set WB_DistribChannelRow(value) {
        setBelongsToProperty(this, 'DistribChannel', value);
    }

}

export class WB_CompanyRow
    extends ESRecord
    implements RowIF.IwbCompany {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbCompany {
        return this
    }

    get WB_MasterDataSetRow(): WB_MasterDataSetRow {
        return getBelongsToProperty(this, 'MDSet');
    }

    set WB_MasterDataSetRow(value) {
        setBelongsToProperty(this, 'MDSet', value);
    }

    get WB_SalesOrgRows(): WB_SalesOrgRow[] {
        return getHasManyProperty(this, 'SalesOrgs')
    }

    get WB_CompanyTextRows(): WB_CompanyTextRow[] {
        return getHasManyProperty(this, 'CompanyTexts')
    }

    get WB_CurrencyRow(): WB_CurrencyRow {
        return getBelongsToProperty(this, 'localCurrency');
    }

    set WB_CurrencyRow(value) {
        setBelongsToProperty(this, 'localCurrency', value);
    }

    get WB_GeneralLedgerRow(): WB_GeneralLedgerRow {
        return getBelongsToProperty(this, 'GeneralLedger');
    }

    set WB_GeneralLedgerRow(value) {
        setBelongsToProperty(this, 'GeneralLedger', value);
    }

    get bManualInd(): boolean {
        return getBooleanIndicator(this, 'MANUAL_IND', false)
    }

}

export class WB_CompanyTextRow
    extends ESRecord
    implements RowIF.IwbCompanyText {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbCompanyText {
        return this
    }

    get WB_CompanyRow(): WB_CompanyRow {
        return getBelongsToProperty(this, 'Company');
    }

    set WB_CompanyRow(value) {
        setBelongsToProperty(this, 'Company', value);
    }


}

export class WB_SalesOrgRow
    extends ESRecord
    implements RowIF.IwbSalesOrg {
    private _salesArea: number

    constructor(props: any, opts: any) {
        super(props, opts);
        this._salesArea = -1
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbSalesOrg {
        return this
    }

    get WB_CompanyRow(): WB_CompanyRow {
        return getBelongsToProperty(this, 'Company');
    }

    set WB_CompanyRow(value) {
        setBelongsToProperty(this, 'Company', value);
    }

    get WB_SalesAreaRows(): WB_SalesAreaRow[] {
        return getHasManyProperty(this, 'SalesAreas')
    }

    get WB_SalesOrgTextRows(): WB_SalesOrgTextRow[] {
        return getHasManyProperty(this, 'SalesOrgTexts')
    }

    get bManualInd(): boolean {
        return getBooleanIndicator(this, 'MANUAL_IND', false)
    }

    get WB_CustomerExternalRelationshipRows(): WB_CustomerExternalRelationshipRow[] {
        return getHasManyProperty(this, 'ExternalCustomers')
    }

    get WB_CustomerCalendarRows(): WB_CustomerCalendarRow[] {
        return getHasManyProperty(this, 'CustomerCalendars')
    }

    get WB_LiftAPIRows(): WB_LiftAPIRow[] {
        return getHasManyProperty(this, 'LiftAPIs')
    }

    get Selected_SalesArea(): number {
        return this._salesArea
    }

    set Selected_SalesArea(value: number) {
        this._salesArea = value
    }

    get WB_BenchmarkRows(): WB_BenchmarkRow[] {
        return getHasManyProperty(this, 'Benchmarks')
    }
}

export class WB_SalesOrgTextRow
    extends ESRecord
    implements RowIF.IwbSalesOrgText {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbSalesOrgText {
        return this
    }

    get WB_SalesOrgRow(): WB_SalesOrgRow {
        return getBelongsToProperty(this, 'SalesOrg');
    }

    set WB_SalesOrgRow(value) {
        setBelongsToProperty(this, 'SalesOrg', value);
    }

}

export class WB_SalesAreaRow
    extends ESRecord
    implements RowIF.IwbSalesArea {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbSalesArea {
        return this
    }

    get WB_SalesOrgRow(): WB_SalesOrgRow {
        return getBelongsToProperty(this, 'SalesOrg');
    }

    set WB_SalesOrgRow(value) {
        setBelongsToProperty(this, 'SalesOrg', value);
    }

    get WB_DivisionRow(): WB_DivisionRow {
        return getBelongsToProperty(this, 'Division');
    }

    set WB_DivisionRow(value) {
        setBelongsToProperty(this, 'Division', value);
    }

    get WB_DistribChannelRow(): WB_DistribChannelRow {
        return getBelongsToProperty(this, 'DistribChannel');
    }

    set WB_DistribChannelRow(value) {
        setBelongsToProperty(this, 'DistribChannel', value);
    }

    get WB_SalesAreaTextRows(): WB_SalesAreaTextRow[] {
        return getHasManyProperty(this, 'SalesAreaTexts')
    }

    get bManualInd(): boolean {
        return getBooleanIndicator(this, 'MANUAL_IND', false)
    }
}

export class WB_SalesAreaTextRow
    extends ESRecord
    implements RowIF.IwbSalesAreaText {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbSalesAreaText {
        return this
    }

    get WB_SalesAreaRow(): WB_SalesAreaRow {
        return getBelongsToProperty(this, 'SalesArea');
    }

    set WB_SalesAreaRow(value) {
        setBelongsToProperty(this, 'SalesArea', value);
    }

}

export class WB_LiftAPIRow
    extends ESRecord
    implements RowIF.IwbLiftAPI {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbLiftAPI {
        return this
    }

    get WB_SalesOrgRow(): WB_SalesOrgRow {
        return getBelongsToProperty(this, 'SalesOrg');
    }

    set WB_SalesOrgRow(value) {
        setBelongsToProperty(this, 'SalesOrg', value);
    }

    get WB_PublishedModelRow(): WB_Published_ModelRow {
        return getBelongsToProperty(this, 'PublishedModel');
    }

    set WB_PublishedModelRow(value) {
        setBelongsToProperty(this, 'PublishedModel', value);
    }

    get bManualInd(): boolean {
        return getBooleanIndicator(this, 'MANUAL_IND', false)
    }
}


//
//Approval

export class WB_ApprovalRow
    extends ESRecord
    implements RowIF.IwbApproval {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.EFFECTIVE_START_DT = defaultRowValues.Min_Dt()
        this.cif.EFFECTIVE_END_DT = defaultRowValues.Max_Dt()
    }

    get cif(): RowIF.IwbApproval {
        return this
    }

    get EffectiveStartDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_START_DT')
    }

    set EffectiveStartDt(value: Date) {
        setBWDateProperty(this, 'EffectiveStartDt', 'EFFECTIVE_START_DT', value)
    }

    get EffectiveEndDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_END_DT')
    }

    set EffectiveEndDt(value: Date) {
        setBWDateProperty(this, 'EffectiveEndDt', 'EFFECTIVE_END_DT', value)
    }

    get REVISED_THRESHOLD_PCNT_BASE_100(): number {
        return this.cif.REVISED_THRESHOLD_PCNT * 100
    }

    set REVISED_THRESHOLD_PCNT_BASE_100(value: number) {
        this.cif.REVISED_THRESHOLD_PCNT = _.toNumber(value) / 100
    }
}


//
// Customer/ Customer Hierarchy

export class WB_CustomerRow
    extends ESRecord
    implements RowIF.IwbCustomer {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.SOURCE_ID = "WB"
    }

    async afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this

        // Set the Defaults for the Domain Values
        let dbContext: PAdbContext = <any>self.dataStore()

        if (_.isEmpty(dbContext))
            return

        self.setDefaults()
        let newKey: number = <any>(await dbContext.getNewId(self._mapper().name))
        let sNewId = TextUtils.padStart(newKey.toString(36), 12, '0').toUpperCase()
        self.cif.CUSTOMER_ID = sNewId
        self.cif.CUSTOMER_NAME = "Unnamed Customer"
        self.cif.MANUAL_IND = "1"
    }

    get cif(): RowIF.IwbCustomer {
        return this
    }

    get WB_CustomerRelationshipRows_Children(): WB_CustomerRelationshipRow[] {
        return getHasManyProperty(this, 'Children')
    }

    get WB_CustomerRelationshipRows_Parents(): WB_CustomerRelationshipRow[] {
        return getHasManyProperty(this, 'Parents')
    }

    get WB_CustomerTagRelationshipRows(): WB_CustomerTagRelationshipRow[] {
        return getBelongsToProperty(this, 'CustomerTags');
    }

    get WB_CustomerDistributionRelationshipRows(): WB_CustomerDistributionRelationshipRow[] {
        return getHasManyProperty(this, 'CustomerDistribution')
    }

    get WB_CustomerRoleRelationshipRows(): WB_CustomerRoleRelationshipRow[] {
        return getHasManyProperty(this, 'CustomerRoles')
    }

    get WB_CustomerRoleCustomerRelationshipRows_ProvidedBy(): WB_CustomerRoleCustomerRelationshipRow[] {
        return getHasManyProperty(this, 'RoleProvidedBy')
    }

    get WB_CustomerRoleCustomerRelationshipRows_ProvidedTo(): WB_CustomerRoleCustomerRelationshipRow[] {
        return getHasManyProperty(this, 'RoleProvidedTo')
    }

    get WB_CustomerSalesAreaRows(): WB_CustomerSalesAreaRow[] {
        return getHasManyProperty(this, 'CustomerSalesAreas')
    }

    get WB_CustomerAttributeRows(): WB_CustomerAttributeRow[] {
        return getHasManyProperty(this, 'CustomerAttributes')
    }


    get WB_CustomerLogicalKeyRows(): WB_CustomerLogicalKeyRow[] {
        return getHasManyProperty(this, 'CustomerLogicalKeys')
    }

    get SearchText(): string {
        return (this.cif?.CUSTOMER_NAME || '') + ' ' + (this.cif?.CUSTOMER_ID || '')
    }

    get WB_SourceRow(): WB_SourceRow {
        return getBelongsToProperty(this, 'Source')
    }

    set WB_SourceRow(value: WB_SourceRow) {
        setBelongsToProperty(this, 'Source', value)
    }

    get WB_MasterDataSetRow(): WB_MasterDataSetRow {
        return getBelongsToProperty(this, 'MasterDataSet')
    }

    set WB_MasterDataSetRow(value: WB_MasterDataSetRow) {
        setBelongsToProperty(this, 'MasterDataSet', value)
    }

    get bManual(): boolean {
        return getBooleanIndicator(this, "MANUAL_IND", false)
    }

}

export class WB_CustomerAttributeRow
    extends ESRecord
    implements RowIF.IwbCustomerAttribute {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbCustomerAttribute {
        return this
    }

    get WB_CustomerRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Customer');
    }

    set WB_CustomerRow(value) {
        setBelongsToProperty(this, 'Customer', value);
    }

    get WB_SalesAreaRow(): WB_SalesAreaRow {
        return getBelongsToProperty(this, 'SalesArea');
    }

    set WB_SalesAreaRow(value) {
        setBelongsToProperty(this, 'SalesArea', value);
    }

    get WB_AttributeTypeRow(): WB_AttributeTypeRow {
        return getBelongsToProperty(this, 'AttributeType');
    }

    set WB_AttributeTypeRow(value) {
        setBelongsToProperty(this, 'AttributeType', value);
    }

}

export class WB_CustomerLogicalKeyRow
    extends ESRecord
    implements RowIF.IwbCustomerLogicalKey {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbCustomerLogicalKey {
        return this
    }

    get WB_CustomerRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Customer');
    }

    set WB_CustomerRow(value) {
        setBelongsToProperty(this, 'Customer', value);
    }

}


export class WB_CustomerHierarchyRow
    extends ESRecord
    implements RowIF.IwbCustomerHierarchy {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.MANUAL_IND = '1'
    }

    get cif(): RowIF.IwbCustomerHierarchy {
        return this
    }

    get WB_CustomerHierarchyLevelRows(): WB_CustomerHierarchyLevelRow[] {
        return getHasManyProperty(this, 'CustomerHierarchyLevel');
    }

    get WB_CustomerHierarchySalesAreaRows(): WB_CustomerHierarchySalesAreaRow[] {
        return getHasManyProperty(this, 'SalesAreas');
    }

    get WB_MasterDataSetRow(): WB_MasterDataSetRow {
        return getBelongsToProperty(this, 'MasterDataSet')
    }

    set WB_MasterDataSetRow(value: WB_MasterDataSetRow) {
        setBelongsToProperty(this, 'MasterDataSet', value)
    }

    get bManual(): boolean {
        return getBooleanIndicator(this, "MANUAL_IND", false)
    }
}

export class WB_CustomerHierarchySalesAreaRow
    extends ESRecord
    implements RowIF.IwbCustomerHierarchySalesArea {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbCustomerHierarchySalesArea {
        return this
    }

    set WB_CustomerHierarchyRow(value) {
        setBelongsToProperty(this, 'CustomerHierarchy', value)
    }

    get WB_CustomerHierarchyRow(): WB_CustomerHierarchyRow {
        return getBelongsToProperty(this, 'CustomerHierarchy')
    }

    set WB_SalesAreaRow(value) {
        setBelongsToProperty(this, 'SalesArea', value)
    }

    get WB_SalesAreaRow(): WB_SalesAreaRow {
        return getBelongsToProperty(this, 'SalesArea')
    }

}


export class WB_CustomerHierarchyLevelRow
    extends ESRecord
    implements RowIF.IwbCustomerHierarchyLevel {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbCustomerHierarchyLevel {
        return this
    }
}

export class WB_CustomerRelationshipRow
    extends ESRecord
    implements RowIF.IwbCustomerRelationship {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.EFFECTIVE_START_DT = defaultRowValues.Min_Dt()
        this.cif.EFFECTIVE_END_DT = defaultRowValues.Max_Dt()
    }

    get WB_CustomerRowParent(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Parent');
    }

    set WB_CustomerRowParent(value) {
        setBelongsToProperty(this, 'Parent', value);
    }

    get WB_CustomerRowChild(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Child');
    }

    set WB_CustomerRowChild(value) {
        setBelongsToProperty(this, 'Child', value);
    }

    get EffectiveStartDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_START_DT')
    }

    set EffectiveStartDt(value: Date) {
        setBWDateProperty(this, 'EffectiveStartDt', 'EFFECTIVE_START_DT', value)
    }

    get EffectiveEndDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_END_DT')
    }

    set EffectiveEndDt(value: Date) {
        setBWDateProperty(this, 'EffectiveEndDt', 'EFFECTIVE_END_DT', value)
    }

    get cif(): RowIF.IwbCustomerRelationship {
        return this
    }

    get bManual(): boolean {
        return getBooleanIndicator(this, "MANUAL_IND", false)
    }
}

export class WB_CustomerTagRelationshipRow
    extends ESRecord
    implements RowIF.IwbCustomerTagRelationship {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.EFFECTIVE_START_DT = defaultRowValues.Min_Dt()
        this.cif.EFFECTIVE_END_DT = defaultRowValues.Max_Dt()
    }

    get cif(): RowIF.IwbCustomerTagRelationship {
        return this
    }

    get WB_CustomerRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Customer');
    }

    get WB_TagRow(): WB_TagRow {
        return getBelongsToProperty(this, 'Tag');
    }

    set WB_TagRow(value: WB_TagRow) {
        setBelongsToProperty(this, 'Tag', value)
    }

    get EffectiveStartDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_START_DT')
    }

    set EffectiveStartDt(value: Date) {
        setBWDateProperty(this, 'EffectiveStartDt', 'EFFECTIVE_START_DT', value)
    }

    get EffectiveEndDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_END_DT')
    }

    set EffectiveEndDt(value: Date) {
        setBWDateProperty(this, 'EffectiveEndDt', 'EFFECTIVE_END_DT', value)
    }

    get bManual(): boolean {
        return getBooleanIndicator(this, "MANUAL_IND", false)
    }


}

export class WB_CustomerExternalRelationshipRow
    extends ESRecord
    implements RowIF.IwbCustomerExternalRelationship {

    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.COVERAGE_FACTOR = 100
        this.cif.SOURCE_ID = "WB"
        this.cif.PRODUCT_ORG_DIVISION = "All"
        this.cif.EFFECTIVE_START_DT = defaultRowValues.Min_Dt()
        this.cif.EFFECTIVE_END_DT = defaultRowValues.Max_Dt()
    }

    get cif(): RowIF.IwbCustomerExternalRelationship {
        return this
    }

    //cenk 6/20/2017
    get WB_CustomerRow_Source(): WB_CustomerRow {
        return getBelongsToProperty(this, 'ExternalCustomer')
    }

    //cenk 6/20/2017
    set WB_CustomerRow_Source(value) {
        setBelongsToProperty(this, 'ExternalCustomer', value)
    }

    //cenk 6/20/2017
    get WB_CustomerRow_Planning(): WB_CustomerRow {
        return getBelongsToProperty(this, 'PlanningCustomer')
    }

    //cenk 6/20/2017
    set WB_CustomerRow_Planning(value) {
        setBelongsToProperty(this, 'PlanningCustomer', value)
    }

    get EffectiveStartDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_START_DT')
    }

    set EffectiveStartDt(value: Date) {
        setBWDateProperty(this, 'EffectiveStartDt', 'EFFECTIVE_START_DT', value)
    }

    get EffectiveEndDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_END_DT')
    }

    set EffectiveEndDt(value: Date) {
        setBWDateProperty(this, 'EffectiveEndDt', 'EFFECTIVE_END_DT', value)
    }

    get Coverage_Factor(): number {
        return this.cif.COVERAGE_FACTOR * 100
    }

    set Coverage_Factor(value: number) {
        this.cif.COVERAGE_FACTOR = value / 100
    }

}

export class WB_CustomerProxyRelationshipRow
    extends ESRecord
    implements RowIF.IwbCustomerProxyRelationship {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.EFFECTIVE_START_DT = defaultRowValues.Min_Dt()
        this.cif.EFFECTIVE_END_DT = defaultRowValues.Max_Dt()
    }

    get cif(): RowIF.IwbCustomerProxyRelationship {
        return this
    }

    get WB_CustomerRow_Source(): WB_CustomerRow {
        return getBelongsToProperty(this, 'SourceCustomer')
    }

    set WB_CustomerRow_Source(value) {
        setBelongsToProperty(this, 'SourceCustomer', value)
    }

    get WB_CustomerRow_Proxy(): WB_CustomerRow {
        return getBelongsToProperty(this, 'ProxyCustomer')
    }

    set WB_CustomerRow_Proxy(value) {
        setBelongsToProperty(this, 'ProxyCustomer', value)
    }

    get EffectiveStartDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_START_DT')
    }

    set EffectiveStartDt(value: Date) {
        setBWDateProperty(this, 'EffectiveStartDt', 'EFFECTIVE_START_DT', value)
    }

    get EffectiveEndDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_END_DT')
    }

    set EffectiveEndDt(value: Date) {
        setBWDateProperty(this, 'EffectiveEndDt', 'EFFECTIVE_END_DT', value)
    }

}

export class WB_CustomerCalendarRow
    extends ESRecord
    implements RowIF.IwbCustomerCalendar {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.EFFECTIVE_START_DT = defaultRowValues.Min_Dt()
        this.cif.EFFECTIVE_END_DT = defaultRowValues.Max_Dt()
        this.cif.RETAIL_CALENDAR_START = "1"
        this.cif.WEEK_START_DAY_OF_WEEK_ACT = "1"
        this.cif.CONSUMPTION_DAY_OFFSET = 0
    }

    get cif(): RowIF.IwbCustomerCalendar {
        return this
    }

    //cenk
    get WB_CustomerRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Customer')
    }

    set WB_CustomerRow(value: WB_CustomerRow) {
        setBelongsToProperty(this, 'Customer', value)
    }

    get WB_SourceRow(): WB_SourceRow {
        return getBelongsToProperty(this, 'Source')
    }

    set WB_SourceRow(value: WB_SourceRow) {
        setBelongsToProperty(this, 'Source', value)
    }

    get EffectiveStartDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_START_DT')
    }

    set EffectiveStartDt(value: Date) {
        setBWDateProperty(this, 'EffectiveStartDt', 'EFFECTIVE_START_DT', value)
    }

    get EffectiveEndDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_END_DT')
    }

    set EffectiveEndDt(value: Date) {
        setBWDateProperty(this, 'EffectiveEndDt', 'EFFECTIVE_END_DT', value)
    }
}

export class WB_CustomerModelParameters1Row
    extends ESRecord
    implements RowIF.IwbCustomerModelParameters1 {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbCustomerModelParameters1 {
        return this
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup')
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value)
    }

    get WB_CustomerRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Customer')
    }

    set WB_CustomerRow(value) {
        setBelongsToProperty(this, 'Customer', value)
    }
}

export class WB_CustomerProductRow
    extends ESRecord
    implements RowIF.IwbCustomerProduct {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.EFFECTIVE_START_DT = defaultRowValues.Min_Dt()
        this.cif.EFFECTIVE_END_DT = defaultRowValues.Max_Dt()
    }

    get cif(): RowIF.IwbCustomerProduct {
        return this
    }

    get WB_CustomerRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Customer')
    }

    get WB_FinishedProductRow(): WB_FinishedProductRow {
        return getBelongsToProperty(this, 'Product')
    }

    set WB_FinishedProductRow(value) {
        setBelongsToProperty(this, 'Product', value)
    }

    get WB_SourceRow(): WB_SourceRow {
        return getBelongsToProperty(this, 'Source')
    }
}

export class WB_CustomerDistributionRelationshipRow
    extends ESRecord
    implements RowIF.IwbCustomerDistributionRelationship {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.EFFECTIVE_START_DT = defaultRowValues.Min_Dt()
        this.cif.EFFECTIVE_END_DT = defaultRowValues.Max_Dt()
    }

    get cif(): RowIF.IwbCustomerDistributionRelationship {
        return this
    }

    get WB_CustomerRow_Related(): WB_CustomerRow {
        return getBelongsToProperty(this, 'CustomerRelated')
    }

    set WB_CustomerRow_Related(value) {
        setBelongsToProperty(this, 'CustomerRelated', value)
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup')
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value)
    }

    get EffectiveStartDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_START_DT')
    }

    set EffectiveStartDt(value: Date) {
        setBWDateProperty(this, 'EffectiveStartDt', 'EFFECTIVE_START_DT', value)
    }

    get EffectiveEndDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_END_DT')
    }

    set EffectiveEndDt(value: Date) {
        setBWDateProperty(this, 'EffectiveEndDt', 'EFFECTIVE_END_DT', value)
    }

    get bManual(): boolean {
        return getBooleanIndicator(this, "MANUAL_IND", false)
    }
}


export class WB_CustomerTypeRow
    extends ESRecord
    implements RowIF.IwbCustomerType {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.MANUAL_IND = defaultRowValues.True_Ind()
    }

    get cif(): RowIF.IwbCustomerType {
        return this;
    }

    get WB_MasterDataSetRow(): WB_MasterDataSetRow {
        return getBelongsToProperty(this, 'MasterDataSet')
    }

    set WB_MasterDataSetRow(value) {
        setBelongsToProperty(this, 'MasterDataSet', value)
    }

    get WB_EntityRow(): WB_EntityRow {
        return getBelongsToProperty(this, 'Entity')
    }

    set WB_EntityRow(value: WB_EntityRow) {
        setBelongsToProperty(this, 'Entity', value)
    }


    get bManual(): boolean {
        return getBooleanIndicator(this, "MANUAL_IND", false)
    }

    get bAddressShowInd(): boolean {
        return getBooleanIndicator(this, "ADDRESS_SHOW_IND", false)
    }

    get bAddressSearchByInd(): boolean {
        return getBooleanIndicator(this, "ADDRESS_SEARCHABLE_IND", false)
    }

    get bSalesAreaSearchByInd(): boolean {
        return getBooleanIndicator(this, "SALESAREA_SEARCHABLE_IND", false)
    }

    get bSalesAreaShowInd(): boolean {
        return getBooleanIndicator(this, "SALESAREA_SHOW_IND", false)
    }

    get bStatusSearchByInd(): boolean {
        return getBooleanIndicator(this, "STATUS_SEARCHABLE_IND", false)
    }

    get bStatusShowInd(): boolean {
        return getBooleanIndicator(this, "STATUS_SHOW_IND", false)
    }

    get HeaderSearchFields(): string[] {
        return this.cif.HEADER_SEARCH_FIELDS.split(",")
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT');
    }

}

export class WB_CustomerRoleRow
    extends ESRecord
    implements RowIF.IwbCustomerRole {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.MANUAL_IND = defaultRowValues.True_Ind()
    }

    get cif(): RowIF.IwbCustomerRole {
        return this;
    }

    get WB_MasterDataSetRow(): WB_MasterDataSetRow {
        return getBelongsToProperty(this, 'MasterDataSet')
    }

    set WB_MasterDataSetRow(value) {
        setBelongsToProperty(this, 'MasterDataSet', value)
    }

    get WB_CustomerTypeRow(): WB_CustomerTypeRow {
        return getBelongsToProperty(this, 'CustomerType')
    }

    set WB_CustomerTypeRow(value) {
        setBelongsToProperty(this, 'CustomerType', value)
    }

}

export class WB_CustomerSalesAreaRow
    extends ESRecord
    implements RowIF.IwbCustomerSalesArea {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbCustomerSalesArea {
        return this;
    }

    get WB_CustomerRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Customer')
    }

    set WB_CustomerRow(value) {
        setBelongsToProperty(this, 'Customer', value)
    }

    get WB_SalesAreaRow(): WB_SalesAreaRow {
        return getBelongsToProperty(this, 'SalesArea')
    }

    set WB_SalesAreaRow(value) {
        setBelongsToProperty(this, 'SalesArea', value)
    }

    get bManual(): boolean {
        return getBooleanIndicator(this, "MANUAL_IND", false)
    }

}

export class WB_CustomerRoleRelationshipRow
    extends ESRecord
    implements RowIF.IwbCustomerRoleRelationship {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbCustomerRoleRelationship {
        return this;
    }

    get WB_CustomerRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Customer')
    }

    set WB_CustomerRow(value) {
        setBelongsToProperty(this, 'Customer', value)
    }

    get WB_SalesAreaRow(): WB_SalesAreaRow {
        return getBelongsToProperty(this, 'SalesArea')
    }

    set WB_SalesAreaRow(value) {
        setBelongsToProperty(this, 'SalesArea', value)
    }

    get WB_CustomerRoleRow(): WB_CustomerRoleRow {
        return getBelongsToProperty(this, 'CustomerRole')
    }

    set WB_CustomerRoleRow(value) {
        setBelongsToProperty(this, 'CustomerRole', value)
    }

    get bManual(): boolean {
        return getBooleanIndicator(this, "MANUAL_IND", false)
    }

}

export class WB_CustomerRoleCustomerRelationshipRow
    extends ESRecord
    implements RowIF.IwbCustomerRoleCustomerRelationship {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbCustomerRoleCustomerRelationship {
        return this;
    }

    get WB_CustomerRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Customer')
    }

    set WB_CustomerRow(value) {
        setBelongsToProperty(this, 'Customer', value)
    }

    get WB_CustomerRow_Related(): WB_CustomerRow {
        return getBelongsToProperty(this, 'CustomerRel')
    }

    set WB_CustomerRow_Related(value) {
        setBelongsToProperty(this, 'CustomerRel', value)
    }

    get WB_SalesAreaRow(): WB_SalesAreaRow {
        return getBelongsToProperty(this, 'SalesArea')
    }

    set WB_SalesAreaRow(value) {
        setBelongsToProperty(this, 'SalesArea', value)
    }

    get WB_CustomerRoleRow(): WB_CustomerRoleRow {
        return getBelongsToProperty(this, 'CustomerRole')
    }

    set WB_CustomerRoleRow(value) {
        setBelongsToProperty(this, 'CustomerRole', value)
    }

    get bManual(): boolean {
        return getBooleanIndicator(this, "MANUAL_IND", false)
    }

}

// Currency
export class WB_CurrencyRow
    extends ESRecord
    implements RowIF.IwbCurrency {


    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MANUAL_IND = defaultRowValues.True_Ind()
    }

    get cif(): RowIF.IwbCurrency {
        return this
    }

    get WB_MasterDataSetRow(): WB_MasterDataSetRow {
        return getBelongsToProperty(this, 'MasterDataSet')
    }

    set WB_MasterDataSetRow(value) {
        setBelongsToProperty(this, 'MasterDataSet', value)
    }

    get WB_CurrencyTRows(): WB_CurrencyTRow[] {
        return getHasManyProperty(this, 'CurrencyText')
    }

    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }
}

export class WB_CurrencyTRow
    extends ESRecord
    implements RowIF.IwbCurrencyT {


    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbCurrencyT {
        return this
    }

    get WB_CurrencyRow(): WB_CurrencyRow {
        return getBelongsToProperty(this, 'Currency')
    }

    set WB_CurrencyRow(value) {
        setBelongsToProperty(this, 'Currency', value)
    }

    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }
}


// Exchange Rate

export class WB_ExchangeRateMRow
    extends ESRecord
    implements RowIF.IwbExchangeRateM {


    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbExchangeRateM {
        return this
    }

    get WB_ExchangeRateMTRows(): WB_ExchangeRateMTRow[] {
        return getHasManyProperty(this, 'ExchangeRateMT')
    }

    get WB_ExchangeRateMRRows(): WB_ExchangeRateMRRow[] {
        return getHasManyProperty(this, 'ExchangeRateMR')
    }

    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }
}


export class WB_ExchangeRateMTRow
    extends ESRecord
    implements RowIF.IwbExchangeRateMT {


    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbExchangeRateMT {
        return this
    }

    get WB_ExchangeRateMRow(): WB_ExchangeRateMRow {
        return getBelongsToProperty(this, 'ExchangeRateM')
    }

    set WB_ExchangeRateMRow(value) {
        setBelongsToProperty(this, 'ExchangeRateM', value)
    }

    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }
}

export class WB_ExchangeRateMRRow
    extends ESRecord
    implements RowIF.IwbExchangeRateMR {


    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbExchangeRateMR {
        return this
    }

    get WB_ExchangeRateMRow(): WB_ExchangeRateMRow {
        return getBelongsToProperty(this, 'ExchangeRateM')
    }

    set WB_ExchangeRateMRow(value) {
        setBelongsToProperty(this, 'ExchangeRateM', value)
    }

    get WB_CurrencyRow_To(): WB_CurrencyRow {
        return getBelongsToProperty(this, 'ExchangeRateMRTo')
    }

    set WB_CurrencyRow_To(value) {
        setBelongsToProperty(this, 'ExchangeRateMRTo', value)
    }

    get WB_CurrencyRow_From(): WB_CurrencyRow {
        return getBelongsToProperty(this, 'ExchangeRateMRFrom')
    }

    set WB_CurrencyRow_From(value) {
        setBelongsToProperty(this, 'ExchangeRateMRFrom', value)
    }

    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }
}

// SourceType
export class WB_SourceTypeRow
    extends ESRecord
    implements RowIF.IwbSourceType {

    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbSourceType {
        return this
    }

    get WB_SourceTypeSTRRows(): WB_SourceTypeSTRRow[] {
        return getHasManyProperty(this, 'SourceTypeStr')
    }

    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    set CreatedDtTs(value: Date) {
        setBWDateTsProperty(this, "CreatedDtTs", 'CREATED_DTTS', value);
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    set ModifiedDtTs(value: Date) {
        setBWDateTsProperty(this, "ModifiedDtTs", 'MODIFIED_DTTS', value);
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

    set DeletedDt(value: Date) {
        setBWDateProperty(this, 'DeletedDt', 'DELETED_DT', value);
    }
}

export class WB_SourceTypeSTRRow
    extends ESRecord
    implements RowIF.IwbSourceTypeSTR {

    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbSourceTypeSTR {
        return this
    }

    get WB_SourceTypeRow(): WB_SourceTypeRow {
        return getBelongsToProperty(this, 'SourceType')
    }

    set WB_SourceTypeRow(value) {
        setBelongsToProperty(this, 'SourceType', value)
    }

    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    set CreatedDtTs(value: Date) {
        setBWDateTsProperty(this, "CreatedDtTs", 'CREATED_DTTS', value);
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    set ModifiedDtTs(value: Date) {
        setBWDateTsProperty(this, "ModifiedDtTs", 'MODIFIED_DTTS', value);
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

    set DeletedDt(value: Date) {
        setBWDateProperty(this, 'DeletedDt', 'DELETED_DT', value);
    }
}

// Data Object
export class WB_DataObjectRow
    extends ESRecord
    implements RowIF.IwbDataObject {
    private _languageText: LanguageText

    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbDataObject {
        return this
    }

    get WB_DataObjectTextRows(): WB_DataObjectTextRow[] {
        return getHasManyProperty(this, 'DataObjectText')
    }

    get WB_DataObjectColumnRows(): WB_DataObjectColumnRow[] {
        return getHasManyProperty(this, 'DataObjectColumn')
    }

    get WB_DataObjectMessageRows(): WB_DataObjectMessageRow[] {
        return getHasManyProperty(this, 'DataObjectMessage')
    }

    get LanguageText(): LanguageText {
        return this._languageText
    }

    set LanguageText(value: LanguageText) {
        this._languageText = value
    }

    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

}


export class WB_DataObjectTextRow
    extends ESRecord
    implements RowIF.IwbDataObjectText {

    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbDataObjectText {
        return this
    }

    get WB_DataObjectRow(): WB_DataObjectRow {
        return getBelongsToProperty(this, 'DataObject')
    }

    set WB_DataObjectRow(value) {
        setBelongsToProperty(this, 'DataObject', value)
    }

    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

}

export class WB_DataObjectColumnRow
    extends ESRecord
    implements RowIF.IwbDataObjectColumn {

    private _languageText: LanguageText
    private _languageTextGroup: LanguageText

    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbDataObjectColumn {
        return this
    }

    get WB_DataObjectRow(): WB_DataObjectRow {
        return getBelongsToProperty(this, 'DataObj')
    }

    set WB_DataObjectRow(value) {
        setBelongsToProperty(this, 'DataObj', value)
    }

    get WB_DataObjectColumnTextRows(): WB_DataObjectColumnTextRow[] {
        return getHasManyProperty(this, 'DataObjectColumnText')
    }

    get LanguageText(): LanguageText {
        return this._languageText
    }

    set LanguageText(value: LanguageText) {
        this._languageText = value
    }

    get LanguageTextGroup(): LanguageText {
        return this._languageTextGroup
    }

    set LanguageTextGroup(value: LanguageText) {
        this._languageTextGroup = value
    }

    get bForeignKeyInd(): boolean {
        return getBooleanIndicator(this, 'FOREIGNKEY_IND')
    }

    get bCustomColumnInd(): boolean {
        return getBooleanIndicator(this, 'CUSTOM_IND')
    }

    get bMapperInd(): boolean {
        return getBooleanIndicator(this, 'MAPPER_IND')
    }

    get bLogicalKeyInd(): boolean {
        return getBooleanIndicator(this, 'LOGICALKEY_IND')
    }

    get bMetricVisibleInd(): boolean {
        return getBooleanIndicator(this, 'METRIC_CUBESOURCE_VISIBLE_IND')
    }

    get bMetricEditableInd(): boolean {
        return getBooleanIndicator(this, 'METRIC_EDITABLE_IND')
    }

    get bMetricWritebackEnabledInd(): boolean {
        return getBooleanIndicator(this, 'METRIC_WB_ENABLED_IND')
    }

    get bEntityServiceInd(): boolean {
        return getBooleanIndicator(this, 'ENTITY_SERVICE_IND')
    }

    get bManualInd(): boolean {
        return getBooleanIndicator(this, 'MANUAL_IND')
    }


    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }


}

export class WB_DataObjectColumnTextRow
    extends ESRecord
    implements RowIF.IwbDataObjectColumnText {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbDataObjectColumnText {
        return this
    }

    get WB_DataObjectColumnRow(): WB_DataObjectColumnRow {
        return getBelongsToProperty(this, 'DataObjColumn')
    }

    set WB_DataObjectColumnRow(value) {
        setBelongsToProperty(this, 'DataObjColumn', value)
    }


    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

}

export class WB_DataObjectMessageRow
    extends ESRecord
    implements RowIF.IwbDataObjectMessage {

    private _languageText: LanguageText

    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbDataObjectMessage {
        return this
    }

    get WB_DataObjectRow(): WB_DataObjectRow {
        return getBelongsToProperty(this, 'DataObj')
    }

    set WB_DataObjectRow(value) {
        setBelongsToProperty(this, 'DataObj', value)
    }

    get WB_DataObjectMessageTextRows(): WB_DataObjectMessageTextRow[] {
        return getHasManyProperty(this, 'DataObjectMessageText')
    }

    get LanguageText(): LanguageText {
        return this._languageText
    }

    set LanguageText(value: LanguageText) {
        this._languageText = value
    }


    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

}

export class WB_DataObjectMessageTextRow
    extends ESRecord
    implements RowIF.IwbDataObjectMessageText {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbDataObjectMessageText {
        return this
    }


    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

    get WB_DataObjectMessageRow(): WB_DataObjectMessageRow {
        return getBelongsToProperty(this, 'DataObjectMsg')
    }

    set WB_DataObjectMessageRow(value) {
        setBelongsToProperty(this, 'DataObjectMsg', value)
    }


}


// Circular Config
export class WB_CircularConfigRow
    extends ESRecord
    implements RowIF.IwbCircularConfig {

    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbCircularConfig {
        return this
    }

    get WB_CircularConfigCRRows(): WB_CircularConfigCRRow[] {
        return getHasManyProperty(this, 'CircularConfigColumns')
    }

    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }
}

export class WB_CircularConfigCRRow
    extends ESRecord
    implements RowIF.IwbCircularConfigCR {

    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbCircularConfigCR {
        return this
    }

    get WB_CircularConfigRow(): WB_CircularConfigRow {
        return getBelongsToProperty(this, 'CircularConfig')
    }

    set WB_CircularConfigRow(value) {
        setBelongsToProperty(this, 'CircularConfig', value)
    }

    get WB_DataObjectColumnRow(): WB_DataObjectColumnRow {
        return getBelongsToProperty(this, 'DataObjectColumn')
    }

    set WB_DataObjectColumnRow(value) {
        setBelongsToProperty(this, 'DataObjectColumn', value)
    }

    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }
}


// Circulars

export class WB_CircularAdBlockRow
    extends ESRecord
    implements RowIF.IwbCircularAdBlock {

    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbCircularAdBlock {
        return this
    }

    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }
}

export class WB_CircularRow
    extends ESRecord
    implements RowIF.IwbCircular {

    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbCircular {
        return this
    }

    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

}

export class WB_CircularCRRow
    extends ESRecord
    implements RowIF.IwbCircularCR {

    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbCircularCR {
        return this
    }

    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

}

export class WB_CircularPRRow
    extends ESRecord
    implements RowIF.IwbCircularPR {

    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbCircularPR {
        return this
    }

    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

}

// Product / Product Group/ Product Hierachy

export class WB_FinishedProductRow
    extends ESRecord
    implements RowIF.IwbFinishedProduct {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.MANUAL_IND = "1"
    }

    get WB_MasterDataSetRow(): WB_MasterDataSetRow {
        return getBelongsToProperty(this, 'MasterDataSet')
    }

    set WB_MasterDataSetRow(value) {
        setBelongsToProperty(this, 'MasterDataSet', value)
    }

    get WB_ProductTypeRow(): WB_ProductTypeRow {
        return getBelongsToProperty(this, 'ProductType')
    }

    set WB_ProductTypeRow(value) {
        setBelongsToProperty(this, 'ProductType', value)
    }

    get WB_FinishedProductSalesAreaRows(): WB_FinishedProductSalesAreaRow[] {
        return getHasManyProperty(this, 'SalesAreas')
    }

    get WB_ProductAttributeRows(): WB_ProductAttributeRow[] {
        return getHasManyProperty(this, 'ProductAttributes')
    }

    get WB_FinishedProductRelationshipRows(): WB_FinishedProductRelationshipRow[] {
        return getHasManyProperty(this, 'ProductGroups')
    }

    get WB_ProductBOMRows(): WB_ProductBOMRow[] {
        return getHasManyProperty(this, 'ProductBOMs')
    }

    get WB_ProductUOMRows(): WB_ProductUOMRow[] {
        return getHasManyProperty(this, 'ProductUOMs')
    }

    get WB_FinishedProductTagRelationshipRows(): WB_FinishedProductTagRelationshipRow[] {
        return getHasManyProperty(this, 'ProdTags')
    }

    get cif(): RowIF.IwbFinishedProduct {
        return this
    }

    get bManualInd(): boolean {
        return getBooleanIndicator(this, 'MANUAL_IND', false)
    }

    get ConsumerUPCThenProductUPC(): string {
        let upc = (this.cif.CONSUMER_PRODUCT_UPC || '').trim()
        if (!_.isEmpty(upc))
            return upc
        return (this.cif.PRODUCT_UPC || '').trim()
    }


}

export class WB_FinishedProductSalesAreaRow
    extends ESRecord
    implements RowIF.IwbFinishedProductSalesArea {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    get cif(): RowIF.IwbFinishedProductSalesArea {
        return this
    }

    setDefaults(): void {
        this.cif.MANUAL_IND = "1"
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
    }

    set WB_ProductRow(value) {
        setBelongsToProperty(this, 'Product', value)
    }

    get WB_ProductRow(): WB_FinishedProductRow {
        return getBelongsToProperty(this, 'Product')
    }

    set WB_SalesAreaRow(value: WB_SalesAreaRow) {
        setBelongsToProperty(this, 'SalesArea', value)
    }

    get WB_SalesAreaRow(): WB_SalesAreaRow {
        return getBelongsToProperty(this, 'SalesArea')
    }

}


export class WB_FinishedProductRelationshipRow
    extends ESRecord
    implements RowIF.IwbFinishedProductRelationship {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    get cif(): RowIF.IwbFinishedProductRelationship {
        return this
    }

    setDefaults(): void {
        this.cif.EFFECTIVE_START_DT = defaultRowValues.Min_Dt()
        this.cif.EFFECTIVE_END_DT = defaultRowValues.Max_Dt()
        this.cif.INTEGRATION_IND = defaultRowValues.Integration_Ind()
        // this.cif.MANUAL_IND = defaultRowValues.True_Ind()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
    }

    set WB_FinishedProductRow(value) {
        setBelongsToProperty(this, 'Product', value)
    }

    get WB_FinishedProductRow(): WB_FinishedProductRow {
        return getBelongsToProperty(this, 'Product')
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value)
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup')
    }

    get EffectiveStartDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_START_DT')
    }

    set EffectiveStartDt(value: Date) {
        setBWDateProperty(this, 'EffectiveStartDt', 'EFFECTIVE_START_DT', value)
    }

    get EffectiveEndDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_END_DT')
    }

    set EffectiveEndDt(value: Date) {
        setBWDateProperty(this, 'EffectiveEndDt', 'EFFECTIVE_END_DT', value)
    }

}

export class WB_FinishedProductTagRelationshipRow
    extends ESRecord
    implements RowIF.IwbFinishedProductTagRelationship {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    get cif(): RowIF.IwbFinishedProductTagRelationship {
        return this
    }

    setDefaults(): void {
        this.cif.EFFECTIVE_START_DT = defaultRowValues.Min_Dt()
        this.cif.EFFECTIVE_END_DT = defaultRowValues.Max_Dt()
        this.cif.INTEGRATION_IND = defaultRowValues.Integration_Ind()
        this.cif.MANUAL_IND = "1"
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
    }

    set WB_FinishedProductRow(value) {
        setBelongsToProperty(this, 'Product', value)
    }

    get WB_FinishedProductRow(): WB_FinishedProductRow {
        return getBelongsToProperty(this, 'Product')
    }

    set WB_TagRow(value: WB_TagRow) {
        setBelongsToProperty(this, 'ProdTag', value)
    }

    get WB_TagRow(): WB_TagRow {
        return getBelongsToProperty(this, 'ProdTag')
    }

    get EffectiveStartDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_START_DT')
    }

    set EffectiveStartDt(value: Date) {
        setBWDateProperty(this, 'EffectiveStartDt', 'EFFECTIVE_START_DT', value)
    }

    get EffectiveEndDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_END_DT')
    }

    set EffectiveEndDt(value: Date) {
        setBWDateProperty(this, 'EffectiveEndDt', 'EFFECTIVE_END_DT', value)
    }

}

export class WB_ProductTypeRow
    extends ESRecord
    implements RowIF.IwbProductType {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.MANUAL_IND = defaultRowValues.True_Ind()

    }

    get cif(): RowIF.IwbProductType {
        return this;
    }

    get WB_MasterDataSetRow(): WB_MasterDataSetRow {
        return getBelongsToProperty(this, 'MasterDataSet')
    }

    set WB_MasterDataSetRow(value) {
        setBelongsToProperty(this, 'MasterDataSet', value)
        this.cif.CONSUMER_UPC_SEARCHABLE_IND
    }

    get WB_EntityRow(): WB_EntityRow {
        return getBelongsToProperty(this, 'Entity')
    }

    set WB_EntityRow(value: WB_EntityRow) {
        setBelongsToProperty(this, 'Entity', value)
    }

    get bManual(): boolean {
        return getBooleanIndicator(this, "MANUAL_IND", false)
    }

    get bSizesShowInd(): boolean {
        return getBooleanIndicator(this, "SIZES_SHOW_IND", false)
    }

    get bSizesSearchByInd(): boolean {
        return getBooleanIndicator(this, "SIZES_SEARCHABLE_IND", false)
    }

    get bBOMShowInd(): boolean {
        return getBooleanIndicator(this, "BOM_SHOW_IND", false)
    }

    get bBOMSearchByInd(): boolean {
        return getBooleanIndicator(this, "BOM_SEARCHABLE_IND", false)
    }

    get bUOMShowInd(): boolean {
        return getBooleanIndicator(this, "UOM_SHOW_IND", false)
    }

    get bUOMSearchByInd(): boolean {
        return getBooleanIndicator(this, "UOM_SEARCHABLE_IND", false)
    }

    get bConsumerUPCShowInd(): boolean {
        return getBooleanIndicator(this, "CONSUMER_UPC_SHOW_IND", false)
    }

    get bConsumerUPCSearchByInd(): boolean {
        return getBooleanIndicator(this, "CONSUMER_UPC_SEARCHABLE_IND", false)
    }


    get bSalesAreaSearchByInd(): boolean {
        return getBooleanIndicator(this, "SALESAREA_SEARCHABLE_IND", false)
    }

    get bSalesAreaShowInd(): boolean {
        return getBooleanIndicator(this, "SALESAREA_SHOW_IND", false)
    }

    get bStatusSearchByInd(): boolean {
        return getBooleanIndicator(this, "STATUS_SEARCHABLE_IND", false)
    }

    get bStatusShowInd(): boolean {
        return getBooleanIndicator(this, "STATUS_SHOW_IND", false)
    }

    get HeaderSearchFields(): string[] {
        return this.cif.HEADER_SEARCH_FIELDS.split(",")
    }


}

export class WB_ProductAttributeRow
    extends ESRecord
    implements RowIF.IwbProductAttribute {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    get cif(): RowIF.IwbProductAttribute {
        return this
    }

    setDefaults(): void {
        this.cif.MANUAL_IND = "1"
    }

    get WB_ProductRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Product');
    }

    set WB_ProductRow(value) {
        setBelongsToProperty(this, 'Product', value);
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup');
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value);
    }

    get WB_SalesAreaRow(): WB_SalesAreaRow {
        return getBelongsToProperty(this, 'SalesArea');
    }

    set WB_SalesAreaRow(value) {
        setBelongsToProperty(this, 'SalesArea', value);
    }

    get WB_AttributeTypeRow(): WB_AttributeTypeRow {
        return getBelongsToProperty(this, 'AttributeType');
    }

    set WB_AttributeTypeRow(value) {
        setBelongsToProperty(this, 'AttributeType', value);
    }

    get bManualInd(): boolean {
        return getBooleanIndicator(this, 'MANUAL_IND', false)
    }
}


export class WB_ProductGroupRow
    extends ESRecord
    implements RowIF.IwbProductGroup {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.MANUAL_IND = '1'
    }

    get WB_MasterDataSetRow(): WB_MasterDataSetRow {
        return getBelongsToProperty(this, 'MasterDataSet')
    }

    set WB_MasterDataSetRow(value) {
        setBelongsToProperty(this, 'MasterDataSet', value)
    }

    get WB_ProductTypeRow(): WB_ProductTypeRow {
        return getBelongsToProperty(this, 'ProductType')
    }

    set WB_ProductTypeRow(value) {
        setBelongsToProperty(this, 'ProductType', value)
    }

    get WB_ProductGroupRelationshipRows_Children(): WB_ProductGroupRelationshipRow[] {
        return getHasManyProperty(this, 'Children')
    }

    get WB_ProductGroupSalesAreaRows(): WB_ProductGroupSalesAreaRow[] {
        return getHasManyProperty(this, 'SalesAreas')
    }

    get WB_ProductGroupLogicalKeyRows(): WB_ProductGroupLogicalKeyRow[] {
        return getHasManyProperty(this, 'NodeLogicalKeys')
    }

    get WB_ProductAttributeRows(): WB_ProductAttributeRow[] {
        return getHasManyProperty(this, 'ProductGroupAttributes')
    }


    get WB_ProductGroupRelationshipRows_Parent(): WB_ProductGroupRelationshipRow[] {
        return getHasManyProperty(this, 'Parents')
    }

    get WB_ProductGroupAttributeRows(): WB_ProductGroupAttributeRow[] {
        return getHasManyProperty(this, 'ProductAttributes')
    }

    get WB_ProductGroupChildProductRows(): WB_FinishedProductRelationshipRow[] {
        return getHasManyProperty(this, 'ChildProduct')
    }

    get WB_ProductGroupExternalRelationshipRows(): WB_ProductGroupExternalRelationshipRow[] {
        return getHasManyProperty(this, 'Externals')
    }

    get WB_ProductGroupTagRelationshipRows(): WB_ProductGroupTagRelationshipRow[] {
        return getHasManyProperty(this, 'PrdGrpTags')
    }

    get WB_ProductGroupUOMRows(): WB_ProductGroupUOMRow[] {
        return getHasManyProperty(this, 'ProductGroupUOMs')
    }


    get cif(): RowIF.IwbProductGroup {
        return this
    }

    get bManualInd(): boolean {
        return getBooleanIndicator(this, 'MANUAL_IND', false)
    }

    get SearchText(): string {
        return (this.cif?.PRODUCT_GROUP_NAME || '') + ' ' + (this.cif?.PRODUCT_GROUP_ID || '')
    }

    get SalesAreas(): string {
        let salesAreas = _.join(_.map(
            _.filter(this.WB_ProductGroupSalesAreaRows, aSARow => aSARow.isActive), aRow => aRow.WB_SalesAreaRow.cif.SALESAREA_NAME), ",")
        return salesAreas
    }

}

export class WB_ProductGroupSalesAreaRow
    extends ESRecord
    implements RowIF.IwbProductGroupSalesArea {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbProductGroupSalesArea {
        return this
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup');
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value);
    }

    get WB_SalesAreaRow(): WB_SalesAreaRow {
        return getBelongsToProperty(this, 'SalesArea');
    }

    set WB_SalesAreaRow(value) {
        setBelongsToProperty(this, 'SalesArea', value);
    }

}

export class WB_ProductGroupLogicalKeyRow
    extends ESRecord
    implements RowIF.IwbProductGroupLogicalKey {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbProductGroupLogicalKey {
        return this
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup');
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value);
    }

}

export class WB_ProductGroupRelationshipRow
    extends ESRecord
    implements RowIF.IwbProductGroupRelationship {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.EFFECTIVE_START_DT = defaultRowValues.Min_Dt()
        this.cif.EFFECTIVE_END_DT = defaultRowValues.Max_Dt()
        this.cif.INTEGRATION_IND = defaultRowValues.Integration_Ind()
        this.cif.MANUAL_IND = "1"
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
    }

    get cif(): RowIF.IwbProductGroupRelationship {
        return this
    }

    get WB_ProductGroupRowParent(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'Parent');
    }

    set WB_ProductGroupRowParent(value) {
        setBelongsToProperty(this, 'Parent', value);
    }

    get WB_ProductGroupRowChild(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'Child');
    }

    set WB_ProductGroupRowChild(value) {
        setBelongsToProperty(this, 'Child', value);
    }


    get EffectiveStartDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_START_DT')
    }

    set EffectiveStartDt(value: Date) {
        setBWDateProperty(this, 'EffectiveStartDt', 'EFFECTIVE_START_DT', value)
    }

    get EffectiveEndDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_END_DT')
    }

    set EffectiveEndDt(value: Date) {
        setBWDateProperty(this, 'EffectiveEndDt', 'EFFECTIVE_END_DT', value)
    }
}

export class WB_ProductGroupTagRelationshipRow
    extends ESRecord
    implements RowIF.IwbProductGroupTagRelationship {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.EFFECTIVE_START_DT = defaultRowValues.Min_Dt()
        this.cif.EFFECTIVE_END_DT = defaultRowValues.Max_Dt()
    }

    get cif(): RowIF.IwbProductGroupTagRelationship {
        return this
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup');
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value);
    }

    get WB_TagRow(): WB_TagRow {
        return getBelongsToProperty(this, 'PrdGrpTag');
    }

    set WB_TagRow(value) {
        setBelongsToProperty(this, 'PrdGrpTag', value);
    }


    get EffectiveStartDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_START_DT')
    }

    set EffectiveStartDt(value: Date) {
        setBWDateProperty(this, 'EffectiveStartDt', 'EFFECTIVE_START_DT', value)
    }

    get EffectiveEndDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_END_DT')
    }

    set EffectiveEndDt(value: Date) {
        setBWDateProperty(this, 'EffectiveEndDt', 'EFFECTIVE_END_DT', value)
    }
}

export class WB_ProductGroupExternalRelationshipRow
    extends ESRecord
    implements RowIF.IwbProductGroupExternalRelationship {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup');
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value);
    }

    get cif(): RowIF.IwbProductGroupExternalRelationship {
        return this
    }
}


export class WB_ProductGroupAttributeRow
    extends ESRecord
    implements RowIF.IwbProductGroupAttribute {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbProductGroupAttribute {
        return this
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup');
    }
}


export class WB_ProductHierarchyRow
    extends ESRecord
    implements RowIF.IwbProductHierarchy {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.SOURCE_ID = 'WB'
        this.cif.INTEGRATION_IND = defaultRowValues.Integration_Ind()
        this.cif.DELETED_DT = defaultRowValues.Deleted_Dt()
        this.cif.MANUAL_IND = defaultRowValues.True_Ind()

    }

    get cif(): RowIF.IwbProductHierarchy {
        return this

    }

    get WB_MasterDataSetRow(): WB_MasterDataSetRow {
        return getBelongsToProperty(this, 'MasterDataSet')
    }

    set WB_MasterDataSetRow(value) {
        setBelongsToProperty(this, 'MasterDataSet', value)
    }


    get WB_ProductHierarchyLevelRows(): WB_ProductHierarchyLevelRow[] {
        return getHasManyProperty(this, 'ProductHierarchyLevel');
    }

    get WB_ProductHierarchySalesAreaRows(): WB_ProductHierarchySalesAreaRow[] {
        return getHasManyProperty(this, 'SalesAreas');
    }

    get bManual(): boolean {
        return (this.cif.MANUAL_IND == '1')
    }

}

export class WB_ProductHierarchySalesAreaRow
    extends ESRecord
    implements RowIF.IwbProductHierarchySalesArea {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbProductHierarchySalesArea {
        return this
    }

    set WB_ProductHierarchyRow(value) {
        setBelongsToProperty(this, 'ProductHierarchy', value)
    }

    get WB_ProductHierarchyRow(): WB_ProductHierarchyRow {
        return getBelongsToProperty(this, 'ProductHierarchy')
    }

    set WB_SalesAreaRow(value) {
        setBelongsToProperty(this, 'SalesArea', value)
    }

    get WB_SalesAreaRow(): WB_SalesAreaRow {
        return getBelongsToProperty(this, 'SalesArea')
    }

}


export class WB_ProductHierarchyLevelRow
    extends ESRecord
    implements RowIF.IwbProductHierarchyLevel {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbProductHierarchyLevel {
        return this
    }

    set WB_ProductHierarchyRow(value) {
        setBelongsToProperty(this, 'ProductHierarchy', value)
    }

    get WB_ProductHierarchyRow(): WB_ProductHierarchyRow {
        return getBelongsToProperty(this, 'ProductHierarchy')
    }

}

//
// Product BOM
export class WB_ProductBOMRow
    extends ESRecord
    implements RowIF.IwbProductBOM {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.EFFECTIVE_START_DT = defaultRowValues.Min_Dt()
        this.cif.EFFECTIVE_END_DT = defaultRowValues.Max_Dt()
    }

    set WB_ProductRow_Component(value) {
        setBelongsToProperty(this, 'ComponentProduct', value)
    }

    get WB_ProductRow_Component(): WB_FinishedProductRow {
        return getBelongsToProperty(this, 'ComponentProduct')
    }

    set WB_ProductRow(value) {
        setBelongsToProperty(this, 'Product', value)
    }

    get WB_ProductRow(): WB_FinishedProductRow {
        return getBelongsToProperty(this, 'Product')
    }

    set EffectiveStartDt(value: Date) {
        setBWDateProperty(this, 'EffectiveStartDt', 'EFFECTIVE_START_DT', value)
    }

    get EffectiveStartDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_START_DT')
    }

    set EffectiveEndDt(value: Date) {
        setBWDateProperty(this, 'EffectiveEndDt', 'EFFECTIVE_END_DT', value)
    }

    get EffectiveEndDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_END_DT')
    }

    get cif(): RowIF.IwbProductBOM {
        return this
    }
}

// Product BOM Components
export class WB_ProductBOMComponentRow
    extends ESRecord
    implements RowIF.IwbProductBOMComponent {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {

    }

    set WB_ProductRow_Component(value) {
        setBelongsToProperty(this, 'ComponentProduct', value)
    }

    get WB_ProductRow_Component(): WB_FinishedProductRow {
        return getBelongsToProperty(this, 'ComponentProduct')
    }

    set WB_ProductRow(value) {
        setHasOneProperty(this, 'Product', value)
    }

    get WB_ProductRow(): WB_FinishedProductRow {
        return getBelongsToProperty(this, 'Product')
    }

    set EffectiveStartDt(value: Date) {
        setBWDateProperty(this, 'EffectiveStartDt', 'EFFECTIVE_START_DT', value)
    }

    get EffectiveStartDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_START_DT')
    }

    set EffectiveEndDt(value: Date) {
        setBWDateProperty(this, 'EffectiveEndDt', 'EFFECTIVE_END_DT', value)
    }

    get EffectiveEndDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_END_DT')
    }

    get cif(): RowIF.IwbProductBOM {
        return this
    }
}

//
// Product UOM
export class WB_ProductUOMRow
    extends ESRecord
    implements RowIF.IwbProductUOM {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CONVERSION_FACTOR = 0
        this.cif.EFFECTIVE_START_DT = defaultRowValues.Min_Dt()
        this.cif.EFFECTIVE_END_DT = defaultRowValues.Max_Dt()
    }

    get cif(): RowIF.IwbProductUOM {
        return this
    }

    get WB_ProductRow(): WB_FinishedProductRow {
        return getBelongsToProperty(this, 'FinishedProduct');
    }

    set WB_ProductRow(value: WB_FinishedProductRow) {
        setBelongsToProperty(this, 'FinishedProduct', value);
    }

}

//
// Product Group UOM
export class WB_ProductGroupUOMRow
    extends ESRecord
    implements RowIF.IwbProductGroupUOM {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CONVERSION_FACTOR = 0
        this.cif.EFFECTIVE_START_DT = defaultRowValues.Min_Dt()
        this.cif.EFFECTIVE_END_DT = defaultRowValues.Max_Dt()
    }

    get cif(): RowIF.IwbProductGroupUOM {
        return this
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup');
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value);
    }

}

//
// UOM
export class WB_UOMRow
    extends ESRecord
    implements RowIF.IwbUOM {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbUOM {
        return this
    }
}

//
// Consumer Product

export class WB_ConsumerProductAlignmentRow
    extends ESRecord
    implements RowIF.IwbConsumerProductAlignment {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbConsumerProductAlignment {
        return this
    }
}

export class WB_ConsumerProductCustomerAlignmentRow
    extends ESRecord
    implements RowIF.IwbConsumerProductCustomerAlignment {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbConsumerProductCustomerAlignment {
        return this
    }
}


// Product Attribute Group

export class WB_ProductAttributeGroupRow
    extends ESRecord
    implements RowIF.IwbProductAttributeGroup {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbProductAttributeGroup {
        return this
    }

    get WB_ProductAttributeGroupRelationshipRows(): WB_ProductAttributeGroupRelationshipRow[] {
        return getHasManyProperty(this, 'ProductAttributes')
    }
}

export class WB_ProductAttributeGroupRelationshipRow
    extends ESRecord
    implements RowIF.IwbProductAttributeGroupRelationship {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbProductAttributeGroupRelationship {
        return this
    }

    get WB_ProductAttributeGroupRow(): WB_ProductAttributeGroupRow {
        return getBelongsToProperty(this, 'ProductAttributeGroup')
    }

    set WB_ProductAttributeGroupRow(value) {
        setBelongsToProperty(this, 'ProductAttributeGroup', value)
    }
}

//Product Attribute Map
export class WB_ProductAttributeMapRow
    extends ESRecord
    implements RowIF.IwbProductAttributeMap {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbProductAttributeMap {
        return this
    }

    get WB_ProductAttributeMapExternalRelationshipRows(): WB_ProductAttributeMapExternalRelationshipRow[] {
        return getHasManyProperty(this, 'ProdAttrMapExtRs')
    }

    get WB_ProductAttributeMapValueRelationshipRows(): WB_ProductAttributeMapValueRelationshipRow[] {
        return getHasManyProperty(this, 'ProdAttrMapValRs')
    }
}

export class WB_ProductAttributeMapExternalRelationshipRow
    extends ESRecord
    implements RowIF.IwbProductAttributeMapExternalRelationship {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbProductAttributeMapExternalRelationship {
        return this
    }

    get WB_ProductAttributeMapRow(): WB_ProductAttributeMapRow {
        return getBelongsToProperty(this, 'ProdAttrMap')
    }

    set WB_ProductAttributeMapRow(value) {
        setBelongsToProperty(this, 'ProdAttrMap', value)
    }
}

export class WB_ProductAttributeMapValueRelationshipRow
    extends ESRecord
    implements RowIF.IwbProductAttributeMapValueRelationship {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbProductAttributeMapValueRelationship {
        return this
    }

    get WB_ProductAttributeMapRow(): WB_ProductAttributeMapRow {
        return getBelongsToProperty(this, 'ProdAttrMap')
    }

    set WB_ProductAttributeMapRow(value) {
        setBelongsToProperty(this, 'ProdAttrMap', value)
    }
}

//
// Period

export class WB_PeriodHierarchyRow
    extends ESRecord
    implements RowIF.IwbPeriodHierarchy {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbPeriodHierarchy {
        return this
    }

    get WB_MasterDataSetRow(): WB_MasterDataSetRow {
        return getBelongsToProperty(this, 'MasterDataSet')
    }

    set WB_MasterDataSetRow(value: WB_MasterDataSetRow) {
        setBelongsToProperty(this, 'MasterDataSet', value)
    }

    get WB_PeriodHierarchyLevelRows(): WB_PeriodHierarchyLevelRow[] {
        return getHasManyProperty(this, 'PeriodHierarchyLevel');
    }

    get WB_PeriodHierarchyCompanyRelationshipRow(): WB_PeriodHierarchyCompanyRelationshipRow[] {
        return getHasManyProperty(this, 'PeriodHierarchyCompanyRelationship')
    }

    get bManualInd(): boolean {
        return getBooleanIndicator(this, 'MANUAL_IND')
    }

}

export class WB_PeriodHierarchyLevelRow
    extends ESRecord
    implements RowIF.IwbPeriodHierarchyLevel {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbPeriodHierarchyLevel {
        return this
    }
}

export class WB_PeriodRow
    extends ESRecord
    implements RowIF.IwbPeriod {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.PERIOD_START_DT = '19000101'
        this.cif.PERIOD_END_DT = defaultRowValues.Max_Dt();
        this.cif.MANUAL_IND = "1";
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }


    async afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this
        // Set the Defaults for the Domain Values
        let dbContext: PAdbContext = <any>self.dataStore()

        if (_.isEmpty(dbContext)) {
            return
        }

        self.setDefaults()
        let newKey: number = <any>(await dbContext.getNewId(self._mapper().name))
        let sNewId = TextUtils.padStart(newKey.toString(36), 12, '0').toUpperCase()
        self.cif.PERIOD_ID = sNewId
        self.cif.PERIOD_NAME = "New Period"
    }

    get cif(): RowIF.IwbPeriod {
        return this
    }

    get WB_MasterDataSetRow(): WB_MasterDataSetRow {
        return getBelongsToProperty(this, 'MasterDataSet')
    }

    set WB_MasterDataSetRow(value: WB_MasterDataSetRow) {
        setBelongsToProperty(this, 'MasterDataSet', value)
    }

    get WB_PeriodTypeRow(): WB_PeriodTypeRow {
        return getBelongsToProperty(this, 'PeriodType');
    }

    set WB_PeriodTypeRow(value: WB_PeriodTypeRow) {
        setBelongsToProperty(this, 'PeriodType', value)
    }

    get PeriodStartDt(): Date {
        return getBWDateProperty(this, 'PERIOD_START_DT')
    }

    set PeriodStartDt(value: Date) {
        setBWDateProperty(this, 'PeriodStartDt', 'PERIOD_START_DT', value)
    }

    get PeriodEndDt(): Date {
        return getBWDateProperty(this, 'PERIOD_END_DT')
    }

    set PeriodEndDt(value: Date) {
        setBWDateProperty(this, 'PeriodEndDt', 'PERIOD_END_DT', value)
    }

    get PeriodStartDtShortFormat() {
        if (!_.isDate(this.PeriodStartDt)) {
            return "-"
        } else {
            return (this.PeriodStartDt.getMonth() + 1) + '/' + this.PeriodStartDt.getDate()
        }
    }

    get PeriodEndDtShortFormat() {
        if (!_.isDate(this.PeriodEndDt)) {
            return "-"
        } else {
            return (this.PeriodEndDt.getMonth() + 1) + '/' + this.PeriodEndDt.getDate()
        }
    }

    get WB_PeriodAttributeRows(): WB_PeriodAttributeRow[] {
        return getHasManyProperty(this, 'PeriodAttributes')
    }

    get ExtendedPeriodStartDt(): Date {
        return getBWDateProperty(this, 'EXTENDED_PERIOD_START_DT')
    }

    get ExtendedPeriodEndDt(): Date {
        return getBWDateProperty(this, 'EXTENDED_PERIOD_END_DT')
    }

    get IsExtendedPeriod(): boolean {
        return this.cif.PERIOD_START_DT !== this.cif.EXTENDED_PERIOD_START_DT
        || this.cif.PERIOD_END_DT !== this.cif.EXTENDED_PERIOD_START_DT;
    }

    get WB_PeriodRelationshipRow_Parent(): WB_PeriodRelationshipRow[] {
        return getHasManyProperty(this, 'Parents')
    }


    get WB_PeriodCompanyRelationshipRow(): WB_PeriodCompanyRelationshipRow[] {
        return getHasManyProperty(this, 'PeriodCompanyRelationship')
    }

    get WB_PeriodRelationshipRow_Children(): WB_PeriodRelationshipRow[] {
        return getHasManyProperty(this, 'Children')
    }

    get WB_PeriodTagRelationshipRows(): WB_PeriodTagRelationshipRow[] {
        return getHasManyProperty(this, 'PeriodTags');
    }

    get bManualInd(): boolean {
        return getBooleanIndicator(this, 'MANUAL_IND')
    }

    get WB_SourceRow(): WB_SourceRow {
        return getBelongsToProperty(this, 'Source')
    }

    set WB_SourceRow(value: WB_SourceRow) {
        setBelongsToProperty(this, 'Source', value)
    }

}

export class WB_PeriodAttributeRow
    extends ESRecord
    implements RowIF.IwbPeriodAttribute {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbPeriodAttribute {
        return this
    }

    get WB_PeriodRow(): WB_PeriodRow {
        return getBelongsToProperty(this, 'Period');
    }

    set WB_PeriodRow(value) {
        setBelongsToProperty(this, 'Period', value);
    }

    get WB_SalesAreaRow(): WB_SalesAreaRow {
        return getBelongsToProperty(this, 'SalesArea');
    }

    set WB_SalesAreaRow(value) {
        setBelongsToProperty(this, 'SalesArea', value);
    }

    get WB_AttributeTypeRow(): WB_AttributeTypeRow {
        return getBelongsToProperty(this, 'AttributeType');
    }

    set WB_AttributeTypeRow(value) {
        setBelongsToProperty(this, 'AttributeType', value);
    }

}


export class WB_PeriodRelationshipRow
    extends ESRecord
    implements RowIF.IwbPeriodRelationship {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbPeriodRelationship {
        return this;
    }

    get WB_PeriodRowParent(): WB_PeriodRow {
        return getBelongsToProperty(this, 'Parent');
    }

    set WB_PeriodRowParent(value) {
        setBelongsToProperty(this, 'Parent', value);
    }

    get WB_PeriodRowChild(): WB_PeriodRow {
        return getBelongsToProperty(this, 'Child');
    }

    set WB_PeriodRowChild(value) {
        setBelongsToProperty(this, 'Child', value);
    }

}

export class WB_PeriodTagRelationshipRow
    extends ESRecord
    implements RowIF.IwbPeriodTagRelationship {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.EFFECTIVE_START_DT = defaultRowValues.Min_Dt()
        this.cif.EFFECTIVE_END_DT = defaultRowValues.Max_Dt()
    }

    get WB_PeriodRow(): WB_PeriodRow {
        return getBelongsToProperty(this, 'Period');
    }

    set WB_PeriodRow(value: WB_PeriodRow) {
        setBelongsToProperty(this, 'Period', value);
    }

    get WB_TagRow(): WB_TagRow {
        return getBelongsToProperty(this, 'Tag');
    }

    set WB_TagRow(value: WB_TagRow) {
        setBelongsToProperty(this, 'Tag', value)
    }

    get EffectiveStartDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_START_DT')
    }

    set EffectiveStartDt(value: Date) {
        setBWDateProperty(this, 'EffectiveStartDt', 'EFFECTIVE_START_DT', value)
    }

    get EffectiveEndDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_END_DT')
    }

    set EffectiveEndDt(value: Date) {
        setBWDateProperty(this, 'EffectiveEndDt', 'EFFECTIVE_END_DT', value)
    }

    get cif(): RowIF.IwbPeriodTagRelationship {
        return this
    }
}

export class WB_PeriodTypeRow
    extends ESRecord
    implements RowIF.IwbPeriodType {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.MANUAL_IND = "1";
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbPeriodType {
        return this
    }

    get WB_MasterDataSetRow(): WB_MasterDataSetRow {
        return getBelongsToProperty(this, 'MasterDataSet')
    }

    set WB_MasterDataSetRow(value: WB_MasterDataSetRow) {
        setBelongsToProperty(this, 'MasterDataSet', value)
    }


    get bManualInd(): boolean {
        return getBooleanIndicator(this, 'MANUAL_IND')
    }
}


export class WB_PeriodCompanyRelationshipRow
    extends ESRecord
    implements RowIF.IwbPeriodCompanyRelationship {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.MANUAL_IND = "1";
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbPeriodCompanyRelationship {
        return this
    }

    get WB_PeriodRow(): WB_PeriodRow {
        return getBelongsToProperty(this, 'Period')
    }

    set WB_PeriodRow(value: WB_PeriodRow) {
        setBelongsToProperty(this, 'Period', value)
    }

    get WB_CompanyRow(): WB_CompanyRow {
        return getBelongsToProperty(this, 'Company')
    }

    set WB_CompanyRow(value: WB_CompanyRow) {
        setBelongsToProperty(this, 'Company', value)
    }


    get bManualInd(): boolean {
        return getBooleanIndicator(this, 'MANUAL_IND')
    }
}

export class WB_PeriodHierarchyCompanyRelationshipRow
    extends ESRecord
    implements RowIF.IwbPeriodHierarchyCompanyRelationship {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.MANUAL_IND = "1";
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbPeriodHierarchyCompanyRelationship {
        return this
    }

    get WB_PeriodHierarchyRow(): WB_PeriodHierarchyRow {
        return getBelongsToProperty(this, 'PeriodHierarchy')
    }

    set WB_PeriodHierarchyRow(value: WB_PeriodHierarchyRow) {
        setBelongsToProperty(this, 'PeriodHierarchy', value)
    }

    get WB_CompanyRow(): WB_CompanyRow {
        return getBelongsToProperty(this, 'Company')
    }

    set WB_CompanyRow(value: WB_CompanyRow) {
        setBelongsToProperty(this, 'Company', value)
    }


    get bManualInd(): boolean {
        return getBooleanIndicator(this, 'MANUAL_IND')
    }
}

//
// Domain

export class WB_DomainRow
    extends ESRecord
    implements RowIF.IwbDomain {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    get WB_DomainItemRows(): WB_DomainItemRow[] {
        return getHasManyProperty(this, 'Items')
    }

    get WB_DomainTextRows(): WB_DomainTextRow[] {
        return getHasManyProperty(this, 'Texts')
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbDomain {
        return this
    }
}


// Custom Column

export class WB_CustomColumnRow
    extends ESRecord
    implements RowIF.IwbCustomColumn {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Deleted_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbCustomColumn {
        return this
    }
}


// Domain
export class WB_DomainTextRow
    extends ESRecord
    implements RowIF.IwbDomainText {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbDomainText {
        return this
    }
}

export class WB_DomainItemRow
    extends ESRecord
    implements RowIF.IwbDomainItem {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbDomainItem {
        return this
    }
}

export class WB_DomainItemTextRow
    extends ESRecord
    implements RowIF.IwbDomainItemText {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbDomainItemText {
        return this
    }
}


//
// Product Condition/ Condition Type

export class WB_ProductConditionRow
    extends ESRecord
    implements RowIF.IwbProductCondition {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        ///this.cif.EFFECTIVE_START_DT
        this.cif.EFFECTIVE_START_DT = defaultRowValues.Min_Dt()
        this.cif.EFFECTIVE_END_DT = defaultRowValues.Max_Dt()
    }

    get WB_ProductConditionTypeRow(): WB_ProductConditionTypeRow {
        return getBelongsToProperty(this, 'ProductConditionType');
    }

    set WB_ProductConditionTypeRow(value) {
        setBelongsToProperty(this, 'ProductConditionType', value);
    }


    get WB_CustomerRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Customer');
    }

    set WB_CustomerRow(value) {
        setBelongsToProperty(this, 'Customer', value);
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup');
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value);
    }

    get WB_FundTypeRow(): WB_FundTypeRow {
        return getBelongsToProperty(this, 'FundType');
    }

    set WB_FundTypeRow(value) {
        setBelongsToProperty(this, 'FundType', value);
    }

    get WB_ProductRow(): WB_FinishedProductRow {
        return getBelongsToProperty(this, 'Product');
    }

    set WB_ProductRow(value) {
        setBelongsToProperty(this, 'Product', value);
    }

    get EffectiveStartDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_START_DT')
    }

    set EffectiveStartDt(value: Date) {
        setBWDateProperty(this, 'EffectiveStartDt', 'EFFECTIVE_START_DT', value)
    }

    get EffectiveEndDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_END_DT')
    }

    set EffectiveEndDt(value: Date) {
        setBWDateProperty(this, 'EffectiveEndDt', 'EFFECTIVE_END_DT', value)
    }

    get cif(): RowIF.IwbProductCondition {
        return this
    }
}

export class WB_ProductConditionTypeRow
    extends ESRecord
    implements RowIF.IwbProductConditionType {
    constructor(props: any, opts: any) {
        super(props, opts);
        this.setupDependents("SALES_AREA_POLICY", ["SalesOrgPolicy", "DivisionPolicy", "DistribChannelPolicy"])
    }

    setDefaults(): void {
        this.cif.NUMBER_VALUE_MAX = 0
        this.cif.NUMBER_VALUE_MIN = 0
    }

    get cif(): RowIF.IwbProductConditionType {
        return this
    }

    get WB_MasterDataSetRow(): WB_MasterDataSetRow {
        return getBelongsToProperty(this, 'MasterDataSet')
    }

    set WB_MasterDataSetRow(value: WB_MasterDataSetRow) {
        setBelongsToProperty(this, 'MasterDataSet', value)
    }

    /**
     * Sets the SALESAREA_POLICY column based on the given dimension information
     * */
    setSalesAreaPolicy(bSalesOrg: boolean, bDivision: boolean, bDistribChannel: boolean) {
        if (bSalesOrg && bDivision && bDistribChannel) {
            this.cif.SALESAREA_POLICY = "SalesArea"
        } else if (!bSalesOrg && !bDivision && !bDistribChannel) {
            this.cif.SALESAREA_POLICY = "None"
        } else {
            this.cif.SALESAREA_POLICY = `${bSalesOrg ? "SalesOrg" : ""}${bDivision ? "Division" : ""}${bDistribChannel ? "DistribChannel" : ""}`
        }
    }

    get SalesOrgPolicy(): boolean {
        return this.cif.SALESAREA_POLICY.includes("SalesOrg") || this.cif.SALESAREA_POLICY == "SalesArea"
    }

    set SalesOrgPolicy(value: boolean) {
        this.setSalesAreaPolicy(value, this.DivisionPolicy, this.DistribChannelPolicy)
    }

    get DivisionPolicy(): boolean {
        return this.cif.SALESAREA_POLICY.includes("Division") || this.cif.SALESAREA_POLICY == "SalesArea"
    }

    set DivisionPolicy(value: boolean) {
        this.setSalesAreaPolicy(this.SalesOrgPolicy, value, this.DistribChannelPolicy)

    }

    get DistribChannelPolicy(): boolean {
        return this.cif.SALESAREA_POLICY.includes("DistribChannel") || this.cif.SALESAREA_POLICY == "SalesArea"
    }

    set DistribChannelPolicy(value: boolean) {
        this.setSalesAreaPolicy(this.SalesOrgPolicy, this.DivisionPolicy, value)
    }

    get WB_EntityCustomerTypeRow(): WB_EntityRow {
        return getBelongsToProperty(this, 'CustomerType');
    }

    set WB_EntityCustomerTypeRow(value: WB_EntityRow) {
        setBelongsToProperty(this, 'CustomerType', value);
    }

    get WB_EntityProductTypeRow(): WB_EntityRow {
        return getBelongsToProperty(this, 'ProductType');
    }

    set WB_EntityProductTypeRow(value: WB_EntityRow) {
        setBelongsToProperty(this, 'ProductType', value);
    }
}


//
// Pricing Group Assignment
export class WB_PricingGroupAssignmentRow
    extends ESRecord
    implements RowIF.IwbPricingGroupAssignment {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbPricingGroupAssignment {
        return this
    }
}

//
// Setting/ Setting Type
export class WB_SettingTypeRow
    extends ESRecord
    implements RowIF.IwbSettingType {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get WB_SettingRows(): WB_SettingRow[] {
        return getHasManyProperty(this, 'Settings')
    }

    get cif(): RowIF.IwbSettingType {
        return this
    }
}

export class WB_SettingRow
    extends ESRecord
    implements RowIF.IwbSetting {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.EFFECTIVE_START_DT = defaultRowValues.Min_Dt()
        this.cif.EFFECTIVE_END_DT = defaultRowValues.Max_Dt()
    }

    get WB_SettingTypeRow(): WB_SettingTypeRow {
        return getBelongsToProperty(this, 'SettingType');
    }

    set WB_SettingTypeRow(value) {
        setBelongsToProperty(this, 'SettingType', value);
    }


    get cif(): RowIF.IwbSetting {
        return this
    }
}


//
// Consumption Adjustment Product Groups/ Products
export class WB_ConsumptionProductGroupRow
    extends ESRecord
    implements RowIF.IwbConsumptionProductGroup {

    _DateRange: DateRangePropertyBW


    constructor(props: any, opts: any) {
        super(props, opts);

        this._DateRange = new DateRangePropertyBW(this, 'DateRange', 'START_DT', 'END_DT')

    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbConsumptionProductGroup {
        return this
    }

    get WB_CustomerRowPlanning(): WB_CustomerRow {
        return getBelongsToProperty(this, 'PlanningCustomer');
    }

    get WB_CustomerRowSource(): WB_CustomerRow {
        return getBelongsToProperty(this, 'SourceCustomer');
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup');
    }

    get DateRange(): DateRangePropertyBW {
        return this._DateRange
    }

    get WB_ConsumptionProductGroupRow_Prev(): WB_ConsumptionProductGroupRow {
        return getBelongsToProperty(this, 'Previous');
    }

    get WB_ConsumptionProductGroupRow_Next(): WB_ConsumptionProductGroupRow {
        return getBelongsToProperty(this, 'Next');
    }

    get WB_ConsumptionProductRows(): WB_ConsumptionProductRow[] {
        return getHasManyProperty(this, 'ConsProducts');
    }


}

export class WB_ConsumptionProductRow
    extends ESRecord
    implements RowIF.IwbConsumptionProduct {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbConsumptionProduct {
        return this
    }

    get WB_FinishedProductRow(): WB_FinishedProductRow {
        return getBelongsToProperty(this, 'Product');
    }

}

// Plan TYPE Row / PlanTypeEventType Row

export class WB_PlanTypeRow
    extends ESRecord
    implements RowIF.IwbPlanType {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    _ValidPeriod: DateRangePropertyBW

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Deleted_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.EVENTCALENDAR_SHOW_IND = '0'
        this.cif.BVP_SHOW_IND = '1'
        this.cif.VALID_FROM = defaultRowValues.Min_Dt()
        this.cif.VALID_THRU = defaultRowValues.Max_Dt()
        this.cif.HR_LAZYLOAD_PG_THRESHOLD = 100
        this._ValidPeriod = new DateRangePropertyBW(this, 'ValidPeriod', 'VALID_FROM', 'VALID_THRU')

    }

    get cif(): RowIF.IwbPlanType {
        return this
    }

    get bUseHyperRectangleInd(): boolean {
        return getBooleanIndicator(this, 'HYPERRECTANGLEUI_IND', false)
    }

    set bUseHyperRectangleInd(value: boolean) {
        setBooleanIndicator(this, 'bUseHyperRectangleInd', 'HYPERRECTANGLEUI_IND', value)
    }

    get bUseHyperRectangleLazyLoadingInd(): boolean {
        return getBooleanIndicator(this, 'HR_LAZYLOAD_IND', false)
    }

    set bUseHyperRectangleLazyLoadingInd(value: boolean) {
        setBooleanIndicator(this, 'bUseHyperRectangleLazyLoadingInd', 'HR_LAZYLOAD_IND', value)
    }

    get bManualInd(): boolean {
        return getBooleanIndicator(this, 'MANUAL_IND', false)
    }

    get bBVPShowInd(): boolean {
        return getBooleanIndicator(this, 'BVP_SHOW_IND', false)
    }

    set bBVPShowInd(value: boolean) {
        setBooleanIndicator(this, 'bBVPShowInd', 'BVP_SHOW_IND', value)
    }


    get ValidPeriod(): DateRangePropertyBW {
        return this._ValidPeriod
    }

    get ValidFrom(): Date {
        return getBWDateProperty(this, 'VALID_FROM')
    }

    set ValidFrom(value) {
        setBWDateProperty(this, 'ValidFrom', 'VALID_FROM', value)
    }

    get ValidThru(): Date {
        return getBWDateProperty(this, 'VALID_THRU')
    }

    set ValidThru(value) {
        setBWDateProperty(this, 'ValidThru', 'VALID_THRU', value)
    }

    get WB_PlanTypeEventTypeRows(): WB_PlanTypeEventTypeRow[] {
        return getHasManyProperty(this, 'EventTypes');
    }

    get WB_PeriodTypeRow(): WB_PeriodTypeRow {
        return getBelongsToProperty(this, 'PeriodType');
    }

    get WB_PeriodTypeMonthRow(): WB_PeriodTypeRow {
        return getBelongsToProperty(this, 'PeriodTypeMonth');
    }

    get WB_PlanTypeFundTypeRows(): WB_PlanTypeFundTypeRow[] {
        return getHasManyProperty(this, 'FundTypes')
    }

    get WB_BusinessUnitRow(): WB_BusinessUnitRow {
        return getBelongsToProperty(this, 'BusinessUnit');
    }

    get SVFTableOptions(): IHRTableModelOptions {
        let dflt: IHRTableModelOptions = {
            MetricPlacement: DimensionPlacement.OnRows,
            DimensionOptions: {},
            ColumnDimensionKeyOrder: [],
            RowDimensionKeyOrder: [],
            MetricOrder: [],
            PageByDimensionKeyOrder: [],
            PageByDimensionSelected: {},
            PageByMetricSelected: undefined,
            MetricUOMVisible: false
        }

        return <any>getJSONProperty(this, "SVF_TABLE_OPTIONS", dflt)
    }

    set SVFTableOptions(newValue: IHRTableModelOptions) {
        setJSONProperty(this, "SVFTableOptions", "SVF_TABLE_OPTIONS", newValue)
    }

    get SVFPerspectiveOptions(): ICubePerspectiveOptions {
        let dflt: ICubePerspectiveOptions = {
            Dimensions: {},
            MetricIds: []
        }

        return <any>getJSONProperty(this, "SVF_PERSPECTIVE_OPTIONS", dflt)
    }

    set SVFPerspectiveOptions(newValue: ICubePerspectiveOptions) {
        setJSONProperty(this, "SVFPerspectiveOptions", "SVF_PERSPECTIVE_OPTIONS", newValue)
    }

    get MetricTableOptions(): IHRTableModelOptions {
        let dflt: IHRTableModelOptions = {
            MetricPlacement: DimensionPlacement.OnRows,
            DimensionOptions: {},
            ColumnDimensionKeyOrder: [],
            RowDimensionKeyOrder: [],
            MetricOrder: [],
            PageByDimensionKeyOrder: [],
            PageByDimensionSelected: {},
            PageByMetricSelected: undefined,
            MetricUOMVisible: false
        }

        return <any>getJSONProperty(this, "METRIC_TABLE_OPTIONS", dflt)
    }

    set MetricTableOptions(newValue: IHRTableModelOptions) {
        setJSONProperty(this, "MetricTableOptions", "METRIC_TABLE_OPTIONS", newValue)
    }

    get MetricPerspectiveOptions(): ICubePerspectiveOptions {
        let dflt: ICubePerspectiveOptions = {
            Dimensions: {},
            MetricIds: []
        }

        return <any>getJSONProperty(this, "METRIC_PERSPECTIVE_OPTIONS", dflt)
    }

    set MetricPerspectiveOptions(newValue: ICubePerspectiveOptions) {
        setJSONProperty(this, "MetricPerspectiveOptions", "METRIC_PERSPECTIVE_OPTIONS", newValue)
    }

    get BVPTableOptions(): IHRTableModelOptions {
        let dflt: IHRTableModelOptions = {
            MetricPlacement: DimensionPlacement.OnRows,
            DimensionOptions: {},
            ColumnDimensionKeyOrder: [],
            RowDimensionKeyOrder: [],
            MetricOrder: [],
            PageByDimensionKeyOrder: [],
            PageByDimensionSelected: {},
            PageByMetricSelected: undefined,
            MetricUOMVisible: false
        }

        return <any>getJSONProperty(this, "BVP_TABLE_OPTIONS", dflt)
    }

    set BVPTableOptions(newValue: IHRTableModelOptions) {
        setJSONProperty(this, "BVPTableOptions", "BVP_TABLE_OPTIONS", newValue)
    }

    get BVPPerspectiveOptions(): ICubePerspectiveOptions {
        let dflt: ICubePerspectiveOptions = {
            Dimensions: {},
            MetricIds: []
        }

        return <any>getJSONProperty(this, "BVP_PERSPECTIVE_OPTIONS", dflt)
    }

    set BVPPerspectiveOptions(newValue: ICubePerspectiveOptions) {
        setJSONProperty(this, "BVPPerspectiveOptions", "BVP_PERSPECTIVE_OPTIONS", newValue)
    }

    get BVPMetricViewIds(): string[] {
        return _.filter(this.cif.BVPMETRICVIEWS.split(","), (a) => !_.isEmpty(a))
    }

    get SVFMetricViewIds(): string[] {
        return _.filter(this.cif.SVFMETRICVIEWS.split(","), (a) => !_.isEmpty(a))
    }

    get SummaryMetricViewIds(): string[] {
        return _.filter(this.cif.MTRCVIEWS.split(","), (a) => !_.isEmpty(a))
    }


}

export class WB_PlanTypeFundTypeRow
    extends ESRecord
    implements RowIF.IwbPlanTypeFundType {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.EFFECTIVE_START_DT = defaultRowValues.Min_Dt()
        this.cif.EFFECTIVE_END_DT = defaultRowValues.Max_Dt()
    }

    get cif(): RowIF.IwbPlanTypeFundType {
        return this
    }

    get WB_PlanTypeRow(): WB_PlanTypeRow {
        return getBelongsToProperty(this, 'PlanType');
    }

    set WB_PlanTypeRow(value) {
        setBelongsToProperty(this, 'PlanType', value);
    }

    get WB_FundTypeRow(): WB_FundTypeRow {
        return getBelongsToProperty(this, 'FundType');
    }

    set WB_FundTypeRow(value) {
        setBelongsToProperty(this, 'FundType', value);
    }

    set EffectiveStartDt(value: Date) {
        setBWDateProperty(this, 'EffectiveStartDt', 'EFFECTIVE_START_DT', value)
    }

    get EffectiveStartDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_START_DT')
    }

    set EffectiveEndDt(value: Date) {
        setBWDateProperty(this, 'EffectiveEndDt', 'EFFECTIVE_END_DT', value)
    }

    get EffectiveEndDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_END_DT')
    }
}

export class WB_PlanTypeEventTypeRow
    extends ESRecord
    implements RowIF.IwbPlanTypeEventType {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbPlanTypeEventType {
        return this
    }

    get WB_PlanTypeRow(): WB_PlanTypeRow {
        return getBelongsToProperty(this, 'PlanType');
    }

    set WB_PlanTypeRow(value) {
        setBelongsToProperty(this, 'PlanType', value);
    }


    get WB_EventTypeRow(): WB_EventTypeRow {
        return getBelongsToProperty(this, 'EventType');
    }

    set WB_EventTypeRow(value) {
        setBelongsToProperty(this, 'EventType', value);
    }


    set EffectiveStartDt(value: Date) {
        setBWDateProperty(this, 'EffectiveStartDt', 'EFFECTIVE_START_DT', value)
    }

    get EffectiveStartDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_START_DT')
    }

    set EffectiveEndDt(value: Date) {
        setBWDateProperty(this, 'EffectiveEndDt', 'EFFECTIVE_END_DT', value)
    }

    get EffectiveEndDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_END_DT')
    }
}

// Spend Allocation Rule
export class WB_SpendAllocationRuleRow
    extends ESRecord
    implements RowIF.IwbSpendAllocationRule {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get WB_SpendAllocationRuleItemRows(): WB_SpendAllocationRuleItemRow[] {
        return getHasManyProperty(this, 'Items')
    }

    get cif(): RowIF.IwbSpendAllocationRule {
        return this
    }
}

export class WB_SpendAllocationRuleItemRow
    extends ESRecord
    implements RowIF.IwbSpendAllocationRuleItem {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get WB_SpendAllocationRuleRow(): WB_SpendAllocationRuleRow {
        return getBelongsToProperty(this, 'SpendAllocationRule')
    }

    get cif(): RowIF.IwbSpendAllocationRuleItem {
        return this
    }
}

// Spend Calc Method Rule
export class WB_SpendMethodRuleRow
    extends ESRecord
    implements RowIF.IwbSpendMethodRule {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get WB_CustomerRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Customer')
    }

    get cif(): RowIF.IwbSpendMethodRule {
        return this
    }
}


//
// Meta
export class WB_MetaRow
    extends ESRecord
    implements RowIF.IwbMeta {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.MANUAL_IND = "1"
        this.cif.META_ID = "New Meta Id"
        this.cif.META_NAME = "New Meta"
        this.cif.WB_META_TYPE_ID = "NA"
        this.cif.META_SORT_ID = "0"
        this.cif.TPM_META_ROW_ID = "-"
        this.cif.SOURCE_ID = "WB"
        this.cif.META_TYPE_ID = "NA"
        this.cif.INTEGRATION_IND = defaultRowValues.Integration_Ind()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Deleted_Dt()
    }

    get cif(): RowIF.IwbMeta {
        return this
    }

    get WB_MetaTagRows(): WB_MetaTagRow[] {
        return getHasManyProperty(this, 'Tags')
    }

    get WB_MetaTextRows(): WB_MetaTextRow[] {
        return getHasManyProperty(this, 'Texts')
    }

    get WB_MasterDataSetRow(): WB_MasterDataSetRow {
        return getBelongsToProperty(this, 'MasterDataSet')
    }

    set WB_MasterDataSetRow(value: WB_MasterDataSetRow) {
        setBelongsToProperty(this, 'MasterDataSet', value)
    }
}

export class WB_MetaTextRow
    extends ESRecord
    implements RowIF.IwbMetaText {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbMetaText {
        return this
    }

    get WB_MetaRow(): WB_MetaRow {
        return getBelongsToProperty(this, 'Meta')
    }

    set WB_MetaRow(value: WB_MetaRow) {
        setBelongsToProperty(this, 'Meta', value)
    }
}

export class WB_MetaTagRow
    extends ESRecord
    implements RowIF.IwbMetaTag {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbMetaTag {
        return this
    }

}


//
// Tag

export class WB_TagRow
    extends ESRecord
    implements RowIF.IwbTag {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this
        return new Promise<void>((resolve, error) => {

            // Set the Defaults for the Domain Values
            let dbContext: PAdbContext = <any>self.dataStore()

            if (_.isEmpty(dbContext)) {
                resolve()
                return
            }

            async function setAsyncDefaults() {
                self.setDefaults()
                let newKey: number = <any>(await dbContext.getNewId(self._mapper().name))
                let sNewId = TextUtils.padStart(newKey.toString(36), 12, '0').toUpperCase()
                self.cif.TAG_ID = sNewId
                self.cif.TAG_NAME = "Unnamed Tag"
                self.cif.TAG_TYPE = "Tag"
                resolve()
            }

            setAsyncDefaults()
        })
    }

    get WB_TagRowParent(): WB_TagSourceRow {
        return getBelongsToProperty(this, 'Source');
    }

    get cif(): RowIF.IwbTag {
        return this
    }

    get TagGroup(): WB_TagRelationshipRow {
        let parents: WB_TagRelationshipRow[] = this.WB_TagRelationshipRows_Parent

        let tagGrpParents = _.filter(parents,
            (aParent: WB_TagRelationshipRow) => aParent.isActive && aParent.WB_TagRowParent.cif.TAG_TYPE == "TagGroup")

        return _.first(tagGrpParents)
    }

    get WB_TagRelationshipRows_Children(): WB_TagRelationshipRow[] {
        return getHasManyProperty(this, 'Children')
    }

    get WB_TagRelationshipRows_Parent(): WB_TagRelationshipRow[] {
        return getHasManyProperty(this, 'Parent')
    }

    get WB_TagTextRows(): WB_TagTextRow[] {
        return getHasManyProperty(this, 'Texts')
    }

    get WB_TagMetaRows(): WB_MetaTagRow[] {
        return getHasManyProperty(this, 'Metas')
    }

    get WB_TagRuleRows(): WB_TagRuleRow[] {
        return getHasManyProperty(this, 'TagRules')
    }

    get TagChildrenSorted(): WB_TagRow[] {
        let arrTags = _.map(_.filter(this.WB_TagRelationshipRows_Children,
                (a) => a.isActive && a.WB_TagRowChild),
            (b: WB_TagRelationshipRow) => b.WB_TagRowChild)

        return _.sortBy(arrTags, ['TAG_SORT', 'TAG_NAME'])
    }

    get WB_TagSourceRow(): WB_TagSourceRow {
        return getBelongsToProperty(this, 'TagSource');
    }
}

export class WB_TagSourceRow
    extends ESRecord
    implements RowIF.IwbTagSource {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbTagSource {
        return this;
    }

    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    set CreatedDtTs(value: Date) {
        setBWDateTsProperty(this, "CreatedDtTs", 'CREATED_DTTS', value);
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    set ModifiedDtTs(value: Date) {
        setBWDateTsProperty(this, "ModifiedDtTs", 'MODIFIED_DTTS', value);
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

    set DeletedDt(value: Date) {
        setBWDateProperty(this, 'DeletedDt', 'DELETED_DT', value)
    }

}


export class WB_TagTextRow
    extends ESRecord
    implements RowIF.IwbTagText {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbTagText {
        return this
    }
}

export class WB_TagRelationshipRow
    extends ESRecord
    implements RowIF.IwbTagRelationship {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get WB_TagRowParent(): WB_TagRow {
        return getBelongsToProperty(this, 'Parent');
    }

    get WB_TagRowChild(): WB_TagRow {
        return getBelongsToProperty(this, 'Child');
    }

    get WB_ModelRow(): WB_ModelRow {
        return getBelongsToProperty(this, 'Model');
    }

    get cif(): RowIF.IwbTagRelationship {
        return this
    }
}

export class WB_TagMetricRow
    extends ESRecord
    implements RowIF.IwbTagMetric {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbTagMetric {
        return this
    }
}


export class WB_TagFunctionRow
    extends ESRecord
    implements RowIF.IwbTagFunction {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbTagFunction {
        return this;
    }

    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    set CreatedDtTs(value: Date) {
        setBWDateTsProperty(this, "CreatedDtTs", 'CREATED_DTTS', value);
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    set ModifiedDtTs(value: Date) {
        setBWDateTsProperty(this, "ModifiedDtTs", 'MODIFIED_DTTS', value);
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

    set DeletedDt(value: Date) {
        setBWDateProperty(this, 'DeletedDt', 'DELETED_DT', value)
    }

    get WB_TagFunctionParamRows(): WB_TagFunctionParamRow[] {
        return getHasManyProperty(this, 'TagFunctionParam')
    }

}

export class WB_TagRuleRow
    extends ESRecord
    implements RowIF.IwbTagRule {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbTagRule {
        return this;
    }

    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    set CreatedDtTs(value: Date) {
        setBWDateTsProperty(this, "CreatedDtTs", 'CREATED_DTTS', value);
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    set ModifiedDtTs(value: Date) {
        setBWDateTsProperty(this, "ModifiedDtTs", 'MODIFIED_DTTS', value);
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

    set DeletedDt(value: Date) {
        setBWDateProperty(this, 'DeletedDt', 'DELETED_DT', value)
    }

    get WB_TagFunctionRow(): WB_TagFunctionRow {
        return getBelongsToProperty(this, 'TagFunction')
    }

    set WB_TagFunctionRow(value) {
        setBelongsToProperty(this, 'TagFunction', value)
    }

    get WB_TagRow(): WB_TagRow {
        return getBelongsToProperty(this, 'Tag')
    }

    set WB_TagRow(value) {
        setBelongsToProperty(this, 'Tag', value)
    }

    get WB_TagRuleParamRows(): WB_TagRuleParamRow[] {
        return getHasManyProperty(this, 'TagRuleParam')
    }
}

export class WB_TagFunctionParamRow
    extends ESRecord
    implements RowIF.IwbTagFunctionParam {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbTagFunctionParam {
        return this;
    }

    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    set CreatedDtTs(value: Date) {
        setBWDateTsProperty(this, "CreatedDtTs", 'CREATED_DTTS', value);
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    set ModifiedDtTs(value: Date) {
        setBWDateTsProperty(this, "ModifiedDtTs", 'MODIFIED_DTTS', value);
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

    set DeletedDt(value: Date) {
        setBWDateProperty(this, 'DeletedDt', 'DELETED_DT', value)
    }

    get WB_TagFunctionRow(): WB_TagFunctionRow {
        return getBelongsToProperty(this, 'TagFunction')
    }

    set WB_TagFunctionRow(value) {
        setBelongsToProperty(this, 'TagFunction', value)
    }

}

export class WB_TagRuleParamRow
    extends ESRecord
    implements RowIF.IwbTagRuleParam {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbTagRuleParam {
        return this;
    }

    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    set CreatedDtTs(value: Date) {
        setBWDateTsProperty(this, 'CreatedDtTs', 'CREATED_DTTS', value)
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    set ModifiedDtTs(value: Date) {
        setBWDateTsProperty(this, 'ModifiedDtTs', 'MODIFIED_DTTS', value)
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

    set DeletedDt(value: Date) {
        setBWDateProperty(this, 'DeletedDt', 'DELETED_DT', value)
    }

    get WB_TagRuleRow(): WB_TagRuleRow {
        return getBelongsToProperty(this, 'TagRule')
    }

    set WB_TagRuleRow(value: WB_TagRuleRow) {
        setBelongsToProperty(this, 'TagRule', value)
    }

    get WB_TagFunctionParam(): WB_TagFunctionParamRow {
        return getBelongsToProperty(this, 'TagFunctionParam')
    }

    set WB_TagFunctionParam(value: WB_TagFunctionParamRow) {
        setBelongsToProperty(this, 'TagFunctionParam', value)
    }
}


// Metrics
export class WB_MetricRow
    extends ESRecord
    implements RowIF.IwbMetric {

    constructor(props: any, opts: any) {
        super(props, opts);
        this.setupDependents("Metric_ROI", ["CNSMP_INCR_PRFTCNTRB", "CNSMP_EDLP_PRFTCNTRB", "SPEND_TOTAL"])
        this.setupDependents("Metric_ROI_Previous", ["CNSMP_INCR_PRFTCNTRB", "CNSMP_EDLP_PRFTCNTRB", "SPEND_TOTAL"])
        this.setupDependents("Metric_CustomerProfit", ["CNSMP_TOTAL_RTLSLS", "CNSMP_TOTAL_LISTSLS", "SPEND_TOTAL"])
        this.setupDependents("Metric_CustomerProfit_Previous", ["CNSMP_TOTAL_RTLSLS", "CNSMP_TOTAL_LISTSLS", "SPEND_TOTAL"])
        this.setupDependents("Metric_CustomerMargin", ["Metric_CustomerProfit", "CNSMP_TOTAL_RTLSLS",])
        this.setupDependents("Metric_CustomerMargin_Previous", ["Metric_CustomerProfit", "CNSMP_TOTAL_RTLSLS"])
        this.setupDependents("Metric_FeatureDisplay_Previous", ["MERCH_ACV_D", "MERCH_FEATUREDISPLAY_ACV_N"])
        this.setupDependents("Metric_FeatureDisplay", ["MERCH_ACV_D", "MERCH_FEATUREDISPLAY_ACV_N"])
        this.setupDependents("Metric_Featurelay_Previous", ["MERCH_ACV_D", "MERCH_FEATUREONLY_ACV_N"])
        this.setupDependents("Metric_Feature", ["MERCH_ACV_D", "MERCH_FEATUREONLY_ACV_N"])
        this.setupDependents("Metric_Display_Previous", ["MERCH_ACV_D", "MERCH_DISPLAYONLY_ACV_N"])
        this.setupDependents("CNSMP_TOTAL_RTLSLS_Previous", ["CNSMP_TOTAL_RTLSLS"])
        this.setupDependents("SPEMD_TOTAL_Previous", ["SPEND_TOTAL"])
        this.setupDependents("CNSMP_EDLP_PRFTCNTRB_Previous", ["CNSMP_EDLP_PRFTCNTRB"])
        this.setupDependents("CNSMP_INCR_PRFTCNTRB_Previous", ["CNSMP_INCR_PRFTCNTRB"])
        this.setupDependents("SHIPMENT_UNITS_Previous", ["SHIPMENT_UNITS"])
        this.setupDependents("CNSMP_TOTAL_UNITS_Previous", ["CNSMP_TOTAL_UNITS"])
        this.setupDependents("LIFT_PERCENT_Previous", ["CNSMP_INCR_UNITS", "CNSMP_BASE_UNITS"])
        this.setupDependents("LIFT_PERCENT", ["CNSMP_INCR_UNITS", "CNSMP_BASE_UNITS"])
        this.setupDependents("CNSMP_INCR_LISTSLS_Previous", ["CNSMP_INCR_LISTSLS"])
        this.setupDependents("CNSMP_INCR_UNITS_Previous", ["CNSMP_INCR_UNITS"])
        this.setupDependents("CNSMP_EDLP_UNITS_Previous", ["CNSMP_EDLP_UNITS"])
        this.setupDependents("SHIPMENT_ORDER_QTY_Previous", ["SHIPMENT_ORDER_QTY", "RETURN_ORDER_QTY"])
        this.setupDependents("SHIPMENT_ORDER_QTY_CALC", ["SHIPMENT_ORDER_QTY", "RETURN_ORDER_QTY"])
        this.setupDependents("CONSUMER_DISCOUNT", ["CNSMP_TOTAL_RTLSLS", "CNSMP_TOTAL_LISTSLS", "CNSMP_TOTAL_UNITS"])
        this.setupDependents("TOTAL_DISCOUNT", ["CNSMP_TOTAL_RTLSLS", "CNSMP_TOTAL_LISTSLS"])
        this.setupDependents("CONSUMPTION_UNITS_LIFT", ["CNSMP_INCR_UNITS", "CNSMP_BASE_UNITS"])
        this.setupDependents("RETAIL_SALES_LIFT", ["CNSMP_TOTAL_RTLSLS", "CNSMP_BASE_RTLSLS"])
        this.setupDependents("SPEND_PA_LE_Previous", ["SPEND_PA_LE"])
    }

    setDefaults(): void {

        var Metrics: RowIF.IwbMetric = this;
        Metrics.MODIFIED_DT = defaultRowValues.Modified_Dt();
        Metrics.INTEGRATION_IND = defaultRowValues.Integration_Ind()
        Metrics.DELETED_IND = defaultRowValues.Deleted_Ind()
        Metrics.DELETED_DT = defaultRowValues.Deleted_Dt()
        Metrics.WB_EVT_ID = 0
        Metrics.WB_PLAN_ID = 0
        Metrics.WB_PRDGRP_ID = 0
        Metrics.REFERENCE_ID = 0
        Metrics.REFERENCE_ID_UI = 'NA'
        Metrics.REFERENCE_LEVEL_ID = 'NA'
        Metrics.METRIC_TYPE_ID = 'NA'
        Metrics.CNSMP_BASE_UNITS = 0
        Metrics.CNSMP_BASE_WT = 0
        Metrics.CNSMP_BASE_STAT = 0
        Metrics.CNSMP_BASE_LISTSLS = 0
        Metrics.CNSMP_BASE_RTLSLS = 0
        Metrics.CNSMP_BASE_PRFTCNTRB = 0
        Metrics.CNSMP_EDLP_UNITS = 0
        Metrics.CNSMP_EDLP_WT = 0
        Metrics.CNSMP_EDLP_STAT = 0
        Metrics.CNSMP_EDLP_LISTSLS = 0
        Metrics.CNSMP_EDLP_RTLSLS = 0
        Metrics.CNSMP_EDLP_PRFTCNTRB = 0
        Metrics.CNSMP_INCR_UNITS = 0
        Metrics.CNSMP_INCR_WT = 0
        Metrics.CNSMP_INCR_STAT = 0
        Metrics.CNSMP_INCR_LISTSLS = 0
        Metrics.CNSMP_INCR_RTLSLS = 0
        Metrics.CNSMP_INCR_PRFTCNTRB = 0
        Metrics.CNSMP_TOTAL_UNITS = 0
        Metrics.CNSMP_TOTAL_WT = 0
        Metrics.CNSMP_TOTAL_STAT = 0
        Metrics.CNSMP_TOTAL_LISTSLS = 0
        Metrics.CNSMP_TOTAL_RTLSLS = 0
        Metrics.CNSMP_TOTAL_PRFTCNTRB = 0
        Metrics.CNSMP_PROMO_UNITS = 0
        Metrics.CNSMP_PROMO_WT = 0
        Metrics.CNSMP_PROMO_STAT = 0
        Metrics.CNSMP_PROMO_LISTSLS = 0
        Metrics.CNSMP_PROMO_RTLSLS = 0
        Metrics.CNSMP_PROMO_PRFTCNTRB = 0
        Metrics.CNSMP_NONPROMO_UNITS = 0
        Metrics.CNSMP_NONPROMO_WT = 0
        Metrics.CNSMP_NONPROMO_STAT = 0
        Metrics.CNSMP_NONPROMO_LISTSLS = 0
        Metrics.CNSMP_NONPROMO_RTLSLS = 0
        Metrics.CNSMP_NONPROMO_PRFTCNTRB = 0
        Metrics.CNSMP_ADJ_INCR_UNITS = 0
        Metrics.CNSMP_ADJ_INCR_WT = 0
        Metrics.CNSMP_ADJ_INCR_STAT = 0
        Metrics.CNSMP_ADJ_INCR_LISTSLS = 0
        Metrics.CNSMP_ADJ_INCR_RTLSLS = 0
        Metrics.CNSMP_ADJ_INCR_PRFTCNTRB = 0
        Metrics.MERCH_FEATUREONLY_ACV_N = 0
        Metrics.MERCH_DISPLAYONLY_ACV_N = 0
        Metrics.MERCH_FEATUREDISPLAY_ACV_N = 0
        Metrics.MERCH_TPRONLY_ACV_N = 0
        Metrics.MERCH_PROMOTED_ACV_N = 0
        Metrics.MERCH_DIST_ACV_N = 0
        Metrics.MERCH_ACV_D = 0
        Metrics.MERCH_FEATUREONLY_UNITS = 0
        Metrics.MERCH_DISPLAYONLY_UNITS = 0
        Metrics.MERCH_FEATUREDISPLAY_UNITS = 0
        Metrics.MERCH_TPRONLY_UNITS = 0
        Metrics.MERCH_PROMOTED_UNITS = 0
        Metrics.SHIPMENT_UNITS = 0
        Metrics.SHIPMENT_WT = 0
        Metrics.SHIPMENT_STAT = 0
        Metrics.SHIPMENT_LISTSLS = 0
        Metrics.SHIPMENT_PRFTCNTRB = 0
        Metrics.SPEND_TOTAL = 0
        Metrics.SPEND_PA_LE = 0
        Metrics.SPEND_TRADE = 0
        Metrics.SPEND_ALLIN = 0
        Metrics.SPEND_CONSUMERDISCOUNT = 0
        Metrics.SPEND_SHOPPER_MARKETING = 0
        Metrics.SPEND_OTHER_WB = 0
        Metrics.SPEND_RATEBYCNSMP = 0
        Metrics.SPEND_RATEBYSHIPMENT = 0
        Metrics.SPEND_LIABILITY_QTY_OVRD = 0
        Metrics.LIST_PRICE = 0
        Metrics.LIFT_BYUNITS_PCNT = 0
        Metrics.LIFT_BYWT_PCNT = 0
        Metrics.VCM_CNSMP_INCR_PCNT = 0
        Metrics.VCM_CNSMP_PCNT = 0
        Metrics.VCM_SHIP_PCNT = 0
        Metrics.TRADETOSALES_CNSMP_PCNT = 0
        Metrics.TRADETOSALES_SHIP_PCNT = 0
        Metrics.RETAILER_TRUE_BASE_PRICE = 0
        Metrics.RETAILER_BASE_PRICE = 0
        Metrics.RETAILER_PROMOTED_PRICE = 0
        Metrics.RETAILER_AVG_PRICE = 0
        Metrics.RETAILER_MARGIN_EVERYDAY_PCNT = 0
        Metrics.RETAILER_MARGIN_PROMOTED_PCNT = 0
        Metrics.CNSMP_BASE_NETLISTSLS = 0
        Metrics.Name = 0;
        Metrics.MODIFIED_DT = defaultRowValues.Created_Dt();
        Metrics.INTEGRATION_IND = "";
        Metrics.DELETED_IND = "0";
        Metrics.DELETED_DT = defaultRowValues.Created_Dt();
        Metrics.WB_PLAN_ID = 0;
        Metrics.CNSMP_BASE_NETLISTSLS = 0;
        Metrics.CNSMP_EDLP_NETLISTSLS = 0;
        Metrics.CNSMP_INCR_NETLISTSLS = 0;
        Metrics.CNSMP_TOTAL_NETLISTSLS = 0;
        Metrics.CNSMP_PROMO_NETLISTSLS = 0;
        Metrics.CNSMP_NONPROMO_NETLISTSLS = 0;
        Metrics.CNSMP_ADJ_INCR_NETLISTSLS = 0;
        Metrics.SHIPMENT_NETLISTSLS = 0;
        Metrics.RETURN_UNITS = 0;
        Metrics.RETURN_WT = 0;
        Metrics.RETURN_STAT = 0;
        Metrics.RETURN_LISTSLS = 0;
        Metrics.RETURN_NETLISTSLS = 0;
        Metrics.RETURN_PRFTCNTRB = 0;
        Metrics.WB_SNAPSHOT_ID = 0;


    }

    get cif(): RowIF.IwbMetric {
        return this
    }


    get Metric_ROI(): number {
        var incrProfit = this.cif.CNSMP_INCR_PRFTCNTRB
        var edlpProfit = this.cif.CNSMP_EDLP_PRFTCNTRB
        var totalConsumption = incrProfit + edlpProfit
        var spendTotal = this.cif.SPEND_TOTAL
        var netProfit = totalConsumption - spendTotal
        if (spendTotal > 0)
            var ROI = (netProfit / spendTotal)
        else
            var ROI = 0
        return ROI
    }

    get Metric_ROI_Previous(): number {
        var previous = (<any>this).previous()
        var incrProfitPrev = previous.CNSMP_INCR_PRFTCNTRB
        var edlpProfitPrev = previous.CNSMP_EDLP_PRFTCNTRB
        var totalConsumptionPrev = incrProfitPrev + edlpProfitPrev
        var spendTotalPrev = previous.SPEND_TOTAL
        var netProfitPrev = totalConsumptionPrev - spendTotalPrev

        if (spendTotalPrev > 0)
            var ROIPrev = (netProfitPrev / spendTotalPrev)
        else
            var ROIPrev = 0

        return isNaN(ROIPrev) ? 0 : ROIPrev
    }

    get LIFT_PERCENT_Previous(): number {
        var previous = (<any>this).previous()
        var Lift_units = previous.CNSMP_INCR_UNITS
        var Base_units = previous.CNSMP_BASE_UNITS

        if (Base_units !== 0)
            var Lift_PCT_Previous = (Lift_units / Base_units)
        else
            var Lift_PCT_Previous = 0

        return isNaN(Lift_PCT_Previous) ? 0 : Lift_PCT_Previous
    }

    get LIFT_PERCENT(): number {
        var Lift_units = this.cif.CNSMP_INCR_UNITS
        var Base_units = this.cif.CNSMP_BASE_UNITS

        if (Base_units !== 0)
            var Lift_PCT = (Lift_units / Base_units)
        else
            var Lift_PCT = 0

        return isNaN(Lift_PCT) ? 0 : Lift_PCT
    }

    get Metric_CustomerProfit(): number {
        var cnsmpTotalSales = this.cif.CNSMP_TOTAL_RTLSLS
        var cnsmpTotalNetListSales = this.cif.CNSMP_TOTAL_NETLISTSLS
        var spendTotal = this.cif.SPEND_TOTAL
        var customerProfit = (cnsmpTotalSales - cnsmpTotalNetListSales) + spendTotal

        return isNaN(customerProfit) ? 0 : customerProfit
    }

    get Metric_CustomerProfit_Previous(): number {
        var previous = (<any>this).previous()
        var cnsmpTotalSales = previous.CNSMP_TOTAL_RTLSLS
        var cnsmpTotalNetListSales = previous.CNSMP_TOTAL_NETLISTSLS
        var spendTotal = previous.SPEND_TOTAL
        var customerProfit = (cnsmpTotalSales - cnsmpTotalNetListSales) + spendTotal

        return isNaN(customerProfit) ? 0 : customerProfit

    }

    get Metric_CustomerMargin(): number {
        var custProfit = this.Metric_CustomerProfit
        var cnsmpTotalSales = this.cif.CNSMP_TOTAL_RTLSLS

        if (cnsmpTotalSales > 0)
            var customerMargin = (custProfit / cnsmpTotalSales)
        else
            var customerMargin = 0

        return isNaN(customerMargin) ? 0 : customerMargin
    }

    get Metric_CustomerMargin_Previous(): number {
        var previous = (<any>this).previous()
        var custProfit = this.Metric_CustomerProfit_Previous
        var cnsmpTotalSales = previous.CNSMP_TOTAL_RTLSLS

        if (cnsmpTotalSales > 0)
            var customerMargin = (custProfit / cnsmpTotalSales)
        else
            var customerMargin = 0

        return isNaN(customerMargin) ? 0 : customerMargin
    }

    get Metric_FeatureDisplay_Previous(): number {
        var previous = (<any>this).previous()
        var merchFDD = previous.MERCH_ACV_D
        var merchFDN = previous.MERCH_FEATUREDISPLAY_ACV_N
        if (merchFDD > 0)
            var metricFD = (merchFDN / merchFDD)
        else
            var metricFD = 0

        return isNaN(metricFD) ? 0 : metricFD
    }

    get Metric_FeatureDisplay(): number {
        var merchFDD = this.cif.MERCH_ACV_D
        var merchFDN = this.cif.MERCH_FEATUREDISPLAY_ACV_N

        if (merchFDD > 0)
            var metricFD = (merchFDN / merchFDD)
        else
            var metricFD = 0

        return isNaN(metricFD) ? 0 : metricFD
    }

    get Metric_Feature_Previous(): number {
        var previous = (<any>this).previous()
        var merchFD = previous.MERCH_ACV_D
        var merchFN = previous.MERCH_FEATUREONLY_ACV_N

        if (merchFD > 0)
            var metricF = (merchFN / merchFD)
        else
            var metricF = 0

        return isNaN(metricF) ? 0 : metricF
    }

    get Metric_Feature(): number {
        var merchFD = this.cif.MERCH_ACV_D
        var merchFN = this.cif.MERCH_FEATUREONLY_ACV_N

        if (merchFD > 0)
            var metricF = (merchFN / merchFD)
        else
            var metricF = 0

        return isNaN(metricF) ? 0 : metricF
    }

    get Metric_Display_Previous(): number {
        var previous = (<any>this).previous()
        var merchDD = previous.MERCH_ACV_D
        var merchDN = previous.MERCH_DISPLAYONLY_ACV_N

        if (merchDD > 0)
            var metricD = (merchDN / merchDD)
        else
            var metricD = 0

        return isNaN(metricD) ? 0 : metricD
    }

    get Metric_Display(): number {
        var merchDD = this.cif.MERCH_ACV_D
        var merchDN = this.cif.MERCH_DISPLAYONLY_ACV_N

        if (merchDD > 0)
            var metricD = (merchDN / merchDD)
        else
            var metricD = 0

        return isNaN(metricD) ? 0 : metricD
    }

    get CNSMP_TOTAL_RTLSLS_Previous(): number {
        var previous = (<any>this).previous()
        return isNaN(previous.CNSMP_TOTAL_RTLSLS) ? 0 : previous.CNSMP_TOTAL_RTLSLS
    }

    get SPEND_TOTAL_Previous(): number {
        var previous = (<any>this).previous()
        return isNaN(previous.SPEND_TOTAL) ? 0 : previous.SPEND_TOTAL
    }

    get SPEND_PA_LE_Previous(): number {
        var previous = (<any>this).previous()
        return isNaN(previous.SPEND_PA_LE) ? 0 : previous.SPEND_PA_LE
    }

    get CNSMP_EDLP_PRFTCNTRB_Previous(): number {
        var previous = (<any>this).previous()
        return isNaN(previous.CNSMP_EDLP_PRFTCNTRB) ? 0 : previous.CNSMP_EDLP_PRFTCNTRB
    }

    get CNSMP_INCR_PRFTCNTRB_Previous(): number {
        var previous = (<any>this).previous()
        return isNaN(previous.CNSMP_INCR_PRFTCNTRB) ? 0 : previous.CNSMP_INCR_PRFTCNTRB
    }

    get SHIPMENT_UNITS_Previous(): number {
        var previous = (<any>this).previous()
        return isNaN(previous.SHIPMENT_UNITS) ? 0 : previous.SHIPMENT_UNITS
    }

    get SHIPMENT_ORDER_QTY_Previous(): number {
        let previous = (<any>this).previous()
        let shipmentOrderQuantity = previous.SHIPMENT_ORDER_QTY - previous.RETURN_ORDER_QTY
        return isNaN(shipmentOrderQuantity) ? 0 : previous.SHIPMENT_ORDER_QTY
    }

    get SHIPMENT_ORDER_QTY_CALC(): number {
        let shpOrderQuantity = this.cif.SHIPMENT_ORDER_QTY - this.cif.RETURN_ORDER_QTY
        return isNaN(shpOrderQuantity) ? 0 : shpOrderQuantity
    }

    get CNSMP_TOTAL_UNITS_Previous(): number {
        var previous = (<any>this).previous()
        return isNaN(previous.CNSMP_TOTAL_UNITS) ? 0 : previous.CNSMP_TOTAL_UNITS
    }

    get CNSMP_INCR_LISTSLS_Previous(): number {
        var previous = (<any>this).previous()
        return isNaN(previous.CNSMP_INCR_LISTSLS) ? 0 : previous.CNSMP_INCR_LISTSLS
    }

    get CNSMP_INCR_UNITS_Previous(): number {
        var previous = (<any>this).previous()
        return isNaN(previous.CNSMP_INCR_UNITS) ? 0 : previous.CNSMP_INCR_UNITS
    }

    get CNSMP_EDLP_UNITS_Previous(): number {
        var previous = (<any>this).previous()
        return isNaN(previous.CNSMP_EDLP_UNITS) ? 0 : previous.CNSMP_EDLP_UNITS
    }

    get TOTAL_DISCOUNT(): number {
        return this.cif.CNSMP_TOTAL_LISTSLS - this.cif.CNSMP_TOTAL_RTLSLS
    }

    get CONSUMER_DISCOUNT(): number {
        return (this.cif.CNSMP_TOTAL_UNITS != 0) ? (this.cif.CNSMP_TOTAL_LISTSLS - this.cif.CNSMP_TOTAL_RTLSLS) / this.cif.CNSMP_TOTAL_UNITS : 0
    }

    get CONSUMPTION_UNITS_LIFT(): number {
        return (this.cif.CNSMP_BASE_UNITS != 0) ? this.cif.CNSMP_INCR_UNITS / this.cif.CNSMP_BASE_UNITS : 0
    }

    get RETAIL_SALES_LIFT(): number {
        return (this.cif.CNSMP_BASE_RTLSLS != 0) ? (this.cif.CNSMP_TOTAL_RTLSLS - this.cif.CNSMP_BASE_RTLSLS) / this.cif.CNSMP_BASE_RTLSLS : 0
    }
}

// TPM Plan Group
export class WB_PlanGroupRow
    extends ESRecord
    implements RowIF.IwbPlanGroup {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbPlanGroup {
        return this
    }
}


// TPM Plan
export class WB_PlanRow
    extends ESRecord
    implements RowIF.IwbPlan {
    _InStore: DateRangePropertyBW
    _Shipment: DateRangePropertyBW

    constructor(props: any, opts: any) {
        super(props, opts);
        this._InStore = new DateRangePropertyBW(this, 'InStore', 'INSTORE_START_DT', 'INSTORE_END_DT')
        this._Shipment = new DateRangePropertyBW(this, 'Shipment', 'SHIPMENT_START_DT', 'SHIPMENT_END_DT')
    }

    afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this
        return new Promise<void>((resolve, error) => {

            // Set the Defaults for the Domain Values
            let dbContext: PAdbContext = <any>self.dataStore()

            if (_.isEmpty(dbContext)) {
                resolve()
                return
            }

            async function setAsyncDefaults() {
                self.setDefaults()

                let newKey: number = <any>(await dbContext.getNewId(self._mapper().name))
                let sNewId = TextUtils.padStart(newKey.toString(36), 12, '0').toUpperCase()
                self.cif.PLAN_ID = sNewId
                resolve()
            }

            setAsyncDefaults()
        })
    }

    setDefaults(): void {
        this.cif.DELETED_IND = "0"
        this.cif.SALESORG = "0100"
        this.cif.DIVISION = "01"
        this.cif.DISTRIBCHANNEL = "01"
        this.cif.MANUAL_IND = "1"
        this.cif.PLAN_COMMENTS = ""
        this.cif.TREE_PATH = ""
        this.cif.WB_BASELINE_ID_ALT = 0
        this.cif.WB_BASELINE_ID_PY = 0
        this.cif.WB_BASELINE_ID_CNS_PY = 0
        this.cif.WB_BASELINE_ID_CNS_ALT = 0
        this.cif.WB_BASELINE_ID_SHIP_PY = 0
        this.cif.WB_BASELINE_ID_SHIP_ALT = 0
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbPlan {
        return this
    }

    get WB_PlanOverrideRow(): WB_PlanOverrideRow {
        return getHasOneProperty(this, 'Overrides');
    }

    set WB_PlanOverrideRow(value) {
        setHasOneProperty(this, 'Overrides', value);
    }

    get InStore(): DateRangePropertyBW {
        return this._InStore
    }

    get Shipment(): DateRangePropertyBW {
        return this._Shipment
    }

    get WB_CustomerRow_Planning(): WB_CustomerRow {
        return getBelongsToProperty(this, 'PlanningCustomer');
    }

    get WB_CustomerRow_SubPlanning(): WB_CustomerRow {
        return getBelongsToProperty(this, 'SubPlanningCustomer');
    }

    get WB_PeriodRow(): WB_PeriodRow {
        return getBelongsToProperty(this, 'Period');
    }

    get WB_ProductGroupRow_PlanningLevel(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'PlanningLevel');
    }

    get WB_PlanManagementRow(): WB_PlanManagementRow {
        return getBelongsToProperty(this, 'PlanManagement');
    }

    get WB_PlanTypeRow(): WB_PlanTypeRow {
        return getBelongsToProperty(this, 'PlanType');
    }

    get WB_Plan_ProductGroupRows(): WB_PlanProductGroupRow[] {
        return getHasManyProperty(this, 'PlanProductGroups')
    }

    get WB_PlanVolumeMetricsRows(): WB_PlanVolumeMetricsRow[] {
        return getHasManyProperty(this, 'PlanVolumeMetrics')
    }

    get WB_PlanFundingMetricsRows(): WB_PlanFundingMetricsRow[] {
        return getHasManyProperty(this, 'PlanFundingMetrics')
    }

    get WB_PlanProductMetricsRows(): WB_PlanProductMetricsRow[] {
        return getHasManyProperty(this, 'PlanProductMetrics')
    }

    get SVFTableOptions(): IHRTableModelOptions {
        let dflt: IHRTableModelOptions = {
            MetricPlacement: DimensionPlacement.OnRows,
            DimensionOptions: {},
            ColumnDimensionKeyOrder: [],
            RowDimensionKeyOrder: [],
            MetricOrder: [],
            PageByDimensionKeyOrder: [],
            PageByDimensionSelected: {},
            PageByMetricSelected: undefined,
            MetricUOMVisible: false
        }

        return <any>getJSONProperty(this, "SVF_TABLE_OPTIONS", dflt)
    }

    set SVFTableOptions(newValue: IHRTableModelOptions) {
        setJSONProperty(this, "SVFTableOptions", "SVF_TABLE_OPTIONS", newValue)
    }

    get SVFPerspectiveOptions(): ICubePerspectiveOptions {
        let dflt: ICubePerspectiveOptions = {
            Dimensions: {},
            MetricIds: []
        }

        return <any>getJSONProperty(this, "SVF_PERSPECTIVE_OPTIONS", dflt)
    }

    set SVFPerspectiveOptions(newValue: ICubePerspectiveOptions) {
        setJSONProperty(this, "SVFPerspectiveOptions", "SVF_PERSPECTIVE_OPTIONS", newValue)
    }

    get MetricTableOptions(): IHRTableModelOptions {
        let dflt: IHRTableModelOptions = {
            MetricPlacement: DimensionPlacement.OnRows,
            DimensionOptions: {},
            ColumnDimensionKeyOrder: [],
            RowDimensionKeyOrder: [],
            MetricOrder: [],
            PageByDimensionKeyOrder: [],
            PageByDimensionSelected: {},
            PageByMetricSelected: undefined,
            MetricUOMVisible: false
        }

        return <any>getJSONProperty(this, "METRIC_TABLE_OPTIONS", dflt)
    }

    set MetricTableOptions(newValue: IHRTableModelOptions) {
        setJSONProperty(this, "MetricTableOptions", "METRIC_TABLE_OPTIONS", newValue)
    }

    get MetricPerspectiveOptions(): ICubePerspectiveOptions {
        let dflt: ICubePerspectiveOptions = {
            Dimensions: {},
            MetricIds: []
        }

        return <any>getJSONProperty(this, "METRIC_PERSPECTIVE_OPTIONS", dflt)
    }

    set MetricPerspectiveOptions(newValue: ICubePerspectiveOptions) {
        setJSONProperty(this, "MetricPerspectiveOptions", "METRIC_PERSPECTIVE_OPTIONS", newValue)
    }

    get BVPTableOptions(): IHRTableModelOptions {
        let dflt: IHRTableModelOptions = {
            MetricPlacement: DimensionPlacement.OnRows,
            DimensionOptions: {},
            ColumnDimensionKeyOrder: [],
            RowDimensionKeyOrder: [],
            MetricOrder: [],
            PageByDimensionKeyOrder: [],
            PageByDimensionSelected: {},
            PageByMetricSelected: undefined,
            MetricUOMVisible: false
        }

        return <any>getJSONProperty(this, "BVP_TABLE_OPTIONS", dflt)
    }

    set BVPTableOptions(newValue: IHRTableModelOptions) {
        setJSONProperty(this, "BVPTableOptions", "BVP_TABLE_OPTIONS", newValue)
    }

    get BVPPerspectiveOptions(): ICubePerspectiveOptions {
        let dflt: ICubePerspectiveOptions = {
            Dimensions: {},
            MetricIds: []
        }

        return <any>getJSONProperty(this, "BVP_PERSPECTIVE_OPTIONS", dflt)
    }

    set BVPPerspectiveOptions(newValue: ICubePerspectiveOptions) {
        setJSONProperty(this, "BVPPerspectiveOptions", "BVP_PERSPECTIVE_OPTIONS", newValue)
    }


}

export class WB_PlanProductGroupRow
    extends ESRecord
    implements RowIF.IwbPlanProductGroup {
    constructor(props: any, opts: any) {
        super(props, opts);
        this.setDefaults();
    }

    setDefaults(): void {
        this.cif.INTEGRATION_IND = defaultRowValues.Integration_Ind()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Deleted_Dt()
        this.cif.PG_DECOMP_METHOD = "";
    }

    get cif(): RowIF.IwbPlanProductGroup {
        return this
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup')
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value)
    }


    get WB_PlanProductRows(): WB_PlanProductRow[] {
        return getHasManyProperty(this, 'PlanProducts')
    }
}

export class WB_PlanProductRow
    extends ESRecord
    implements RowIF.IwbPlanProduct {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbPlanProduct {
        return this
    }

    get WB_FinishedProductRow(): WB_FinishedProductRow {
        return getBelongsToProperty(this, 'Product')
    }
}

export class WB_PlanOverrideRow
    extends ESRecord
    implements RowIF.IwbPlanOverride {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.WB_PLAN_ID = 0
        this.cif.PROCESSED_IND = defaultRowValues.False_Ind();
        this.cif.PROCESSED_DT = defaultRowValues.Blank_Dt();
        this.cif.NOTES = 'NA'
        this.cif.MODIFIED_DT = defaultRowValues.Modified_Dt()
        this.cif.MODIFIED_BY = defaultRowValues.Modified_By()
    }

    get cif(): RowIF.IwbPlanOverride {
        return this
    }

    get WB_MetricRow_Actual(): WB_MetricRow {
        return getBelongsToProperty(this, 'ActualMetrics');
    }

    set WB_MetricRow_Actual(value) {
        setBelongsToProperty(this, 'ActualMetrics', value)
    }
}

export class WB_PlanVolumeMetricsRow
    extends ESRecord
    implements RowIF.IwbPlanVolumeMetrics {
    constructor(props: any, opts: any) {
        super(props, opts);

        // UOM conversion fields
        //this.cif.NET_LIST_PRICE
        this.setupDependents("CNS_BASELN_CY_NETLIST", ["CNS_BASELN_CY_QTY", "NET_LIST_PRICE"])
        this.setupDependents("CNS_BASELN_ADJ_NETLIST", ["CNS_BASELN_ADJ_QTY", "NET_LIST_PRICE"])
        this.setupDependents("SHIP_ADJ_NETLIST", ["SHIP_ADJ_QTY", "NET_LIST_PRICE"])
        this.setupDependents("SHIP_BASELN_CY_NETLIST", ["SHIP_BASELN_CY_QTY", "NET_LIST_PRICE"])

        //this.cif.WT_FACTOR
        this.setupDependents("CNS_BASELN_CY_WT", ["CNS_BASELN_CY_QTY", "WT_FACTOR"])
        this.setupDependents("CNS_BASELN_ADJ_WT", ["CNS_BASELN_ADJ_QTY", "WT_FACTOR"])
        this.setupDependents("SHIP_ADJ_WT", ["SHIP_ADJ_QTY", "WT_FACTOR"])
        this.setupDependents("SHIP_BASELN_CY_WT", ["SHIP_BASELN_CY_QTY", "WT_FACTOR"])

        //this.cif.STATCS_FACTOR
        this.setupDependents("CNS_BASELN_CY_STATCS", ["CNS_BASELN_CY_QTY", "STATCS_FACTOR"])
        this.setupDependents("CNS_BASELN_ADJ_STATCS", ["CNS_BASELN_ADJ_QTY", "STATCS_FACTOR"])
        this.setupDependents("SHIP_ADJ_STATCS", ["SHIP_ADJ_QTY", "STATCS_FACTOR"])
        this.setupDependents("SHIP_BASELN_CY_STATCS", ["SHIP_BASELN_CY_QTY", "STATCS_FACTOR"])

        //this.cif.UNIT_FACTOR
        this.setupDependents("CNS_BASELN_CY_EA", ["CNS_BASELN_CY_QTY", "UNIT_FACTOR"])
        this.setupDependents("CNS_BASELN_ADJ_EA", ["CNS_BASELN_ADJ_QTY", "UNIT_FACTOR"])
        this.setupDependents("SHIP_ADJ_EA", ["SHIP_ADJ_QTY", "UNIT_FACTOR"])
        this.setupDependents("SHIP_BASELN_CY_EA", ["SHIP_BASELN_CY_QTY", "UNIT_FACTOR"])


    }

    setDefaults(): void {
        let rw = this.cif
        rw.ROW_SOURCE = "WB"
        rw.CREATE_DT = defaultRowValues.Created_Dt()
        rw.GROSS_LIST_PRICE = 0
        rw.NET_LIST_PRICE = 0
        rw.RETAILER_BASE_PRICE = 0
        rw.RETAILER_EDLP_PRICE = 0
        rw.RETAILER_PROMO_PRICE = 0
        rw.RETAILER_PRICE = 0
        rw.UNIT_FACTOR = 0
        rw.WT_FACTOR = 0
        rw.STATCS_FACTOR = 0
        rw.CNS_BASELN_PY_QTY = 0
        rw.CNS_BASELN_ALT_QTY = 0
        rw.CNS_BASELN_CY_QTY = 0
        rw.CNS_BASELN_ADJ_QTY = 0
        rw.CNS_BASELN_EFF_QTY = 0
        rw.CNS_BASE_QTY = 0
        rw.CNS_EDLP_QTY = 0
        rw.CNS_INCR_QTY = 0
        rw.CNS_TOTAL_QTY = 0
        rw.SHIP_BASELN_PY_QTY = 0
        rw.SHIP_BASELN_ALT_QTY = 0
        rw.SHIP_BASELN_CY_QTY = 0
        rw.SHIP_BASELN_ADJ_QTY = 0
        rw.SHIP_BASELN_EFF_QTY = 0
        rw.SHIP_BASE_QTY = 0
        rw.SHIP_INCR_QTY = 0
        rw.SHIP_FORWARDBUY_QTY = 0
        rw.SHIP_ADJ_QTY = 0
        rw.SHIP_TOTAL_QTY = 0
        rw.SHIP_BOM_COMP_QTY = 0
        rw.SHIP_OS_PCNT = 0
        rw.SHIP_IND_UNITS = 0
        rw.SHIP_IND_STAT = 0
        rw.SHIP_IND_GRSLSTSLS = 0
        rw.SHIP_IND_NETLSTSLS = 0
        rw.SHIP_DISTRIBUTED_QTY = 0
        rw.SHIP_NET_TOTAL_QTY = 0
        rw.SHIP_EXP_RECV_QTY = 0
        rw.SHIP_EXP_RECV_UNITS = 0
        rw.SHIP_EXP_RECV_STAT = 0
        rw.SHIP_EXP_RECV_GRSLSTSLS = 0
        rw.SHIP_EXP_RECV_NETLSTSLS = 0
        rw.FEATUREONLY_ACV = 0
        rw.DISPLAYONLY_ACV = 0
        rw.FEATUREDISPLAY_ACV = 0
        rw.TPRONLY_ACV = 0
        rw.PROMOTED_ACV = 0
        rw.ACT_CNS_BASE_UNITS = 0
        rw.ACT_CNS_BASE_RTLSLS = 0
        rw.ACT_CNS_BASE_WT = 0
        rw.ACT_CNS_BASE_STAT = 0
        rw.ACT_CNS_EDLP_UNITS = 0
        rw.ACT_CNS_EDLP_RTLSLS = 0
        rw.ACT_CNS_EDLP_WT = 0
        rw.ACT_CNS_EDLP_STAT = 0
        rw.ACT_CNS_INCR_UNITS = 0
        rw.ACT_CNS_INCR_RTLSLS = 0
        rw.ACT_CNS_INCR_WT = 0
        rw.ACT_CNS_INCR_STAT = 0
        rw.ACT_CNS_TOTAL_UNITS = 0
        rw.ACT_CNS_TOTAL_RTLSLS = 0
        rw.ACT_CNS_TOTAL_WT = 0
        rw.ACT_CNS_TOTAL_STAT = 0
        rw.ACT_FEATUREONLY_ACV = 0
        rw.ACT_FEATUREDISPLAY_ACV = 0
        rw.ACT_TPROONLY_ACV = 0
        rw.ACT_PROMOTED_ACV = 0
        rw.LE_CNS_BASE_UNITS = 0
        rw.LE_CNS_BASE_RTLSLS = 0
        rw.LE_CNS_BASE_WT = 0
        rw.LE_CNS_BASE_STAT = 0
        rw.LE_CNS_EDLP_UNITS = 0
        rw.LE_CNS_EDLP_RTLSLS = 0
        rw.LE_CNS_EDLP_WT = 0
        rw.LE_CNS_EDLP_STAT = 0
        rw.LE_CNS_INCR_UNITS = 0
        rw.LE_CNS_INCR_RTLSLS = 0
        rw.LE_CNS_INCR_WT = 0
        rw.LE_CNS_INCR_STAT = 0
        rw.LE_CNS_TOTAL_UNITS = 0
        rw.LE_CNS_TOTAL_RTLSLS = 0
        rw.LE_CNS_TOTAL_WT = 0
        rw.LE_CNS_TOTAL_STAT = 0
        rw.LE_SHIP_UNITS = 0
        rw.LE_SHIP_WT = 0
        rw.LE_SHIP_STAT = 0
        rw.LE_SHIP_GRSLISTSLS = 0
        rw.LE_SHIP_NETLISTSLS = 0
        rw.LE_SHIP_COSTS = 0
        rw.NET_LIST_PRICE_INDIRECT = 0
        rw.SHIP_EDLP_QTY = 0
        rw.SHIP_DIR_BASE_QTY = 0
        rw.SHIP_DIR_EDLP_QTY = 0
        rw.SHIP_DIR_INCR_QTY = 0
        rw.SHIP_DIR_FORWARDBUY_QTY = 0
        rw.SHIP_DIR_ADJ_QTY = 0
        rw.SHIP_DIR_TOTAL_QTY = 0
        rw.SHIP_IND_PCNT = 0
        rw.SHIP_IND_BASE_QTY = 0
        rw.SHIP_IND_EDLP_QTY = 0
        rw.SHIP_IND_INCR_QTY = 0
        rw.SHIP_IND_FORWARDBUY_QTY = 0
        rw.SHIP_IND_ADJ_QTY = 0
        rw.SHIP_IND_TOTAL_QTY = 0
        rw.SHIP_DISTRIB_PCNT = 0
        rw.ACT_DISPLAYONLY_ACV = 0
        rw.ACT_SHIP_DIR_UNITS = 0
        rw.ACT_SHIP_DIR_WT = 0
        rw.ACT_SHIP_DIR_STAT = 0
        rw.ACT_SHIP_DIR_GRSLISTSLS = 0
        rw.ACT_SHIP_DIR_NETLISTSLS = 0
        rw.ACT_SHIP_DIR_COSTS = 0
        rw.ACT_RTN_DIR_UNITS = 0
        rw.ACT_RTN_DIR_WT = 0
        rw.ACT_RTN_DIR_STAT = 0
        rw.ACT_RTN_DIR_GRSLISTSLS = 0
        rw.ACT_RTN_DIR_NETLISTSLS = 0
        rw.ACT_RTN_DIR_COSTS = 0
        rw.ACT_SHIP_DIR_OS_UNITS = 0
        rw.ACT_SHIP_DIR_OS_WT = 0
        rw.ACT_SHIP_DIR_OS_STAT = 0
        rw.ACT_SHIP_DIR_OS_GRSLISTSLS = 0
        rw.ACT_SHIP_DIR_OS_NETLISTSLS = 0
        rw.ACT_SHIP_DIR_OS_COSTS = 0
        rw.ACT_RTN_DIR_OS_UNITS = 0
        rw.ACT_RTN_DIR_OS_WT = 0
        rw.ACT_RTN_DIR_OS_STAT = 0
        rw.ACT_RTN_DIR_OS_GRSLISTSLS = 0
        rw.ACT_RTN_DIR_OS_NETLISTSLS = 0
        rw.ACT_RTN_DIR_OS_COSTS = 0
        rw.ACT_SHIP_IND_UNITS = 0
        rw.ACT_SHIP_IND_WT = 0
        rw.ACT_SHIP_IND_STAT = 0
        rw.ACT_SHIP_IND_GRSLISTSLS = 0
        rw.ACT_SHIP_IND_NETLISTSLS = 0
        rw.ACT_SHIP_DIST_UNITS = 0
        rw.ACT_SHIP_DIST_WT = 0
        rw.ACT_SHIP_DIST_STAT = 0
        rw.ACT_SHIP_DIST_GRSLISTSLS = 0
        rw.ACT_SHIP_DIST_NETLISTSLS = 0
        rw.LE_SHIP_DIR_UNITS = 0
        rw.LE_SHIP_DIR_WT = 0
        rw.LE_SHIP_DIR_STAT = 0
        rw.LE_SHIP_DIR_GRSLISTSLS = 0
        rw.LE_SHIP_DIR_NETLISTSLS = 0
        rw.LE_SHIP_DIR_COSTS = 0
        rw.LE_SHIP_IND_UNITS = 0
        rw.LE_SHIP_IND_WT = 0
        rw.LE_SHIP_IND_STAT = 0
        rw.LE_SHIP_IND_GRSLISTSLS = 0
        rw.LE_SHIP_IND_NETLISTSLS = 0
        rw.LE_SHIP_DIR_OS_UNITS = 0
        rw.LE_SHIP_DIR_OS_WT = 0
        rw.LE_SHIP_DIR_OS_STAT = 0
        rw.LE_SHIP_DIR_OS_GRSLISTSLS = 0
        rw.LE_SHIP_DIR_OS_NETLISTSLS = 0
        rw.LE_SHIP_DIR_OS_COSTS = 0
        rw.LE_SHIP_OS_UNITS = 0
        rw.LE_SHIP_OS_WT = 0
        rw.LE_SHIP_OS_STAT = 0
        rw.LE_SHIP_OS_GRSLISTSLS = 0
        rw.LE_SHIP_OS_NETLISTSLS = 0
        rw.LE_SHIP_OS_COSTS = 0
        rw.VCM = 0
        rw.SPND_VARIABLE = 0
        rw.SPND_FIXED = 0
        rw.ACT_SPND_VARIABLE = 0
        rw.ACT_SPND_FIXED = 0
        rw.LE_SPND_VARIABLE = 0
        rw.LE_SPND_FIXED = 0
        rw.SHP_EXP_RECV_PCNT_TOTAL = 0
        rw.BASELN_EFF_QTY = 0

    }

    get cif(): RowIF.IwbPlanVolumeMetrics {
        return this
    }

    get WB_PlanRow(): WB_PlanRow {
        return getBelongsToProperty(this, 'Plan');
    }

    set WB_PlanRow(value) {
        setBelongsToProperty(this, 'Plan', value);
    }


    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup');
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value);
    }


    get WB_PeriodRow(): WB_PeriodRow {
        return getBelongsToProperty(this, 'Period');
    }

    set WB_PeriodRow(value) {
        setBelongsToProperty(this, 'Period', value);
    }

    // UOM conversion for Leaf Data Entry Metrics
    /*
        // Data Entry, Editable fields
        CNS_BASELN_CY_QTY
        CNS_BASELN_ADJ_QTY
        SHIP_ADJ_QTY
        SHIP_BASELN_CY_QTY

        // Possible UOM fields
        _NETLIST    converts by NET_LIST_PRICE
        _STATCS     converts by STATCS_FACTOR
        _WT         converts by WT_FACTOR
        _EA         converts by UNIT_FACTOR
        _GROSSLIST  converts by GROSS_LIST_PRICE
        _RTLBSSLS   converts by RETAILER_BASE_PRICE
     */

    // -- Net List Conversion
    get CNS_BASELN_CY_NETLIST(): number {
        return NumberUtils.round(this.cif.CNS_BASELN_CY_QTY * this.cif.NET_LIST_PRICE, 2)
    }

    set CNS_BASELN_CY_NETLIST(value: number) {
        if (this.cif.NET_LIST_PRICE > 0)
            this.cif.CNS_BASELN_CY_QTY = Math.round(value / this.cif.NET_LIST_PRICE)
    }

    get CNS_BASELN_ADJ_NETLIST(): number {
        return NumberUtils.round(this.cif.CNS_BASELN_ADJ_QTY * this.cif.NET_LIST_PRICE, 2)
    }

    set CNS_BASELN_ADJ_NETLIST(value: number) {
        if (this.cif.NET_LIST_PRICE > 0)
            this.cif.CNS_BASELN_ADJ_QTY = Math.round(value / this.cif.NET_LIST_PRICE)
    }

    get SHIP_ADJ_NETLIST(): number {
        return NumberUtils.round(this.cif.SHIP_ADJ_QTY * this.cif.NET_LIST_PRICE, 2)
    }

    set SHIP_ADJ_NETLIST(value: number) {
        if (this.cif.NET_LIST_PRICE > 0)
            this.cif.SHIP_ADJ_QTY = Math.round(value / this.cif.NET_LIST_PRICE)
    }

    get SHIP_BASELN_CY_NETLIST(): number {
        return NumberUtils.round(this.cif.SHIP_BASELN_CY_QTY * this.cif.NET_LIST_PRICE, 2)
    }

    set SHIP_BASELN_CY_NETLIST(value: number) {
        if (this.cif.NET_LIST_PRICE > 0)
            this.cif.SHIP_BASELN_CY_QTY = Math.round(value / this.cif.NET_LIST_PRICE)
    }

    // -- Stat Cs Conversion
    get CNS_BASELN_CY_STATCS(): number {
        return NumberUtils.round(this.cif.CNS_BASELN_CY_QTY * this.cif.STATCS_FACTOR, 2)
    }

    set CNS_BASELN_CY_STATCS(value: number) {
        if (this.cif.STATCS_FACTOR > 0)
            this.cif.CNS_BASELN_CY_QTY = Math.round(value / this.cif.STATCS_FACTOR)
    }

    get CNS_BASELN_ADJ_STATCS(): number {
        return NumberUtils.round(this.cif.CNS_BASELN_ADJ_QTY * this.cif.STATCS_FACTOR, 2)
    }

    set CNS_BASELN_ADJ_STATCS(value: number) {
        if (this.cif.STATCS_FACTOR > 0)
            this.cif.CNS_BASELN_ADJ_QTY = Math.round(value / this.cif.STATCS_FACTOR)
    }

    get SHIP_ADJ_STATCS(): number {
        return NumberUtils.round(this.cif.SHIP_ADJ_QTY * this.cif.STATCS_FACTOR, 2)
    }

    set SHIP_ADJ_STATCS(value: number) {
        if (this.cif.STATCS_FACTOR > 0)
            this.cif.SHIP_ADJ_QTY = Math.round(value / this.cif.STATCS_FACTOR)
    }

    get SHIP_BASELN_CY_STATCS(): number {
        return NumberUtils.round(this.cif.SHIP_BASELN_CY_QTY * this.cif.STATCS_FACTOR, 2)
    }

    set SHIP_BASELN_CY_STATCS(value: number) {
        if (this.cif.STATCS_FACTOR > 0)
            this.cif.SHIP_BASELN_CY_QTY = Math.round(value / this.cif.STATCS_FACTOR)
    }

    // -- Weight Conversion
    get CNS_BASELN_CY_WT(): number {
        return NumberUtils.round(this.cif.CNS_BASELN_CY_QTY * this.cif.WT_FACTOR, 2)
    }

    set CNS_BASELN_CY_WT(value: number) {
        if (this.cif.WT_FACTOR > 0)
            this.cif.CNS_BASELN_CY_QTY = Math.round(value / this.cif.WT_FACTOR)
    }

    get CNS_BASELN_ADJ_WT(): number {
        return NumberUtils.round(this.cif.CNS_BASELN_ADJ_QTY * this.cif.WT_FACTOR, 2)
    }

    set CNS_BASELN_ADJ_WT(value: number) {
        if (this.cif.WT_FACTOR > 0)
            this.cif.CNS_BASELN_ADJ_QTY = Math.round(value / this.cif.WT_FACTOR)
    }

    get SHIP_ADJ_WT(): number {
        return NumberUtils.round(this.cif.SHIP_ADJ_QTY * this.cif.NET_LIST_PRICE, 2)
    }

    set SHIP_ADJ_WT(value: number) {
        if (this.cif.WT_FACTOR > 0)
            this.cif.SHIP_ADJ_QTY = Math.round(value / this.cif.WT_FACTOR)
    }

    get SHIP_BASELN_CY_WT(): number {
        return NumberUtils.round(this.cif.SHIP_BASELN_CY_QTY * this.cif.WT_FACTOR, 2)
    }

    set SHIP_BASELN_CY_WT(value: number) {
        if (this.cif.WT_FACTOR > 0)
            this.cif.SHIP_BASELN_CY_QTY = Math.round(value / this.cif.WT_FACTOR)
    }

    // -- EA Conversion
    get CNS_BASELN_CY_EA(): number {
        return NumberUtils.round(this.cif.CNS_BASELN_CY_QTY * this.cif.UNIT_FACTOR, 2)
    }

    set CNS_BASELN_CY_EA(value: number) {
        if (this.cif.UNIT_FACTOR > 0)
            this.cif.CNS_BASELN_CY_QTY = Math.round(value / this.cif.UNIT_FACTOR)
    }

    get CNS_BASELN_ADJ_EA(): number {
        return NumberUtils.round(this.cif.CNS_BASELN_ADJ_QTY * this.cif.UNIT_FACTOR, 2)
    }

    set CNS_BASELN_ADJ_EA(value: number) {
        if (this.cif.UNIT_FACTOR > 0)
            this.cif.CNS_BASELN_ADJ_QTY = Math.round(value / this.cif.UNIT_FACTOR)
    }

    get SHIP_ADJ_EA(): number {
        return NumberUtils.round(this.cif.SHIP_ADJ_QTY * this.cif.UNIT_FACTOR, 2)
    }

    set SHIP_ADJ_EA(value: number) {
        if (this.cif.UNIT_FACTOR > 0)
            this.cif.SHIP_ADJ_QTY = Math.round(value / this.cif.UNIT_FACTOR)
    }

    get SHIP_BASELN_CY_EA(): number {
        return NumberUtils.round(this.cif.SHIP_BASELN_CY_QTY * this.cif.UNIT_FACTOR, 2)
    }

    set SHIP_BASELN_CY_EA(value: number) {
        if (this.cif.UNIT_FACTOR > 0)
            this.cif.SHIP_BASELN_CY_QTY = Math.round(value / this.cif.UNIT_FACTOR)
    }

}

export class WB_PlanRedistributedVolumeMetricsRow
    extends ESRecord
    implements RowIF.IwbPlanRedistributedVolumeMetrics {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        let rw = this.cif
        rw.GROSS_LIST_PRICE = 0
        rw.NET_LIST_PRICE = 0
        rw.NET_LIST_PRICE_INDIRECT = 0
        rw.VCM = 0
        rw.UNIT_FACTOR = 0
        rw.WT_FACTOR = 0
        rw.STATCS_FACTOR = 0
        rw.SHIP_IND_PCNT = 0
        rw.SHIP_IND_QTY = 0
        rw.SHIP_IND_UNITS = 0
        rw.SHIP_IND_STAT = 0
        rw.SHIP_IND_GRSLSTSLS = 0
        rw.SHIP_IND_NETLSTSLS = 0

        rw.SHIP_EXP_RECV_QTY = 0
        rw.SHIP_EXP_RECV_UNITS = 0
        rw.SHIP_EXP_RECV_STAT = 0
        rw.SHIP_EXP_RECV_GRSLSTSLS = 0
        rw.SHIP_EXP_RECV_NETLSTSLS = 0

        rw.ACT_SHIP_IND_UNITS = 0
        rw.ACT_SHIP_IND_WT = 0
        rw.ACT_SHIP_IND_STAT = 0
        rw.ACT_SHIP_IND_GRSLISTSLS = 0
        rw.ACT_SHIP_IND_NETLISTSLS = 0

        rw.LE_SHIP_IND_UNITS = 0
        rw.LE_SHIP_IND_WT = 0
        rw.LE_SHIP_IND_STAT = 0
        rw.LE_SHIP_IND_GRSLISTSLS = 0
        rw.LE_SHIP_IND_NETLISTSLS = 0


    }

    get cif(): RowIF.IwbPlanRedistributedVolumeMetrics {
        return this
    }

    get WB_PlanRow(): WB_PlanRow {
        return getBelongsToProperty(this, 'Plan');
    }

    set WB_PlanRow(value) {
        setBelongsToProperty(this, 'Plan', value);
    }


    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup');
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value);
    }


    get WB_PeriodRow(): WB_PeriodRow {
        return getBelongsToProperty(this, 'Period');
    }

    set WB_PeriodRow(value) {
        setBelongsToProperty(this, 'Period', value);
    }

    get WB_CustomerRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Customer');
    }

    set WB_CustomerRow(value) {
        setBelongsToProperty(this, 'Customer', value);
    }


}

export class WB_PlanVolumeMonthlyMetricsRow
    extends ESRecord
    implements RowIF.IwbPlanVolumeMonthlyMetrics {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        let rw = this.cif;
        rw.CREATE_DT = defaultRowValues.Created_Dt();
        rw.ROW_SOURCE = "WB";
        rw.CNS_TOTAL_UNITS = 0;
        rw.CNS_TOTAL_RTLSLS = 0;
        rw.CNS_TOTAL_WT = 0;
        rw.CNS_TOTAL_STAT = 0;
        rw.CNS_TOTAL_GRSLISTSLS = 0;
        rw.CNS_TOTAL_NETLISTSLS = 0;
        rw.SHIP_UNITS = 0;
        rw.SHIP_WT = 0;
        rw.SHIP_STAT = 0;
        rw.SHIP_GRSLISTSLS = 0;
        rw.SHIP_NETLISTSLS = 0;
    }

    get cif(): RowIF.IwbPlanVolumeMonthlyMetrics {
        return this
    }

    get WB_PlanRow(): WB_PlanRow {
        return getBelongsToProperty(this, 'Plan');
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup');
    }

    get WB_PeriodRow(): WB_PeriodRow {
        return getBelongsToProperty(this, 'Period');
    }
}

export class WB_PlanApprovalMetricsRow
    extends ESRecord
    implements RowIF.IwbPlanApprovalMetrics {

    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.APPROVAL_ID = "";
        this.cif.PLAN_STD_FUNDING_AMT = 0;
        this.cif.PLAN_ADDL_FUNDING_AMT = 0;
        this.cif.ACT_STD_FUNDING_AMT = 0;
        this.cif.ACT_ADDL_FUNDING_AMT = 0;
        this.cif.LE_STD_FUNDING_AMT = 0;
        this.cif.LE_ADDL_FUNDING_AMT = 0;
        this.cif.FIXED_FUNDING_AMT = 0;
        this.cif.PLAN_SPND_VARIABLE = 0;
        this.cif.PLAN_SPND_FIXED = 0;
        this.cif.APRV_SPND_VARIABLE = 0;
        this.cif.APRV_SPND_FIXED = 0;
        this.cif.ACT_SPND_VARIABLE = 0;
        this.cif.ACT_SPND_FIXED = 0;
        this.cif.LE_SPND_VARIABLE = 0;
        this.cif.LE_SPND_FIXED = 0;
        this.cif.LE_CNS_EDLP_UNITS = 0;
        this.cif.LE_CNS_EDLP_RTLSLS = 0;
        this.cif.LE_CNS_EDLP_PROFIT = 0;
        this.cif.LE_CNS_INCR_UNITS = 0;
        this.cif.LE_CNS_INCR_RTLSLS = 0;
        this.cif.LE_CNS_INCR_PROFIT = 0;
        this.cif.LE_SHIP_GRSLISTSLS = 0;
    }

    get cif(): RowIF.IwbPlanApprovalMetrics {
        return this;
    }

    get WB_PlanRow(): WB_PlanRow {
        return getBelongsToProperty(this, 'Plan');
    }
}

export class WB_PlanProductMetricsRow
    extends ESRecord
    implements RowIF.IwbPlanProductMetrics {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.SHIP_TOTAL_QTY = 0;
    }

    get cif(): RowIF.IwbPlanProductMetrics {
        return this
    }


    get WB_PlanRow(): WB_PlanRow {
        return getBelongsToProperty(this, 'Plan');
    }

    set WB_PlanRow(value) {
        setBelongsToProperty(this, 'Plan', value);
    }


    get WB_ProductRow(): WB_FinishedProductRow {
        return getBelongsToProperty(this, 'Product');
    }

    set WB_ProductRow(value) {
        setBelongsToProperty(this, 'Product', value);
    }


    get WB_PeriodRow(): WB_PeriodRow {
        return getBelongsToProperty(this, 'Period');
    }

    set WB_PeriodRow(value) {
        setBelongsToProperty(this, 'Period', value);
    }

    private tEvtIds: { [wbTEvtId: number]: number } = {};

    addEventId(wbTEvtId: number): void {
        this.tEvtIds[wbTEvtId] = wbTEvtId;
    }

    get ContributingEvents(): number[] {
        const retVal: number[] = [];
        for (let aVal of Object.values(this.tEvtIds)) {
            retVal.push(aVal);
        }
        return retVal;
    }
}


export class WB_PlanFundingMetricsRow
    extends ESRecord
    implements RowIF.IwbPlanFundingMetrics {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.ROW_SOURCE = "WB";
        this.cif.CREATE_DT = defaultRowValues.Created_Dt();
        this.cif.PLAN_BASIS_QTY = 0;
        this.cif.ACT_BASIS_QTY = 0;
        this.cif.LE_BASIS_QTY = 0;
        this.cif.GROSS_LIST_PRICE = 0;
        this.cif.NET_LIST_PRICE = 0;
        this.cif.STD_FUNDING_RATE = 0;
        this.cif.ADDL_FUNDING_RATE = 0;
        this.cif.PLAN_STD_FUNDING_AMT = 0;
        this.cif.PLAN_ADDL_FUNDING_AMT = 0;
        this.cif.ACT_STD_FUNDING_AMT = 0;
        this.cif.ACT_ADDL_FUNDING_AMT = 0;
        this.cif.LE_STD_FUNDING_AMT = 0;
        this.cif.LE_ADDL_FUNDING_AMT = 0;

    }

    get cif(): RowIF.IwbPlanFundingMetrics {
        return this
    }

    get WB_PlanRow(): WB_PlanRow {
        return getBelongsToProperty(this, 'Plan');
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup');
    }

    get WB_PeriodRow(): WB_PeriodRow {
        return getBelongsToProperty(this, 'Period');
    }

}


// Event
export class WB_EventRow
    extends ESRecord
    implements RowIF.IwbEvent {
    _InStore: DateRangePropertyBW
    _Shipment: DateRangePropertyBW

    constructor(props: any, opts: any) {
        super(props, opts);
        this._InStore = new DateRangePropertyBW(this, 'InStore', 'INSTORE_START_DT', 'INSTORE_END_DT')
        this._Shipment = new DateRangePropertyBW(this, 'Shipment', 'SHIPMENT_START_DT', 'SHIPMENT_END_DT')
    }

    setDefaults(): void {

        this.cif.EVENT_ROW_ID = "New Row ID"
        this.cif.EVENT_ID = "NewID"
        this.cif.EVENT_NAME = "New Name"
        this.cif.EVENT_COMMENTS = ''
        this.cif.SOURCE_ID = "WB"
        this.cif.MANUAL_IND = '1'
        this.cif.DELETED_IND = '0'
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.INTEGRATION_IND = '1'

        this.cif.INSTORE_START_DT = defaultRowValues.Blank_Dt()
        this.cif.INSTORE_END_DT = defaultRowValues.Blank_Dt()
        this.cif.SHIPMENT_START_DT = defaultRowValues.Blank_Dt()
        this.cif.SHIPMENT_END_DT = defaultRowValues.Blank_Dt()

        this.cif.WB_PLAN_ID = 0
        this.cif.WB_CUST_ID_SUBPLANNING = 0
        this.cif.WB_CUST_ID_PLANNING = 0
        this.cif.WORKFLOW_STATUS_ID = 0
        this.cif.PLANNING_PROFILE_GROUP_ID = 0
        this.cif.EVENT_TYPE_ID = 0

    }

    afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this
        return new Promise<void>((resolve, error) => {

            // Set the Defaults for the Domain Values
            let dbContext: PAdbContext = <any>self.dataStore()

            if (_.isEmpty(dbContext)) {
                resolve()
                return
            }

            async function setAsyncDefaults() {
                self.setDefaults()

                let newKey: number = <any>(await dbContext.getNewId(self._mapper().name))
                let sNewId = TextUtils.padStart(newKey.toString(36), 12, '0').toUpperCase()
                self.cif.EVENT_ROW_ID = "WB-" + sNewId
                self.cif.EVENT_ID = sNewId
                self.cif.EVENT_NAME = "New Event " + sNewId

                self.cif.WORKFLOW_STATUS_ID = <any>await Meta_getDefaultOrFirstItem(dbContext, ['Event Status'])
                self.cif.PLANNING_PROFILE_GROUP_ID = <any>await Meta_getDefaultOrFirstItem(dbContext, ['Planning Profile Group'])
                self.cif.EVENT_TYPE_ID = <any>await EventType_getDefaultOrFirstItem(dbContext, [], false)
                resolve()
            }

            setAsyncDefaults()
        })
    }

    get cif(): RowIF.IwbEvent {
        return this
    }

    get WB_EventOverrideRow(): WB_EventOverrideRow {
        return getHasOneProperty(this, 'Overrides');
    }

    set WB_EventOverrideRow(value) {
        setHasOneProperty(this, 'Overrides', value);
    }

    get InStore(): DateRangePropertyBW {
        return this._InStore
    }

    get Shipment(): DateRangePropertyBW {
        return this._Shipment
    }

    get WB_PlanRow(): WB_PlanRow {
        return getBelongsToProperty(this, 'Plan');
    }

    get WB_CustomerRow_Planning(): WB_CustomerRow {
        return getBelongsToProperty(this, 'PlanningCustomer');
    }

    set WB_CustomerRow_Planning(value) {
        setBelongsToProperty(this, 'PlanningCustomer', value);
    }

    get WB_CustomerRow_SubPlanning(): WB_CustomerRow {
        return getBelongsToProperty(this, 'SubPlanningCustomer');
    }

    set WB_CustomerRow_SubPlanning(value) {
        setBelongsToProperty(this, 'SubPlanningCustomer', value);
    }

    get WB_EventTypeRow(): WB_EventTypeRow {
        return getBelongsToProperty(this, 'EventType');
    }

    set WB_EventTypeRow(value) {
        setBelongsToProperty(this, 'EventType', value);
    }

    get WB_MetaRow_Workflow(): WB_MetaRow {
        return getBelongsToProperty(this, 'WorkflowStatus');
    }

    get WB_MetaRow_PlanningProfileGroup(): WB_MetaRow {
        return getBelongsToProperty(this, 'PlanningProfileGroup');
    }

    get WB_SourceRow(): WB_SourceRow {
        return getBelongsToProperty(this, 'Source');
    }


    get WB_Event_ProductGroupRows(): WB_EventProductGroupRow[] {
        return getHasManyProperty(this, 'EventProductGroups')
    }

    get WB_EventSpend_ProductGroupRows(): WB_EventSpendPrdGrpRow[] {
        return getHasManyProperty(this, 'EventSpendProductGroups')
    }

    get bHasEventSpendProductGroupRows(): boolean {
        for (let aRow of this.WB_EventSpend_ProductGroupRows) {
            if (aRow.isActive)
                return true
        }

        return false
    }

    get WB_EventSpend_RedistributionRows(): WB_EventSpendPrdGrpRedistribRow[] {
        return getHasManyProperty(this, 'EventSpendRedistribution')
    }

    get WB_Event_SourceCustomerRows(): WB_EventCustomerRow[] {
        return getHasManyProperty(this, 'EventSourceCustomers')
    }

    get WB_Event_MetaRows(): WB_EventMetaRow[] {
        return getHasManyProperty(this, 'EventMetas')
    }

    get WB_Event_TagRows(): WB_EventTagRow[] {
        return getHasManyProperty(this, 'EventTags')
    }

    get WB_EventRelationshipRow_Source(): WB_EventRelationshipRow[] {
        return getHasManyProperty(this, 'EventRelsSource')
    }

    get WB_EventRelationshipRow_Target(): WB_EventRelationshipRow[] {
        return getHasManyProperty(this, 'EventRelsTarget')
    }

    get WB_EventFinanceRelationshipRows(): WB_EventFRRow[] {
        return getHasManyProperty(this, 'EventFR')
    }

    get WB_EventCircularRows(): WB_EventCircularRow[] {
        return getHasManyProperty(this, 'EventCirculars');
    }

    get WB_EvtShipPrdRows(): WB_EvtShipPrdRow[] {
        return getHasManyProperty(this, 'EventShipProduct')
    }

    get WB_EvtSShpPrdRows(): WB_EvtSShpPrdRow[] {
        return getHasManyProperty(this, 'EventSpendShipProduct')
    }

}

export class WB_EvtShipPrdRow
    extends ESRecord
    implements RowIF.IwbEvtShipPrd {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbEvtShipPrd {
        return this
    }

    get WB_FinishedProductRow(): WB_FinishedProductRow {
        return getBelongsToProperty(this, 'Product');
    }

    set WB_FinishedProductRow(value) {
        setBelongsToProperty(this, 'Product', value);
    }

    get WB_EventRow(): WB_EventRow {
        return getBelongsToProperty(this, 'Events');
    }

    set WB_EventRow(value) {
        setBelongsToProperty(this, 'Events', value);
    }

    get WB_EvtShipCPrdRows(): WB_EvtShipCPrdRow[] {
        return getHasManyProperty(this, 'EventShipCProduct')
    }

}


export class WB_EvtShipCPrdRow
    extends ESRecord
    implements RowIF.IwbEvtShipCPrd {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbEvtShipCPrd {
        return this
    }

    get WB_EvtShipPrdRow(): WB_EvtShipPrdRow {
        return getBelongsToProperty(this, 'EventShipProduct');
    }

    set WB_EvtShipPrdRow(value) {
        setBelongsToProperty(this, 'EventShipProduct', value);
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup');
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value);
    }

}

export class WB_EventProductGroupRow
    extends ESRecord
    implements RowIF.IwbEventProductGroup {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.DELETED_IND = defaultRowValues.False_Ind()
        this.cif.INTEGRATION_IND = defaultRowValues.Integration_Ind()
        this.cif.DELETED_DT = defaultRowValues.Deleted_Dt()
        this.cif.PG_DECOMP_METHOD = "Standard"
    }

    get cif(): RowIF.IwbEventProductGroup {
        return this
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup');
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value);
    }


    get WB_EventProductGroupOverrideRow(): WB_EventProductGroupOverrideRow {
        return getHasOneProperty(this, 'Overrides')
    }

    set WB_EventProductGroupOverrideRow(value) {
        setHasOneProperty(this, 'Overrides', value)
    }

    get WB_MetricRow_Planned(): WB_MetricRow {
        this.cif.WB_METRIC_ID_PLANNED
        return getBelongsToProperty(this, 'PlannedMetrics');
    }

    set WB_MetricRow_Planned(value) {
        setBelongsToProperty(this, 'PlannedMetrics', value)
    }

    get WB_EventProductRows(): WB_EventProductRow[] {
        return getHasManyProperty(this, 'EventProducts')
    }


}

export class WB_EventProductRow
    extends ESRecord
    implements RowIF.IwbEventProduct {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.ALLOCATION_PCNT = 0
        this.cif.ALLOCATION_UNITS = 0
        this.cif.INTEGRATION_IND = defaultRowValues.Integration_Ind()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MANUAL_IND = defaultRowValues.True_Ind()
    }

    get cif(): RowIF.IwbEventProduct {
        return this
    }

    get WB_FinishedProductRow(): WB_FinishedProductRow {
        return getBelongsToProperty(this, 'Product')
    }

    set WB_FinishedProductRow(value) {
        setBelongsToProperty(this, 'Product', value)
    }

}

export class WB_EventCustomerRow
    extends ESRecord
    implements RowIF.IwbEventCustomer {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.INTEGRATION_IND = defaultRowValues.Integration_Ind()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.EXCLUDE_IND = defaultRowValues.False_Ind()
        this.cif.MANUAL_IND = defaultRowValues.True_Ind()
    }

    get cif(): RowIF.IwbEventCustomer {
        return this
    }

    get WB_CustomerRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Customer')
    }

    set WB_CustomerRow(value) {
        setBelongsToProperty(this, 'Customer', value)
    }

}

export class WB_EventMetaRow
    extends ESRecord
    implements RowIF.IwbEventMeta {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbEventMeta {
        return this
    }

    get WB_MetaRow(): WB_MetaRow {
        return getBelongsToProperty(this, 'Meta')
    }

    set WB_MetaRow(value) {
        setBelongsToProperty(this, 'Meta', value)
    }
}

export class WB_EventCircularRow
    extends ESRecord
    implements RowIF.IwbEventCircular {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbEventCircular {
        return this
    }

    get WB_CircularRow(): WB_CircularRow {
        return getBelongsToProperty(this, "Circular")
    }

    set WB_CircularRow(value) {
        setBelongsToProperty(this, 'Circular', value)
    }
}


export class WB_EventRelationshipRow
    extends ESRecord
    implements RowIF.IwbEventRelationship {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbEventRelationship {
        return this
    }

    get WB_EventRow(): WB_EventRow {
        return getBelongsToProperty(this, 'Event')
    }

    set WB_EventRow(value) {
        setBelongsToProperty(this, 'Event', value)
    }

    get WB_EventRow_Target(): WB_EventRow {
        return getBelongsToProperty(this, 'EventTarget')
    }

    set WB_EventRow_Target(value) {
        setBelongsToProperty(this, 'EventTarget', value)
    }


}


export class WB_EventFRRow
    extends ESRecord
    implements RowIF.IwbEventFR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbEventFR {
        return this
    }

    get WB_EventRow(): WB_EventRow {
        return getBelongsToProperty(this, 'Event')
    }

    set WB_EventRow(value) {
        setBelongsToProperty(this, 'Event', value)
    }

    get WB_EventRow_Target(): WB_EventRow {
        return getBelongsToProperty(this, 'EventTarget')
    }

    set WB_EventRow_Target(value) {
        setBelongsToProperty(this, 'EventTarget', value)
    }

    get WB_MetricRow_Funding(): WB_MetricRow {
        return getBelongsToProperty(this, 'EDLCCalcedMetric');
    }

    set WB_MetricRow_Funding(value) {
        setBelongsToProperty(this, 'EDLCCalcedMetric', value)
    }

}


export class WB_EventTagRow
    extends ESRecord
    implements RowIF.IwbEventTag {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbEventTag {
        return this
    }

    get WB_TagRow(): WB_TagRow {
        return getBelongsToProperty(this, 'Tag')
    }

    set WB_TagRow(value) {
        setBelongsToProperty(this, 'Tag', value)
    }


}

export class WB_EventOverrideRow
    extends ESRecord
    implements RowIF.IwbEventOverride {
    _InStore: DateRangePropertyBW
    _Shipment: DateRangePropertyBW
    _InStoreAligned: DateRangePropertyBW
    _ShipmentAligned: DateRangePropertyBW


    constructor(props: any, opts: any) {
        super(props, opts);
        this._InStore = new DateRangePropertyBW(this, 'InStore', 'INSTORE_START_DT_OVRD', 'INSTORE_END_DT_OVRD')
        this._Shipment = new DateRangePropertyBW(this, 'Shipment', 'SHIPMENT_START_DT_OVRD', 'SHIPMENT_END_DT_OVRD')
        this._InStoreAligned = new DateRangePropertyBW(this, 'InStoreAligned', 'INSTORE_START_DT_ALIGNED', 'INSTORE_END_DT_ALIGNED')
        this._ShipmentAligned = new DateRangePropertyBW(this, 'ShipmentAligned', 'SHIPMENT_START_DT_ALIGNED', 'SHIPMENT_END_DT_ALIGNED')
    }

    setDefaults(): void {
        this.cif.WB_EVT_ID = 0
        this.cif.PROCESSED_IND = defaultRowValues.False_Ind();
        this.cif.PROCESSED_DT = defaultRowValues.Blank_Dt();
        this.cif.ACTUAL_VOL_METHOD_ID = 'Normal'
        this.cif.NOTES = '-'
        this.cif.INSTORE_START_DT_OVRD = defaultRowValues.Blank_Dt()
        this.cif.INSTORE_END_DT_OVRD = defaultRowValues.Blank_Dt()
        this.cif.SHIPMENT_START_DT_OVRD = defaultRowValues.Blank_Dt()
        this.cif.SHIPMENT_END_DT_OVRD = defaultRowValues.Blank_Dt()
        this.cif.INSTORE_START_DT_ALIGNED = defaultRowValues.Blank_Dt()
        this.cif.INSTORE_END_DT_ALIGNED = defaultRowValues.Blank_Dt()
        this.cif.SHIPMENT_START_DT_ALIGNED = defaultRowValues.Blank_Dt()
        this.cif.SHIPMENT_END_DT_ALIGNED = defaultRowValues.Blank_Dt()

        this.cif.MODIFIED_DT = defaultRowValues.Modified_Dt()
        this.cif.MODIFIED_BY = defaultRowValues.Modified_By()
    }

    get cif(): RowIF.IwbEventOverride {
        return this
    }


    get InStore(): DateRangePropertyBW {
        return this._InStore
    }

    set InStore(value) {
        this._InStore.Range = <any>value
    }

    get Shipment(): DateRangePropertyBW {
        return this._Shipment
    }

    set Shipment(value) {
        this._Shipment.Range = <any>value
    }


    get InStoreAligned(): DateRangePropertyBW {
        return this._InStoreAligned
    }

    set InStoreAligned(value) {
        this._InStoreAligned.Range = <any>value
    }

    get ShipmentAligned(): DateRangePropertyBW {
        return this._ShipmentAligned
    }

    set ShipmentAligned(value) {
        this._ShipmentAligned.Range = <any>value
    }


    get WB_MetricRow_Actual(): WB_MetricRow {
        return getBelongsToProperty(this, 'ActualMetrics');
    }

    set WB_MetricRow_Actual(value) {
        setBelongsToProperty(this, 'ActualMetrics', value)
    }

    get WB_MetricRow_ActualOvrd(): WB_MetricRow {
        return getBelongsToProperty(this, 'ActualOvrdMetrics');
    }

    set WB_MetricRow_ActualOvrd(value) {
        setBelongsToProperty(this, 'ActualOvrdMetrics', value)
    }

    get WB_MetricRow_Funding(): WB_MetricRow {
        return getBelongsToProperty(this, 'FundingOvrdMetrics');
    }

    set WB_MetricRow_Funding(value) {
        setBelongsToProperty(this, 'FundingOvrdMetrics', value)
    }

}

export class WB_EventProductGroupOverrideRow
    extends ESRecord
    implements RowIF.IwbEventProductGroupOverride {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbEventProductGroupOverride {
        return this
    }

    get WB_MetricRow_Actual(): WB_MetricRow {
        return getBelongsToProperty(this, 'ActualMetrics');
    }

    set WB_MetricRow_Actual(value) {
        setBelongsToProperty(this, 'ActualMetrics', value)
    }

    get WB_MetricRow_ActualOvrd(): WB_MetricRow {
        return getBelongsToProperty(this, 'ActualOvrdMetrics');
    }

    set WB_MetricRow_ActualOvrd(value) {
        setBelongsToProperty(this, 'ActualOvrdMetrics', value)
    }
}

export class WB_EventSpendRow
    extends ESRecord
    implements RowIF.IwbEventSpend {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbEventSpend {
        return this
    }

    get WB_EventSpendPrdGrpRows(): WB_EventSpendPrdGrpRow[] {
        return getHasManyProperty(this, 'EventSpendProductGroups')
    }

    get WB_SpendTypeRow(): WB_SpendTypeRow {
        return getBelongsToProperty(this, 'SpendType')
    }

    set WB_SpendTypeRow(value) {
        setBelongsToProperty(this, 'SpendType', value)
    }

    get WB_EventRow(): WB_EventRow {
        return getBelongsToProperty(this, 'Event')
    }

    set WB_EventRow(value) {
        setBelongsToProperty(this, 'Event', value)
    }
}

// Event Spend
export class WB_EventSpendPrdGrpRow
    extends ESRecord
    implements RowIF.IwbEventSpendPrdGrp {
    constructor(props: any, opts: any) {
        super(props, opts);
        this.setupDependents("bIsVariable", ["RATE_BASIS_ID"])

    }

    setDefaults(): void {
        this.cif.ROW_TYPE = "WB"
        this.cif.SOURCE_ID = "WB"
        this.cif.PG_DECOMP_METHOD = 'Standard'
        this.cif.MANUAL_IND = '1'
        this.cif.DELETED_IND = '0'
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.INTEGRATION_IND = '1'
        this.cif.EVENT_SPEND_ID = "NewID"
        this.cif.EVENT_SPEND_NAME = "New Name"
        this.cif.EVENT_SPEND_ROW_ID = "New Row ID"
        this.cif.SPEND_PLANNED = 0
        this.cif.SPEND_ACTUAL = 0
        this.cif.SPEND_ACTUAL_FINAL = 0
        this.cif.SPEND_TPM_LE = 0
        this.cif.SPEND_PA_LE = 0
        this.cif.SHIPMENT_START_DT = defaultRowValues.Blank_Dt()
        this.cif.SHIPMENT_END_DT = defaultRowValues.Blank_Dt()
        this.cif.INSTORE_START_DT = defaultRowValues.Blank_Dt()
        this.cif.INSTORE_END_DT = defaultRowValues.Blank_Dt()
        this.cif.DEAL_START_DT = defaultRowValues.Blank_Dt()
        this.cif.DEAL_END_DT = defaultRowValues.Blank_Dt()
        this.cif.RATE_AMT_PER_UNIT = 0
        this.cif.RATE_AMT = 0
        this.cif.RATE_UOM = "CS"
        this.cif.RATE_BASIS_ID = "Consumed"
        this.cif.RATE_CATEGORY_ID = 0
        this.cif.RATE_CURRENCY = "USD"
        this.cif.RATE_DATE_TYPE_ID = 0
        this.cif.RATE_SPEND_METHOD_ID = 0
        this.cif.WORKFLOW_STATUS_ID = 0
        this.cif.EXPENSE_TYPE_ID = 0
    }

    afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this
        return new Promise<void>((resolve, error) => {

            // Set the Defaults for the Domain Values
            let dbContext: PAdbContext = <any>self.dataStore()

            if (_.isEmpty(dbContext)) {
                resolve()
                return
            }

            async function setAsyncDefaults() {
                self.setDefaults()
                self.cif.WB_SPENDM_ID = <any>await SpendType_getDefaultOrFirstItem(dbContext, [])
                //self.cif.WORKFLOW_STATUS_ID = <any> await Meta_getDefaultOrFirstItem(dbContext, [''])
                self.cif.RATE_BASIS_ID = <any>await Domain_getDefaultOrFirstItem(dbContext, ['RateBasis'], true)
                self.cif.RATE_UOM = <any>await Domain_getDefaultOrFirstItem(dbContext, ['RateUOM'], true)
                self.cif.PAYMENT_METHOD_ID = <any>await Meta_getDefaultOrFirstItem(dbContext, ['Payment Method'])
                let newKey: number = <any>(await dbContext.getNewId(self._mapper().name))
                let sNewId = TextUtils.padStart(newKey.toString(36), 12, '0').toUpperCase()
                self.cif.EVENT_SPEND_ROW_ID = sNewId
                self.cif.EVENT_SPEND_ID = sNewId
                self.cif.EVENT_SPEND_NAME = sNewId
            }

            setAsyncDefaults()
                .then((ignore) => {
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    get cif(): RowIF.IwbEventSpendPrdGrp {
        return this
    }

    get WB_EventSpendPrdGrpOverrideRow(): WB_EventSpendPrdGrpOverrideRow {
        return getHasOneProperty(this, 'Overrides')
    }

    set WB_EventSpendPrdGrpOverrideRow(value) {
        setHasOneProperty(this, 'Overrides', value)
    }

    get WB_EventSpendPrdRows(): WB_EventSpendPrdRow[] {
        return getHasManyProperty(this, 'EventSpendProducts')
    }


    get WB_EventSpendPrdGrpCustomerRows(): WB_EventSpendPrdGrpCustomerRow[] {
        return getHasManyProperty(this, 'EventSpendCustomers')
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup')
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value)
    }

    get WB_SpendTypeRow(): WB_SpendTypeRow {
        return getBelongsToProperty(this, 'SpendType')
    }

    set WB_SpendTypeRow(value) {
        setBelongsToProperty(this, 'SpendType', value)
    }

    get WB_EventRow(): WB_EventRow {
        return getBelongsToProperty(this, 'Event')
    }

    set WB_EventRow(value) {
        setBelongsToProperty(this, 'Event', value)
    }

    // InStore
    get InStoreStartDt(): Date {
        return getBWDateProperty(this, 'INSTORE_START_DT')
    }

    set InStoreStartDt(value: Date) {
        setBWDateProperty(this, 'InStoreStartDt', 'INSTORE_START_DT', value)
    }

    get InStoreEndDt(): Date {
        return getBWDateProperty(this, 'INSTORE_END_DT')
    }

    set InStoreEndDt(value: Date) {
        setBWDateProperty(this, 'InStoreEndDt', 'INSTORE_END_DT', value)
    }

    // Shipment
    get ShipmentStartDt(): Date {
        return getBWDateProperty(this, 'SHIPMENT_START_DT')
    }

    set ShipmentStartDt(value: Date) {
        setBWDateProperty(this, 'ShipmentStartDt', 'SHIPMENT_START_DT', value)
    }

    get ShipmentEndDt(): Date {
        return getBWDateProperty(this, 'SHIPMENT_END_DT')
    }

    set ShipmentEndDt(value: Date) {
        setBWDateProperty(this, 'ShipmentEndDt', 'SHIPMENT_END_DT', value)
    }

    get bManualInd(): boolean {
        return getBooleanIndicator(this, 'MANUAL_IND', false)
    }

    get bIsVariable(): boolean {
        return (this.cif.RATE_BASIS_ID != 'Fixed')
    }


}

export class WB_EventSpendPrdRow
    extends ESRecord
    implements RowIF.IwbEventSpendPrd {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.MANUAL_IND = '1'
        this.cif.DELETED_IND = '0'
        this.cif.INTEGRATION_IND = '0'
        this.cif.ALLOCATION_PCNT = 0
        this.cif.ALLOCATION_UNITS = 0
    }

    get cif(): RowIF.IwbEventSpendPrd {
        return this
    }

    get WB_FinishedProductRow(): WB_FinishedProductRow {
        return getBelongsToProperty(this, 'Product')
    }

    set WB_FinishedProductRow(value) {
        setBelongsToProperty(this, 'Product', value)
    }

}

export class WB_EventSpendPrdGrpCustomerRow
    extends ESRecord
    implements RowIF.IwbEventSpendPrdGrpCustomer {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbEventSpendPrdGrpCustomer {
        return this
    }

    get WB_CustomerRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Customer')
    }

    set WB_CustomerRow(value) {
        setBelongsToProperty(this, 'Customer', value)
    }


}

export class WB_EventSpendPrdGrpOverrideRow
    extends ESRecord
    implements RowIF.IwbEventSpendPrdGrpOverride {
    _InStoreOvrd: DateRangePropertyBW
    _ShipmentOvrd: DateRangePropertyBW
    _InStoreAligned: DateRangePropertyBW
    _ShipmentAligned: DateRangePropertyBW

    constructor(props: any, opts: any) {
        super(props, opts);

        this._InStoreOvrd = new DateRangePropertyBW(this, 'InStoreOvrd', 'INSTORE_START_DT_OVRD', 'INSTORE_END_DT_OVRD')
        this._ShipmentOvrd = new DateRangePropertyBW(this, 'ShipmentOvrd', 'SHIPMENT_START_DT_OVRD', 'SHIPMENT_END_DT_OVRD')
        this._InStoreAligned = new DateRangePropertyBW(this, 'InStoreAligned', 'INSTORE_START_DT_ALIGNED', 'INSTORE_END_DT_ALIGNED')
        this._ShipmentAligned = new DateRangePropertyBW(this, 'ShipmentAligned', 'SHIPMENT_START_DT_ALIGNED', 'SHIPMENT_END_DT_ALIGNED')

        this.setupDependents("Spend_Override", ["RATE_AMT_OVRD", "LIABILITY_QTY_OVRD"]);

    }

    setDefaults(): void {
        //
        this.cif.SPEND_CALC_METHOD = 'TPM Actual' // this is overwritten by defaultSpendCalcMethod
        this.cif.RATE_AMT_OVRD = 0
        this.cif.REDEMPTION_PCNT_OVRD = 0
        this.cif.LIABILITY_QTY_OVRD = 0
        this.cif.LIABILITY_QTY = 0
        this.cif.INSTORE_START_DT_OVRD = defaultRowValues.Blank_Dt()
        this.cif.INSTORE_END_DT_OVRD = defaultRowValues.Blank_Dt()
        this.cif.INSTORE_START_DT_ALIGNED = defaultRowValues.Blank_Dt()
        this.cif.INSTORE_END_DT_ALIGNED = defaultRowValues.Blank_Dt()
        this.cif.SHIPMENT_START_DT_OVRD = defaultRowValues.Blank_Dt()
        this.cif.SHIPMENT_END_DT_OVRD = defaultRowValues.Blank_Dt()
        this.cif.SHIPMENT_START_DT_ALIGNED = defaultRowValues.Blank_Dt()
        this.cif.SHIPMENT_END_DT_ALIGNED = defaultRowValues.Blank_Dt()
        this.cif.INSTOREDT_PARENTLINK_IND = defaultRowValues.True_Ind()
        this.cif.SHIPMENTDT_PARENTLINK_IND = defaultRowValues.True_Ind()
        this.cif.MARGINAL_SPEND_IND = defaultRowValues.False_Ind()
        this.cif.MODIFIED_BY = defaultRowValues.Modified_By()
        this.cif.MODIFIED_DT = defaultRowValues.Modified_Dt()
    }

    defaultSpendCalcMethod(aEvtSPGRow: WB_EventSpendPrdGrpRow): Promise<void> {
        const self = this
        return new Promise<void>((resolve, error) => {

            // Set the Defaults for the Domain Values
            let dbContext: PAdbContext = <any>self.dataStore()

            if (_.isEmpty(dbContext)) {
                resolve()
                return
            }

            async function setSpendCalcMethodDefaults() {
                self.cif.SPEND_CALC_METHOD = <any>await Domain_getDefaultOrFirstItem(dbContext, ['LE_Spend'], true)
                if (_.isEmpty(self.cif.SPEND_CALC_METHOD)) {
                    self.cif.SPEND_CALC_METHOD = 'TPM Actual'
                }

                // if ((self.cif.SPEND_CALC_METHOD == "Consumption") && (aEvtSPGRow)) {
                //     if (aEvtSPGRow.cif.RATE_BASIS_ID == "Fixed") {
                //         self.cif.SPEND_CALC_METHOD = 'TPM Actual'
                //     }
                // }
            }

            setSpendCalcMethodDefaults()
                .then((ignore) => {
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })

        })
    }

    get cif(): RowIF.IwbEventSpendPrdGrpOverride {
        return this
    }


    get InStoreOvrd(): DateRangePropertyBW {
        return this._InStoreOvrd
    }

    set InStoreOvrd(value) {
        this._InStoreOvrd.Range = <any>value
    }

    get ShipmentOvrd(): DateRangePropertyBW {
        return this._ShipmentOvrd
    }

    set ShipmentOvrd(value) {
        this._ShipmentOvrd.Range = <any>value
    }


    get InStoreAligned(): DateRangePropertyBW {
        return this._InStoreAligned
    }

    set InStoreAligned(value) {
        this._InStoreAligned.Range = <any>value
    }

    get ShipmentAligned(): DateRangePropertyBW {
        return this._ShipmentAligned
    }

    set ShipmentAligned(value) {
        this._ShipmentAligned.Range = <any>value
    }


    get WB_MetricRow_Actual(): WB_MetricRow {
        return getBelongsToProperty(this, 'ActualMetrics');
    }

    set WB_MetricRow_Actual(value) {
        setBelongsToProperty(this, 'ActualMetrics', value)
    }

    get WB_MetricRow_ActualOvrd(): WB_MetricRow {
        return getBelongsToProperty(this, 'ActualOvrdMetrics');
    }

    set WB_MetricRow_ActualOvrd(value) {
        setBelongsToProperty(this, 'ActualOvrdMetrics', value)
    }

    // InStore
    get InStoreStartDtOvrd(): Date {
        return getBWDateProperty(this, 'INSTORE_START_DT_OVRD')
    }

    set InStoreStartDtOvrd(value: Date) {
        setBWDateProperty(this, 'InStoreStartDtOvrd', 'INSTORE_START_DT_OVRD', value)
    }

    get InStoreEndDtOvrd(): Date {
        return getBWDateProperty(this, 'INSTORE_END_DT_OVRD')
    }

    set InStoreEndDtOvrd(value: Date) {
        setBWDateProperty(this, 'InStoreEndDtOvrd', 'INSTORE_END_DT_OVRD', value)
    }

    // Shipment
    get ShipmentStartDtOvrd(): Date {
        return getBWDateProperty(this, 'SHIPMENT_START_DT_OVRD')
    }

    set ShipmentStartDtOvrd(value: Date) {
        setBWDateProperty(this, 'ShipmentStartDtOvrd', 'SHIPMENT_START_DT_OVRD', value)
    }

    get ShipmentEndDtOvrd(): Date {
        return getBWDateProperty(this, 'SHIPMENT_END_DT_OVRD')
    }

    set ShipmentEndDtOvrd(value: Date) {
        setBWDateProperty(this, 'ShipmentEndDtOvrd', 'SHIPMENT_END_DT_OVRD', value)
    }

    get Spend_Override(): number {
        return (isNaN(this.cif.LIABILITY_QTY_OVRD) ? 0 : this.cif.LIABILITY_QTY_OVRD) * (isNaN(this.cif.RATE_AMT_OVRD) ? 0 : this.cif.RATE_AMT_OVRD);
    }

}

export class WB_EvtSShpPrdRow
    extends ESRecord
    implements RowIF.IwbEvtSShpPrd {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {

        this.cif.SOURCE_ID = "WB"
        this.cif.MANUAL_IND = '1'
        this.cif.DELETED_IND = '0'
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.INTEGRATION_IND = '1'

        this.cif.INSTORE_START_DT = defaultRowValues.Blank_Dt()
        this.cif.INSTORE_END_DT = defaultRowValues.Blank_Dt()
        this.cif.SHIPMENT_START_DT = defaultRowValues.Blank_Dt()
        this.cif.SHIPMENT_END_DT = defaultRowValues.Blank_Dt()
    }

    afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {

            // Set the Defaults for the Domain Values
            let dbContext: PAdbContext = <any>self.dataStore()

            if (_.isEmpty(dbContext)) {
                resolve()
                return
            }

            async function setAsyncDefaults() {
                self.setDefaults()
                self.cif.WB_SPENDM_ID = <any>await SpendType_getDefaultOrFirstItem(dbContext, [])
                self.cif.RATE_BASIS_ID = <any>await Domain_getDefaultOrFirstItem(dbContext, ['RateBasisShipperSpend'], true)
                self.cif.RATE_UOM = <any>await Domain_getDefaultOrFirstItem(dbContext, ['RateUOM'], true)
                self.cif.PAYMENT_METHOD_ID = <any>await Meta_getDefaultOrFirstItem(dbContext, ['Payment Method'])
                let newKey: number = <any>(await dbContext.getNewId(self._mapper().name))
                let sNewId = TextUtils.padStart(newKey.toString(36), 12, '0').toUpperCase()
                self.cif.EVENT_SPEND_ID = sNewId
                self.cif.EVENT_SPEND_NAME = sNewId

                if (self?.WB_EvtSShpPrdOverrideRow) {
                    self.WB_EvtSShpPrdOverrideRow.cif.SPEND_CALC_METHOD = <any>await Domain_getDefaultOrFirstItem(dbContext, ['LE_ShipperSpend'], true)

                }
                resolve()
            }

            setAsyncDefaults()
        })
    }

    get cif(): RowIF.IwbEvtSShpPrd {
        return this
    }

    get WB_EvtSShpPrdOverrideRow(): WB_EvtSShpPrdOverrideRow {
        return getHasOneProperty(this, 'Overrides')
    }

    set WB_EvtSShpPrdOverrideRow(value) {
        setHasOneProperty(this, 'Overrides', value)
    }


    get WB_FinishedProductRow(): WB_FinishedProductRow {
        return getBelongsToProperty(this, 'Product')
    }

    set WB_FinishedProductRow(value) {
        setBelongsToProperty(this, 'Product', value)
    }

    get WB_SpendTypeRow(): WB_SpendTypeRow {
        return getBelongsToProperty(this, 'SpendType')
    }

    set WB_SpendTypeRow(value) {
        setBelongsToProperty(this, 'SpendType', value)
    }

    get WB_EventRow(): WB_EventRow {
        return getBelongsToProperty(this, 'Event')
    }

    set WB_EventRow(value) {
        setBelongsToProperty(this, 'Event', value)
    }

    // InStore
    get InStoreStartDt(): Date {
        return getBWDateProperty(this, 'INSTORE_START_DT')
    }

    set InStoreStartDt(value: Date) {
        setBWDateProperty(this, 'InStoreStartDt', 'INSTORE_START_DT', value)
    }

    get InStoreEndDt(): Date {
        return getBWDateProperty(this, 'INSTORE_END_DT')
    }

    set InStoreEndDt(value: Date) {
        setBWDateProperty(this, 'InStoreEndDt', 'INSTORE_END_DT', value)
    }

    // Shipment
    get ShipmentStartDt(): Date {
        return getBWDateProperty(this, 'SHIPMENT_START_DT')
    }

    set ShipmentStartDt(value: Date) {
        setBWDateProperty(this, 'ShipmentStartDt', 'SHIPMENT_START_DT', value)
    }

    get ShipmentEndDt(): Date {
        return getBWDateProperty(this, 'SHIPMENT_END_DT')
    }

    set ShipmentEndDt(value: Date) {
        setBWDateProperty(this, 'ShipmentEndDt', 'SHIPMENT_END_DT', value)
    }

    get bManualInd(): boolean {
        return getBooleanIndicator(this, 'MANUAL_IND', false)
    }
}

export class WB_EvtSShpPrdOverrideRow
    extends ESRecord
    implements RowIF.IwbEvtSShpPrdO {

    _InStoreOvrd: DateRangePropertyBW
    _ShipmentOvrd: DateRangePropertyBW
    _InStoreAligned: DateRangePropertyBW
    _ShipmentAligned: DateRangePropertyBW

    constructor(props: any, opts: any) {
        super(props, opts);

        this._InStoreOvrd = new DateRangePropertyBW(this, 'InStoreOvrd', 'INSTORE_START_DT_OVRD', 'INSTORE_END_DT_OVRD')
        this._ShipmentOvrd = new DateRangePropertyBW(this, 'ShipmentOvrd', 'SHIPMENT_START_DT_OVRD', 'SHIPMENT_END_DT_OVRD')
        this._InStoreAligned = new DateRangePropertyBW(this, 'InStoreAligned', 'INSTORE_START_DT_ALIGNED', 'INSTORE_END_DT_ALIGNED')
        this._ShipmentAligned = new DateRangePropertyBW(this, 'ShipmentAligned', 'SHIPMENT_START_DT_ALIGNED', 'SHIPMENT_END_DT_ALIGNED')

    }

    setDefaults(): void {
        //
        this.cif.SPEND_CALC_METHOD = 'Shipment' // this is overwritten by defaultSpendCalcMethod
        this.cif.RATE_AMT_OVRD = 0
        this.cif.LIABILITY_QTY_OVRD = 0
        this.cif.LIABILITY_QTY = 0
        this.cif.INSTORE_START_DT_OVRD = defaultRowValues.Blank_Dt()
        this.cif.INSTORE_END_DT_OVRD = defaultRowValues.Blank_Dt()
        this.cif.INSTORE_START_DT_ALIGNED = defaultRowValues.Blank_Dt()
        this.cif.INSTORE_END_DT_ALIGNED = defaultRowValues.Blank_Dt()
        this.cif.SHIPMENT_START_DT_OVRD = defaultRowValues.Blank_Dt()
        this.cif.SHIPMENT_END_DT_OVRD = defaultRowValues.Blank_Dt()
        this.cif.SHIPMENT_START_DT_ALIGNED = defaultRowValues.Blank_Dt()
        this.cif.SHIPMENT_END_DT_ALIGNED = defaultRowValues.Blank_Dt()
        this.cif.INSTOREDT_PARENTLINK_IND = defaultRowValues.True_Ind()
        this.cif.SHIPMENTDT_PARENTLINK_IND = defaultRowValues.True_Ind()
        this.cif.MARGINAL_SPEND_IND = defaultRowValues.False_Ind()
        this.cif.MODIFIED_BY = defaultRowValues.Modified_By()
        this.cif.MODIFIED_DT = defaultRowValues.Modified_Dt()
    }


    get cif(): RowIF.IwbEvtSShpPrdO {
        return this
    }

    get WB_MetricRow_Actual(): WB_MetricRow {
        return getBelongsToProperty(this, 'ActualMetrics');
    }

    set WB_MetricRow_Actual(value) {
        setBelongsToProperty(this, 'ActualMetrics', value)
    }

    get WB_MetricRow_ActualOvrd(): WB_MetricRow {
        return getBelongsToProperty(this, 'ActualOvrdMetrics');
    }

    set WB_MetricRow_ActualOvrd(value) {
        setBelongsToProperty(this, 'ActualOvrdMetrics', value)
    }

    get InStoreOvrd(): DateRangePropertyBW {
        return this._InStoreOvrd
    }

    set InStoreOvrd(value) {
        this._InStoreOvrd.Range = <any>value
    }

    get ShipmentOvrd(): DateRangePropertyBW {
        return this._ShipmentOvrd
    }

    set ShipmentOvrd(value) {
        this._ShipmentOvrd.Range = <any>value
    }


    get InStoreAligned(): DateRangePropertyBW {
        return this._InStoreAligned
    }

    set InStoreAligned(value) {
        this._InStoreAligned.Range = <any>value
    }

    get ShipmentAligned(): DateRangePropertyBW {
        return this._ShipmentAligned
    }

    set ShipmentAligned(value) {
        this._ShipmentAligned.Range = <any>value
    }


    // InStore
    get InStoreStartDtOvrd(): Date {
        return getBWDateProperty(this, 'INSTORE_START_DT_OVRD')
    }

    set InStoreStartDtOvrd(value: Date) {
        setBWDateProperty(this, 'InStoreStartDtOvrd', 'INSTORE_START_DT_OVRD', value)
    }

    get InStoreEndDtOvrd(): Date {
        return getBWDateProperty(this, 'INSTORE_END_DT_OVRD')
    }

    set InStoreEndDtOvrd(value: Date) {
        setBWDateProperty(this, 'InStoreEndDtOvrd', 'INSTORE_END_DT_OVRD', value)
    }

    // Shipment
    get ShipmentStartDtOvrd(): Date {
        return getBWDateProperty(this, 'SHIPMENT_START_DT_OVRD')
    }

    set ShipmentStartDtOvrd(value: Date) {
        setBWDateProperty(this, 'ShipmentStartDtOvrd', 'SHIPMENT_START_DT_OVRD', value)
    }

    get ShipmentEndDtOvrd(): Date {
        return getBWDateProperty(this, 'SHIPMENT_END_DT_OVRD')
    }

    set ShipmentEndDtOvrd(value: Date) {
        setBWDateProperty(this, 'ShipmentEndDtOvrd', 'SHIPMENT_END_DT_OVRD', value)
    }
}


export class WB_EventPortfolioRow
    extends ESRecord
    implements RowIF.IwbEventPortfolio {
    private _bChanged: boolean

    constructor(props: any, opts: any) {
        super(props, opts);
        this._bChanged = false
    }

    setDefaults(): void {

        this.cif.WB_AUTHUSR_ID_CREATEDBY = defaultRowValues.CurrentUserWbId()
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.OVERLAP_HANDLING = "None"
        this.cif.CANNIBALIZATION_POLICY = "Off"
        this.cif.METRIC_SET = "LatestEstimation"
    }

    async afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this
        // Set the Defaults for the Domain Values
        let dbContext: PAdbContext = <any>self.dataStore()

        if (_.isEmpty(dbContext)) {
            return
        }

        self.setDefaults()
        let newKey: number = <any>(await dbContext.getNewId(self._mapper().name))
        let sNewId = TextUtils.padStart(newKey.toString(36), 12, '0').toUpperCase()
        self.cif.PORTFOLIO_ID = sNewId
        self.cif.PORTFOLIO_NAME = 'New Portfolio ' + sNewId

    }

    get cif(): RowIF.IwbEventPortfolio {
        return this
    }

    get WB_SalesOrgRow(): WB_SalesOrgRow {
        return getBelongsToProperty(this, 'SalesOrg')
    }

    set WB_SalesOrgRow(value: WB_SalesOrgRow) {
        setBelongsToProperty(this, 'SalesOrg', value)
    }

    get WB_EventPortfolioRelationshipRows(): WB_EventPortfolioRelationshipRow[] {
        return getHasManyProperty(this, 'EventPortfolioRs')
    }

    get WB_EventPortfolioCustomerRelationshipRows(): WB_EventPortfolioCustomerRelationshipRow[] {
        return getHasManyProperty(this, 'Customers')
    }

    get WB_EventPortfolioProductRelationshipRows(): WB_EventPortfolioProductRelationshipRow[] {
        return getHasManyProperty(this, 'Products')
    }

    get WB_EventPortfolioPeriodRelationshipRows(): WB_EventPortfolioPeriodRelationshipRow[] {
        return getHasManyProperty(this, 'Periods')
    }

    get WB_EventPortfolioTagRelationshipRows(): WB_EventPortfolioTagRelationshipRow[] {
        return getHasManyProperty(this, 'Tags')
    }

    get WB_EventPortfolioEventTypeRelationshipRows(): WB_EventPortfolioEventTypeRelationshipRow[] {
        return getHasManyProperty(this, 'EventTypes')
    }

    get WB_EventPortfolioLinkedAnalysisRows(): WB_EventPortfolioLinkedAnalysisRow[] {
        return getHasManyProperty(this, 'LinkedAnalyses')
    }

    get bChanged(): boolean {
        return this._bChanged
    }

    set bChanged(value: boolean) {
        this._bChanged = value
    }

}

export class WB_EventPortfolioRelationshipRow
    extends ESRecord
    implements RowIF.IwbEventPortfolioRelationship {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbEventPortfolioRelationship {
        return this
    }

    get WB_EventPortfolioRow(): WB_EventPortfolioRow {
        return getBelongsToProperty(this, 'EventPortfolio')
    }

    set WB_EventPortfolioRow(value) {
        setBelongsToProperty(this, 'EventPortfolio', value)
    }

    get WB_EventRow(): WB_EventRow {
        return getBelongsToProperty(this, 'Event')
    }

    set WB_EventRow(value) {
        setBelongsToProperty(this, 'Event', value)
    }


}

export class WB_EventPortfolioCustomerRelationshipRow
    extends ESRecord
    implements RowIF.IwbEventPortfolioCustomerRelationship {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbEventPortfolioCustomerRelationship {
        return this
    }

    get WB_CustomerRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Customer')
    }

    set WB_CustomerRow(value) {
        setBelongsToProperty(this, 'Customer', value)
    }

    get WB_EventPortfolioRow(): WB_EventPortfolioRow {
        return getBelongsToProperty(this, 'EventPortfolio')
    }

    set WB_EventPortfolioRow(value) {
        setBelongsToProperty(this, 'EventPortfolio', value)
    }

    get bIsBenchmark(): boolean {
        return (this.cif.BENCHMARK_IND == '1')
    }


}

export class WB_EventPortfolioProductRelationshipRow
    extends ESRecord
    implements RowIF.IwbEventPortfolioProductRelationship {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbEventPortfolioProductRelationship {
        return this
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup')
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value)
    }

    get WB_EventPortfolioRow(): WB_EventPortfolioRow {
        return getBelongsToProperty(this, 'EventPortfolio')
    }

    set WB_EventPortfolioRow(value) {
        setBelongsToProperty(this, 'EventPortfolio', value)
    }

    get bIsBenchmark(): boolean {
        return (this.cif.BENCHMARK_IND == '1')
    }


}

export class WB_EventPortfolioPeriodRelationshipRow
    extends ESRecord
    implements RowIF.IwbEventPortfolioPeriodRelationship {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbEventPortfolioPeriodRelationship {
        return this
    }

    get WB_PeriodRow(): WB_PeriodRow {
        return getBelongsToProperty(this, 'Period')
    }

    set WB_PeriodRow(value) {
        setBelongsToProperty(this, 'Period', value)
    }

    get WB_EventPortfolioRow(): WB_EventPortfolioRow {
        return getBelongsToProperty(this, 'EventPortfolio')
    }

    set WB_EventPortfolioRow(value) {
        setBelongsToProperty(this, 'EventPortfolio', value)
    }


    get bIsBenchmark(): boolean {
        return (this.cif.BENCHMARK_IND == '1')
    }

}

export class WB_EventPortfolioTagRelationshipRow
    extends ESRecord
    implements RowIF.IwbEventPortfolioTagRelationship {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbEventPortfolioTagRelationship {
        return this
    }

    get WB_TagRow(): WB_TagRow {
        return getBelongsToProperty(this, 'Tag')
    }

    set WB_TagRow(value) {
        setBelongsToProperty(this, 'Tag', value)
    }

    get WB_EventPortfolioRow(): WB_EventPortfolioRow {
        return getBelongsToProperty(this, 'EventPortfolio')
    }

    set WB_EventPortfolioRow(value) {
        setBelongsToProperty(this, 'EventPortfolio', value)
    }


    get bIsBenchmark(): boolean {
        return (this.cif.BENCHMARK_IND == '1')
    }

}

export class WB_EventPortfolioEventTypeRelationshipRow
    extends ESRecord
    implements RowIF.IwbEventPortfolioEventTypeRelationship {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbEventPortfolioEventTypeRelationship {
        return this
    }

    get WB_EventTypeRow(): WB_EventTypeRow {
        return getBelongsToProperty(this, 'EventType')
    }

    set WB_EventTypeRow(value) {
        setBelongsToProperty(this, 'EventType', value)
    }

    get WB_EventPortfolioRow(): WB_EventPortfolioRow {
        return getBelongsToProperty(this, 'EventPortfolio')
    }

    set WB_EventPortfolioRow(value) {
        setBelongsToProperty(this, 'EventPortfolio', value)
    }


}

export class WB_EventPortfolioLinkedAnalysisRow
    extends ESRecord
    implements RowIF.IwbEventPortfolioLinkedAnalysis {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbEventPortfolioLinkedAnalysis {
        return this
    }

    get WB_EventPortfolioRow(): WB_EventPortfolioRow {
        return getBelongsToProperty(this, 'EventPortfolio')
    }

    set WB_EventPortfolioRow(value) {
        setBelongsToProperty(this, 'EventPortfolio', value)
    }

    get WB_EventPortfolioLinkedAnalysisRelationshipRows(): WB_EventPortfolioLinkedAnalysisRelationshipRow[] {
        return getHasManyProperty(this, 'Events')
    }


}

export class WB_EventPortfolioLinkedAnalysisRelationshipRow
    extends ESRecord
    implements RowIF.IwbEventPortfolioLinkedAnalysisRelationship {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbEventPortfolioLinkedAnalysisRelationship {
        return this
    }

    get WB_EventPortfolioLinkedAnalysisRow(): WB_EventPortfolioLinkedAnalysisRow {
        return getBelongsToProperty(this, 'EventPortfolioLA')
    }

    set WB_EventPortfolioLinkedAnalysisRow(value) {
        setBelongsToProperty(this, 'EventPortfolioLA', value)
    }


}

export class WB_EventSpendPrdGrpRedistribRow
    extends ESRecord
    implements RowIF.IwbEventSpendPrdGrpRedistrib {
    _InStoreOvrlp: DateRangePropertyBW
    _ShipmentOvrlp: DateRangePropertyBW

    constructor(props: any, opts: any) {
        super(props, opts);

        this._InStoreOvrlp = new DateRangePropertyBW(this, 'InStoreOvrlp', 'OVRLP_INSTORE_START_DT', 'OVRLP_INSTORE_END_DT')
        this._ShipmentOvrlp = new DateRangePropertyBW(this, 'ShipmentOvrlp', 'OVRLP_SHIPMENT_START_DT', 'OVRLP_SHIPMENT_END_DT')

    }

    setDefaults(): void {
        this.cif.OVRLP_INSTORE_START_DT = defaultRowValues.Blank_Dt()
        this.cif.OVRLP_INSTORE_END_DT = defaultRowValues.Blank_Dt()
        this.cif.OVRLP_INSTORE_PCNT = 0
        this.cif.OVRLP_SHIPMENT_START_DT = defaultRowValues.Blank_Dt()
        this.cif.OVRLP_SHIPMENT_END_DT = defaultRowValues.Blank_Dt()
        this.cif.OVRLP_SHIPMENT_PCNT = 0
        this.cif.WB_SPENDRL_ID = 0
        this.cif.BASIS_RATE_AMT = 0;
        this.cif.OVRLP_SPEND_CNS = 0
        this.cif.OVRLP_SPEND_SHIP = 0
        this.cif.OVRLP_SPEND = 0
        this.cif.OVRLP_SPEND_CALC_DT = defaultRowValues.Blank_Dt()
        this.cif.ALLOCATED_SPEND = 0;
        this.cif.MANUAL_IND = '1';
        this.cif.MODIFIED_DT = defaultRowValues.Modified_Dt()
        this.cif.MODIFIED_BY = defaultRowValues.Modified_By()

    }

    afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this
        return new Promise<void>((resolve, error) => {

            // Set the Defaults for the Domain Values
            let dbContext: PAdbContext = <any>self.dataStore()

            if (_.isEmpty(dbContext)) {
                resolve()
                return
            }

            async function setAsyncDefaults() {
                self.setDefaults()
                self.cif.BASIS_ID = <any>await Domain_getDefaultOrFirstItem(dbContext, ['RedistributionBasis'], false)
            }

            setAsyncDefaults()
                .then((ignore) => {
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    get cif(): RowIF.IwbEventSpendPrdGrpRedistrib {
        return this
    }

    get InStoreOvrlp(): DateRangePropertyBW {
        return this._InStoreOvrlp
    }

    set InStoreOvrlp(value) {
        this._InStoreOvrlp.Range = <any>value
    }

    get ShipmentOvrlp(): DateRangePropertyBW {
        return this._ShipmentOvrlp
    }

    set ShipmentOvrlp(value) {
        this._ShipmentOvrlp.Range = <any>value
    }


    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup')
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value)
    }

    get WB_EventSpendPrdGrpRow(): WB_EventSpendPrdGrpRow {
        return getBelongsToProperty(this, 'EventSpendProductGroup')
    }

    set WB_EventSpendPrdGrpRow(value) {
        setBelongsToProperty(this, 'EventSpendProductGroup', value)
    }

    get WB_MetricRow_Overlap(): WB_MetricRow {
        return getBelongsToProperty(this, 'OvrlpMetrics')
    }

    set WB_MetricRow_Overlap(value) {
        setBelongsToProperty(this, 'OvrlpMetrics', value)
    }

    get WB_EventRow(): WB_EventRow {
        return getBelongsToProperty(this, 'Event')
    }

    set WB_EventRow(value) {
        setBelongsToProperty(this, 'Event', value)
    }


}

// Spend Type
export class WB_SpendTypeRow
    extends ESRecord
    implements RowIF.IwbSpendType {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get WB_TPM_EventSpendRows(): WB_TPM_EventSpendRow[] {
        return getHasManyProperty(this, 'EventSpend')
    }

    get cif(): RowIF.IwbSpendType {
        return this
    }
}


// TPM Event
export class WB_TPM_EventRow
    extends ESRecord
    implements RowIF.IwbTPMEvent {


    _InStore: DateRangePropertyBW
    _Distribution: DateRangePropertyBW
    _Shipment: DateRangePropertyBW
    _Order: DateRangePropertyBW


    constructor(props: any, opts: any) {
        super(props, opts);
        this._InStore = new DateRangePropertyBW(this, 'InStore', 'INSTORE_START_DT', 'INSTORE_END_DT')
        this._Distribution = new DateRangePropertyBW(this, 'Shipment', 'DISTRIBUTION_START_DT', 'DISTRIBUTION_END_DT')
        this._Shipment = new DateRangePropertyBW(this, 'Shipment', 'SHIPMENT_START_DT', 'SHIPMENT_END_DT')
        this._Order = new DateRangePropertyBW(this, 'InStore', 'ORDER_START_DT', 'ORDER_END_DT')

    }

    setDefaults(): void {

        this.cif.EVENT_ID = "NewID"
        this.cif.EVENT_NAME = "New Name"
        this.cif.EVENT_COMMENTS = ''

        this.cif.MANUAL_IND = '1'
        this.cif.DELETED_IND = '0'
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.INTEGRATION_IND = '1'

        this.cif.INSTORE_START_DT = defaultRowValues.Blank_Dt()
        this.cif.INSTORE_END_DT = defaultRowValues.Blank_Dt()
        this.cif.DISTRIBUTION_START_DT = defaultRowValues.Blank_Dt()
        this.cif.DISTRIBUTION_END_DT = defaultRowValues.Blank_Dt()
        this.cif.SHIPMENT_START_DT = defaultRowValues.Blank_Dt()
        this.cif.SHIPMENT_END_DT = defaultRowValues.Blank_Dt()
        this.cif.ORDER_START_DT = defaultRowValues.Blank_Dt()
        this.cif.ORDER_END_DT = defaultRowValues.Blank_Dt()

        this.cif.COVERAGE_FACTOR = 1
        this.cif.PAID_IN_FULL_IND = '0'

        this.cif.ACTIVE_IND = '1'
        this.cif.WB_PLAN_ID = 0
        this.cif.WB_CUST_ID_SUBPLANNING = 0
        this.cif.WB_CUST_ID_PLANNING = 0
        this.cif.WORKFLOW_STATUS_ID = 0
        this.cif.WB_AUTHUSR_ID_CREATEDBY = 0
        let usrCtx: IUsrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
        if (usrCtx && usrCtx.User) {
            this.cif.WB_AUTHUSR_ID_CREATEDBY = usrCtx.User.cif.WB_AUTHUSR_ID
        }
    }

    afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this
        return new Promise<void>((resolve, error) => {

            // Set the Defaults for the Domain Values
            let dbContext: PAdbContext = <any>self.dataStore()

            if (_.isEmpty(dbContext)) {
                resolve()
                return
            }

            async function setAsyncDefaults() {
                self.setDefaults()

                let newKey: number = <any>(await dbContext.getNewId(self._mapper().name))
                let sNewId = TextUtils.padStart(newKey.toString(36), 12, '0').toUpperCase()
                self.cif.EVENT_ID = sNewId
                self.cif.EVENT_NAME = "New Event " + sNewId

                resolve()
            }

            setAsyncDefaults()
        })
    }


    get cif(): RowIF.IwbTPMEvent {
        return this
    }


    //<editor-fold desc="Date Range Properties">
    get InStore(): DateRangePropertyBW {
        return this._InStore
    }

    get Distribution(): DateRangePropertyBW {
        return this._Distribution
    }

    get Shipment(): DateRangePropertyBW {
        return this._Shipment
    }

    get Order(): DateRangePropertyBW {
        return this._Order
    }

    //</editor-fold>

    //<editor-fold desc="Date Properties - Setters and Getters">

    get InStoreStartDt(): Date {
        return getBWDateProperty(this, 'INSTORE_START_DT')
    }

    set InStoreStartDt(value) {
        setBWDateProperty(this, 'InStoreStartDt', 'INSTORE_START_DT', value)
    }

    get InStoreEndDt(): Date {
        return getBWDateProperty(this, 'INSTORE_END_DT')
    }

    set InStoreEndDt(value) {
        setBWDateProperty(this, 'InStoreEndDt', 'INSTORE_END_DT', value)
    }


    get DistributionStartDt(): Date {
        return getBWDateProperty(this, 'DISTRIBUTION_START_DT')
    }

    set DistributionStartDt(value) {
        setBWDateProperty(this, 'DistributionStartDt', 'DISTRIBUTION_START_DT', value)
    }

    get DistributionEndDt(): Date {
        return getBWDateProperty(this, 'DISTRIBUTION_END_DT')
    }

    set DistributionEndDt(value) {
        setBWDateProperty(this, 'DistributionEndDt', 'DISTRIBUTION_END_DT', value)
    }


    get ShipmentStartDt(): Date {
        return getBWDateProperty(this, 'SHIPMENT_START_DT')
    }

    set ShipmentStartDt(value) {
        setBWDateProperty(this, 'ShipmentStartDt', 'SHIPMENT_START_DT', value)
    }

    get ShipmentEndDt(): Date {
        return getBWDateProperty(this, 'SHIPMENT_END_DT')
    }

    set ShipmentEndDt(value) {
        setBWDateProperty(this, 'ShipmentEndDt', 'SHIPMENT_END_DT', value)
    }


    get OrderStartDt(): Date {
        return getBWDateProperty(this, 'ORDER_START_DT')
    }

    set OrderStartDt(value) {
        setBWDateProperty(this, 'OrderStartDt', 'ORDER_START_DT', value)
    }

    get OrderEndDt(): Date {
        return getBWDateProperty(this, 'ORDER_END_DT')
    }

    set OrderEndDt(value) {
        setBWDateProperty(this, 'OrderEndDt', 'ORDER_END_DT', value)
    }


    //</editor-fold>


    get WB_PlanRow(): WB_PlanRow {
        return getBelongsToProperty(this, 'Plan');
    }

    set WB_PlanRow(value) {
        setBelongsToProperty(this, 'Plan', value);
    }

    get WB_CustomerRow_Planning(): WB_CustomerRow {
        return getBelongsToProperty(this, 'PlanningCustomer');
    }

    get WB_CustomerRow_SubPlanning(): WB_CustomerRow {
        return getBelongsToProperty(this, 'SubPlanningCustomer');
    }

    get WB_EventTypeRow(): WB_EventTypeRow {
        return getBelongsToProperty(this, 'EventType');
    }

    set WB_EventTypeRow(value) {
        setBelongsToProperty(this, 'EventType', value);
    }

    get WB_WorkflowStatusRow(): WB_WorkflowStatusRow {
        return getBelongsToProperty(this, 'WorkflowStatus');
    }

    get WB_UserRow_CreatedBy(): WB_UserRow {
        return getBelongsToProperty(this, 'UserCreatedBy');
    }

    set WB_UserRow_CreatedBy(value) {
        setBelongsToProperty(this, 'UserCreatedBy', value);
    }

    get WB_TPM_EventProductGroupRows(): WB_TPM_EventProductGroupRow[] {
        return getHasManyProperty(this, 'EventProductGroups')
    }

    get WB_TPM_EventProductRows(): WB_TPM_EventProductRow[] {
        return getHasManyProperty(this, 'EventProducts')
    }

    get WB_TPM_EventTagRows(): WB_TPM_EventTagRow[] {
        return getHasManyProperty(this, 'EventTags')
    }

    get WB_TPM_EventMetricsRows(): WB_TPM_EventMetricsRow[] {
        return getHasManyProperty(this, 'EventMetrics')
    }

    get WB_TPM_EventProductMetricsRows(): WB_TPM_EventProductMetricsRow[] {
        return getHasManyProperty(this, 'EventProductMetrics')
    }

    get WB_TPM_EventSpendRows(): WB_TPM_EventSpendRow[] {
        return getHasManyProperty(this, 'EventSpend')
    }

    get COVERAGE_FACTOR_BASE_100(): number {
        return this.cif.COVERAGE_FACTOR * 100
    }

    set COVERAGE_FACTOR_BASE_100(value: number) {
        this.cif.COVERAGE_FACTOR = _.toNumber(value) / 100
    }


}

export class WB_TPM_EventProductGroupRow
    extends ESRecord
    implements RowIF.IwbTPMEventProductGroup {
    _IncrEdit: string

    constructor(props: any, opts: any) {
        super(props, opts);
        this._IncrEdit = ""
    }

    setDefaults(): void {
        this.cif.OES_SENT_TO_IND = defaultRowValues.False_Ind()
        this.cif.DELETED_IND = defaultRowValues.False_Ind()
        this.cif.INTEGRATION_IND = defaultRowValues.Integration_Ind()
        this.cif.DELETED_DT = defaultRowValues.Deleted_Dt()
        this.cif.GROSS_LIST_PRICE = 0
        this.cif.NET_LIST_PRICE = 0
        this.cif.BASE_PRICE = 0
        this.cif.EDLP_PRICE = 0
        this.cif.PROMOTED_PRICE = 0
        this.cif.DISCOUNT_PCNT = 0
        this.cif.DISCOUNT_AMT = 0

        this.cif.CNS_PLAN_BASE_QTY = 0
        this.cif.CNS_PLAN_EDLP_QTY = 0
        this.cif.COVERAGE_FACTOR = 1
        this.cif.CNS_BASE_QTY = 0
        this.cif.CNS_BASEANDEDLP_QTY = 0
        this.cif.CNS_EDLP_QTY = 0
        this.cif.CNS_LIFT_PCNT = 0
        this.cif.CNS_LIFT_PCNT_OVRD = 0
        this.cif.CNS_INCR_QTY = 0
        this.cif.CNS_CANN_QTY = 0
        this.cif.CNS_TOTAL_QTY = 0

        this.cif.SHIP_PLAN_BASE_QTY = 0
        this.cif.SHIP_PLAN_EDLP_QTY = 0
        this.cif.SHIP_BASE_QTY = 0
        this.cif.SHIP_BASEANDEDLP_QTY = 0
        this.cif.SHIP_INCR_QTY = 0
        this.cif.CNS_FORWARD_BUY_PCNT = 0
        this.cif.SHIP_FORWARD_BUY_QTY = 0
        this.cif.SHIP_ADJ_QTY = 0
        this.cif.SHIP_TOTAL_QTY = 0
        this.cif.SHIP_INDIRECT_QTY = 0
        this.cif.SHIP_DISPLAY_QTY = 0
        this.cif.SHIP_DISPLAY_PCNT = 1
    }

    get cif(): RowIF.IwbTPMEventProductGroup {
        return this
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup');
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value);
    }

    get WB_TPM_Event(): WB_TPM_EventRow {
        return getBelongsToProperty(this, 'Event');
    }

    get COVERAGE_FACTOR_BASE_100(): number {
        return this.cif.COVERAGE_FACTOR * 100
    }

    set COVERAGE_FACTOR_BASE_100(value: number) {
        this.cif.COVERAGE_FACTOR = _.toNumber(value) / 100
    }

    get DISCOUNT_PCNT_BASE_100(): number {
        return this.cif.DISCOUNT_PCNT * 100
    }

    set DISCOUNT_PCNT_BASE_100(value: number) {
        this.cif.DISCOUNT_PCNT = _.toNumber(value) / 100
    }

    get CNS_LIFT_PCNT_BASE_100(): number {
        return this.cif.CNS_LIFT_PCNT * 100
    }

    set CNS_LIFT_PCNT_BASE_100(value: number) {
        this.cif.CNS_LIFT_PCNT = _.toNumber(value) / 100
    }

    get CNS_LIFT_PCNT_OVRD_BASE_100(): number {
        return this.cif.CNS_LIFT_PCNT_OVRD * 100
    }

    set CNS_LIFT_PCNT_OVRD_BASE_100(value: number) {
        this.cif.CNS_LIFT_PCNT_OVRD = _.toNumber(value) / 100
    }

    get CNS_FORWARD_BUY_PCNT_BASE_100(): number {
        return this.cif.CNS_FORWARD_BUY_PCNT * 100
    }

    set CNS_FORWARD_BUY_PCNT_BASE_100(value: number) {
        this.cif.CNS_FORWARD_BUY_PCNT = _.toNumber(value) / 100
    }

    get SHIP_DISPLAY_PCNT_BASE_100(): number {
        return this.cif.SHIP_DISPLAY_PCNT * 100
    }

    set SHIP_DISPLAY_PCNT_BASE_100(value: number) {
        this.cif.SHIP_DISPLAY_PCNT = _.toNumber(value) / 100
    }

    get IncrEdit(): string {
        return this._IncrEdit
    }

    set IncrEdit(value: string) {
        this._IncrEdit = value
    }
}


export class WB_TPM_EventProductRow
    extends ESRecord
    implements RowIF.IwbTPMEventProduct {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.OES_SENT_TO_IND = defaultRowValues.False_Ind()
        this.cif.INTEGRATION_IND = defaultRowValues.Integration_Ind()
        this.cif.DELETED_IND = defaultRowValues.False_Ind()
        this.cif.DELETED_DT = defaultRowValues.Deleted_Dt()
        this.cif.MANUAL_IND = defaultRowValues.True_Ind()

        this.cif.GROSS_LIST_PRICE = 0
        this.cif.NET_LIST_PRICE = 0
        this.cif.ROW_TYPE = 'na'
        this.cif.PARENT_ROW_ID = 0
        this.cif.SHIP_DISPLAY_QTY = 0
        this.cif.SHIP_TOTAL_QTY = 0
    }

    get cif(): RowIF.IwbTPMEventProduct {
        return this
    }

    get WB_ProductRow(): WB_FinishedProductRow {
        return getBelongsToProperty(this, 'Product');
    }

    set WB_ProductRow(value) {
        setBelongsToProperty(this, 'Product', value);
    }

    get WB_TPM_Event(): WB_TPM_EventRow {
        return getBelongsToProperty(this, 'Event');
    }

}


export class WB_TPM_EventSpendTypeRow
    extends ESRecord
    implements RowIF.IwbTPMEventSpendType {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            self.setDefaults()
            resolve()
        })
    }

    setDefaults(): void {
        this.cif.SPENDTYPE_ID = 'New '
        this.cif.SPEND_TYPE_NAME = 'New '
        this.cif.ACTIVE_IND = '1'
        this.cif.RATE_LEVEL = 'Header'
        this.cif.RATEBASIS_SHOW_IND = ''
        this.cif.RATEBASIS_OPTIONS = ''
        this.cif.RATEBASIS_DEFAULT = ''
        this.cif.RATEUOM_SHOW_IND = ''
        this.cif.RATEUOM_OPTIONS = ''
        this.cif.RATEUOM_DEFAULT = ''
        this.cif.PAYMENTMETHOD_SHOW_IND = ''
        this.cif.PAYMENTMETHOD_OPTIONS = ''
        this.cif.PAYMENTMETHOD_DEFAULT = ''
        this.cif.FUNDTYPE_SHOW_IND = ''
        this.cif.FUNDTYPE_OPTIONS = ''
        this.cif.FUNDTYPE_DEFAULT = 0
        this.cif.REDEMPTIONRATE_SHOW_IND = '0'
        this.cif.REDEMPTIONRATE_LEVEL = 'ProductGroup'
        this.cif.WORKFLOW_SHOW_IND = '0'
        this.cif.WB_WORKFLOW_ID = 0
        this.cif.WORKFLOW_POLICY = ''
        this.cif.PLANNED_SPEND_SHOW_IND = '1'
        this.cif.APPROVED_SPEND_SHOW_IND = '0'
        this.cif.ACTUAL_SPEND_SHOW_IND = '0'
        this.cif.LE_SPEND_SHOW_IND = '0'
        this.cif.CUSTPMT_WORKFLOW_SHOW_IND = '0'
        this.cif.CUSTPMT_WORKFLOW_ID = 0
        this.cif.PAIDINFULL_SHOW_IND = '0'
        this.cif.THIRDPARTY_SHOW_IND = '0'
        this.cif.INSTOREDATES_SHOW_IND = '0'
        this.cif.INSTOREDATES_POLICY = ''
        this.cif.SHIPMENTDATES_SHOW_IND = '0'
        this.cif.SHIPMENTDATES_POLICY = ''
        this.cif.ORDERDATES_SHOW_IND = '0'
        this.cif.ORDERDATES_POLICY = ''
        this.cif.DISTRIBUTIONDATES_SHOW_IND = '0'
        this.cif.DISTRIBUTIONDATES_POLICY = ''
        this.cif.SPENDTYPE_ROW_ID = ''
        this.cif.SOURCE_ID = 'WB'
        this.cif.MANUAL_IND = '1'
        this.cif.INTEGRATION_IND = ''
        this.cif.DELETED_IND = '0'
        this.cif.RENDER_OPTIONS = ''
        this.cif.TREE_PATH = ''
        this.cif.PRODUCT_SUMMARY_SHOW_IND = '0'
        this.cif.PROCUCT_INCL_SHOW_IND = '0'
        this.cif.PRODUCT_SYNC_POLICY = 'All'
        this.cif.DISPLAY_BUOM_QTY_SHOW_IND = '0'
        this.cif.DISPLAY_QTY_SHOW_IND = '0'
        this.cif.PRODUCTGROUP_SUMMARY_SHOW_IND = '0'
        this.cif.PRODUCTGROUP_INCL_SHOW_IND = '1'
        this.cif.PRODUCTGROUP_SYNC_POLICY = 'All'
        this.cif.PAYMENTS_SHOW_IND = '1'
        this.cif.OFFINVOICELOG_SHOW_IND = '1'
        this.cif.COMMENTS_SHOW_IND = '1'
        this.cif.SUBCUSTOMER_SHOW_IND = '0'
        this.cif.NAME_SHOW_IND = '1'
        this.cif.NETLISTPRICE_SHOW_IND = '0'
        this.cif.GROSSLISTPRICE_SHOW_IND = '0'
        this.cif.MAINTABGRID = 'ProductGroup'
        this.cif.MARGIN_CALCULATOR_SHOW_IND = '0'
        this.cif.PEA_IND = '1'
        this.cif.TRADEIND = '1'
    }

    get cif(): RowIF.IwbTPMEventSpendType {
        return this
    }

    get bActiveInd(): boolean {
        return getBooleanIndicator(this, 'ACTIVE_IND')
    }

    get bRateBasisShowInd(): boolean {
        return getBooleanIndicator(this, 'RATEBASIS_SHOW_IND')
    }

    get bRateUOMShowInd(): boolean {
        return getBooleanIndicator(this, 'RATEUOM_SHOW_IND')
    }

    get bRedemptionRateShowInd(): boolean {
        return getBooleanIndicator(this, 'REDEMPTIONRATE_SHOW_IND')
    }

    get bPaymentMethodShowInd(): boolean {
        return getBooleanIndicator(this, 'PAYMENTMETHOD_SHOW_IND')
    }

    get bFundTypeShowInd(): boolean {
        return getBooleanIndicator(this, 'FUNDTYPE_SHOW_IND')
    }

    get bWorkflowShowInd(): boolean {
        return getBooleanIndicator(this, 'WORKFLOW_SHOW_IND')
    }

    get bPlannedSpendShowInd(): boolean {
        return getBooleanIndicator(this, 'PLANNED_SPEND_SHOW_IND')
    }

    get bApprovedSpendShowInd(): boolean {
        return getBooleanIndicator(this, 'APPROVED_SPEND_SHOW_IND')
    }

    get bActualSpendShowInd(): boolean {
        return getBooleanIndicator(this, 'ACTUAL_SPEND_SHOW_IND')
    }

    get bLESpendShowInd(): boolean {
        return getBooleanIndicator(this, 'LE_SPEND_SHOW_IND')
    }

    get bPaidInFullShowInd(): boolean {
        return getBooleanIndicator(this, 'PAIDINFULL_SHOW_IND')
    }

    get bThirdPartyShowInd(): boolean {
        return getBooleanIndicator(this, 'THIRDPARTY_SHOW_IND')
    }

    get bProductGroupSummaryShowInd(): boolean {
        return getBooleanIndicator(this, 'PRODUCTGROUP_SUMMARY_SHOW_IND')
    }


    get bPaymentsShowInd(): boolean {
        return getBooleanIndicator(this, 'PAYMENTS_SHOW_IND')
    }

    get bOffInvoiceLogShowInd(): boolean {
        return getBooleanIndicator(this, 'OFFINVOICELOG_SHOW_IND')
    }

    get bCommentsShowInd(): boolean {
        return getBooleanIndicator(this, 'COMMENTS_SHOW_IND')
    }

    get bSubCustomerShowInd(): boolean {
        return getBooleanIndicator(this, 'SUBCUSTOMER_SHOW_IND')
    }

    get bInStoreDatesShowInd(): boolean {
        return getBooleanIndicator(this, 'INSTOREDATES_SHOW_IND')
    }

    get bShipmentDatesShowInd(): boolean {
        return getBooleanIndicator(this, 'SHIPMENTDATES_SHOW_IND')
    }

    get bOrderDatesShowInd(): boolean {
        return getBooleanIndicator(this, 'ORDERDATES_SHOW_IND')
    }

    get bDistributionDatesShowInd(): boolean {
        return getBooleanIndicator(this, 'DISTRIBUTIONDATES_SHOW_IND')
    }

    get bManualInd(): boolean {
        return getBooleanIndicator(this, 'MANUAL_IND')
    }

    get bProductSummaryShowInd(): boolean {
        return getBooleanIndicator(this, 'PRODUCT_SUMMARY_SHOW_IND')
    }

    get bDisplayBUOMQtyShowInd(): boolean {
        return getBooleanIndicator(this, 'DISPLAY_BUOM_QTY_SHOW_IND')
    }

    get bDisplayQtyShowInd(): boolean {
        return getBooleanIndicator(this, 'DISPLAY_QTY_SHOW_IND')
    }

    get bProductIncludeShowInd(): boolean {
        return getBooleanIndicator(this, 'PROCUCT_INCL_SHOW_IND')
    }

    get bProductGroupIncludeShowInd(): boolean {
        return getBooleanIndicator(this, 'PRODUCTGROUP_INCL_SHOW_IND')
    }

    get bNameShowInd(): boolean {
        return getBooleanIndicator(this, 'NAME_SHOW_IND')
    }

    get bMarginCalculatorShowInd(): boolean {
        return getBooleanIndicator(this, 'MARGIN_CALCULATOR_SHOW_IND')
    }

    get bGrossListPriceShowInd(): boolean {
        return getBooleanIndicator(this, 'GROSSLISTPRICE_SHOW_IND')
    }

    get bNetListPriceShowInd(): boolean {
        return getBooleanIndicator(this, 'NETLISTPRICE_SHOW_IND')
    }

    get bProductVolBasisShowInd(): boolean {
        return getBooleanIndicator(this, 'PRDVOLBASIS_SHOW_IND')
    }

    get bIndirectCustomerShowInd(): boolean {
        return getBooleanIndicator(this, 'INDIRECT_CUST_SHOW_IND')
    }

    get WB_EventSpendAccounts(): WB_TPM_EventSpendTypeAccountRow[] {
        return getHasManyProperty(this, 'EventSpendAccounts')
    }


}

export class WB_TPM_EventSpendTypeAccountRow
    extends ESRecord
    implements RowIF.IwbTPMEventSpendTypeAccount {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            self.setDefaults()
            resolve()
        })
    }

    setDefaults(): void {

    }

    get cif(): RowIF.IwbTPMEventSpendTypeAccount {
        return this
    }

    get WB_TPM_EventSpendTypeRow(): WB_TPM_EventSpendTypeRow {
        return getBelongsToProperty(this, 'EventSpendType')
    }

    set WB_TPM_EventSpendTypeRow(value) {
        setBelongsToProperty(this, 'EventSpendType', value)
    }

    get WB_GLAccountLiabilityRow(): WB_GeneralLedgerAccountRow {
        return getBelongsToProperty(this, 'GLAccountLiability')
    }

    set WB_GLAccountLiabilityRow(value) {
        setBelongsToProperty(this, 'GLAccountLiability', value)
    }

    get WB_GLAccountExpenseRow(): WB_GeneralLedgerAccountRow {
        return getBelongsToProperty(this, 'GLAccountExpense')
    }

    set WB_GLAccountExpenseRow(value) {
        setBelongsToProperty(this, 'GLAccountExpense', value)
    }
}


export class WB_TPM_EventSpendCustomerRow
    extends ESRecord
    implements RowIF.IwbTPMEventSpendCustomer {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.INTEGRATION_IND = defaultRowValues.Integration_Ind()
        this.cif.DELETED_DT = defaultRowValues.Deleted_Dt()
        this.cif.MANUAL_IND = defaultRowValues.True_Ind()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()

    }

    get cif(): RowIF.IwbTPMEventSpendCustomer {
        return this
    }

    get OESSentToDt(): Date {
        return getBWDateTsProperty(this, 'OES_SENT_TO_DTTS')
    }


    get bOESSentInd(): boolean {
        return getBooleanIndicator(this, 'OES_SENT_TO_IND')
    }

    set bOESSentInd(value) {
        setBooleanIndicator(this, 'bOESSentInd', 'OES_SENT_TO_IND', value)
    }
}

export class WB_EventSpendTypeRelationshipRow
    extends ESRecord
    implements RowIF.IwbEventSpendTypeRelationship {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.EFFECTIVE_START_DT = defaultRowValues.Min_Dt()
        this.cif.EFFECTIVE_END_DT = defaultRowValues.Max_Dt()
    }

    get cif(): RowIF.IwbEventSpendTypeRelationship {
        return this
    }

    get WB_EventType(): WB_EventTypeRow {
        return getBelongsToProperty(this, 'EventType')
    }

    set WB_EventType(value) {
        setBelongsToProperty(this, 'EventType', value)
    }

    get WB_EventSpendType(): WB_TPM_EventSpendTypeRow {
        return getBelongsToProperty(this, 'EventSpendType')
    }

    set WB_EventSpendType(value) {
        setBelongsToProperty(this, 'EventSpendType', value)
    }

    get EffectiveStartDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_START_DT')
    }

    set EffectiveStartDt(value: Date) {
        setBWDateProperty(this, 'EffectiveStartDt', 'EFFECTIVE_START_DT', value)
    }

    get EffectiveEndDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_END_DT')
    }

    set EffectiveEndDt(value: Date) {
        setBWDateProperty(this, 'EffectiveEndDt', 'EFFECTIVE_END_DT', value)
    }

}


export class WB_TPM_EventSpendRow
    extends ESRecord
    implements RowIF.IwbTPMEventSpend {

    _InStore: DateRangePropertyBW
    _Distribution: DateRangePropertyBW
    _Shipment: DateRangePropertyBW
    _Order: DateRangePropertyBW
    _Accrual: DateRangePropertyBW

    constructor(props: any, opts: any) {
        super(props, opts);
        this._InStore = new DateRangePropertyBW(this, 'InStore', 'INSTORE_START_DT', 'INSTORE_END_DT')
        this._Distribution = new DateRangePropertyBW(this, 'Shipment', 'DISTRIBUTION_START_DT', 'DISTRIBUTION_END_DT')
        this._Shipment = new DateRangePropertyBW(this, 'Shipment', 'SHIPMENT_START_DT', 'SHIPMENT_END_DT')
        this._Order = new DateRangePropertyBW(this, 'InStore', 'ORDER_START_DT', 'ORDER_END_DT')
        this._Accrual = new DateRangePropertyBW(this, 'Accrual', 'ACCRUAL_START_DT', 'ACCRUAL_END_DT')
        this.setupDependents("PRDVOLBASIS_OPTIONS", ["PAYMENT_METHOD", "RATE_BASIS_ID"])
    }

    setDefaults(): void {

        this.cif.EVENT_SPEND_ID = "NewID"
        this.cif.EVENT_SPEND_NAME = "New Name"
        this.cif.EVENT_SPEND_COMMENTS = ''

        this.cif.REDEMPTION_RATE_PCNT = 1
        this.cif.PLANNED_SPEND = 0
        this.cif.APPROVED_SPEND = 0
        this.cif.ACTUAL_SPEND = 0
        this.cif.LE_SPEND = 0

        this.cif.ACTIVE_IND = defaultRowValues.True_Ind()
        this.cif.OES_SENT_TO_IND = defaultRowValues.False_Ind()
        this.cif.PAID_IN_FULL_IND = defaultRowValues.False_Ind()
        this.cif.RATE_AMT = 0
        this.cif.MANUAL_IND = '1'
        this.cif.DELETED_IND = defaultRowValues.False_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.INTEGRATION_IND = defaultRowValues.True_Ind()

        this.cif.INSTORE_START_DT = defaultRowValues.Blank_Dt()
        this.cif.INSTORE_END_DT = defaultRowValues.Blank_Dt()
        this.cif.DISTRIBUTION_START_DT = defaultRowValues.Blank_Dt()
        this.cif.DISTRIBUTION_END_DT = defaultRowValues.Blank_Dt()
        this.cif.SHIPMENT_START_DT = defaultRowValues.Blank_Dt()
        this.cif.SHIPMENT_END_DT = defaultRowValues.Blank_Dt()


        this.cif.WB_AUTHUSR_ID_CREATEDBY = 0
        let usrCtx: IUsrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
        if (usrCtx && usrCtx.User) {
            this.cif.WB_AUTHUSR_ID_CREATEDBY = usrCtx.User.cif.WB_AUTHUSR_ID
        }
    }

    afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {

            // Set the Defaults for the Domain Values
            let dbContext: PAdbContext = <any>self.dataStore()

            if (_.isEmpty(dbContext)) {
                resolve()
                return
            }

            async function setAsyncDefaults() {
                self.setDefaults()

                let newKey: number = <any>(await dbContext.getNewId(self._mapper().name))
                let sNewId = TextUtils.padStart(newKey.toString(36), 10, '0').toUpperCase()
                self.cif.EVENT_SPEND_ID = sNewId
                self.cif.EVENT_SPEND_NAME = "New Event Spend " + sNewId

                resolve()
            }

            setAsyncDefaults()
        })
    }

    get cif(): RowIF.IwbTPMEventSpend {
        return this
    }

    //<editor-fold desc="Date Range Properties">
    get InStore(): DateRangePropertyBW {
        return this._InStore
    }

    get Distribution(): DateRangePropertyBW {
        return this._Distribution
    }

    get Shipment(): DateRangePropertyBW {
        return this._Shipment
    }

    //get Order(): DateRangePropertyBW {return this._Order }
    //</editor-fold>

    //<editor-fold desc="Date Properties - Setters and Getters">

    get InStoreStartDt(): Date {
        return getBWDateProperty(this, 'INSTORE_START_DT')
    }

    set InStoreStartDt(value) {
        setBWDateProperty(this, 'InStoreStartDt', 'INSTORE_START_DT', value)
    }

    get InStoreEndDt(): Date {
        return getBWDateProperty(this, 'INSTORE_END_DT')
    }

    set InStoreEndDt(value) {
        setBWDateProperty(this, 'InStoreEndDt', 'INSTORE_END_DT', value)
    }


    get DistributionStartDt(): Date {
        return getBWDateProperty(this, 'DISTRIBUTION_START_DT')
    }

    set DistributionStartDt(value) {
        setBWDateProperty(this, 'DistributionStartDt', 'DISTRIBUTION_START_DT', value)
    }

    get DistributionEndDt(): Date {
        return getBWDateProperty(this, 'DISTRIBUTION_END_DT')
    }

    set DistributionEndDt(value) {
        setBWDateProperty(this, 'DistributionEndDt', 'DISTRIBUTION_END_DT', value)
    }


    get ShipmentStartDt(): Date {
        return getBWDateProperty(this, 'SHIPMENT_START_DT')
    }

    set ShipmentStartDt(value) {
        setBWDateProperty(this, 'ShipmentStartDt', 'SHIPMENT_START_DT', value)
    }

    get ShipmentEndDt(): Date {
        return getBWDateProperty(this, 'SHIPMENT_END_DT')
    }

    set ShipmentEndDt(value) {
        setBWDateProperty(this, 'ShipmentEndDt', 'SHIPMENT_END_DT', value)
    }


    get OrderStartDt(): Date {
        return getBWDateProperty(this, 'ORDER_START_DT')
    }

    set OrderStartDt(value) {
        setBWDateProperty(this, 'OrderStartDt', 'ORDER_START_DT', value)
    }

    get OrderEndDt(): Date {
        return getBWDateProperty(this, 'ORDER_END_DT')
    }

    set OrderEndDt(value) {
        setBWDateProperty(this, 'OrderEndDt', 'ORDER_END_DT', value)
    }

    //</editor-fold>

    get OESSentToDt(): Date {
        return getBWDateTsProperty(this, 'OES_SENT_TO_DTTS')
    }


    get bOESSentInd(): boolean {
        return getBooleanIndicator(this, 'OES_SENT_TO_IND')
    }

    set bOESSentInd(value) {
        setBooleanIndicator(this, 'bOESSentInd', 'OES_SENT_TO_IND', value)
    }

    get REDEMPTION_RATE_PCNT_BASE_100(): number {
        return this.cif.REDEMPTION_RATE_PCNT * 100
    }

    set REDEMPTION_RATE_PCNT_BASE_100(value: number) {
        this.cif.REDEMPTION_RATE_PCNT = _.toNumber(value) / 100
    }

    get WB_TPM_EventRow(): WB_TPM_EventRow {
        return getBelongsToProperty(this, 'Event')
    }

    get WB_TPM_EventSpendTypeRow(): WB_TPM_EventSpendTypeRow {
        return getBelongsToProperty(this, 'EventSpendType')
    }

    set WB_TPM_EventSpendTypeRow(value) {
        setBelongsToProperty(this, 'EventSpendType', value)
    }

    get WB_WorkflowStatusRow(): WB_WorkflowStatusRow {
        return getBelongsToProperty(this, 'WorkflowStatus');
    }

    get WB_TPM_EventSpendPrdGrpRows(): WB_TPM_EventSpendPrdGrpRow[] {
        return getHasManyProperty(this, 'EventSpendProductGroups')
    }

    get WB_TPM_EventSpendPrdRows(): WB_TPM_EventSpendPrdRow[] {
        return getHasManyProperty(this, 'EventSpendProducts')
    }

    get WB_TPM_EventMetricsRows(): WB_TPM_EventMetricsRow[] {
        return getHasManyProperty(this, 'EventSpendMetrics')
    }

    get PRDVOLBASIS_OPTIONS(): string {
        switch (this.cif.PAYMENT_METHOD) {
            case TPMConstants.PaymentMethod_Check:
            case TPMConstants.PaymentMethod_Deduction:
                return this.WB_TPM_EventSpendTypeRow.cif.PRDVOLBASIS_BB_OPTIONS
            case TPMConstants.PaymentMethod_OffInvoice:
                return this.WB_TPM_EventSpendTypeRow.cif.PRDVOLBASIS_OI
            case TPMConstants.PaymentMethod_Rebate:
                return this.WB_TPM_EventSpendTypeRow.cif.PRDVOLBASIS_REBATE
            default:
                return ''
        }
    }

}

export class WB_TPM_EventSpendPrdGrpRow
    extends ESRecord
    implements RowIF.IwbTPMEventSpendPrdGrp {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.ROW_TYPE = "ProductGroup"
        this.cif.INCLUDE_IND = '1'
        this.cif.GROSS_LIST_PRICE = 0
        this.cif.NET_LIST_PRICE = 0
        this.cif.RATE_AMT = 0
        this.cif.SHIP_BUOM_QTY = 0
        this.cif.SHIP_DISPLAY_QTY = 0
        this.cif.SHIP_TOTAL_QTY = 0
        this.cif.MANUAL_IND = '1'
        this.cif.ACTUAL_SPEND = 0
        this.cif.PLANNED_SPEND = 0
        this.cif.APPROVED_SPEND = 0
        this.cif.LE_SPEND = 0
        this.cif.OES_SENT_TO_IND = defaultRowValues.False_Ind()
        this.cif.DELETED_IND = defaultRowValues.False_Ind()
        this.cif.REDEMPTION_RATE_PCNT = 1
    }

    get cif(): RowIF.IwbTPMEventSpendPrdGrp {
        return this
    }

    get REDEMPTION_RATE_PCNT_BASE_100(): number {
        return this.cif.REDEMPTION_RATE_PCNT * 100
    }

    set REDEMPTION_RATE_PCNT_BASE_100(value: number) {
        this.cif.REDEMPTION_RATE_PCNT = _.toNumber(value) / 100
    }

    get WB_TPM_EventSpendRow(): WB_TPM_EventSpendRow {
        return getBelongsToProperty(this, 'EventSpend')
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup');
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value);
    }

}


export class WB_TPM_EventSpendPrdRow
    extends ESRecord
    implements RowIF.IwbTPMEventSpendPrd {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.ROW_TYPE = "na"
        this.cif.PARENT_ROW_ID = 0
        this.cif.INCLUDE_IND = '1'
        this.cif.GROSS_LIST_PRICE = 0
        this.cif.NET_LIST_PRICE = 0
        this.cif.RATE_AMT = 0
        this.cif.REDEMPTION_RATE_PCNT = 1
        this.cif.SHIP_BUOM_QTY = 0
        this.cif.SHIP_DISPLAY_QTY = 0
        this.cif.SHIP_TOTAL_QTY = 0
        this.cif.ACTUAL_SPEND = 0
        this.cif.PLANNED_SPEND = 0
        this.cif.APPROVED_SPEND = 0
        this.cif.LE_SPEND = 0
        this.cif.MANUAL_IND = '1'
        this.cif.OES_SENT_TO_IND = defaultRowValues.False_Ind()
        this.cif.DELETED_IND = defaultRowValues.False_Ind()
    }


    get cif(): RowIF.IwbTPMEventSpendPrd {
        return this
    }

    get WB_TPM_EventSpendRow(): WB_TPM_EventSpendRow {
        return getBelongsToProperty(this, 'EventSpend')
    }

    get WB_ProductRow(): WB_FinishedProductRow {
        return getBelongsToProperty(this, 'Product');
    }

    set WB_ProductRow(value) {
        setBelongsToProperty(this, 'Product', value);
    }

}


export class WB_TPM_EventTagRow
    extends ESRecord
    implements RowIF.IwbTPMEventTag {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbTPMEventTag {
        return this
    }

    get WB_TagRow(): WB_TagRow {
        return getBelongsToProperty(this, 'Tag');
    }

    set WB_TagRow(value) {
        setBelongsToProperty(this, 'Tag', value);
    }
}


export class WB_TPM_EventMetricsRow
    extends ESRecord
    implements RowIF.IwbTPMEventMetrics {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.ROW_SOURCE = "WB";
        this.cif.CREATE_DT = defaultRowValues.Created_Dt();
        this.cif.GROSS_LIST_PRICE = 0;
        this.cif.NET_LIST_PRICE = 0;
        this.cif.NET_LIST_PRICE_INDIRECT = 0;
        this.cif.VCM = 0;
        this.cif.RETAILER_BASE_PRICE = 0;
        this.cif.RETAILER_EDLP_PRICE = 0;
        this.cif.RETAILER_PROMO_PRICE = 0;
        this.cif.UNIT_FACTOR = 0;
        this.cif.WT_FACTOR = 0;
        this.cif.STATCS_FACTOR = 0;
        this.cif.CNS_BASE_QTY = 0;
        this.cif.CNS_EDLP_QTY = 0;
        this.cif.CNS_INCR_QTY = 0;
        this.cif.CNS_CANN_QTY = 0;
        this.cif.CNS_TOTAL_QTY = 0;
        this.cif.SHIP_BASE_QTY = 0;
        this.cif.SHIP_EDLP_QTY = 0;
        this.cif.SHIP_INCR_QTY = 0;
        this.cif.SHIP_FORWARDBUY_QTY = 0;
        this.cif.SHIP_ADJ_QTY = 0;
        this.cif.SHIP_TOTAL_QTY = 0;
        this.cif.SHIP_DIR_TOTAL_QTY = 0;
        this.cif.SHIP_DIR_PCNT = 0;
        this.cif.SHIP_IND_TOTAL_QTY = 0;
        this.cif.SHIP_IND_PCNT = 0;
        this.cif.SHIP_DISTRIB_PCNT = 0;
        this.cif.SHIP_DISTRIBUTED_QTY = 0;
        this.cif.SHIP_NET_TOTAL_QTY = 0;
        this.cif.SHP_EXP_RECV_PCNT_TOTAL = 0;
        this.cif.FEATUREONLY_ACV = 0;
        this.cif.DISPLAYONLY_ACV = 0;
        this.cif.FEATUREDISPLAY_ACV = 0;
        this.cif.TPRONLY_ACV = 0;
        this.cif.PROMOTED_ACV = 0;
        this.cif.ACT_CNS_BASE_UNITS = 0;
        this.cif.ACT_CNS_BASE_RTLSLS = 0;
        this.cif.ACT_CNS_BASE_WT = 0;
        this.cif.ACT_CNS_BASE_STAT = 0;
        this.cif.ACT_CNS_EDLP_UNITS = 0;
        this.cif.ACT_CNS_EDLP_RTLSLS = 0;
        this.cif.ACT_CNS_EDLP_WT = 0;
        this.cif.ACT_CNS_EDLP_STAT = 0;
        this.cif.ACT_CNS_INCR_UNITS = 0;
        this.cif.ACT_CNS_INCR_RTLSLS = 0;
        this.cif.ACT_CNS_INCR_WT = 0;
        this.cif.ACT_CNS_INCR_STAT = 0;
        this.cif.ACT_CNS_TOTAL_UNITS = 0;
        this.cif.ACT_CNS_TOTAL_RTLSLS = 0;
        this.cif.ACT_CNS_TOTAL_WT = 0;
        this.cif.ACT_CNS_TOTAL_STAT = 0;
        this.cif.ACT_FEATUREONLY_ACV = 0;
        this.cif.ACT_DISPLAYONLY_ACV = 0;
        this.cif.ACT_FEATUREDISPLAY_ACV = 0;
        this.cif.ACT_TPRONLY_ACV = 0;
        this.cif.ACT_PROMOTED_ACV = 0;
        this.cif.ACT_SHIP_DIR_UNITS = 0;
        this.cif.ACT_SHIP_DIR_WT = 0;
        this.cif.ACT_SHIP_DIR_STAT = 0;
        this.cif.ACT_SHIP_DIR_GRSLISTSLS = 0;
        this.cif.ACT_SHIP_DIR_NETLISTSLS = 0;
        this.cif.ACT_SHIP_DIR_COSTS = 0;
        this.cif.ACT_RTN_DIR_UNITS = 0;
        this.cif.ACT_RTN_DIR_WT = 0;
        this.cif.ACT_RTN_DIR_STAT = 0;
        this.cif.ACT_RTN_DIR_GRSLISTSLS = 0;
        this.cif.ACT_RTN_DIR_NETLISTSLS = 0;
        this.cif.ACT_RTN_DIR_COSTS = 0;
        this.cif.ACT_SHIP_IND_UNITS = 0;
        this.cif.ACT_SHIP_IND_WT = 0;
        this.cif.ACT_SHIP_IND_STAT = 0;
        this.cif.ACT_SHIP_IND_GRSLISTSLS = 0;
        this.cif.ACT_SHIP_IND_NETLISTSLS = 0;
        this.cif.ACT_SHIP_DIST_UNITS = 0;
        this.cif.ACT_SHIP_DIST_WT = 0;
        this.cif.ACT_SHIP_DIST_STAT = 0;
        this.cif.ACT_SHIP_DIST_GRSLISTSLS = 0;
        this.cif.ACT_SHIP_DIST_NETLISTSLS = 0;
        this.cif.LE_CNS_BASE_UNITS = 0;
        this.cif.LE_CNS_BASE_RTLSLS = 0;
        this.cif.LE_CNS_BASE_WT = 0;
        this.cif.LE_CNS_BASE_STAT = 0;
        this.cif.LE_CNS_EDLP_UNITS = 0;
        this.cif.LE_CNS_EDLP_RTLSLS = 0;
        this.cif.LE_CNS_EDLP_WT = 0;
        this.cif.LE_CNS_EDLP_STAT = 0;
        this.cif.LE_CNS_INCR_UNITS = 0;
        this.cif.LE_CNS_INCR_RTLSLS = 0;
        this.cif.LE_CNS_INCR_WT = 0;
        this.cif.LE_CNS_INCR_STAT = 0;
        this.cif.LE_CNS_TOTAL_UNITS = 0;
        this.cif.LE_CNS_TOTAL_RTLSLS = 0;
        this.cif.LE_CNS_TOTAL_WT = 0;
        this.cif.LE_CNS_TOTAL_STAT = 0;
        this.cif.LE_SHIP_UNITS = 0;
        this.cif.LE_SHIP_WT = 0;
        this.cif.LE_SHIP_STAT = 0;
        this.cif.LE_SHIP_GRSLISTSLS = 0;
        this.cif.LE_SHIP_NETLISTSLS = 0;
        this.cif.LE_SHIP_COSTS = 0;
        this.cif.LE_SHIP_DIR_UNITS = 0;
        this.cif.LE_SHIP_DIR_WT = 0;
        this.cif.LE_SHIP_DIR_STAT = 0;
        this.cif.LE_SHIP_DIR_GRSLISTSLS = 0;
        this.cif.LE_SHIP_DIR_NETLISTSLS = 0;
        this.cif.LE_SHIP_DIR_COSTS = 0;
        this.cif.LE_SHIP_IND_UNITS = 0;
        this.cif.LE_SHIP_IND_WT = 0;
        this.cif.LE_SHIP_IND_STAT = 0;
        this.cif.LE_SHIP_IND_GRSLISTSLS = 0;
        this.cif.LE_SHIP_IND_NETLISTSLS = 0;
        this.cif.SPND_VARIABLE = 0;
        this.cif.SPND_FIXED = 0;
        this.cif.ACT_SPND_VARIABLE = 0;
        this.cif.ACT_SPND_FIXED = 0;
        this.cif.LE_SPND_FIXED = 0;
        this.cif.LE_SPND_VARIABLE = 0;
        this.cif.EST_SPND_FIXED = 0;
        this.cif.EST_SPND_VARIABLE = 0;
    }

    get cif(): RowIF.IwbTPMEventMetrics {
        return this
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup');
    }

    get WB_PeriodRow(): WB_PeriodRow {
        return getBelongsToProperty(this, 'Period');
    }

    get WB_EventRow(): WB_TPM_EventRow {
        return getBelongsToProperty(this, 'Event');
    }

}


export class WB_TPM_EventProductMetricsRow
    extends ESRecord
    implements RowIF.IwbTPMEventProductMetrics {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.ROW_SOURCE = "WB";
        this.cif.CREATE_DT = defaultRowValues.Created_Dt();
        this.cif.GROSS_LIST_PRICE = 0;
        this.cif.NET_LIST_PRICE = 0;
        this.cif.UNIT_FACTOR = 0;
        this.cif.WT_FACTOR = 0;
        this.cif.STATCS_FACTOR = 0;
        this.cif.SHIP_DISPLAY_QTY = 0;
        this.cif.SHIP_BUOM_QTY = 0;
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbTPMEventProductMetrics {
        return this
    }

    get bDeletedInd(): boolean {
        return getBooleanIndicator(this, 'DELETED_IND')
    }

    get WB_PeriodRow(): WB_PeriodRow {
        return getBelongsToProperty(this, 'Period');
    }

    get WB_ProductRow(): WB_FinishedProductRow {
        return getBelongsToProperty(this, 'Product');
    }

    get WB_TPM_EventRow(): WB_TPM_EventRow {
        return getBelongsToProperty(this, 'Event');
    }

}

export class WB_TPM_EventSpendMetricsRow
    extends ESRecord
    implements RowIF.IwbTPMEventSpendMetrics {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.ROW_SOURCE = "WB";
        this.cif.CREATE_DT = defaultRowValues.Created_Dt();
        this.cif.GROSS_LIST_PRICE = 0;
        this.cif.NET_LIST_PRICE = 0;
        this.cif.VCM = 0;
        this.cif.CNS_TOTAL_UNITS = 0;
        this.cif.CNS_TOTAL_WT = 0;
        this.cif.CNS_TOTAL_STAT = 0;
        this.cif.SHIP_UNITS = 0;
        this.cif.SHIP_WT = 0;
        this.cif.SHIP_STAT = 0;
        this.cif.PLANNED_SPEND = 0;
        this.cif.APPROVED_SPEND = 0;
        this.cif.ACTUAL_SPEND = 0;
        this.cif.LE_SPEND = 0;
        this.cif.ESTIMATED_SPEND = 0;
        this.cif.EST_CNS_TOTAL_UNITS = 0;
        this.cif.EST_CNS_TOTAL_WT = 0;
        this.cif.EST_CNS_TOTAL_STAT = 0;
        this.cif.EST_SHIP_UNITS = 0;
        this.cif.EST_SHIP_WT = 0;
        this.cif.EST_SHIP_STAT = 0;

    }

    get cif(): RowIF.IwbTPMEventSpendMetrics {
        return this
    }

}

// Lift
export class WB_LiftRow
    extends ESRecord
    implements RowIF.IwbLift {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbLift {
        return this
    }
}

// Event Accrual
export class WB_EventAccrualRow
    extends ESRecord
    implements RowIF.IwbEventAccrual {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbEventAccrual {
        return this
    }
}

// Claim Type
export class WB_ClaimTypeRow
    extends ESRecord
    implements RowIF.IwbClaimType {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbClaimType {
        return this
    }

    get WB_ClaimTypePaymentTypeRows(): WB_ClaimTypePaymentTypeRow[] {
        return getHasManyProperty(this, 'PaymentTypes')
    }
}

export class WB_ClaimTypePaymentTypeRow
    extends ESRecord
    implements RowIF.IwbClaimTypePaymentType {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbClaimTypePaymentType {
        return this
    }

    get WB_ClaimTypeRow(): WB_ClaimTypeRow {
        return getBelongsToProperty(this, 'ClaimType')
    }

    set WB_ClaimTypeRow(value) {
        setBelongsToProperty(this, 'ClaimType', value)
    }

    get WB_PaymentTypeRow(): WB_PaymentTypeRow {
        return getBelongsToProperty(this, 'PaymentType')
    }

    set WB_PaymentTypeRow(value) {
        setBelongsToProperty(this, 'PaymentType', value)
    }
}

// Claim
export class WB_ClaimRow
    extends ESRecord
    implements RowIF.IwbClaim {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {

        this.cif.MANUAL_IND = '1'
        this.cif.DELETED_IND = '0'
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.INTEGRATION_IND = '0'

        this.cif.WB_CUST_ID_PLANNING = 0
        this.cif.WB_STATUS_ID = 0
        this.cif.WB_STATUS_ID_NEXT = 0
        this.cif.WB_AUTHUSR_ID_CREATEDBY = 0
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        let usrCtx: IUsrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
        if (usrCtx && usrCtx.User) {
            this.cif.WB_AUTHUSR_ID_CREATEDBY = usrCtx.User.cif.WB_AUTHUSR_ID
        }
    }

    async afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this

        // Set the Defaults for the Domain Values
        let dbContext: PAdbContext = <any>self.dataStore()

        if (_.isEmpty(dbContext))
            return

        self.setDefaults()

        let newKey: number = <any>(await dbContext.getNewId(self._mapper().name))
        let sNewId = TextUtils.padStart(newKey.toString(36), 12, '0').toUpperCase()
        self.cif.CLAIM_ID = sNewId
        self.cif.CLAIM_NAME = sNewId
        self.ClaimDt = DateUtils.today
        await self.loadRelations([esWB_User])
    }

    get cif(): RowIF.IwbClaim {
        return this
    }

    get WB_ClaimTypeRow(): WB_ClaimTypeRow {
        return getBelongsToProperty(this, 'ClaimType')
    }

    set WB_ClaimTypeRow(value: WB_ClaimTypeRow) {
        setBelongsToProperty(this, 'ClaimType', value)
    }

    get WB_UserRow_CreatedBy(): WB_UserRow {
        return getBelongsToProperty(this, 'UserCreatedBy');
    }

    get WB_CustomerRow_Claim(): WB_CustomerRow {
        return getBelongsToProperty(this, 'ClaimCustomer');
    }

    set WB_CustomerRow_Claim(value: WB_CustomerRow) {
        setBelongsToProperty(this, 'ClaimCustomer', value);
    }

    get WB_CustomerRow_Planning(): WB_CustomerRow {
        return getBelongsToProperty(this, 'PlanningCustomer');
    }

    set WB_CustomerRow_Planning(value: WB_CustomerRow) {
        setBelongsToProperty(this, 'PlanningCustomer', value);
    }

    get WB_ClaimPlanMatchRow(): WB_ClaimPlanMatchRow[] {
        return getHasManyProperty(this, 'ClaimMatches')
    }

    get WB_BusinessUnitRow(): WB_BusinessUnitRow {
        return getBelongsToProperty(this, 'BusinessUnit')
    }

    set WB_BusinessUnitRow(value: WB_BusinessUnitRow) {
        setBelongsToProperty(this, 'BusinessUnit', value)
    }

    get WB_ClaimPaymentRows(): WB_PaymentClaimRow[] {
        return getHasManyProperty(this, 'Claim')
    }

    get WB_CurrentWorkflowStatusRow(): WB_WorkflowStatusRow {
        return getBelongsToProperty(this, 'CurrentStatus')
    }

    set WB_CurrentWorkflowStatusRow(value) {
        setBelongsToProperty(this, 'CurrentStatus', value)
    }


    get CreateDt(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    get ClaimDt(): Date {
        return getBWDateProperty(this, 'CLAIM_DT')
    }

    set ClaimDt(value: Date) {
        setBWDateProperty(this, 'ClaimDt', 'CLAIM_DT', value)
    }

}


export class WB_ClaimPlanMatchRow
    extends ESRecord
    implements RowIF.IwbClaimPlanMatch {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbClaimPlanMatch {
        return this
    }

    get WB_ClaimRow(): WB_ClaimRow {
        return getBelongsToProperty(this, 'Claim')
    }

    set WB_ClaimRow(value) {
        setBelongsToProperty(this, 'Claim', value)
    }

    get WB_CustomerRow_Planning(): WB_CustomerRow {
        return getBelongsToProperty(this, 'PlanningCustomer')
    }

    set WB_CustomerRow_Planning(value) {
        setBelongsToProperty(this, 'PlanningCustomer', value)
    }

    get WB_CustomerRow_SubPlanning(): WB_CustomerRow {
        return getBelongsToProperty(this, 'SubPlanningCustomer')
    }

    set WB_CustomerRow_SubPlanning(value) {
        setBelongsToProperty(this, 'SubPlanningCustomer', value)
    }

    get WB_PlanRow(): WB_PlanRow {
        return getBelongsToProperty(this, 'Plan')
    }

    set WB_PlanRow(value) {
        setBelongsToProperty(this, 'Plan', value)
    }

    get WB_TPM_EventRow(): WB_TPM_EventRow {
        return getBelongsToProperty(this, 'Event')
    }

    set WB_TPM_EventRow(value) {
        setBelongsToProperty(this, 'Event', value)
    }

    get WB_TPM_EventSpendRow(): WB_TPM_EventSpendRow {
        return getBelongsToProperty(this, 'EventSpend')
    }

    set WB_TPM_EventSpendRow(value) {
        setBelongsToProperty(this, 'EventSpend', value)
    }

}


// Payment Type
export class WB_PaymentTypeRow
    extends ESRecord
    implements RowIF.IwbPaymentType {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbPaymentType {
        return this
    }

    get WB_ClaimTypePaymentTypeRows(): WB_ClaimTypePaymentTypeRow[] {
        return getHasManyProperty(this, 'ClaimTypes')
    }

    get bIsManual(): boolean {
        return (this.cif.MANUAL_IND == '1')
    }

    get bIsActive(): boolean {
        return (this.cif.ACTIVE_IND == '1')
    }

    get bShowFundingCustomer(): boolean {
        return (this.cif.FUNDING_CUST_SHOW_IND == '1')
    }

    get bShowPlanningCustomer(): boolean {
        return (this.cif.PLANNING_CUST_SHOW_IND == '1')
    }

    get bShowPayToCustomer(): boolean {
        return (this.cif.PAYTO_CUST_SHOW_IND == '1')
    }

    get bShowExpenseToCustomer(): boolean {
        return (this.cif.EXPENSETO_CUST_SHOW_IND == '1')
    }

    get bIsCorrection(): boolean {
        return (this.cif.SHOW_CORRECTION_IND == '1')
    }

    get bShowCheck(): boolean {
        return (this.cif.SHOW_CHECK_IND == '1')
    }

    get bShowCreditMemo(): boolean {
        return (this.cif.SHOW_CREDIT_MEMO_IND == '1')
    }

    get bShowOffInvoice(): boolean {
        return (this.cif.SHOW_OFF_INVOICE_IND == '1')
    }

    get bShowCustomerInvoice(): boolean {
        return (this.cif.SHOW_OFF_INVOICE_IND == '1')
    }


}

// Payment
export class WB_PaymentRow
    extends ESRecord
    implements RowIF.IwbPayment {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {

        this.cif.MANUAL_IND = '1'
        this.cif.DELETED_IND = '0'
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.INTEGRATION_IND = '1'

        this.cif.WB_CUST_ID_SUBPLANNING = 0
        this.cif.WB_CUST_ID_PLANNING = 0
        this.cif.WB_STATUS_ID = 0
        this.cif.WB_STATUS_ID_NEXT = 0
        this.cif.WB_AUTHUSR_ID_CREATEDBY = 0
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        let usrCtx: IUsrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
        if (usrCtx && usrCtx.User) {
            this.cif.WB_AUTHUSR_ID_CREATEDBY = usrCtx.User.cif.WB_AUTHUSR_ID
        }
    }

    async afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this

        // Set the Defaults for the Domain Values
        let dbContext: PAdbContext = <any>self.dataStore()

        if (_.isEmpty(dbContext))
            return

        self.setDefaults()

        let newKey: number = <any>(await dbContext.getNewId(self._mapper().name))
        let sNewId = TextUtils.padStart(newKey.toString(36), 12, '0').toUpperCase()
        self.cif.PAYMENT_ID = sNewId
        self.cif.PAYMENT_NAME = sNewId
        self.PaymentDt = DateUtils.today
        await self.loadRelations([esWB_User])
    }


    get cif(): RowIF.IwbPayment {
        return this
    }

    get WB_CustomerRow_Funding(): WB_CustomerRow {
        return getBelongsToProperty(this, 'FundingCustomer');
    }

    set WB_CustomerRow_Funding(value: WB_CustomerRow) {
        setBelongsToProperty(this, 'FundingCustomer', value);
    }

    get WB_CustomerRow_Planning(): WB_CustomerRow {
        return getBelongsToProperty(this, 'PlanningCustomer');
    }

    set WB_CustomerRow_Planning(value: WB_CustomerRow) {
        setBelongsToProperty(this, 'PlanningCustomer', value);
    }

    get WB_CustomerRow_SubPlanning(): WB_CustomerRow {
        return getBelongsToProperty(this, 'SubPlanningCustomer');
    }

    set WB_CustomerRow_SubPlanning(value: WB_CustomerRow) {
        setBelongsToProperty(this, 'SubPlanningCustomer', value);
    }

    get WB_CustomerRow_PayTo(): WB_CustomerRow {
        return getBelongsToProperty(this, 'PayTo');
    }

    set WB_CustomerRow_PayTo(value: WB_CustomerRow) {
        setBelongsToProperty(this, 'PayTo', value);
    }

    get WB_PaymentTypeRow(): WB_PaymentTypeRow {
        return getBelongsToProperty(this, 'PaymentType');
    }

    set WB_PaymentTypeRow(value: WB_PaymentTypeRow) {
        setBelongsToProperty(this, 'PaymentType', value);
    }

    get WB_BusinessUnitRow(): WB_BusinessUnitRow {
        return getBelongsToProperty(this, 'BusinessUnit');
    }

    set WB_BusinessUnitRow(value: WB_BusinessUnitRow) {
        setBelongsToProperty(this, 'BusinessUnit', value);
    }


    get WB_WorkflowStatusRow(): WB_WorkflowStatusRow {
        return getBelongsToProperty(this, 'WorkflowStatus');
    }

    set WB_WorkflowStatusRow(value: WB_WorkflowStatusRow) {
        setBelongsToProperty(this, 'WorkflowStatus', value);
    }


    get WB_UserRow_CreatedBy(): WB_UserRow {
        return getBelongsToProperty(this, 'UserCreatedBy');
    }

    set WB_UserRow_CreatedBy(value: WB_UserRow) {
        setBelongsToProperty(this, 'UserCreatedBy', value);
    }

    get WB_UserRow_ApprovedBy(): WB_UserRow {
        return getBelongsToProperty(this, 'UserApprovedBy');
    }

    get WB_PeriodRow(): WB_PeriodRow {
        return getBelongsToProperty(this, 'Period');
    }

    get WB_PaymentClaimRows(): WB_PaymentClaimRow[] {
        return getHasManyProperty(this, 'PaymentClaim')
    }

    get WB_PaymentEventSpendRows(): WB_PaymentEventSpendRow[] {
        return getHasManyProperty(this, 'PaymentEventSpend')
    }

    get WB_PaymentFundRows(): WB_PaymentFundRow[] {
        return getHasManyProperty(this, 'PaymentFund')
    }


    get CreateDt(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    get PaymentDt(): Date {
        return getBWDateProperty(this, 'PAYMENT_DT')
    }

    set PaymentDt(value: Date) {
        setBWDateProperty(this, 'PaymentDt', 'PAYMENT_DT', value)
    }

    get ApprovalDt(): Date {
        return getBWDateTsProperty(this, 'APPROVED_DTTS')
    }

    set ApprovalDt(value: Date) {
        setBWDateTsProperty(this, 'ApprovalDt', 'APPROVED_DTTS', value)
    }

    get CreateDate(): string {
        let dt: Date = this.CreateDt
        if (dt)
            return dt.toLocaleDateString("en-US")
        return ''
    }

    get ApprovalDate(): string {
        let dt: Date = this.ApprovalDt
        if (dt)
            return dt.toLocaleDateString("en-US")
        return ''
    }

}


export class WB_PaymentClaimRow
    extends ESRecord
    implements RowIF.IwbPaymentClaim {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.WB_AUTHUSR_ID_CREATEDBY = 0
        let usrCtx: IUsrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
        if (usrCtx && usrCtx.User) {
            this.cif.WB_AUTHUSR_ID_CREATEDBY = usrCtx.User.cif.WB_AUTHUSR_ID
        }
    }

    get cif(): RowIF.IwbPaymentClaim {
        return this
    }

    get WB_UserRow_CreatedBy(): WB_UserRow {
        return getBelongsToProperty(this, 'UserCreatedBy');
    }

    set WB_UserRow_CreatedBy(value) {
        setBelongsToProperty(this, 'UserCreatedBy', value);
    }

    get WB_ClaimRow(): WB_ClaimRow {
        return getBelongsToProperty(this, 'Claim')
    }

    set WB_ClaimRow(value) {
        setBelongsToProperty(this, 'Claim', value)
    }

    get WB_PaymentRow(): WB_PaymentRow {
        return getBelongsToProperty(this, 'Payment')
    }

    set WB_PaymentRow(value) {
        setBelongsToProperty(this, 'Payment', value)
    }

    get CreateDate(): Date {
        return getBWDateProperty(this, 'CREATED_DTTS')
    }


}

export class WB_PaymentEventSpendRow
    extends ESRecord
    implements RowIF.IwbPaymentEventSpend {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.WB_AUTHUSR_ID_CREATEDBY = 0
        let usrCtx: IUsrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
        if (usrCtx && usrCtx.User) {
            this.cif.WB_AUTHUSR_ID_CREATEDBY = usrCtx.User.cif.WB_AUTHUSR_ID
        }
    }

    get cif(): RowIF.IwbPaymentEventSpend {
        return this
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

    set DeletedDt(value: Date) {
        setBWDateProperty(this, 'DeletedDt', 'DELETED_DT', value)
    }

    get WB_PaymentRow(): WB_PaymentRow {
        return getBelongsToProperty(this, 'Payment');
    }

    set WB_PaymentRow(value: WB_PaymentRow) {
        setBelongsToProperty(this, 'Payment', value);
    }


    get WB_TPM_EventSpendRow(): WB_TPM_EventSpendRow {
        return getBelongsToProperty(this, 'EventSpend')
    }

    set WB_TPM_EventSpendRow(value: WB_TPM_EventSpendRow) {
        setBelongsToProperty(this, 'EventSpend', value)
    }

    get WB_PaymentEventSpendProductGroupRows(): WB_PaymentEventSpendProductGroupRow[] {
        return getHasManyProperty(this, 'PaymentEventSpendPrds')
    }

}

export class WB_PaymentEventSpendProductGroupRow
    extends ESRecord
    implements RowIF.IwbPaymentEventSpendProductGroup {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbPaymentEventSpendProductGroup {
        return this
    }

    get WB_PaymentEventSpendRow(): WB_PaymentEventSpendRow {
        return getBelongsToProperty(this, 'PaymentEventSpend');
    }

    set WB_PaymentEventSpendRow(value: WB_PaymentEventSpendRow) {
        setBelongsToProperty(this, 'PaymentEventSpend', value);
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup');
    }

    set WB_ProductGroupRow(value: WB_ProductGroupRow) {
        setBelongsToProperty(this, 'ProductGroup', value);
    }

}

export class WB_PaymentFundRow
    extends ESRecord
    implements RowIF.IwbPaymentFund {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.WB_AUTHUSR_ID_CREATEDBY = 0
        let usrCtx: IUsrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
        if (usrCtx && usrCtx.User) {
            this.cif.WB_AUTHUSR_ID_CREATEDBY = usrCtx.User.cif.WB_AUTHUSR_ID
        }
    }

    get cif(): RowIF.IwbPaymentFund {
        return this
    }

    get WB_PaymentRow(): WB_PaymentRow {
        return getBelongsToProperty(this, 'Payment');
    }

    set WB_PaymentRow(value: WB_PaymentRow) {
        setBelongsToProperty(this, 'Payment', value);
    }

    get WB_CustomerRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'FundingCustomer')
    }

    set WB_CustomerRow(value: WB_CustomerRow) {
        setBelongsToProperty(this, 'FundingCustomer', value)
    }

    get WB_PlanRow(): WB_PlanRow {
        return getBelongsToProperty(this, 'Plan')
    }

    set WB_PlanRow(value: WB_PlanRow) {
        setBelongsToProperty(this, 'Plan', value)
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'FundingProductGroup')
    }

    set WB_ProductGroupRow(value: WB_ProductGroupRow) {
        setBelongsToProperty(this, 'FundingProductGroup', value)
    }

    get WB_PeriodRow(): WB_PeriodRow {
        return getBelongsToProperty(this, 'FundingPeriod')
    }

    set WB_PeriodRow(value: WB_PeriodRow) {
        setBelongsToProperty(this, 'FundingPeriod', value)
    }

    get WB_PaymentFundProductGroupRows(): WB_PaymentFundProductGroupRow[] {
        return getHasManyProperty(this, 'PaymentFundPrds')
    }

}

export class WB_PaymentFundProductGroupRow
    extends ESRecord
    implements RowIF.IwbPaymentFundProductGroup {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbPaymentFundProductGroup {
        return this
    }

    get WB_PaymentFundRow(): WB_PaymentFundRow {
        return getBelongsToProperty(this, 'PaymentFund')
    }

    set WB_PaymentFundRow(value: WB_PaymentFundRow) {
        setBelongsToProperty(this, 'PaymentFund', value)
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup')
    }

    set WB_ProductGroupRow(value: WB_ProductGroupRow) {
        setBelongsToProperty(this, 'ProductGroup', value)
    }

}

//
// Authorization Provider
export class WB_AuthProviderRow
    extends ESRecord
    implements RowIF.IwbAuthProvider {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbAuthProvider {
        return this
    }

    get WB_UserRows(): WB_UserRow[] {
        return getHasManyProperty(this, 'Users')
    }
}

//
// User
export class WB_UserRow
    extends ESRecord
    implements RowIF.IwbUser {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbUser {
        return this
    }

    get WB_AuthProviderRow(): WB_AuthProviderRow {
        return getBelongsToProperty(this, 'AuthProvider')
    }

    set WB_AuthProviderRow(value) {
        setBelongsToProperty(this, 'AuthProvider', value)
    }

    get WB_UserCustomerRows(): WB_UserCustomerRow[] {
        return getHasManyProperty(this, 'Customers')
    }

    get WB_UserRoleRows(): WB_UserRoleRow[] {
        return getHasManyProperty(this, 'Roles')
    }

    get WB_UserDimensionRows(): WB_UserDimensionRow[] {
        return getHasManyProperty(this, 'Dimensions')
    }

    get WB_UserGroupUserRows(): WB_UserGroupUserRow[] {
        return getHasManyProperty(this, 'UserGroups')
    }

    get WB_PlanManagementUserRows(): WB_PlanManagementUserRow[] {
        return getHasManyProperty(this, 'PlanManagements')
    }

    get WB_UsrBusinessUnitRows(): WB_UsrBusinessUnitRow[] {
        return getHasManyProperty(this, 'BusinessUnitUsers')
    }


}

export class WB_UserRoleRow
    extends ESRecord
    implements RowIF.IwbUserRole {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.WB_AUTHUSR_ID = 0
        this.cif.WB_DOMITEM_ID = 0
        this.cif.WB_CUST_ID = 0
        this.cif.MANUAL_IND = '1'
        this.cif.EFFECTIVE_START_DT = defaultRowValues.Min_Dt()
        this.cif.EFFECTIVE_END_DT = defaultRowValues.Max_Dt()
        this.cif.CREATED_DT = defaultRowValues.Created_Dt()
        this.cif.MODIFIED_DT = defaultRowValues.Modified_Dt()
        this.cif.MODIFIED_BY = defaultRowValues.Modified_By()
    }

    get cif(): RowIF.IwbUserRole {
        return this
    }

    get WB_RoleRow(): WB_DomainItemRow {
        return getBelongsToProperty(this, 'Role')
    }

    set WB_RoleRow(value) {
        setBelongsToProperty(this, 'Role', value)
    }

    get WB_CustomerRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Customer')
    }

    set WB_CustomerRow(value) {
        setBelongsToProperty(this, 'Customer', value)
    }

}


export class WB_UserDimensionRow
    extends ESRecord
    implements RowIF.IwbUserDimension {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        //  this.cif.WB_AUTHUSR_ID = 0
        //  this.cif.WB_DIMENSION_ID = 0
        this.cif.CREATED_DT = defaultRowValues.Created_Dt()
        this.cif.MODIFIED_DT = defaultRowValues.Modified_Dt()
        this.cif.MODIFIED_BY = defaultRowValues.Modified_By()
    }

    get cif(): RowIF.IwbUserDimension {
        return this
    }

    get WB_DimensionRow(): WB_DimensionRow {
        return getBelongsToProperty(this, 'Dimension')
    }

    set WB_DimensionRow(value) {
        setBelongsToProperty(this, 'Dimension', value)
    }

    get WB_UserRow(): WB_UserRow {
        return getBelongsToProperty(this, 'User')
    }

    set WB_UserRow(value) {
        setBelongsToProperty(this, 'User', value)
    }

}


export class WB_UserCustomerRow
    extends ESRecord
    implements RowIF.IwbUserCustomer {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.MANUAL_IND = '1'
        this.cif.EFFECTIVE_START_DT = defaultRowValues.Min_Dt()
        this.cif.EFFECTIVE_END_DT = defaultRowValues.Max_Dt()
        this.cif.CREATED_DT = defaultRowValues.Created_Dt()
        this.cif.MODIFIED_DT = defaultRowValues.Modified_Dt()
        this.cif.MODIFIED_BY = defaultRowValues.Modified_By()
    }

    get cif(): RowIF.IwbUserCustomer {
        return this
    }

    get WB_CustomerRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Customer')
    }

    set WB_CustomerRow(value) {
        setBelongsToProperty(this, 'Customer', value)
    }

}

//
// Session
export class WB_SessionRow
    extends ESRecord
    implements RowIF.IwbSession {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbSession {
        return this
    }

    get WB_UserRow(): WB_UserRow {
        return getBelongsToProperty(this, 'User')
    }

}

// Audit Log
export class WB_AuditLogRow
    extends ESRecord
    implements RowIF.IwbAuditLog {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbAuditLog {
        return this
    }

    get WB_UserRow(): WB_UserRow {
        return getBelongsToProperty(this, 'User')
    }

    get CreatedDateTime(): Date {
        return getBWDateTsSplitProperty(this, 'CREATED_DT', 'CREATED_TM')
    }

    set CreatedDateTime(value) {
        setBWDateTsSplitProperty(this, 'CreatedDateTime', 'CREATED_DT', 'CREATED_TM', value)
    }

    get CreationDate_Only(): string {
        return getDateStringFormat(this, 'CREATED_DT', 'CREATED_TM')
    }

    get CreationTime_Only(): string {
        return getTimeStringFormat(this, 'CREATED_DT', 'CREATED_TM')
    }

    get CreationTimeWithSeconds(): string {
        return getTimeStringFormat(this, 'CREATED_DT', 'CREATED_TM', true)
    }
}

//Business Unit
export class WB_BusinessUnitRow
    extends ESRecord
    implements RowIF.IwbBusinessUnit {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DT = defaultRowValues.Created_Dt()
        this.cif.DELETED_DT = defaultRowValues.Deleted_Dt()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DT = defaultRowValues.Modified_Dt()
    }

    get cif(): RowIF.IwbBusinessUnit {
        return this
    }

    get WB_BusinessUnitSourceRows(): WB_BusinessUnitSourceRow[] {
        return getHasManyProperty(this, 'BusinessUnitSources')
    }

    get WB_UsrBusinessUnitRows(): WB_UsrBusinessUnitRow[] {
        return getHasManyProperty(this, 'UsrBusinessUnits')
    }

    get WB_LoaderRows(): WB_LoaderRow[] {
        return getHasManyProperty(this, 'Loaders')
    }

    get CreatedDt(): Date {
        return getBWDateProperty(this, 'Created_Dt')
    }

    set CreatedDt(value: Date) {
        setBWDateProperty(this, 'CreatedDt', 'Created_Dt', value)
    }

    get ModifiedDt(): Date {
        return getBWDateProperty(this, 'Modified_Dt')
    }

    set ModifiedDt(value: Date) {
        setBWDateProperty(this, 'ModifiedDt', 'Modified_Dt', value)
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'Deleted_Dt')
    }

    set DeletedDt(value: Date) {
        setBWDateProperty(this, 'DeletedDt', 'Deleted_Dt', value)
    }

    get WB_LicenseRows(): WB_LicenseRow[] {
        return getHasManyProperty(this, 'LicBusinessUnits')
    }

    get WB_BenchmarkRows(): WB_BenchmarkRow[] {
        return getHasManyProperty(this, 'BenchmarkBusinessUnits')
    }
}

export class WB_BusinessUnitSourceRow
    extends ESRecord
    implements RowIF.IwbBusinessUnitSource {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DT = defaultRowValues.Created_Dt();
        this.cif.DELETED_DT = defaultRowValues.Deleted_Dt();
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind();
        this.cif.MODIFIED_DT = defaultRowValues.Modified_Dt();
    }

    get cif(): RowIF.IwbBusinessUnitSource {
        return this
    }

    get WB_BusinessUnitRow(): WB_BusinessUnitRow {
        return getBelongsToProperty(this, 'BusinessUnit')
    }

    set WB_BusinessUnitRow(value) {
        setBelongsToProperty(this, 'BusinessUnit', value)
    }

    get WB_SourceRow(): WB_SourceRow {
        return getBelongsToProperty(this, 'Source')
    }

    set WB_SourceRow(value) {
        setBelongsToProperty(this, 'Source', value)
    }

    get CreatedDt(): Date {
        return getBWDateProperty(this, 'Created_Dt')
    }

    set CreatedDt(value: Date) {
        setBWDateProperty(this, 'CreatedDt', 'Created_Dt', value)
    }

    get ModifiedDt(): Date {
        return getBWDateProperty(this, 'Modified_Dt')
    }

    set ModifiedDt(value: Date) {
        setBWDateProperty(this, 'ModifiedDt', 'Modified_Dt', value)
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'Deleted_Dt')
    }

    set DeletedDt(value: Date) {
        setBWDateProperty(this, 'DeletedDt', 'Deleted_Dt', value)
    }
}

export class WB_UsrBusinessUnitRow
    extends ESRecord
    implements RowIF.IwbUsrBusinessUnit {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DT = defaultRowValues.Created_Dt();
        this.cif.DELETED_DT = defaultRowValues.Deleted_Dt();
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind();
        this.cif.MODIFIED_DT = defaultRowValues.Modified_Dt();
    }

    get cif(): RowIF.IwbUsrBusinessUnit {
        return this
    }

    get WB_BusinessUnitRow(): WB_BusinessUnitRow {
        return getBelongsToProperty(this, 'BusinessUnit')
    }

    set WB_BusinessUnitRow(value) {
        setBelongsToProperty(this, 'BusinessUnit', value)
    }

    get WB_UserRow(): WB_UserRow {
        return getBelongsToProperty(this, 'User')
    }

    set WB_UserRow(value) {
        setBelongsToProperty(this, 'Source', value)
    }

    get CreatedDt(): Date {
        return getBWDateProperty(this, 'Created_Dt')
    }

    set CreatedDt(value: Date) {
        setBWDateProperty(this, 'CreatedDt', 'Created_Dt', value)
    }

    get ModifiedDt(): Date {
        return getBWDateProperty(this, 'Modified_Dt')
    }

    set ModifiedDt(value: Date) {
        setBWDateProperty(this, 'ModifiedDt', 'Modified_Dt', value)
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'Deleted_Dt')
    }

    set DeletedDt(value: Date) {
        setBWDateProperty(this, 'DeletedDt', 'Deleted_Dt', value)
    }
}

// Pricing Calculation
export class WB_PricingCalcRow
    extends ESRecord
    implements RowIF.IwbPricingCalc {
    constructor(props: any, opts: any) {
        super(props, opts);
        this.setupDependents("Id", ["PRCCLC_ID"])
        this.setupDependents("Name", ["PRODUCT_SET_ID", "PRICE_TYPE"])
    }

    setDefaults(): void {
        this.cif.EFFECTIVE_START_DT = defaultRowValues.Min_Dt();
        this.cif.EFFECTIVE_END_DT = defaultRowValues.Max_Dt();
    }

    get cif(): RowIF.IwbPricingCalc {
        return this
    }

    get WB_PricingCalcTermRows(): WB_PricingCalcTermRow[] {
        return getHasManyProperty(this, 'Terms')
    }

    get EffectiveStartDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_START_DT')
    }

    set EffectiveStartDt(value: Date) {
        setBWDateProperty(this, 'EffectiveStartDt', 'EFFECTIVE_START_DT', value)
    }

    get EffectiveEndDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_END_DT')
    }

    set EffectiveEndDt(value: Date) {
        setBWDateProperty(this, 'EffectiveEndDt', 'EFFECTIVE_END_DT', value)
    }

    get Id(): string {
        return this.cif.PRCCLC_ID + ''
    }

    get Name(): string {
        return this.cif.PRODUCT_SET_ID + ' ' + this.cif.PRICE_TYPE
    }
}

// Pricing Calculation
export class WB_PricingCalcTermRow
    extends ESRecord
    implements RowIF.IwbPricingCalcTerm {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbPricingCalcTerm {
        return this
    }
}

//Pricing Engine
export class WB_PricingEngineRow
    extends ESRecord
    implements RowIF.IwbPricingEngine {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbPricingEngine {
        return this
    }

    get WB_PricingEnginePriceRelRows(): WB_PricingEnginePriceRelRow[] {
        return getHasManyProperty(this, 'PricingEnginePRs')
    }
}

export class WB_PricingEnginePriceRelRow
    extends ESRecord
    implements RowIF.IwbPricingEnginePR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbPricingEnginePR {
        return this
    }

    get WB_PricingEngineRow(): WB_PricingEngineRow {
        return getBelongsToProperty(this, 'PricingEngine')
    }

    set WB_PricingEngineRow(value) {
        setBelongsToProperty(this, 'PricingEngine', value)
    }
}

// Job
export class WB_JobRow
    extends ESRecord
    implements RowIF.IwbJob {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbJob {
        return this
    }

    get WB_JobRunRows(): WB_JobRunRow[] {
        return getHasManyProperty(this, 'JobRuns')
    }
}

// Job Trigger
export class WB_JobTriggerRow
    extends ESRecord
    implements RowIF.IwbJobTrigger {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbJobTrigger {
        return this
    }

    get TriggerDtts(): Date {
        return getBWDateTsProperty(this, 'TRIGGER_DTTS')
    }

    get WB_SalesOrgRow(): WB_SalesOrgRow {
        return getBelongsToProperty(this, "JobTriggerSalesOrg")
    }

    get WB_MDSetRow(): WB_MasterDataSetRow {
        return getBelongsToProperty(this, 'JobTriggerMdSet')
    }

    get WB_CompanyRow(): WB_CompanyRow {
        return getBelongsToProperty(this, 'JobTriggerCompany')
    }
}

// Job run
export class WB_JobRunRow
    extends ESRecord
    implements RowIF.IwbJobRun {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbJobRun {
        return this
    }

}

// Job Processor
export class WB_JobProcessorRow
    extends ESRecord
    implements RowIF.IwbJobProcessor {
    constructor(props: any, opts: any) {
        super(props, opts)
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbJobProcessor {
        return this
    }

    get CreatedDt(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    get JobProcessHBDt(): Date {
        return getBWDateTsProperty(this, 'JOBPROCESSOR_HB_DTTS')
    }

    get WB_JobProcessRows(): WB_JobProcessRow[] {
        return getHasManyProperty(this, 'JobProcesses')
    }


}

// Job Processor Config relationship
export class WB_JobProcessorConfigRRow
    extends ESRecord
    implements RowIF.IwbJobProcessorConfigR {
    constructor(props: any, opts: any) {
        super(props, opts)
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbJobProcessorConfigR {
        return this
    }

    get CreatedDt(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }
}

//Job Process
export class WB_JobProcessRow
    extends ESRecord
    implements RowIF.IwbJobProcess {

    constructor(props: any, opts: any) {
        super(props, opts)
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbJobProcess {
        return this
    }

    get ProcessStartDtts(): Date {
        return getBWDateTsProperty(this, 'PROCESS_START_DTTS')
    }

    get ProcessEndDtts(): Date {
        return getBWDateTsProperty(this, 'PROCESS_END_DTTS')
    }

    get ProcessErrorDtts(): Date {
        return getBWDateTsProperty(this, 'PROCESS_ERROR_DTTS')
    }

    get WB_JobProcessorRow(): WB_JobProcessorRow {
        return getBelongsToProperty(this, 'JobProcessor')
    }

    get WB_JobParamRow(): WB_JobParamRow {
        return getBelongsToProperty(this, 'JobParam')
    }

    get HeartbeatDtTs(): Date {
        return getBWDateTsProperty(this, 'JOBPROCESSOR_HB_DTTS')
    }

    /** True if the job process uses the queue table */
    get bQueueInd(): boolean {
        return getBooleanIndicator(this, 'QUEUE_IND')
    }

    set bQueueInd(value) {
        setBooleanIndicator(this, 'bQueueInd', 'QUEUE_IND', value)
    }

}

export class WB_JobProcessQueueRow
    extends ESRecord
    implements RowIF.IwbJobProcessQueue {

    constructor(props: any, opts: any) {
        super(props, opts)
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbJobProcessQueue {
        return this
    }

    get ProcessStartDtts(): Date {
        return getBWDateTsProperty(this, 'PROCESS_START_DTTS')
    }

    get ProcessEndDtts(): Date {
        return getBWDateTsProperty(this, 'PROCESS_END_DTTS')
    }
}


export class WB_JobParamRow
    extends ESRecord
    implements RowIF.IwbJobParam {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs();
        this.cif.DELETED_DT = defaultRowValues.Deleted_Dt();
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind();
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs();
    }

    get cif(): RowIF.IwbJobParam {
        return this
    }

    get WB_MasterDataSetRow(): WB_MasterDataSetRow {
        return getBelongsToProperty(this, "JobParamMdSet")
    }

    set WB_MasterDataSetRow(value: WB_MasterDataSetRow) {
        setBelongsToProperty(this, "JobParamMdSet", value)
    }

    get WB_SalesOrgRow(): WB_SalesOrgRow {
        return getBelongsToProperty(this, "JobParamSalesOrg")
    }

    set WB_SalesOrgRow(value) {
        setBelongsToProperty(this, 'JobParamSalesOrg', value)
    }

    get WB_UIAppExecutableRow(): WB_UIAppExecutableRow {
        return getBelongsToProperty(this, "JobParamExec")
    }

    set WB_UIAppExecutableRow(value) {
        setBelongsToProperty(this, 'JobParamExec', value)
    }

    get WB_JobParamSRRows(): WB_JobParamSRRow[] {
        return getHasManyProperty(this, "JobParamScheduleXref")
    }

}

export class WB_JobParamSRRow
    extends ESRecord
    implements RowIF.IwbJobParamSR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs();
        this.cif.DELETED_DT = defaultRowValues.Deleted_Dt();
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind();
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs();
    }

    afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this
        return new Promise<void>((resolve, error) => {

            // Set the Defaults for the Domain Values
            let dbContext: PAdbContext = <any>self.dataStore()

            if (_.isEmpty(dbContext)) {
                resolve()
                return
            }

            async function setAsyncDefaults() {
                self.setDefaults()

                let usrCtx: PAusrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
                if (!_.isEmpty(usrCtx)) {
                    self.cif.WB_AUTHUSR_ID_CREATEDBY = usrCtx.User.cif.WB_AUTHUSR_ID
                } else {
                    self.cif.WB_AUTHUSR_ID_CREATEDBY = 0
                }
                resolve()
            }

            setAsyncDefaults()
        })
    }

    get cif(): RowIF.IwbJobParamSR {
        return this
    }

    get WB_JobParamRow(): WB_JobParamRow {
        return getBelongsToProperty(this, 'JobParam')
    }

    set WB_JobParamRow(value: WB_JobParamRow) {
        setBelongsToProperty(this, 'JobParam', value)
    }

    get WB_ScheduleRow(): WB_ScheduleRow {
        return getBelongsToProperty(this, 'JobParamSchedule')
    }

    set WB_ScheduleRow(value: WB_ScheduleRow) {
        setBelongsToProperty(this, 'JobParamSchedule', value)
    }
}

//Queue
export class WB_QueueRow
    extends ESRecord
    implements RowIF.IwbQueue {

    constructor(props: any, opts: any) {
        super(props, opts)
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbQueue {
        return this
    }

    get ProcessStartDtts(): Date {
        return getBWDateTsProperty(this, 'PROCESS_START_DTTS')
    }

    get ProcessEndDtts(): Date {
        return getBWDateTsProperty(this, 'PROCESS_END_DTTS')
    }

}


// Job Schedule
export class WB_JobScheduleRow
    extends ESRecord
    implements RowIF.IwbJobSchedule {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.SCHEDULE_NAME = "New Schedule"
    }

    get cif(): RowIF.IwbJobSchedule {
        return this
    }

    get WB_JobScheduleJobRows(): WB_JobScheduleJobRow[] {
        return getHasManyProperty(this, 'Jobs')
    }

    get WB_JobScheduleProcessRows(): WB_JobScheduleProcessRow[] {
        return getHasManyProperty(this, 'JobScheduleProcess')
    }

    get ScheduleStartDtTs(): Date {
        return getBWDateTsProperty(this, 'SCHEDULE_START_DTTS')
    }

    set ScheduleStartDtTs(value: Date) {
        setBWDateTsProperty(this, "ScheduleStartDtTs", 'SCHEDULE_START_DTTS', value);
    }

    set ScheduleEndDtTs(value: Date) {
        setBWDateTsProperty(this, "ScheduleEndDtTs", 'SCHEDULE_END_DTTS', value);
    }

    get ScheduleEndDtTs(): Date {
        return getBWDateTsProperty(this, 'SCHEDULE_END_DTTS')
    }

}

export class WB_JobScheduleJobRow
    extends ESRecord
    implements RowIF.IwbJobScheduleJob {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbJobScheduleJob {
        return this
    }


    get WB_JobScheduleRow(): WB_JobScheduleRow {
        return getBelongsToProperty(this, 'JobSchedule')
    }

    get WB_JobRow(): WB_JobRow {
        return getBelongsToProperty(this, 'Job')
    }

    set WB_JobRow(value) {
        setBelongsToProperty(this, 'Job', value)
    }

}

/**
 * Job Schedule Process
 */
export class WB_JobScheduleProcessRow
    extends ESRecord
    implements RowIF.IwbJobScheduleProcess {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbJobScheduleProcess {
        return this
    }


    get WB_JobScheduleRow(): WB_JobScheduleRow {
        return getBelongsToProperty(this, 'JobSchedule')
    }

    set WB_JobScheduleRow(value) {
        setBelongsToProperty(this, 'JobSchedule', value)
    }

    set ProcessStartDtTs(value: Date) {
        setBWDateTsProperty(this, "ProcessStartDtTs", 'PROCESS_START_DTTS', value);
    }

    get ProcessStartDtTs(): Date {
        return getBWDateTsProperty(this, 'PROCESS_START_DTTS')
    }

    set ProcessEndDtTs(value: Date) {
        setBWDateTsProperty(this, "ProcessEndDtTs", 'PROCESS_END_DTTS', value);
    }

    get ProcessEndDtTs(): Date {
        return getBWDateTsProperty(this, 'PROCESS_END_DTTS')
    }

    set ProcessErrorDtTs(value: Date) {
        setBWDateTsProperty(this, "ProcessErrorDtTs", 'PROCESS_ERROR_DTTS', value);
    }

    get ProcessErrorDtTs(): Date {
        return getBWDateTsProperty(this, 'PROCESS_ERROR_DTTS')
    }

    set CreatedDtTs(value: Date) {
        setBWDateTsProperty(this, "CreatedDtTs", 'CREATED_DTTS', value);
    }

    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    set ModifiedDtTs(value: Date) {
        setBWDateTsProperty(this, "ModifiedDtTs", 'MODIFIED_DTTS', value);
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }
}

//Job Schedule end

// Connection
export class WB_ConnectionRow
    extends ESRecord
    implements RowIF.IwbConnection {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbConnection {
        return this
    }


}

// Dimension
export class WB_DimensionRow
    extends ESRecord
    implements RowIF.IwbDimension {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbDimension {
        return this
    }

    get WB_ConnectionRow(): WB_ConnectionRow {
        return getBelongsToProperty(this, 'Connection')
    }

    set WB_ConnectionRow(value) {
        setBelongsToProperty(this, 'Connection', value)
    }

    get WB_UserDimensionRows(): WB_UserDimensionRow[] {
        return getHasManyProperty(this, 'Dimensions')
    }

}


// Report
export class WB_ReportTileRow
    extends ESRecord
    implements RowIF.IwbReportTile {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
    }

    get cif(): RowIF.IwbReportTile {
        return this
    }

    get WB_ConnectionRow(): WB_ConnectionRow {
        return getBelongsToProperty(this, 'Connection')
    }

    set WB_ConnectionRow(value) {
        setBelongsToProperty(this, 'Connection', value)
    }

    get WB_ReportTileDimensionRows(): WB_ReportTileDimensionRow[] {
        return getHasManyProperty(this, 'ReportTileDimensions')
    }

    get WB_LicenseRows(): WB_LicenseRow[] {
        return getHasManyProperty(this, 'LicReportTiles')
    }

}

// Report Tile Dimension
export class WB_ReportTileDimensionRow
    extends ESRecord
    implements RowIF.IwbReportTileDimension {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
    }

    get cif(): RowIF.IwbReportTileDimension {
        return this
    }

    get WB_ReportTileRow(): WB_ReportTileRow {
        return getBelongsToProperty(this, 'ReportTile')
    }

    set WB_ReportTileRow(value) {
        setBelongsToProperty(this, 'ReportTile', value)
    }

    get WB_DimensionRow(): WB_DimensionRow {
        return getBelongsToProperty(this, 'Dimension')
    }

    set WB_DimensionRow(value) {
        setBelongsToProperty(this, 'Dimension', value)
    }


}

export class WB_SubjectAreaRow
    extends ESRecord
    implements RowIF.IwbSubjectArea {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbSubjectArea {
        return this
    }

    get WB_MetricDefinitionRows(): WB_MetricDefinitionRow[] {
        return getHasManyProperty(this, 'MetricDefinitions')
    }

    get bGenerateInd(): boolean {
        return getBooleanIndicator(this, 'GENERATE_IND')
    }

    get bPlanHierInd(): boolean {
        return getBooleanIndicator(this, 'PLAN_HIER_IND')
    }

    get bCustomerInd(): boolean {
        return getBooleanIndicator(this, 'CUSTOMER_IND')
    }

    get bCustomerRelInd(): boolean {
        return getBooleanIndicator(this, 'CUSTOMER_REL_IND')
    }

    get bCustomerSrcInd(): boolean {
        return getBooleanIndicator(this, 'CUSTOMER_SRC_IND')
    }

    get bSupplyDirectionInd(): boolean {
        return getBooleanIndicator(this, 'SUPPLYDIRECTION_IND')
    }

    get bProdctGroupInd(): boolean {
        return getBooleanIndicator(this, 'PRODUCTGROUP_IND')
    }

    get bPeriodInd(): boolean {
        return getBooleanIndicator(this, 'PERIOD_IND')
    }

    get bSnapShotInd(): boolean {
        return getBooleanIndicator(this, 'SNAPSHOT_IND')
    }

    get bGLAccountInd(): boolean {
        return getBooleanIndicator(this, 'GLACCOUNT_IND')
    }

    get bEventTypeInd(): boolean {
        return getBooleanIndicator(this, 'EVENT_TYPE_IND')
    }

    get bEventSpendTypeInd(): boolean {
        return getBooleanIndicator(this, 'EVENT_SPEND_TYPE_IND')
    }

    get bFundTypeInd(): boolean {
        return getBooleanIndicator(this, 'FUND_TYPE_IND')
    }

    get bDeletedInd(): boolean {
        return getBooleanIndicator(this, 'DELETED_IND')
    }


}

//<editor-fold desc="Reporting Hierarchy Tables">
// Report customer hierarchy
export class WB_ReportCustomerHierarchyRow
    extends ESRecord
    implements RowIF.IwbReportCustomerHierarchy {

    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbReportCustomerHierarchy {
        return this
    }
}

// Report product group hierarchy
export class WB_ReportProductGroupHierarchyRow
    extends ESRecord
    implements RowIF.IwbReportProductGroupHierarchy {

    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbReportProductGroupHierarchy {
        return this
    }
}

// Report time hierarchy
export class WB_ReportTimeHierarchyRow
    extends ESRecord
    implements RowIF.IwbReportTimeHierarchy {

    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbReportTimeHierarchy {
        return this
    }
}

//</editor-fold>

//<editor-fold desc="Loader">
// Loader
export class WB_LoaderRow
    extends ESRecord
    implements RowIF.IwbLoader {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.LOADER_NAME = "New Loader"
    }

    get cif(): RowIF.IwbLoader {
        return this
    }

    get WB_BusinessUnitRow(): WB_BusinessUnitRow {
        return getBelongsToProperty(this, 'BusinessUnit')
    }

    set WB_BusinessUnitRow(value) {
        setBelongsToProperty(this, 'BusinessUnit', value)
    }

    get WB_LoaderSourceRow(): WB_LoaderSourceRow {
        return getBelongsToProperty(this, 'LoaderSource')
    }

    set WB_LoaderSourceRow(value) {
        setBelongsToProperty(this, 'LoaderSource', value)
    }

    get WB_MasterDataSetRow(): WB_MasterDataSetRow {
        return getBelongsToProperty(this, 'MDSet')
    }

    set WB_MasterDataSetRow(value) {
        setBelongsToProperty(this, 'MDSet', value)
    }

    get WB_CompanyRow(): WB_CompanyRow {
        return getBelongsToProperty(this, 'Company')
    }

    set WB_CompanyRow(value) {
        setBelongsToProperty(this, 'Company', value)
    }

    get WB_LoaderKeyMapRows(): WB_LoaderKeyMapRow[] {
        return getHasManyProperty(this, 'LoaderKeyMaps')
    }

    get WB_LoaderMetricMapRows(): WB_LoaderMetricMapRow[] {
        return getHasManyProperty(this, 'LoaderMetricMaps')
    }

    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    set CreatedDtTs(value: Date) {
        setBWDateTsProperty(this, "CreatedDtTs", 'CREATED_DTTS', value);
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

    set DeletedDt(value: Date) {
        setBWDateProperty(this, 'DeletedDt', 'DELETED_DT', value)
    }
}

export class WB_LoaderKeyMapRow
    extends ESRecord
    implements RowIF.IwbLoader_KeyMap {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.DIMENSION_ID = ""
        this.cif.SOURCE_TYPE = "Constant"
        this.cif.SOURCE_VALUE_CONSTANT = ""
        this.cif.SOURCE_FIELDNAME = ""
        this.cif.TRANSLATION_OPERATION_ID = 0
        this.cif.ALLOCATION_OPERATION_ID = 0
        this.cif.AGGREGATION_OPERATION_ID = 0

    }

    get cif(): RowIF.IwbLoader_KeyMap {
        return this
    };

    get WB_LoaderRow(): WB_LoaderRow {
        return getBelongsToProperty(this, 'Loader')
    }

    set WB_LoaderRow(value) {
        setBelongsToProperty(this, 'Loader', value)
    }
}

export class WB_LoaderMetricMapRow
    extends ESRecord
    implements RowIF.IwbLoader_MetricMap {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.WB_MTRDFN_ID = 0
        this.cif.CALCULATION_POLICY = ""
        this.cif.FORMULA = ""
        this.cif.METRIC_FIELDNAME = ""
        this.cif.SOURCE_FIELDNAME = ""
    }

    get cif(): RowIF.IwbLoader_MetricMap {
        return this
    };

    get WB_LoaderRow(): WB_LoaderRow {
        return getBelongsToProperty(this, 'Loader')
    }

    set WB_LoaderRow(value) {
        setBelongsToProperty(this, 'Loader', value)
    }

    get WB_MetricDefinitionRow(): WB_MetricDefinitionRow {
        return getBelongsToProperty(this, 'MetricDefinition')
    }

    set WB_MetricDefinitionRow(value) {
        setBelongsToProperty(this, 'MetricDefinition', value)
    }

    get WB_LoaderMetricTermRows(): WB_LoaderMetricTermRow[] {
        return getHasManyProperty(this, 'LoaderMetricTerms')
    }
}

export class WB_LoaderMetricTermRow
    extends ESRecord
    implements RowIF.IwbLoader_MetricTerm {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbLoader_MetricTerm {
        return this
    };

    get WB_LoaderMetricMapRow(): WB_LoaderMetricMapRow {
        return getBelongsToProperty(this, 'LoaderMetricMap')
    }

    set WB_LoaderMetricMapRow(value) {
        setBelongsToProperty(this, 'LoaderMetricMap', value)
    }

    get WB_ProductConditionTypeRow(): WB_ProductConditionTypeRow {
        return getBelongsToProperty(this, 'ProductConditionType')
    }

    set WB_ProductConditionTypeRow(value) {
        setBelongsToProperty(this, 'ProductConditionType', value)
    }

    get WB_CustomerHierarchyRow(): WB_CustomerHierarchyRow {
        return getBelongsToProperty(this, 'CustHierarchy')
    }

    set WB_CustomerHierarchyRow(value) {
        setBelongsToProperty(this, 'CustHierarchy', value)
    }

    get WB_ProductHierarchyRow(): WB_ProductHierarchyRow {
        return getBelongsToProperty(this, 'PrdHierarchy')
    }

    set WB_ProductHierarchyRow(value) {
        setBelongsToProperty(this, 'PrdHierarchy', value)
    }
}

export class WB_LoaderOperationRow
    extends ESRecord
    implements RowIF.IwbLoaderOperation {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbLoaderOperation {
        return this
    }

    get WB_MasterDataSetRow(): WB_MasterDataSetRow {
        return getBelongsToProperty(this, 'MDSet')
    }

    set WB_MasterDataSetRow(value) {
        setBelongsToProperty(this, 'MDSet', value)
    }

    get WB_CompanyRow(): WB_CompanyRow {
        return getBelongsToProperty(this, 'Company')
    }

    set WB_CompanyRow(value) {
        setBelongsToProperty(this, 'Company', value)
    }
}

export class WB_LoaderSourceRow
    extends ESRecord
    implements RowIF.IwbLoaderSource {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbLoaderSource {
        return this
    }

    get WB_PeriodTypeRow(): WB_PeriodTypeRow {
        return getBelongsToProperty(this, 'PeriodType')
    }

    set WB_PeriodTypeRow(value) {
        setBelongsToProperty(this, 'PeriodType', value)
    }

    get WB_ConnectionRow(): WB_ConnectionRow {
        return getBelongsToProperty(this, 'Connection')
    }

    set WB_ConnectionRow(value) {
        setBelongsToProperty(this, 'Connection', value)
    }

    get WB_LoaderRows(): WB_LoaderRow[] {
        return getHasManyProperty(this, 'Loaders')
    }
}

//</editor-fold>


// Workspace
export class WB_WorkspaceRow
    extends ESRecord
    implements RowIF.IwbWorkspace {
    _wbSalesOrgId: number
    _salesOrgRow:WB_SalesOrgRow
    constructor(props: any, opts: any) {
        super(props, opts);
        this._wbSalesOrgId=0
        this._salesOrgRow=undefined
    }

    afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this
        return new Promise<void>((resolve, error) => {

            // Set the Defaults for the Domain Values
            let dbContext: PAdbContext = <any>self.dataStore()

            if (_.isEmpty(dbContext)) {
                resolve()
                return
            }

            async function setAsyncDefaults() {
                self.setDefaults()

                let newKey: number = <any>(await dbContext.getNewId(self._mapper().name))
                let sNewId = TextUtils.padStart(newKey.toString(36), 12, '0').toUpperCase()
                self.cif.WORKSPACE_ID = sNewId
                let usrCtx: PAusrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
                if (!_.isEmpty(usrCtx)) {
                    self.cif.WB_AUTHUSR_ID = usrCtx.User.cif.WB_AUTHUSR_ID
                } else {
                    self.cif.WB_AUTHUSR_ID = 0
                }
                resolve()
            }

            setAsyncDefaults()
        })
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
    }

    get cif(): RowIF.IwbWorkspace {
        return this
    }

    get WB_UserRow(): WB_UserRow {
        return getBelongsToProperty(this, 'User')
    }

    set WB_UserRow(value) {
        setBelongsToProperty(this, 'User', value)
    }

    get WB_WorkspaceDimensionRows(): WB_WorkspaceDimensionRow[] {
        return getHasManyProperty(this, 'WorkspaceDimensions')
    }

    get WB_WorkspaceReportRows(): WB_WorkspaceReportRow[] {
        return getHasManyProperty(this, 'WorkspaceReports')
    }

    get WB_SALESORG_ID():number{
        return this._wbSalesOrgId
    }

    set WB_SALESORG_ID(value:number){
        this._wbSalesOrgId=value
    }

    get WB_SalesOrgRow():WB_SalesOrgRow{
        return this._salesOrgRow
    }

    set WB_SalesOrgRow(value:WB_SalesOrgRow){
        this._salesOrgRow=value
    }

}


// Workspace Dimension
export class WB_WorkspaceDimensionRow
    extends ESRecord
    implements RowIF.IwbWorkspaceDimension {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
    }

    get cif(): RowIF.IwbWorkspaceDimension {
        return this
    }

    get WB_WorkspaceRow(): WB_WorkspaceRow {
        return getBelongsToProperty(this, 'Workspace')
    }

    set WB_WorkspaceRow(value) {
        setBelongsToProperty(this, 'Workspace', value)
    }

    get WB_DimensionRow(): WB_DimensionRow {
        return getBelongsToProperty(this, 'Dimension')
    }

    set WB_DimensionRow(value) {
        setBelongsToProperty(this, 'Dimension', value)
    }

}


// Workspace Report
export class WB_WorkspaceReportRow
    extends ESRecord
    implements RowIF.IwbWorkspaceReport {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
    }

    get cif(): RowIF.IwbWorkspaceReport {
        return this
    }

    get WB_WorkspaceRow(): WB_WorkspaceRow {
        return getBelongsToProperty(this, 'Workspace')
    }

    set WB_WorkspaceRow(value) {
        setBelongsToProperty(this, 'Workspace', value)
    }

    get WB_ReportRow(): WB_ReportTileRow {
        return getBelongsToProperty(this, 'Report')
    }

    set WB_ReportRow(value) {
        setBelongsToProperty(this, 'Report', value)
    }

    get WB_WorkspaceReportDimensionRows(): WB_WorkspaceReportDimensionRow[] {
        return getHasManyProperty(this, 'ReportDimensions')
    }

}


// Workspace Report Dimension

export class WB_WorkspaceReportDimensionRow
    extends ESRecord
    implements RowIF.IwbWorkspaceReportDimension {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
    }

    get cif(): RowIF.IwbWorkspaceReportDimension {
        return this
    }

    get WB_WorkspaceReportRow(): WB_WorkspaceReportRow {
        return getBelongsToProperty(this, 'WorkspaceReport')
    }

    set WB_WorkspaceReportRow(value) {
        setBelongsToProperty(this, 'WorkspaceReport', value)
    }

    get WB_DimensionRow(): WB_DimensionRow {
        return getBelongsToProperty(this, 'Dimension')
    }

    set WB_DimensionRow(value) {
        setBelongsToProperty(this, 'Dimension', value)
    }

}

// Note
export class WB_NoteRow
    extends ESRecord
    implements RowIF.IwbNote {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbNote {
        return this
    }

    get WB_NoteUserRows(): WB_NoteUserRow[] {
        return getHasManyProperty(this, 'UserNotes')
    }

}

export class WB_NoteUserRow
    extends ESRecord
    implements RowIF.IwbNoteUser {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbNoteUser {
        return this
    }

    get WB_UserRow(): WB_UserRow {
        return getBelongsToProperty(this, 'User')
    }

    set WB_UserRow(value) {
        setBelongsToProperty(this, 'User', value)
    }


    get WB_NoteRow(): WB_NoteRow {
        return getBelongsToProperty(this, 'Note')
    }

    set WB_NoteRow(value) {
        setBelongsToProperty(this, 'Note', value)
    }


}


// File
export class WB_FileRow
    extends ESRecord
    implements RowIF.IwbFile {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.WB_AUTHUSR_ID = defaultRowValues.CurrentUserWbId()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()

    }

    get cif(): RowIF.IwbFile {
        return this
    }

    get WB_UserRow(): WB_UserRow {
        return getBelongsToProperty(this, "creator")
    }

    set WB_UserRow(value) {
        setBelongsToProperty(this, 'creator', value)
    }
}

//<editor-fold desc="Cannibalization">

// Cannibalization
export class WB_CannibalizationSetRow
    extends ESRecord
    implements RowIF.IwbCannibalizationSet {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbCannibalizationSet {
        return this
    }


    get EffectiveStartDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_START_DT')
    }

    set EffectiveStartDt(value: Date) {
        setBWDateProperty(this, 'EffectiveStartDt', 'EFFECTIVE_START_DT', value)
    }

    get EffectiveEndDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_END_DT')
    }

    set EffectiveEndDt(value: Date) {
        setBWDateProperty(this, 'EffectiveEndDt', 'EFFECTIVE_END_DT', value)
    }

    get WB_CannibalizationTypeRow(): WB_DomainItemRow {
        return getBelongsToProperty(this, 'CannibalizationSetType')
    }

    set WB_CannibalizationTypeRow(value) {
        setBelongsToProperty(this, 'CannibalizationSetType', value)
    }


    get WB_AffinitySet_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'AffinitySet')
    }

    set WB_AffinitySet_ProductGroupRow(value) {
        setBelongsToProperty(this, 'AffinitySet', value)
    }


    get WB_UserRow(): WB_UserRow {
        return getBelongsToProperty(this, 'User')
    }

    set WB_UserRow(value) {
        setBelongsToProperty(this, 'User', value)
    }


    get WB_CannibalizationSetCustomerRows(): WB_CannibalizationSetCustomerRow[] {
        return getHasManyProperty(this, 'CannCustomers')
    }


    get WB_CannibalizationSetProductGroupRows(): WB_CannibalizationSetProductGroupRow[] {
        return getHasManyProperty(this, 'CannProductGroups')
    }


}


export class WB_CannibalizationSetCustomerRow
    extends ESRecord
    implements RowIF.IwbCannibalizationSetCustomer {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbCannibalizationSetCustomer {
        return this
    }

    get WB_CustomerRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Customer')
    }

    set WB_CustomerRow(value) {
        setBelongsToProperty(this, 'Customer', value)
    }


}


export class WB_CannibalizationSetProductGroupRow
    extends ESRecord
    implements RowIF.IwbCannibalizationSetProductGroup {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {

        this.cif.EFFECTIVE_DT_AGGR = defaultRowValues.Min_Dt()
        this.cif.EFFECTIVE_DT_VICT = defaultRowValues.Min_Dt()
        this.cif.CURRENCY = defaultRowValues.Currency()

        this.cif.VICTIM_EQV = 0

        this.cif.VICTIM_LSTSLS = 0
        this.cif.VICTIM_PROFIT = 0
        this.cif.VICTIM_RTLSLS = 0
        this.cif.VICTIM_UNITS = 0
        this.cif.AGGR_LSTSLS = 0
        this.cif.AGGR_PROFIT = 0
        this.cif.AGGR_RTLSLS = 0
        this.cif.AGGR_UNITS = 0

        this.cif.AGGR_BASE_LSTSLS = 0
        this.cif.AGGR_BASE_PROFIT = 0
        this.cif.AGGR_BASE_RTLSLS = 0
        this.cif.AGGR_BASE_UNITS = 0
        this.cif.AGGR_INCR_LSTSLS = 0
        this.cif.AGGR_INCR_PROFIT = 0
        this.cif.AGGR_INCR_RTLSLS = 0
        this.cif.AGGR_INCR_UNITS = 0
        this.cif.AGGR_TOTAL_LSTSLS = 0
        this.cif.AGGR_TOTAL_PROFIT = 0
        this.cif.AGGR_TOTAL_RTLSLS = 0
        this.cif.AGGR_TOTAL_UNITS = 0

        this.cif.ANY_DISPLAY_WO_FEAT_ACV = 0
        this.cif.ANY_FEAT_WO_DISPLAY_ACV = 0
        this.cif.ANY_FEAT_DISPLAY_ACV = 0
        this.cif.PRICE_DECREASE_ACV = 0
        this.cif.ANY_PROMO_ACV = 0

    }

    get cif(): RowIF.IwbCannibalizationSetProductGroup {
        return this
    }

    get WB_CustomerRow_Victim(): WB_CustomerRow {
        return getBelongsToProperty(this, 'VictimPlanningCustomer')
    }

    set WB_CustomerRow_Victim(value) {
        setBelongsToProperty(this, 'VictimPlanningCustomer', value)
    }


    get WB_CustomerRow_Aggressor(): WB_CustomerRow {
        return getBelongsToProperty(this, 'AggressorPlanningCustomer')
    }

    set WB_CustomerRow_Aggressor(value) {
        setBelongsToProperty(this, 'AggressorPlanningCustomer', value)
    }


    get WB_ProductGroupRow_Victim(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'VictimProductGroup')
    }

    set WB_ProductGroupRow_Victim(value) {
        setBelongsToProperty(this, 'VictimProductGroup', value)
    }

    get WB_ProductGroupRow_Aggressor(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'AggressorProductGroup')
    }

    set WB_ProductGroupRow_Aggressor(value) {
        setBelongsToProperty(this, 'AggressorProductGroup', value)
    }


    get EffectiveAggressorDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_DT_AGGR')
    }

    set EffectiveAggressorDt(value: Date) {
        setBWDateProperty(this, 'EffectiveAggressorDt', 'EFFECTIVE_DT_AGGR', value)
    }

    get EffectiveVictimDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_DT_VICT')
    }

    set EffectiveVictimDt(value: Date) {
        setBWDateProperty(this, 'EffectiveVictimDt', 'EFFECTIVE_DT_VICT', value)
    }

    get WB_CannibalizationSetProductRows(): WB_CannibalizationSetProductRow[] {
        return getHasManyProperty(this, 'CannProducts')
    }

}


export class WB_CannibalizationSetProductRow
    extends ESRecord
    implements RowIF.IwbCannibalizationSetProduct {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.EFFECTIVE_DT = defaultRowValues.Min_Dt()

        this.cif.VICTIM_EQV = 0
        this.cif.VICTIM_LSTSLS = 0
        this.cif.VICTIM_PROFIT = 0
        this.cif.VICTIM_RTLSLS = 0
        this.cif.VICTIM_UNITS = 0

        this.cif.AGGR_LSTSLS = 0
        this.cif.AGGR_PROFIT = 0
        this.cif.AGGR_RTLSLS = 0
        this.cif.AGGR_UNITS = 0

        this.cif.AGGR_BASE_LSTSLS = 0
        this.cif.AGGR_BASE_PROFIT = 0
        this.cif.AGGR_BASE_RTLSLS = 0
        this.cif.AGGR_BASE_UNITS = 0
        this.cif.AGGR_INCR_LSTSLS = 0
        this.cif.AGGR_INCR_PROFIT = 0
        this.cif.AGGR_INCR_RTLSLS = 0
        this.cif.AGGR_INCR_UNITS = 0

        this.cif.AGGR_TOTAL_LSTSLS = 0
        this.cif.AGGR_TOTAL_PROFIT = 0
        this.cif.AGGR_TOTAL_RTLSLS = 0
        this.cif.AGGR_TOTAL_UNITS = 0
    }

    get cif(): RowIF.IwbCannibalizationSetProduct {
        return this
    }


    get WB_ProductRow(): WB_FinishedProductRow {
        return getBelongsToProperty(this, 'Product')
    }

    set WB_ProductRow(value) {
        setBelongsToProperty(this, 'Product', value)
    }

}

//</editor-fold>


// Snapshot
export class WB_SnapshotRow
    extends ESRecord
    implements RowIF.IwbSnapshot {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this
        return new Promise<void>((resolve, error) => {

            // Set the Defaults for the Domain Values
            let dbContext: PAdbContext = <any>self.dataStore()

            if (_.isEmpty(dbContext)) {
                resolve()
                return
            }

            async function setAsyncDefaults() {
                self.setDefaults()

                let newKey: number = <any>(await dbContext.getNewId(self._mapper().name))
                let sNewId = TextUtils.padStart(newKey.toString(36), 12, '0').toUpperCase()
                self.cif.SNAPSHOT_ID = sNewId
                resolve()
            }

            setAsyncDefaults()
        })
    }

    set CreatedDateTime(value) {
        setBWDateTsProperty(this, 'CreatedDateTime', 'CREATED_DTTS', value)
    }

    get CreatedDateTime(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    set ModifiedDateTime(value) {
        setBWDateTsProperty(this, 'ModifiedDateTime', 'MODIFIED_DTTS', value)
    }

    get ModifiedDateTime(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    set ProcessedStartDateTime(value) {
        setBWDateTsProperty(this, 'ProcessedStartDateTime', 'PROCESSED_START_DTTS', value)
    }

    get ProcessedStartDateTime(): Date {
        return getBWDateTsProperty(this, 'PROCESSED_START_DTTS')
    }

    set AutoRunStartTime(value) {
        setBWDateTsProperty(this, 'AutoRunStartTime', 'AUTO_RUN_DTTS', value)
    }

    get AutoRunStartTime(): Date {
        return getBWDateTsProperty(this, 'AUTO_RUN_DTTS')
    }


    set ProcessedEndDateTime(value) {
        setBWDateTsProperty(this, 'ProcessedEndDateTime', 'PROCESSED_END_DTTS', value)
    }

    get ProcessedEndDateTime(): Date {
        return getBWDateTsProperty(this, 'PROCESSED_END_DTTS')
    }

    set ScheduledRunDateTime(value) {
        setBWDateTsProperty(this, 'ScheduledRunDateTime', 'SCHEDULED_RUN_DTTS', value)
    }

    get ScheduledRunDateTime(): Date {
        return getBWDateTsProperty(this, 'SCHEDULED_RUN_DTTS')
    }

    set WB_SnapshotTypeRow(value) {
        setBelongsToProperty(this, 'SnapshotType', value)
    }

    get WB_SnapshotTypeRow(): WB_Snapshot_TypeRow {
        return getBelongsToProperty(this, 'SnapshotType')
    }

    set WB_SnapshotParamRow(value) {
        setBelongsToProperty(this, 'SnapshotpParam', value)
    }

    get WB_SnapshotParamRow(): WB_Snapshot_ParamRow {
        return getBelongsToProperty(this, 'SnapshotpParam')
    }


    get WB_WorkflowStatusRow(): WB_WorkflowStatusRow {
        return getBelongsToProperty(this, 'WorkflowStatus');
    }

    get AutoRunDateTime(): Date {
        return getBWDateTsProperty(this, 'AUTO_RUN_DTTS');
    }

    get AutoRunDays(): string[] {
        return !this.cif.AUTO_RUN_DAYS ? [] : this.cif.AUTO_RUN_DAYS.split(",");
    }

    get AutoRunEnabled(): boolean {
        return this.cif.AUTO_RUN_ENABLE_IND == '1' && this.WB_SnapshotTypeRow.cif.AUTO_RUN_IND == '1' && (_.isUndefined(this.WB_WorkflowStatusRow) || !this.WB_WorkflowStatusRow.StatusTypeCancelled);
    }

    get cif(): RowIF.IwbSnapshot {
        return this
    }

    get WB_SnapshotPeriodRelationshipRows(): WB_SnapshotPeriodRelationshipRow[] {
        return getHasManyProperty(this, 'SnapshotPeriod')
    }

    get WB_SnapshotProductGroupRelationshipRows(): WB_SnapshotProductGroupRelationshipRow[] {
        return getHasManyProperty(this, 'SnapshotProductGroup')
    }

    get WB_SnapshotCustomerRelationshipRows(): WB_SnapshotCustomerRelationshipRow[] {
        return getHasManyProperty(this, 'SnapshotCustomer')
    }

    get WB_SnapshotPlanRelationshipRows(): WB_SnapshotPlanRelationshipRow[] {
        return getHasManyProperty(this, 'SnapshotPlan')
    }


}


// Snapshot
export class WB_Snapshot_TypeRow
    extends ESRecord
    implements RowIF.IwbSnapshotType {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbSnapshotType {
        return this
    }

    async afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this

        let dbContext: PAdbContext = <any>self.dataStore()
        if (_.isEmpty(dbContext))
            return

        self.setDefaults()
        self.cif.ENTERPRISE_POLICY = (<any>await Domain_getDefaultOrFirstItem(dbContext, ['SnapshotTypeEnterprisePolicy'], true)) || ''

    }

    get WB_SnapshotTypeSubjectAreaRows(): WB_SnapshotTypeSubjectAreaRow[] {
        return getHasManyProperty(this, 'SnapShotMsar')
    }

    get WB_SnapshotRows(): WB_SnapshotRow[] {
        return getHasManyProperty(this, 'SnapShot')
    }

    get WB_CompanyRow(): WB_CompanyRow {
        return getHasOneProperty(this, 'SnapshotCompany')
    }

    set WB_CompanyRow(value) {
        setBelongsToProperty(this, 'SnapshotCompany', value)
    }

    get WB_MasterDataSetRow(): WB_MasterDataSetRow {
        return getBelongsToProperty(this, 'SnapshotMDSet')
    }

    set WB_MasterDataSetRow(value: WB_MasterDataSetRow) {
        setBelongsToProperty(this, 'SnapshotMDSet', value)
    }

    get bHasSnapshotRows(): boolean {
        for (let aRow of this.WB_SnapshotRows) {
            if (aRow.isActive)
                return true
        }

        return false
    }

    get bHasSnapshotTypeSubjectAreaRows(): boolean {
        for (let aRow of this.WB_SnapshotTypeSubjectAreaRows) {
            if (aRow.isActive)
                return true
        }

        return false
    }
}

// Snapshot Param
export class WB_Snapshot_ParamRow
    extends ESRecord
    implements RowIF.IwbSnapshotParam {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DATE_RANGE_IND = '0'
        this.cif.PLANNING_YEAR_IND = '1'
        this.cif.SELECT_TACTICS_IND = '0'

        this.cif.WB_AUTHUSR_ID_CREATED_BY = defaultRowValues.CurrentUserWbId()
    }

    get cif(): RowIF.IwbSnapshotParam {
        return this
    }

    get WB_SnapshotRows(): WB_SnapshotRow[] {
        return getHasManyProperty(this, 'SnapShots')
    }

    get WB_Snapshot_ParamGLRRows(): WB_Snapshot_ParamGLRRow[] {
        return getHasManyProperty(this, 'SnapshotParamGLRs')
    }

    get WB_Snapshot_ParamGLELRRows(): WB_Snapshot_ParamGLELRRow[] {
        return getHasManyProperty(this, 'SnapshotParamGLELRs')
    }

    get WB_Snapshot_ParamGLPHRRows(): WB_Snapshot_ParamGLPHRRow[] {
        return getHasManyProperty(this, 'SnapshotParamGLPHRs')
    }

    get WB_Snapshot_ParamGLCHRRows(): WB_Snapshot_ParamGLCHRRow[] {
        return getHasManyProperty(this, 'SnapshotParamGLCHRs')
    }

    get WB_Snapshot_ParamSARRows(): WB_Snapshot_ParamSARRow[] {
        return getHasManyProperty(this, 'SnapshotParamSARs')
    }

    get WB_Snapshot_ParamAMRRows(): WB_Snapshot_ParamAMRRow[] {
        return getHasManyProperty(this, 'SnapshotParamAMRs')
    }

    get WB_Snapshot_ParamCHRRows(): WB_Snapshot_ParamCHRRow[] {
        return getHasManyProperty(this, 'SnapshotParamCHRs')
    }

    get WB_Snapshot_ParamPHRRows(): WB_Snapshot_ParamPHRRow[] {
        return getHasManyProperty(this, 'SnapshotParamPHRs')
    }

    get WB_MasterDataSetRow(): WB_MasterDataSetRow {
        return getBelongsToProperty(this, 'SnapshotpParamMDSet')
    }

    set WB_MasterDataSetRow(value) {
        setBelongsToProperty(this, 'SnapshotpParamMDSet', value)
    }

    get WB_SalesOrgRow(): WB_SalesOrgRow {
        return getBelongsToProperty(this, "SnapshotpParamSalesOrg")
    }

    set WB_SalesOrgRow(value: WB_SalesOrgRow) {
        setBelongsToProperty(this, "SnapshotpParamSalesOrg", value)
    }

    get WB_CompanyRow(): WB_CompanyRow {
        return getBelongsToProperty(this, "SnapshotpParamCompany")
    }

    set WB_CompanyRow(value: WB_CompanyRow) {
        setBelongsToProperty(this, "SnapshotpParamCompany", value)
    }

    get bTradeAccrual(): boolean {
        switch (this.cif.PARAM_TYPE?.toLowerCase()) {
            case 'tradeaccrual':
                return true;
            default:
                return false;
        }
    }

    get bEnableGLSalesArea(): boolean {
        return getBooleanIndicator(this, 'GLH_SALESAREA_IND')
    }

    set bEnableGLSalesArea(value) {
        setBooleanIndicator(this, 'bEnableGLSalesArea', 'GLH_SALESAREA_IND', value)
    }

    get bAllSalesAreaInd(): boolean {
        return getBooleanIndicator(this, "ALL_SALESAREA_IND")
    }

    set bAllSalesAreaInd(value) {
        setBooleanIndicator(this, 'bAllSalesAreaInd', 'ALL_SALESAREA_IND', value)
    }

    get bHierarchyBySalesAreaInd(): boolean {
        return getBooleanIndicator(this, "SNH_SALESAREA_IND")
    }

    set bHierarchyBySalesAreaInd(value) {
        setBooleanIndicator(this, 'bHierarchyBySalesAreaInd', 'SNH_SALESAREA_IND', value)
    }

    get bGLHierarchyBySalesAreaInd(): boolean {
        return getBooleanIndicator(this, "GLH_SALESAREA_IND")
    }

    set bGLHierarchyBySalesAreaInd(value) {
        setBooleanIndicator(this, 'bGLHierarchyBySalesAreaInd', 'GLH_SALESAREA_IND', value)
    }

    get bExcludeOI(): boolean {
        return getBooleanIndicator(this, "EXCLUDE_OI_IND")
    }
    
    




}


// Snapshot ParamGLR
export class WB_Snapshot_ParamGLRRow
    extends ESRecord
    implements RowIF.IwbSnapshotParamGLR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbSnapshotParamGLR {
        return this
    }

    get WB_SnapshotParamRow(): WB_SnapshotRow[] {
        return getBelongsToProperty(this, 'SnapshotParam')
    }
}

// Snapshot ParamGLELR
export class WB_Snapshot_ParamGLELRRow
    extends ESRecord
    implements RowIF.IwbSnapshotParamGLELR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbSnapshotParamGLELR {
        return this
    }

    get WB_SnapshotParamRow(): WB_SnapshotRow[] {
        return getBelongsToProperty(this, 'SnapshotParam')
    }
}


// Snapshot ParamSAR
export class WB_Snapshot_ParamSARRow
    extends ESRecord
    implements RowIF.IwbSnapshotParamSAR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbSnapshotParamSAR {
        return this
    }

    get WB_SnapshotParamRow(): WB_Snapshot_ParamRow {
        return getBelongsToProperty(this, 'SnapshotParam')
    }

    set WB_SnapshotParamRow(value: WB_Snapshot_ParamRow) {
        setBelongsToProperty(this, 'SnapshotParam', value)
    }

    get WB_SalesAreaRow(): WB_SalesAreaRow {
        return getBelongsToProperty(this, 'SalesArea')
    }

    set WB_SalesAreaRow(value: WB_SalesAreaRow) {
        setBelongsToProperty(this, 'SalesArea', value)
    }
}

// Snapshot ParamAMR
export class WB_Snapshot_ParamAMRRow
    extends ESRecord
    implements RowIF.IwbSnapshotParamAMR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbSnapshotParamAMR {
        return this
    }

    get WB_SnapshotParamRow(): WB_Snapshot_ParamRow {
        return getBelongsToProperty(this, 'SnapshotParam')
    }

    /** True if the row is the default catch-all allocation rule */
    get isDefaultRow(): boolean {
        return this.cif.WB_EVTSTYPE_ID === 0 && this.cif.RATE_BASIS_ID === "All";
    }

    /** Sets the row as the default catch-all allocation rule */
    setToDefaultRow(): void {
        this.cif.WB_EVTSTYPE_ID = 0;
        this.cif.RATE_BASIS_ID = "All";
    }

    set WB_SnapshotParamRow(value: WB_Snapshot_ParamRow) {
        setBelongsToProperty(this, 'SnapshotParam', value)
    }

    get WB_ProductConditionTypeRow(): WB_ProductConditionTypeRow {
        return getBelongsToProperty(this, "ProductConditionType")
    }

    set WB_ProductConditionTypeRow(value: WB_ProductConditionTypeRow) {
        setBelongsToProperty(this, "ProductConditionType", value);
    }

    get WB_ProductConditionTypeDefaultRow(): WB_ProductConditionTypeRow {
        return getBelongsToProperty(this, "ProductConditionTypeDefault")
    }

    set WB_ProductConditionTypeDefaultRow(value: WB_ProductConditionTypeRow) {
        setBelongsToProperty(this, "ProductConditionTypeDefault", value);
    }
}

// Snapshot ParamCHR
export class WB_Snapshot_ParamCHRRow
    extends ESRecord
    implements RowIF.IwbSnapshotParamCHR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbSnapshotParamCHR {
        return this
    }

    get WB_SnapshotParamRow(): WB_Snapshot_ParamRow {
        return getBelongsToProperty(this, 'SnapshotParam')
    }

    set WB_SnapshotParamRow(value: WB_Snapshot_ParamRow) {
        setBelongsToProperty(this, 'SnapshotParam', value)
    }

    get WB_CustomerHierarchyRow(): WB_CustomerHierarchyRow {
        return getBelongsToProperty(this, 'CustomerHier')
    }

    set WB_CustomerHierarchyRow(value: WB_CustomerHierarchyRow) {
        setBelongsToProperty(this, 'CustomerHier', value)
    }

    get WB_SalesAreaRow(): WB_SalesAreaRow {
        return getBelongsToProperty(this, 'SalesArea')
    }

    set WB_SalesAreaRow(value: WB_SalesAreaRow) {
        setBelongsToProperty(this, 'SalesArea', value)
    }

}

// Snapshot ParamPHR
export class WB_Snapshot_ParamPHRRow
    extends ESRecord
    implements RowIF.IwbSnapshotParamPHR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbSnapshotParamPHR {
        return this
    }

    get WB_SnapshotParamRow(): WB_Snapshot_ParamRow {
        return getBelongsToProperty(this, 'SnapshotParam')
    }

    set WB_SnapshotParamRow(value: WB_Snapshot_ParamRow) {
        setBelongsToProperty(this, 'SnapshotParam', value)
    }

    get WB_ProductHierarchyRow(): WB_ProductHierarchyRow {
        return getBelongsToProperty(this, 'ProductHier')
    }

    set WB_ProductHierarchyRow(value: WB_ProductHierarchyRow) {
        setBelongsToProperty(this, 'ProductHier', value)
    }

    get WB_ProductEntitySource(): WB_EntityRow {
        return getBelongsToProperty(this, 'SrcPrdEntity')
    }

    set WB_ProductEntitySource(value: WB_EntityRow) {
        setBelongsToProperty(this, 'SrcPrdEntity', value)
    }

    get WB_SalesAreaRow(): WB_SalesAreaRow {
        return getBelongsToProperty(this, 'SalesArea')
    }

    set WB_SalesAreaRow(value: WB_SalesAreaRow) {
        setBelongsToProperty(this, 'SalesArea', value)
    }

}

// Snapshot ParamCHR
export class WB_Snapshot_ParamGLCHRRow
    extends ESRecord
    implements RowIF.IwbSnapshotParamGLCHR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbSnapshotParamGLCHR {
        return this
    }

    get WB_SnapshotParamRow(): WB_Snapshot_ParamRow {
        return getBelongsToProperty(this, 'SnapshotParam')
    }

    set WB_SnapshotParamRow(value: WB_Snapshot_ParamRow) {
        setBelongsToProperty(this, 'SnapshotParam', value)
    }

    get WB_CustomerHierarchyRow(): WB_CustomerHierarchyRow {
        return getBelongsToProperty(this, 'CustomerHier')
    }

    set WB_CustomerHierarchyRow(value: WB_CustomerHierarchyRow) {
        setBelongsToProperty(this, 'CustomerHier', value)
    }

    get WB_SalesAreaRow(): WB_SalesAreaRow {
        return getBelongsToProperty(this, 'SalesArea')
    }

    set WB_SalesAreaRow(value: WB_SalesAreaRow) {
        setBelongsToProperty(this, 'SalesArea', value)
    }

}

// Snapshot ParamPHR
export class WB_Snapshot_ParamGLPHRRow
    extends ESRecord
    implements RowIF.IwbSnapshotParamGLPHR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbSnapshotParamGLPHR {
        return this
    }

    get WB_SnapshotParamRow(): WB_Snapshot_ParamRow {
        return getBelongsToProperty(this, 'SnapshotParam')
    }

    set WB_SnapshotParamRow(value: WB_Snapshot_ParamRow) {
        setBelongsToProperty(this, 'SnapshotParam', value)
    }

    get WB_ProductHierarchyRow(): WB_ProductHierarchyRow {
        return getBelongsToProperty(this, 'ProductHier')
    }

    set WB_ProductHierarchyRow(value: WB_ProductHierarchyRow) {
        setBelongsToProperty(this, 'ProductHier', value)
    }

    get WB_SalesAreaRow(): WB_SalesAreaRow {
        return getBelongsToProperty(this, 'SalesArea')
    }

    set WB_SalesAreaRow(value: WB_SalesAreaRow) {
        setBelongsToProperty(this, 'SalesArea', value)
    }

}

export class WB_SnapshotTypeSubjectAreaRow
    extends ESRecord
    implements RowIF.IwbSnapshotTypeSubjectArea {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbSnapshotTypeSubjectArea {
        return this
    }


    get WB_Snapshot_TypeRow(): WB_Snapshot_TypeRow {
        return getBelongsToProperty(this, 'SnapshotType')
    }

    get WB_SubjectAreaRow(): WB_SubjectAreaRow {
        return getBelongsToProperty(this, 'SubjectArea')
    }

    set WB_Snapshot_TypeRow(value) {
        setBelongsToProperty(this, 'SnapshotType', value)
    }

    set WB_SubjectAreaRow(value) {
        setBelongsToProperty(this, 'SubjectArea', value)
    }

    set CreatedDtTs(value: Date) {
        setBWDateTsProperty(this, "CreatedDtTs", 'CREATED_DTTS', value);
    }

    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    set ModifiedDtTs(value: Date) {
        setBWDateTsProperty(this, "ModifiedDtTs", 'MODIFIED_DTTS', value);
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }
}

// Snapshot Customer Relationship
export class WB_SnapshotCustomerRelationshipRow
    extends ESRecord
    implements RowIF.IwbSnapshotCustomer {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbSnapshotCustomer {
        return this
    }

    set CreatedDtTs(value: Date) {
        setBWDateTsProperty(this, "CreatedDtTs", 'CREATED_DTTS', value);
    }

    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    set ModifiedDtTs(value: Date) {
        setBWDateTsProperty(this, "ModifiedDtTs", 'MODIFIED_DTTS', value);
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    get WB_SnapshotRow(): WB_SnapshotRow {
        return getBelongsToProperty(this, 'Snapshot')
    }

    get WB_CustomerRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Customer')
    }

    set WB_CustomerRow(value) {
        setBelongsToProperty(this, 'Customer', value)
    }
}


// Snapshot ProductGroup Relationship
export class WB_SnapshotProductGroupRelationshipRow
    extends ESRecord
    implements RowIF.IwbSnapshotProductGroup {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbSnapshotProductGroup {
        return this
    }

    set CreatedDtTs(value: Date) {
        setBWDateTsProperty(this, "CreatedDtTs", 'CREATED_DTTS', value);
    }

    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    set ModifiedDtTs(value: Date) {
        setBWDateTsProperty(this, "ModifiedDtTs", 'MODIFIED_DTTS', value);
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    get WB_SnapshotRow(): WB_SnapshotRow {
        return getBelongsToProperty(this, 'Snapshot')
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup')
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value)
    }
}


// Snapshot Period Relationship
export class WB_SnapshotPeriodRelationshipRow
    extends ESRecord
    implements RowIF.IwbSnapshotPeriod {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbSnapshotPeriod {
        return this
    }

    set CreatedDtTs(value: Date) {
        setBWDateTsProperty(this, "CreatedDtTs", 'CREATED_DTTS', value);
    }

    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    set ModifiedDtTs(value: Date) {
        setBWDateTsProperty(this, "ModifiedDtTs", 'MODIFIED_DTTS', value);
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    get WB_SnapshotRow(): WB_SnapshotRow {
        return getBelongsToProperty(this, 'Snapshot')
    }

    get WB_PeriodRow(): WB_PeriodRow {
        return getBelongsToProperty(this, 'Period')
    }

    set WB_PeriodRow(value) {
        setBelongsToProperty(this, 'Period', value)
    }
}


// Snapshot Plan Relationship
export class WB_SnapshotPlanRelationshipRow
    extends ESRecord
    implements RowIF.IwbSnapshotPlan {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbSnapshotPlan {
        return this
    }

    set CreatedDtTs(value: Date) {
        setBWDateTsProperty(this, "CreatedDtTs", 'CREATED_DTTS', value);
    }

    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    set ModifiedDtTs(value: Date) {
        setBWDateTsProperty(this, "ModifiedDtTs", 'MODIFIED_DTTS', value);
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    get WB_SnapshotRow(): WB_SnapshotRow {
        return getBelongsToProperty(this, 'Snapshot')
    }

    get WB_PlanRow(): WB_PlanRow {
        return getBelongsToProperty(this, 'Plan')
    }

    set WB_PlanRow(value) {
        setBelongsToProperty(this, 'Plan', value)
    }
}

// Snapshot SVF Metrics
export class WB_PlanVolumeMetricsSnapshotRow
    extends ESRecord
    implements RowIF.IwbPlanVolumeMetricsSnapshot {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        let rw = this.cif
        rw.GROSS_LIST_PRICE = 0
        rw.NET_LIST_PRICE = 0
        rw.NET_LIST_PRICE_INDIRECT = 0
        rw.VCM = 0
        rw.RETAILER_BASE_PRICE = 0
        rw.RETAILER_EDLP_PRICE = 0
        rw.RETAILER_PROMO_PRICE = 0
        rw.RETAILER_PRICE = 0
        rw.UNIT_FACTOR = 0
        rw.WT_FACTOR = 0
        rw.STATCS_FACTOR = 0
        rw.CNS_BASE_QTY = 0
        rw.CNS_EDLP_QTY = 0
        rw.CNS_INCR_QTY = 0
        rw.CNS_CANN_QTY = 0
        rw.CNS_TOTAL_QTY = 0
        rw.SHIP_BASE_QTY = 0
        rw.SHIP_EDLP_QTY = 0
        rw.SHIP_INCR_QTY = 0
        rw.SHIP_FORWARDBUY_QTY = 0
        rw.SHIP_ADJ_QTY = 0
        rw.SHIP_TOTAL_QTY = 0
        rw.SHIP_BOM_COMP_QTY = 0
        rw.SHIP_OS_PCNT = 0
        rw.SHIP_DIR_BASE_QTY = 0
        rw.SHIP_DIR_EDLP_QTY = 0
        rw.SHIP_DIR_INCR_QTY = 0
        rw.SHIP_DIR_FORWARDBUY_QTY = 0
        rw.SHIP_DIR_ADJ_QTY = 0
        rw.SHIP_DIR_TOTAL_QTY = 0
        rw.SHIP_IND_PCNT = 0
        rw.SHIP_IND_BASE_QTY = 0
        rw.SHIP_IND_EDLP_QTY = 0
        rw.SHIP_IND_INCR_QTY = 0
        rw.SHIP_IND_FORWARDBUY_QTY = 0
        rw.SHIP_IND_ADJ_QTY = 0
        rw.SHIP_IND_TOTAL_QTY = 0
        rw.SHIP_IND_UNITS = 0
        rw.SHIP_IND_STAT = 0
        rw.SHIP_IND_GRSLSTSLS = 0
        rw.SHIP_IND_NETLSTSLS = 0
        rw.SHIP_DISTRIB_PCNT = 0
        rw.SHIP_DISTRIBUTED_QTY = 0
        rw.SHIP_NET_TOTAL_QTY = 0
        rw.SHIP_EXP_RECV_QTY = 0
        rw.SHIP_EXP_RECV_UNITS = 0
        rw.SHIP_EXP_RECV_STAT = 0
        rw.SHIP_EXP_RECV_GRSLSTSLS = 0
        rw.SHIP_EXP_RECV_NETLSTSLS = 0
        rw.ACT_CNS_BASE_UNITS = 0
        rw.ACT_CNS_BASE_RTLSLS = 0
        rw.ACT_CNS_EDLP_UNITS = 0
        rw.ACT_CNS_EDLP_RTLSLS = 0
        rw.ACT_CNS_INCR_UNITS = 0
        rw.ACT_CNS_INCR_RTLSLS = 0
        rw.ACT_CNS_TOTAL_UNITS = 0
        rw.ACT_CNS_TOTAL_RTLSLS = 0
        rw.LE_CNS_BASE_UNITS = 0
        rw.LE_CNS_BASE_RTLSLS = 0
        rw.LE_CNS_EDLP_UNITS = 0
        rw.LE_CNS_EDLP_RTLSLS = 0
        rw.LE_CNS_INCR_UNITS = 0
        rw.LE_CNS_INCR_RTLSLS = 0
        rw.LE_CNS_TOTAL_UNITS = 0
        rw.LE_CNS_TOTAL_RTLSLS = 0
        rw.ACT_SHIP_DIR_UNITS = 0
        rw.ACT_SHIP_DIR_WT = 0
        rw.ACT_SHIP_DIR_STAT = 0
        rw.ACT_SHIP_DIR_GRSLISTSLS = 0
        rw.ACT_SHIP_DIR_NETLISTSLS = 0
        rw.ACT_SHIP_DIR_COSTS = 0
        rw.ACT_RTN_DIR_UNITS = 0
        rw.ACT_RTN_DIR_WT = 0
        rw.ACT_RTN_DIR_STAT = 0
        rw.ACT_RTN_DIR_GRSLISTSLS = 0
        rw.ACT_RTN_DIR_NETLISTSLS = 0
        rw.ACT_RTN_DIR_COSTS = 0
        rw.ACT_SHIP_IND_UNITS = 0
        rw.ACT_SHIP_IND_WT = 0
        rw.ACT_SHIP_IND_STAT = 0
        rw.ACT_SHIP_IND_GRSLISTSLS = 0
        rw.ACT_SHIP_IND_NETLISTSLS = 0
        rw.ACT_SHIP_DIST_UNITS = 0
        rw.ACT_SHIP_DIST_WT = 0
        rw.ACT_SHIP_DIST_STAT = 0
        rw.ACT_SHIP_DIST_GRSLISTSLS = 0
        rw.ACT_SHIP_DIST_NETLISTSLS = 0
        rw.LE_SHIP_UNITS = 0
        rw.LE_SHIP_WT = 0
        rw.LE_SHIP_STAT = 0
        rw.LE_SHIP_GRSLISTSLS = 0
        rw.LE_SHIP_NETLISTSLS = 0
        rw.LE_SHIP_COSTS = 0
        rw.LE_SHIP_DIR_UNITS = 0
        rw.LE_SHIP_DIR_WT = 0
        rw.LE_SHIP_DIR_STAT = 0
        rw.LE_SHIP_DIR_GRSLISTSLS = 0
        rw.LE_SHIP_DIR_NETLISTSLS = 0
        rw.LE_SHIP_DIR_COSTS = 0
        rw.LE_SHIP_IND_UNITS = 0
        rw.LE_SHIP_IND_WT = 0
        rw.LE_SHIP_IND_STAT = 0
        rw.LE_SHIP_IND_GRSLISTSLS = 0
        rw.LE_SHIP_IND_NETLISTSLS = 0
        rw.SPND_VARIABLE = 0
        rw.SPND_FIXED = 0
        rw.ACT_SPND_VARIABLE = 0
        rw.ACT_SPND_FIXED = 0
        rw.LE_SPND_VARIABLE = 0
        rw.LE_SPND_FIXED = 0


    }

    get cif(): RowIF.IwbPlanVolumeMetricsSnapshot {
        return this
    }

}

// Snapshot Promotion Tactic
export class WB_EventSpendMetricsSnapshotRow
    extends ESRecord
    implements RowIF.IwbEventSpendMetricsSnapshot {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.PAID_IN_FULL_IND = defaultRowValues.False_Ind()
        this.cif.CURRENCY = defaultRowValues.Currency()
        this.cif.REDEMPTION_RATE_PCNT = 1
        this.cif.PLANNED_SPEND = 0
        this.cif.APPROVED_SPEND = 0
        this.cif.ACTUAL_SPEND = 0
        this.cif.LE_SPEND = 0
        this.cif.GROSS_LIST_PRICE = 0
        this.cif.NET_LIST_PRICE = 0
        this.cif.VCM = 0
    }

    get cif(): RowIF.IwbEventSpendMetricsSnapshot {
        return this
    }

}

// Snapshot Plan NFP Metrics
export class WB_PlanNFPSnapshotRow
    extends ESRecord
    implements RowIF.IwbPlanNFPSnapshot {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.PLANNED_SPEND = 0
        this.cif.APPROVED_SPEND = 0
        this.cif.ACTUAL_SPEND = 0
        this.cif.LE_SPEND = 0
        this.cif.PLAN_STD_FUNDING_AMT = 0;
        this.cif.PLAN_ADDL_FUNDING_AMT = 0;
        this.cif.ACT_STD_FUNDING_AMT = 0;
        this.cif.ACT_ADDL_FUNDING_AMT = 0;
        this.cif.LE_STD_FUNDING_AMT = 0;
        this.cif.LE_ADDL_FUNDING_AMT = 0;
        this.cif.LE_ACT_YTD_STD_FUNDING_AMT = 0;
        this.cif.LE_ACT_YTD_ADDL_FUNDING_AMT = 0;
        this.cif.LE_PLAN_YTD_STD_FUNDING_AMT = 0;
        this.cif.LE_PLAN_YTD_ADDL_FUNDING_AMT = 0;
    }

    get cif(): RowIF.IwbPlanNFPSnapshot {
        return this
    }

}

// Event Type
export class WB_EventTypeRow
    extends ESRecord
    implements RowIF.IwbEventType {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {

    }

    get cif(): RowIF.IwbEventType {
        return this
    }

    get WB_EventSpendTypeRows(): WB_EventSpendTypeRelationshipRow[] {
        return getHasManyProperty(this, 'EventSpendTypes')
    }

    get bActiveInd(): boolean {
        return getBooleanIndicator(this, 'ACTIVE_IND')
    }

    get bActualSpendShowInd(): boolean {
        return getBooleanIndicator(this, 'ACTUAL_SPEND_SHOW_IND')
    }

    get bApprovedSpendShowInd(): boolean {
        return getBooleanIndicator(this, 'APPROVED_SPEND_SHOW_IND')
    }

    get bCoverageFactorShowInd(): boolean {
        return getBooleanIndicator(this, 'COVERAGEFACTOR_SHOW_IND')
    }

    get bDefaultInd(): boolean {
        return getBooleanIndicator(this, 'DEFAULT_IND')
    }

    get bDisplayShowInd(): boolean {
        return getBooleanIndicator(this, 'DISPLAYS_SHOW_IND')
    }

    get bDistributionDatesShowInd(): boolean {
        return getBooleanIndicator(this, 'DISTRIBUTIONDATES_SHOW_IND')
    }

    get bInStoreDatesShowInd(): boolean {
        return getBooleanIndicator(this, 'INSTOREDATES_SHOW_IND')
    }

    get bLESpendShowInd(): boolean {
        return getBooleanIndicator(this, 'LE_SPEND_SHOW_IND')
    }

    get bManualInd(): boolean {
        return getBooleanIndicator(this, 'MANUAL_IND')
    }

    get bOrderDatesShowInd(): boolean {
        return getBooleanIndicator(this, 'ORDERDATES_SHOW_IND')
    }

    get bPaidInFullShowInd(): boolean {
        return getBooleanIndicator(this, 'PAIDINFULL_SHOW_IND')
    }

    get bPlannedSpendShowInd(): boolean {
        return getBooleanIndicator(this, 'PLANNED_SPEND_SHOW_IND')
    }

    get bPlanningCustomerShowInd(): boolean {
        return getBooleanIndicator(this, 'PLANNING_CUST_SHOW_IND')
    }


    get bShipmentDatesShowInd(): boolean {
        return getBooleanIndicator(this, 'SHIPMENTDATES_SHOW_IND')
    }


    get bSubPlanningCustomerShowInd(): boolean {
        return getBooleanIndicator(this, 'SUBPLANNING_CUST_SHOW_IND')
    }

    get bWorkflowShowInd(): boolean {
        return ((this.cif.WB_WORKFLOW_ID > 0) && (this.cif.WORKFLOW_POLICY != 'None'))
    }

    get bCommentsShowInd(): boolean {
        return getBooleanIndicator(this, 'COMMENTS_SHOW_IND')
    }

    get bPlanShowInd(): boolean {
        return getBooleanIndicator(this, 'PLAN_SHOW_IND')
    }

    get bCreatorShowInd(): boolean {
        return getBooleanIndicator(this, 'CREATOR_SHOW_IND')
    }

    get bTagsShowInd(): boolean {
        return getBooleanIndicator(this, 'TAGS_SHOW_IND')
    }

    get bPGGrossListPriceShowInd(): boolean {
        return getBooleanIndicator(this, 'PGGROSSLISTPRICE_SHOW_IND')
    }

    get bPGNetListPriceShowInd(): boolean {
        return getBooleanIndicator(this, 'PGNETLISTPRICE_SHOW_IND')
    }

    get bPGBasePriceShowInd(): boolean {
        return getBooleanIndicator(this, 'PGBASEPRICE_SHOW_IND')
    }

    get bPGEDLPPriceShowInd(): boolean {
        return getBooleanIndicator(this, 'PGEDLPPRICE_SHOW_IND')
    }

    get bPGPromotedPriceShowInd(): boolean {
        return getBooleanIndicator(this, 'PGPROMOTEDPRICE_SHOW_IND')
    }

    get bPGDiscountPcntShowInd(): boolean {
        return getBooleanIndicator(this, 'PGDISCOUNTPCNT_SHOW_IND')
    }

    get bPGDiscountAmtShowInd(): boolean {
        return getBooleanIndicator(this, 'PGDISCOUNTAMT_SHOW_IND')
    }

    get bPGCnsBaseShowInd(): boolean {
        return getBooleanIndicator(this, 'PGCNSBASE_SHOW_IND')
    }

    get bPGCnsBaseEDLPShowInd(): boolean {
        return getBooleanIndicator(this, 'PGCNSBASEEDLP_SHOW_IND')
    }

    get bPGCnsEDLPShowInd(): boolean {
        return getBooleanIndicator(this, 'PGCNSEDLP_SHOW_IND')
    }

    get bPGCnsLiftPcntShowInd(): boolean {
        return getBooleanIndicator(this, 'PGCNSLIFTPCNT_SHOW_IND')
    }

    get bPGCnsLiftPcntOvrdShowInd(): boolean {
        return getBooleanIndicator(this, 'PGCNSLIFTPCNTOVR_SHOW_IND')
    }

    get bPGCnsIncrShowInd(): boolean {
        return getBooleanIndicator(this, 'PGCNSINCR_SHOW_IND')
    }

    get bPGCnsCannShowInd(): boolean {
        return getBooleanIndicator(this, 'PGCNSCANN_SHOW_IND')
    }

    get bPGCnsTotalShowInd(): boolean {
        return getBooleanIndicator(this, 'PGCNSTOTAL_SHOW_IND')
    }


    get bPGShpBaseShowInd(): boolean {
        return getBooleanIndicator(this, 'PGSHPBASE_SHOW_IND')
    }

    get bPGShpBaseEDLPShowInd(): boolean {
        return getBooleanIndicator(this, 'PGSHPBASEEDLP_SHOW_IND')
    }

    get bPGShpEDLPShowInd(): boolean {
        return getBooleanIndicator(this, 'PGSHPEDLP_SHOW_IND')
    }

    get bPGShpIncrShowInd(): boolean {
        return getBooleanIndicator(this, 'PGSHPINCR_SHOW_IND')
    }

    get bPGShpFwdBuyShowInd(): boolean {
        return getBooleanIndicator(this, 'PGSHPFWDBUY_SHOW_IND')
    }

    get bPGShpFwdBuyPcntShowInd(): boolean {
        return getBooleanIndicator(this, 'PGSHPFWDBUYPCNT_SHOW_IND')
    }

    get bPGShpAdjShowInd(): boolean {
        return getBooleanIndicator(this, 'PGSHPADJ_SHOW_IND')
    }

    get bPGShpTotalShowInd(): boolean {
        return getBooleanIndicator(this, 'PGSHPTOTAL_SHOW_IND')
    }

    get bPGShpDisplayShowInd(): boolean {
        return getBooleanIndicator(this, 'PGSHPDISP_SHOW_IND')
    }

    get bPGShpDisplayPcntShowInd(): boolean {
        return getBooleanIndicator(this, 'PGSHPDISPPCNT_SHOW_IND')
    }

    get bPGShpOSShowInd(): boolean {
        return getBooleanIndicator(this, 'PGSHPOS_SHOW_IND')
    }

    get bPrdPeriodShowInd(): boolean {
        return getBooleanIndicator(this, 'PROD_PERIOD_SHOW_IND')
    }

    get bPrdShowInd(): boolean {
        return getBooleanIndicator(this, 'PROD_SHOW_IND')
    }

    get bPrdGrpShowInd(): boolean {
        return getBooleanIndicator(this, 'PRODUCTGROUPS_SHOW_IND')
    }


    get bPGCnsEDLPEditInd(): boolean {
        return getBooleanIndicator(this, 'PGCNSEDLP_EDIT_IND')
    }

    get bPGCnsIncrEditInd(): boolean {
        return getBooleanIndicator(this, 'PGCNSINCR_EDIT_IND')
    }
}

// General Ledger
export class WB_GeneralLedgerRow
    extends ESRecord
    implements RowIF.IwbGeneralLedger {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get WB_GeneralLedgerAccountRows(): WB_GeneralLedgerAccountRow[] {
        return getHasManyProperty(this, 'GeneralLedgerAccounts')
    }

    get WB_CompanyRows(): WB_CompanyRow[] {
        return getHasManyProperty(this, 'Companies')
    }

    get cif(): RowIF.IwbGeneralLedger {
        return this
    }

    get WB_MasterDataSetRow(): WB_MasterDataSetRow {
        return getBelongsToProperty(this, 'MasterDataSet')
    }

    set WB_MasterDataSetRow(value: WB_MasterDataSetRow) {
        setBelongsToProperty(this, 'MasterDataSet', value)
    }
}

//General Ledger Account
export class WB_GeneralLedgerAccountRow
    extends ESRecord
    implements RowIF.IwbGeneralLedgerAccount {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbGeneralLedgerAccount {
        return this
    }

    get WB_MetricDefinitionGLAccountRows(): WB_MetricDefinitionGLAccountRow[] {
        return getHasManyProperty(this, 'MetricDefinitionGLAccounts');
    }
}


// General Ledger TPM Policy
export class WB_GeneralLedgerPolicyRow
    extends ESRecord
    implements RowIF.IwbGeneralLedgerPolicy {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.EFFECTIVE_START_DT = defaultRowValues.Min_Dt()
        this.cif.EFFECTIVE_END_DT = defaultRowValues.Max_Dt()
    }


    afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this
        return new Promise<void>((resolve, error) => {

            // Set the Defaults for the Domain Values
            let dbContext: PAdbContext = <any>self.dataStore()

            if (_.isEmpty(dbContext)) {
                resolve()
                return
            }

            async function setAsyncDefaults() {
                self.setDefaults()

                let newKey: number = <any>(await dbContext.getNewId(self._mapper().name))
                let sNewId = TextUtils.padStart(newKey.toString(36), 12, '0').toUpperCase()
                self.cif.GLRULE_ID = sNewId
                resolve()
            }

            setAsyncDefaults()
        })
    }

    get WB_GeneralLedgerPolicyAccountRows(): WB_GeneralLedgerPolicyAccountRow[] {
        return getHasManyProperty(this, 'GeneralLedgerPolicyAccounts')
    }


    get cif(): RowIF.IwbGeneralLedgerPolicy {
        return this
    }


    get bUseRuleGLAccountAssignmentsInd(): boolean {
        return getBooleanIndicator(this, "USE_RULE_GLACCT_IND")
    }

    set bUseRuleGLAccountAssignmentsInd(value) {
        setBooleanIndicator(this, 'bUseRuleGLAccountAssignmentsInd', 'USE_RULE_GLACCT_IND', value)
    }

    get WB_MasterDataSetRow(): WB_MasterDataSetRow {
        return getBelongsToProperty(this, 'MasterDataSet')
    }

    set WB_MasterDataSetRow(value: WB_MasterDataSetRow) {
        setBelongsToProperty(this, 'MasterDataSet', value)
    }

    get WB_CompanyRow(): WB_CompanyRow {
        return getHasOneProperty(this, 'Company')
    }

    set WB_CompanyRow(value) {
        setBelongsToProperty(this, 'Company', value)
    }

    //


}

//General Ledger Policy Account
export class WB_GeneralLedgerPolicyAccountRow
    extends ESRecord
    implements RowIF.IwbGeneralLedgerPolicyAccount {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbGeneralLedgerPolicyAccount {
        return this
    }

    get WB_GeneralLedgerPolicy(): WB_GeneralLedgerPolicyRow {
        return getBelongsToProperty(this, 'GeneralLedgerPolicy')
    }
}


//Fund Type
export class WB_FundTypeRow
    extends ESRecord
    implements RowIF.IwbFundType {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbFundType {
        return this
    }
}


//Transaction Type
export class WB_TransactionTypeRow
    extends ESRecord
    implements RowIF.IwbTransactionType {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbTransactionType {
        return this
    }

    get WB_TransactionRows(): WB_TransactionRow[] {
        return getHasManyProperty(this, 'Transactions')
    }

}


//Transaction
export class WB_TransactionRow
    extends ESRecord
    implements RowIF.IwbTransaction {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get WB_TransactionTypeRow(): WB_TransactionTypeRow {
        return getBelongsToProperty(this, 'TransactionType')
    }

    set WB_TransactionTypeRow(value) {
        setBelongsToProperty(this, 'TransactionType', value)
    }

    get WB_TransactionItemRows(): WB_TransactionItemRow[] {
        return getHasManyProperty(this, 'TransactionItems')
    }

    get cif(): RowIF.IwbTransaction {
        return this
    }
}

//Transaction Item
export class WB_TransactionItemRow
    extends ESRecord
    implements RowIF.IwbTransactionItem {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.MANUAL_IND = "1"
        this.cif.DELETED_IND = "0"
    }

    get cif(): RowIF.IwbTransactionItem {
        return this
    }
}


//Transaction GL
export class WB_GLTransactionRow
    extends ESRecord
    implements RowIF.IwbGLTransaction {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.MANUAL_IND = "1"
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this
        return new Promise<void>((resolve, error) => {

            // Set the Defaults for the Domain Values
            let dbContext: PAdbContext = <any>self.dataStore()
            if (_.isEmpty(dbContext)) {
                resolve()
                return
            }

            async function setAsyncDefaults() {
                self.setDefaults()

                let newKey: number = <any>(await dbContext.getNewId(self._mapper().name))
                let sNewId = TextUtils.padStart(newKey.toString(36), 12, '0').toUpperCase()
                self.cif.TXN_ID = sNewId
                resolve()
            }

            setAsyncDefaults()
        })
    }

    get WB_GLTransactionItemRows(): WB_GLTransactionItemRow[] {
        return getHasManyProperty(this, 'GLTransactionItems')
    }

    get cif(): RowIF.IwbGLTransaction {
        return this
    }
}

//Transaction GL Item
export class WB_GLTransactionItemRow
    extends ESRecord
    implements RowIF.IwbGLTransactionItem {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.MANUAL_IND = "1"
        this.cif.DELETED_IND = "0"
    }

    get cif(): RowIF.IwbTransactionItem {
        return this
    }

    get WB_GLAccountRowExpense(): WB_GeneralLedgerAccountRow {
        return getBelongsToProperty(this, 'GLAccountExp')
    }

    get WB_GLTransactionRow(): WB_GLTransactionRow {
        return getBelongsToProperty(this, 'GLTransaction')
    }

    set WB_GLTransactionRow(value: WB_GLTransactionRow) {
        setBelongsToProperty( this, 'GLTransaction', value)
    }
}

//Transaction GL Item
export class WB_GLAccountBalRow
    extends ESRecord
    implements RowIF.IwbGLAccountBal {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.MANUAL_IND = "1"
        this.cif.DELETED_IND = "0"
    }

    get cif(): RowIF.IwbGLAccountBal {
        return this
    }

    get WB_GLAccountRow(): WB_GeneralLedgerAccountRow {
        return getBelongsToProperty(this, 'GLAccount')
    }

    // InStore
    get StartDt(): Date {
        return getBWDateProperty(this, 'START_DT')
    }

    set StartDt(value: Date) {
        setBWDateProperty(this, 'StartDt', 'START_DT', value)
    }
}

//<editor-fold desc="Workflow">

//Workflow
export class WB_WorkflowRow
    extends ESRecord
    implements RowIF.IwbWorkflow {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbWorkflow {
        return this
    }

    get WB_WorkflowStatusRows(): WB_WorkflowStatusRow[] {
        return getHasManyProperty(this, 'WorkflowStatuses')
    }
}

export class WB_WorkflowStatusRow
    extends ESRecord
    implements RowIF.IwbWorkflowStatus {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.STATUS_ID = 'New Id'
        this.cif.STATUS_NAME = 'New Name'
        this.cif.STATUS_TYPE = 'Initial'
        this.cif.APPROVED_IND = '0'
    }

    get cif(): RowIF.IwbWorkflowStatus {
        return this
    }

    get WB_WorkflowRow(): WB_WorkflowRow {
        return getBelongsToProperty(this, 'Workflow')
    }

    set WB_WorkflowRow(value) {
        setBelongsToProperty(this, 'Workflow', value)
    }

    get WB_WorkflowStatusRelationshipRows(): WB_WorkflowStatusRelationshipRow[] {
        return getHasManyProperty(this, 'StateTransitions')
    }


    get StatusTypeInitial(): boolean {
        return (this.cif.STATUS_TYPE == 'Initial')
    }

    get StatusTypePendingApproval(): boolean {
        return (this.cif.STATUS_TYPE == 'PendingApproval')
    }

    get StatusTypeRejected(): boolean {
        return (this.cif.STATUS_TYPE == 'Rejected')
    }

    get StatusTypeApproved(): boolean {
        return (this.cif.STATUS_TYPE == 'Approved')
    }

    get StatusTypeRevised(): boolean {
        return (this.cif.STATUS_TYPE == 'Revised')
    }

    get StatusTypeRevisionDenied(): boolean {
        return (this.cif.STATUS_TYPE == 'RevisionsDenied')
    }

    get StatusTypeCancelled(): boolean {
        return (this.cif.STATUS_TYPE == 'Cancelled')
    }

    get StatusTypeClosed(): boolean {
        return (this.cif.STATUS_TYPE == 'Closed')
    }

    get StatusTypeIsRequestingApproval(): boolean {
        return this.StatusTypePendingApproval || this.StatusTypeRevised
    }

    get StatusTypeIsPostApproval(): boolean {
        return this.StatusTypeApproved ||
            this.StatusTypeClosed ||
            this.StatusTypeRevised ||
            this.StatusTypeRevisionDenied
    }

    get StatusTypeIsPreApproval(): boolean {
        return this.StatusTypeInitial ||
            this.StatusTypePendingApproval ||
            this.StatusTypeRejected
    }


}


export class WB_WorkflowStatusRelationshipRow
    extends ESRecord
    implements RowIF.IwbWorkflowStatusRelationship {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {

    }

    get cif(): RowIF.IwbWorkflowStatusRelationship {
        return this
    }

    set WB_WorkflowStatusRow(value) {
        setBelongsToProperty(this, 'Status', value)
    }

    get WB_WorkflowStatusRow(): WB_WorkflowStatusRow {
        return getBelongsToProperty(this, 'Status')
    }

    set WB_WorkflowStatusRow_Next(value) {
        setBelongsToProperty(this, 'NextStatus', value)
    }

    get WB_WorkflowStatusRow_Next(): WB_WorkflowStatusRow {
        return getBelongsToProperty(this, 'NextStatus')
    }

    get WB_DomainItemRow_Role(): WB_DomainItemRow {
        return getBelongsToProperty(this, 'Role')
    }

}


export class WB_WorflowStatusHistoryRow
    extends ESRecord
    implements RowIF.IwbWorkflowStatusHistory {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.WB_APP_ID = 0
        this.cif.APPMGR_ID = ""
        this.cif.APP_ID = ""
        this.cif.WB_AUTHUSR_ID = 0
        this.cif.WB_STATUS_ID = 0
        this.cif.WB_AUTHUSR_ID = defaultRowValues.CurrentUserWbId()
        this.StatusDateTime = new Date(Date.now())

    }

    get cif(): RowIF.IwbWorkflowStatusHistory {
        return this
    }

    get WB_WorkflowStatusRow(): WB_WorkflowStatusRow {
        return getBelongsToProperty(this, 'Status')
    }

    get WB_UserRow(): WB_UserRow {
        return getBelongsToProperty(this, 'User')
    }

    get WB_WorflowStatusHistoryLogRows(): WB_WorflowStatusHistoryLogRow {
        return getHasManyProperty(this, "Log")
    }

    get StatusDateTime(): Date {
        return getBWDateTsSplitProperty(this, 'STATUS_DT', 'STATUS_TM')
    }

    set StatusDateTime(value) {
        setBWDateTsSplitProperty(this, 'StatusDateTime', 'STATUS_DT', 'STATUS_TM', value)
    }


}

export class WB_WorflowStatusHistoryLogRow
    extends ESRecord
    implements RowIF.IwbWorkflowStatusHistoryLog {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbWorkflowStatusHistoryLog {
        return this
    }

    get WB_WorflowStatusHistoryRow(): WB_WorflowStatusHistoryRow {
        return getBelongsToProperty(this, 'StatusHistory')
    }

}

export class WB_UserReviewerRow
    extends ESRecord
    implements RowIF.IwbUserReviewer {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbUserReviewer {
        return this
    }

}

//</editor-fold>


//<editor-fold desc="Baseline">
// Baseline
export class WB_BaseLnRow
    extends ESRecord
    implements RowIF.IwbBaseLn {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.MANUAL_IND = "1"
    }

    get cif(): RowIF.IwbBaseLn {
        return this
    }
}

// Baseline Metrics
export class WB_BaseLnMtRow
    extends ESRecord
    implements RowIF.IwbBaseLnMt {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbBaseLnMt {
        return this
    }
}

// Baseline
export class WB_BaselineRow
    extends ESRecord
    implements RowIF.IwbBaseline {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.MANUAL_IND = "1"
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this
        return new Promise<void>((resolve, error) => {

            // Set the Defaults for the Domain Values
            let dbContext: PAdbContext = <any>self.dataStore()

            if (_.isEmpty(dbContext)) {
                resolve()
                return
            }

            async function setAsyncDefaults() {
                self.setDefaults()

                let newKey: number = <any>(await dbContext.getNewId(self._mapper().name))
                let sNewId = TextUtils.padStart(newKey.toString(36), 12, '0').toUpperCase()
                self.cif.PLNMGMT_ID = sNewId
                resolve()
            }

            setAsyncDefaults()
        })
    }

    get cif(): RowIF.IwbBaseline {
        return this
    }

    get WB_PartitionRow(): WB_PartitionRow {
        return getBelongsToProperty(this, 'Partition')
    }

    set WB_PartitionRow(value) {
        setBelongsToProperty(this, 'Partition', value)
    }

    get WB_ScheduleRow(): WB_ScheduleRow {
        return getBelongsToProperty(this, 'Schedule')
    }

    set WB_ScheduleRow(value) {
        setBelongsToProperty(this, 'Schedule', value)
    }


}

// Baseline Metrics
export class WB_BaselineMetricsRow
    extends ESRecord
    implements RowIF.IwbBaselineMetrics {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.MANUAL_IND = "1"
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbBaselineMetrics {
        return this
    }
}

//</editor-fold>


//<editor-fold desc="Plan Management">
// Plan Management
export class WB_PlanManagementRow
    extends ESRecord
    implements RowIF.IwbPlanManagement {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Deleted_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this
        return new Promise<void>((resolve, error) => {

            // Set the Defaults for the Domain Values
            let dbContext: PAdbContext = <any>self.dataStore()

            if (_.isEmpty(dbContext)) {
                resolve()
                return
            }

            async function setAsyncDefaults() {
                self.setDefaults()

                let newKey: number = <any>(await dbContext.getNewId(self._mapper().name))
                let sNewId = TextUtils.padStart(newKey.toString(36), 12, '0').toUpperCase()
                self.cif.PLNMGMT_ID = sNewId
                resolve()
            }

            setAsyncDefaults()
        })
    }

    get cif(): RowIF.IwbPlanManagement {
        return this
    }


    get WB_PlanManagementPeriodRows(): WB_PlanManagementPeriodRow[] {
        return getHasManyProperty(this, 'Periods')
    }

    get WB_PlanManagementUserRows(): WB_PlanManagementUserRow[] {
        return getHasManyProperty(this, 'Users')
    }

    get WB_PlanManagementUserGroupRows(): WB_PlanManagementUserGroupRow[] {
        return getHasManyProperty(this, 'UserGroups')
    }

    get WB_PlanRows(): WB_PlanRow[] {
        return getHasManyProperty(this, 'Plans')
    }


}


export class WB_PlanManagementPeriodRow
    extends ESRecord
    implements RowIF.IwbPlanManagementPeriod {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Deleted_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbPlanManagementPeriod {
        return this
    }

    get WB_PlanManagementRow(): WB_PlanManagementRow {
        return getBelongsToProperty(this, 'PlanManagement')
    }

    set WB_PlanManagementRow(value) {
        setBelongsToProperty(this, 'PlanManagement', value)
    }

    get WB_PeriodRow(): WB_PeriodRow {
        return getBelongsToProperty(this, 'Period')
    }

    set WB_PeriodRow(value) {
        setBelongsToProperty(this, 'Period', value)
    }


    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup')
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value)
    }

}

export class WB_PlanManagementUserRow
    extends ESRecord
    implements RowIF.IwbPlanManagementUser {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Deleted_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbPlanManagementUser {
        return this
    }

    get WB_PlanManagementRow(): WB_PlanManagementRow {
        return getBelongsToProperty(this, 'PlanManagement')
    }

    set WB_PlanManagementRow(value) {
        setBelongsToProperty(this, 'PlanManagement', value)
    }

    get WB_AuthUserRow(): WB_UserRow {
        return getBelongsToProperty(this, 'AuthUser')
    }

    set WB_AuthUserRow(value) {
        setBelongsToProperty(this, 'AuthUser', value)
    }

}

export class WB_PlanManagementUserGroupRow
    extends ESRecord
    implements RowIF.IwbPlanManagementUserGroup {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Deleted_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbPlanManagementUserGroup {
        return this
    }

    get WB_PlanManagementRow(): WB_PlanManagementRow {
        return getBelongsToProperty(this, 'PlanManagement')
    }

    set WB_PlanManagementRow(value) {
        setBelongsToProperty(this, 'PlanManagement', value)
    }

    get WB_UserGroupRow(): WB_UserGroupRow {
        return getBelongsToProperty(this, 'UserGroup')
    }

    set WB_UserGroupRow(value) {
        setBelongsToProperty(this, 'UserGroup', value)
    }

}

//</editor-fold>


//<editor-fold desc="User Group">
export class WB_UserGroupRow
    extends ESRecord
    implements RowIF.IwbUserGroup {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.EFFECTIVE_START_DT = defaultRowValues.Min_Dt()
        this.cif.EFFECTIVE_END_DT = defaultRowValues.Max_Dt()
        this.cif.CREATED_DT = defaultRowValues.Created_Dt()
        this.cif.MODIFIED_DT = defaultRowValues.Modified_Dt()
        this.cif.MODIFIED_BY = defaultRowValues.Modified_By()
    }

    afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this
        return new Promise<void>((resolve, error) => {

            // Set the Defaults for the Domain Values
            let dbContext: PAdbContext = <any>self.dataStore()

            if (_.isEmpty(dbContext)) {
                resolve()
                return
            }

            async function setAsyncDefaults() {
                self.setDefaults()

                let newKey: number = <any>(await dbContext.getNewId(self._mapper().name))
                let sNewId = TextUtils.padStart(newKey.toString(36), 12, '0').toUpperCase()
                self.cif.USRGRP_ID = sNewId
                resolve()
            }

            setAsyncDefaults()
        })
    }

    get cif(): RowIF.IwbUserGroup {
        return this
    }

    get WB_UserGroupCustomerRows(): WB_UserGroupCustomerRow[] {
        return getHasManyProperty(this, 'UserGroupCustomers')
    }

    get WB_UserGroupProductRows(): WB_UserGroupProductRow[] {
        return getHasManyProperty(this, 'UserGroupProducts')
    }

    get WB_UserGroupUserRows(): WB_UserGroupUserRow[] {
        return getHasManyProperty(this, 'UserGroupUsers')
    }

    get WB_UserGroupRoleRows(): WB_UserGroupRoleRow[] {
        return getHasManyProperty(this, 'UserGroupRoles')
    }

    get WB_UserGroupRelationshipRows(): WB_UserGroupRelationshipRow[] {
        return getHasManyProperty(this, 'UserGroupRs')
    }

    get WB_UserGroupSalesAreaRows(): WB_UserGroupSalesAreaRow[] {
        return getHasManyProperty(this, 'UserGroupSalesAreas')
    }

    get WB_UserGroupTypeRow(): WB_UserGroupTypeRow {
        return getBelongsToProperty(this, 'UserGroupType')
    }

    set WB_UserGroupTypeRow(value) {
        setBelongsToProperty(this, 'UserGroupType', value)
    }

    get WB_SalesOrgRow(): WB_SalesOrgRow {
        return getBelongsToProperty(this, 'SalesOrg')
    }

    set WB_SalesOrgRow(value) {
        setBelongsToProperty(this, 'SalesOrg', value)
    }

    get WB_MasterDataSetRow(): WB_MasterDataSetRow {
        return getBelongsToProperty(this, 'MasterDataSet')
    }

    set WB_MasterDataSetRow(value) {
        setBelongsToProperty(this, 'MasterDataSet', value)
    }
}

export class WB_UserGroupCustomerRow
    extends ESRecord
    implements RowIF.IwbUserGroupCR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.MANUAL_IND = '1'
        this.cif.EFFECTIVE_START_DT = defaultRowValues.Min_Dt()
        this.cif.EFFECTIVE_END_DT = defaultRowValues.Max_Dt()
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbUserGroupCR {
        return this
    }

    get WB_UserGroupRow(): WB_UserGroupRow {
        return getBelongsToProperty(this, 'UserGroup')
    }

    get WB_CustomerRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Customer')
    }

    set WB_CustomerRow(value) {
        setBelongsToProperty(this, 'Customer', value)
    }
}

export class WB_UserGroupProductRow
    extends ESRecord
    implements RowIF.IwbUserGroupPR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.MANUAL_IND = '1'
        this.cif.EFFECTIVE_START_DT = defaultRowValues.Min_Dt()
        this.cif.EFFECTIVE_END_DT = defaultRowValues.Max_Dt()
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbUserGroupPR {
        return this
    }

    get WB_UserGroupRow(): WB_UserGroupRow {
        return getBelongsToProperty(this, 'UserGroup')
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup')
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value)
    }
}

export class WB_UserGroupUserRow
    extends ESRecord
    implements RowIF.IwbUserGroupUR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.MANUAL_IND = '1'
        this.cif.EFFECTIVE_START_DT = defaultRowValues.Min_Dt()
        this.cif.EFFECTIVE_END_DT = defaultRowValues.Max_Dt()
        this.cif.CREATED_DT = defaultRowValues.Created_Dt()
        this.cif.MODIFIED_DT = defaultRowValues.Modified_Dt()
        this.cif.MODIFIED_BY = defaultRowValues.Modified_By()
    }

    get cif(): RowIF.IwbUserGroupUR {
        return this
    }

    get WB_UserGroupRow(): WB_UserGroupRow {
        return getBelongsToProperty(this, 'UserGroup')
    }

    set WB_UserGroupRow(value) {
        setBelongsToProperty(this, 'UserGroup', value)
    }


    get WB_UserRow(): WB_UserRow {
        return getBelongsToProperty(this, 'User')
    }

    set WB_UserRow(value) {
        setBelongsToProperty(this, 'User', value)
    }

}

export class WB_UserGroupRoleRow
    extends ESRecord
    implements RowIF.IwbUserGroupRR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.MANUAL_IND = '1'
        this.cif.EFFECTIVE_START_DT = defaultRowValues.Min_Dt()
        this.cif.EFFECTIVE_END_DT = defaultRowValues.Max_Dt()
        this.cif.CREATED_DT = defaultRowValues.Created_Dt()
        this.cif.MODIFIED_DT = defaultRowValues.Modified_Dt()
        this.cif.MODIFIED_BY = defaultRowValues.Modified_By()
    }

    get cif(): RowIF.IwbUserGroupRR {
        return this
    }

    get WB_UserGroupRow(): WB_UserGroupRow {
        return getBelongsToProperty(this, 'UserGroup')
    }

    get WB_CustomerRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Customer')
    }

    get WB_DomainItemRow_Role(): WB_DomainItemRow {
        return getBelongsToProperty(this, 'DomainItem')
    }

    set WB_DomainItemRow_Role(value) {
        setBelongsToProperty(this, 'DomainItem', value)
    }

}


export class WB_UserGroupTypeRow
    extends ESRecord
    implements RowIF.IwbUserGroupType {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.MANUAL_IND = '1'
        this.cif.WB_AUTHUSR_ID_CREATEDBY = defaultRowValues.CurrentUserWbId()
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbUserGroupType {
        return this
    }

    get WB_UserGroupRows(): WB_UserGroupRow[] {
        return getHasManyProperty(this, 'UserGroups')
    }

    get bHasUserGroups(): boolean {
        let activeUGs = _.filter(this.WB_UserGroupRows, aUGRow => aUGRow.isActive)
        return activeUGs.length > 0
    }

    get WB_MasterDataSetRow(): WB_MasterDataSetRow {
        return getBelongsToProperty(this, 'MDSet')
    }

    set WB_MasterDataSetRow(value) {
        setBelongsToProperty(this, 'MDSet', value)
    }
}

export class WB_UserGroupRelationshipRow
    extends ESRecord
    implements RowIF.IwbUserGroupR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.MANUAL_IND = '1'
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbUserGroupR {
        return this
    }

    get WB_UserGroupRowParent(): WB_UserGroupRow {
        return getBelongsToProperty(this, 'Parent');
    }

    set WB_UserGroupRowParent(value) {
        setBelongsToProperty(this, 'Parent', value);
    }

    get WB_UserGroupRowChild(): WB_UserGroupRow {
        return getBelongsToProperty(this, 'Child');
    }

    set WB_UserGroupRowChild(value) {
        setBelongsToProperty(this, 'Child', value);
    }

    get WB_UserGroupRow(): WB_UserGroupRow {
        return getBelongsToProperty(this, 'UserGroup')
    }

    set WB_UserGroupRow(value) {
        setBelongsToProperty(this, 'UserGroup', value)
    }

    get WB_UserGroupHierarchyRow(): WB_UserGroupHierarchyRow {
        return getBelongsToProperty(this, 'UserGroupHierarchy')
    }

    set WB_UserGroupHierarchyRow(value) {
        setBelongsToProperty(this, 'UserGroupHierarchy', value)
    }
}

export class WB_UserGroupSalesAreaRow
    extends ESRecord
    implements RowIF.IwbUserGroupSAR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbUserGroupSAR {
        return this
    }

    get WB_UserGroupRow(): WB_UserGroupRow {
        return getBelongsToProperty(this, 'UserGroup')
    }

    set WB_UserGroupRow(value) {
        setBelongsToProperty(this, 'UserGroup', value)
    }


    get WB_SalesAreaRow(): WB_SalesAreaRow {
        return getBelongsToProperty(this, 'SalesArea')
    }

    set WB_SalesAreaRow(value) {
        setBelongsToProperty(this, 'SalesArea', value)
    }
}


export class WB_UserGroupHierarchyRow
    extends ESRecord
    implements RowIF.IwbUserGroupHierarchy {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.MANUAL_IND = '1'
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbUserGroupHierarchy {
        return this
    }

    get WB_MasterDataSetRow(): WB_MasterDataSetRow {
        return getBelongsToProperty(this, 'MDSet')
    }

    set WB_MasterDataSetRow(value) {
        setBelongsToProperty(this, 'MDSet', value)
    }

    get WB_SalesOrgRow(): WB_SalesOrgRow {
        return getBelongsToProperty(this, 'SalesOrg')
    }

    set WB_SalesOrgRow(value) {
        setBelongsToProperty(this, 'SalesOrg', value)
    }
}

//</editor-fold>


//<editor-fold desc="Metric Definition/ Metric View">

export class WB_MetricDefinitionRow
    extends ESRecord
    implements RowIF.IwbMetricDefinition {
    private _currencySymbol: string

    constructor(props: any, opts: any) {
        super(props, opts);
        this._currencySymbol = ""
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.WB_SUBJECTAREA_ID = 0
    }

    get cif(): RowIF.IwbMetricDefinition {
        return this
    }

    get WB_SubjectAreaRow(): WB_SubjectAreaRow {
        return getBelongsToProperty(this, 'SubjectArea')
    }

    set WB_SubjectAreaRow(value) {
        setBelongsToProperty(this, 'SubjectArea', value)
    }

    get WB_MetricDefinitionGLAccountRows(): WB_MetricDefinitionGLAccountRow[] {
        return getHasManyProperty(this, 'MetricDefinitionGLAccounts');
    }

    get WB_MetricDefinitionEventSpendRows(): WB_MetricDefinitionEventSpendRow[] {
        return getHasManyProperty(this, 'MetricDefinitionEvtSTypes');
    }

    get WB_MetricDefinitionComponentRows(): WB_MetricDefinitionComponentRow[] {
        return getHasManyProperty(this, 'MetricComponents')
    }

    get WB_MetricDefinitionComponentRows_Usage(): WB_MetricDefinitionComponentRow[] {
        return getHasManyProperty(this, 'MetricUsedBy')
    }

    get bEditable(): boolean {
        return getBooleanIndicator(this, 'EDITABLE_IND')
    }

    set bEditable(value: boolean) {
        setBooleanIndicator(this, 'bEditable', 'EDITABLE_IND', value)
    }

    get bVisible(): boolean {
        return getBooleanIndicator(this, 'VISIBLE_IND')
    }

    set bVisible(value: boolean) {
        setBooleanIndicator(this, 'bVisible', 'VISIBLE_IND', value)
    }

    get bRowCalcWriteBack(): boolean {
        return getBooleanIndicator(this, 'ROWCALC_WB_IND')
    }

    set bRowCalcWriteBack(value: boolean) {
        setBooleanIndicator(this, 'bRowCalcWriteBack', 'ROWCALC_WB_IND', value)
    }


    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

    get CurrencySymbol(): string {
        return this._currencySymbol
    }

    set CurrencySymbol(value) {
        this._currencySymbol = value
    }


}

export class WB_MetricDefinitionComponentRow
    extends ESRecord
    implements RowIF.IwbMetricDefinitionComponent {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs();
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind();
        this.cif.DELETED_DT = defaultRowValues.Deleted_Dt();
    }

    get cif(): RowIF.IwbMetricDefinitionComponent {
        return this
    }

    get WB_MetricDefinitionRow(): WB_MetricDefinitionRow {
        return getBelongsToProperty(this, 'MetricDefinition')
    }

    set WB_MetricDefinitionRow(value) {
        setBelongsToProperty(this, 'MetricDefinition', value)
    }

    get WB_CubeSourceDataSourceRow(): WB_CubeSourceDataSourceRow {
        return getBelongsToProperty(this, 'CubeSourceDSR')
    }

    set WB_CubeSourceDataSourceRow(value) {
        setBelongsToProperty(this, 'CubeSourceDSR', value)
    }

    get WB_DataObjectColumnRow(): WB_DataObjectColumnRow {
        return getBelongsToProperty(this, 'DataObjectColumn')
    }

    set WB_DataObjectColumnRow(value) {
        setBelongsToProperty(this, 'DataObjectColumn', value)
    }

    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

}

export class WB_MetricDefinitionGLAccountRow
    extends ESRecord
    implements RowIF.IwbMetricDefinitionGLAccount {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs();
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind();
        this.cif.DELETED_DT = defaultRowValues.Deleted_Dt();
    }

    get cif(): RowIF.IwbMetricDefinitionGLAccount {
        return this
    }

    get WB_MetricDefinitionRow(): WB_MetricDefinitionRow {
        return getBelongsToProperty(this, 'MetricDefinition')
    }

    set WB_MetricDefinitionRow(value) {
        setBelongsToProperty(this, 'MetricDefinition', value)
    }

    get WB_GeneralLedgerAccountRow(): WB_GeneralLedgerAccountRow {
        return getBelongsToProperty(this, 'GLAccount')
    }

    set WB_GeneralLedgerAccountRow(value) {
        setBelongsToProperty(this, 'GLAccount', value)
    }

    get EffectiveStartDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_START_DT');
    }

    set EffectiveStartDt(value: Date) {
        setBWDateProperty(this, 'EffectiveStartDt', 'EFFECTIVE_START_DT', value);
    }
}

export class WB_MetricDefinitionEventSpendRow
    extends ESRecord
    implements RowIF.IwbMetricDefinitionEventSpendType {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs();
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind();
        this.cif.DELETED_DT = defaultRowValues.Deleted_Dt();
    }

    get cif(): RowIF.IwbMetricDefinitionEventSpendType {
        return this
    }

    get WB_MetricDefinitionRow(): WB_MetricDefinitionRow {
        return getBelongsToProperty(this, 'MetricDefinition')
    }

    set WB_MetricDefinitionRow(value) {
        setBelongsToProperty(this, 'MetricDefinition', value)
    }

    get WB_TPM_EventSpendTypeRow(): WB_TPM_EventSpendTypeRow {
        return getBelongsToProperty(this, 'EventSpendType')
    }

    set WB_TPM_EventSpendTypeRow(value) {
        setBelongsToProperty(this, 'EventSpendType', value)
    }

    get EffectiveStartDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_START_DT');
    }

    set EffectiveStartDt(value: Date) {
        setBWDateProperty(this, 'EffectiveStartDt', 'EFFECTIVE_START_DT', value);
    }

    get EffectiveEndDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_END_DT');
    }

    set EffectiveEndDt(value: Date) {
        setBWDateProperty(this, 'EffectiveEndDt', 'EFFECTIVE_END_DT', value);
    }


}


export class WB_MetricViewRow
    extends ESRecord
    implements RowIF.IwbMetricView {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbMetricView {
        return this
    }

    get WB_MetricViewMetricRows(): WB_MetricViewMetricRow[] {
        return getHasManyProperty(this, 'Metrics')
    }

    set WB_MetricViewMetricRows(value) {
        setBelongsToProperty(this, 'Metrics', value)
    }

}


export class WB_MetricViewMetricRow
    extends ESRecord
    implements RowIF.IwbMetricViewMetric {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbMetricViewMetric {
        return this
    }

    get WB_MetricViewRow(): WB_MetricViewRow {
        return getBelongsToProperty(this, 'MetricView')
    }

    set WB_MetricViewRow(value) {
        setBelongsToProperty(this, 'MetricView', value)
    }

    get WB_MetricDefinitionRow(): WB_MetricDefinitionRow {
        return getBelongsToProperty(this, 'MetricDefinition')
    }

    set WB_MetricDefinitionRow(value) {
        setBelongsToProperty(this, 'MetricDefinition', value)
    }

    get WB_CubeSourceDataSourceRow(): WB_CubeSourceDataSourceRow {
        return getBelongsToProperty(this, 'CubeSourceDSR')
    }

    set WB_CubeSourceDataSourceRow(value) {
        setBelongsToProperty(this, 'CubeSourceDSR', value)
    }

    get WB_DataObjectColumnRow(): WB_DataObjectColumnRow {
        return getBelongsToProperty(this, 'DataObjectColumn')
    }

    set WB_DataObjectColumnRow(value) {
        setBelongsToProperty(this, 'DataObjectColumn', value)
    }

    get MetricId(): string {
        if (this.WB_MetricDefinitionRow)
            return this.WB_MetricDefinitionRow.cif.METRIC_ID

        if (this.WB_CubeSourceDataSourceRow && this.WB_DataObjectColumnRow) {
            return `${this.WB_CubeSourceDataSourceRow.cif.ALIAS_ID}_${this.WB_DataObjectColumnRow.cif.COLUMN_ID}`
        }

        return ""
    }

    get MetricName(): string {
        if (this.WB_MetricDefinitionRow)
            return this.WB_MetricDefinitionRow.cif.METRIC_NAME

        if (this.WB_CubeSourceDataSourceRow && this.WB_DataObjectColumnRow) {
            return this.WB_DataObjectColumnRow.cif.COLUMN_NAME
        }

        return ""
    }

    get MetricGroup(): string {
        if (this.WB_MetricDefinitionRow)
            return this.WB_MetricDefinitionRow.cif.METRIC_GROUP

        if (this.WB_CubeSourceDataSourceRow && this.WB_DataObjectColumnRow) {
            return this.WB_DataObjectColumnRow.cif.METRIC_GROUP
        }

        return ""
    }

    get MetricType(): string {
        if (this.WB_MetricDefinitionRow)
            return "MetricDefinition"

        if (this.WB_CubeSourceDataSourceRow && this.WB_DataObjectColumnRow) {
            return "ColumnMetric"
        }

        return ""
    }

    get MetricComments(): string {
        if (this.WB_MetricDefinitionRow)
            return this.WB_MetricDefinitionRow.cif.METRIC_NOTES

        if (this.WB_CubeSourceDataSourceRow && this.WB_DataObjectColumnRow) {
            return `Source Column:  ${this.WB_DataObjectColumnRow.cif.COLUMN_ID}`
        }

        return ""
    }

}

//</editor-fold>

//<editor-fold desc="CubeSource">

export class WB_CubeSourceRow
    extends ESRecord
    implements RowIF.IwbCubeSource {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbCubeSource {
        return this
    }

    get WB_CubeSourceDimensionRows(): WB_CubeSourceDimensionRow[] {
        return getHasManyProperty(this, 'Dimensions')
    }

    get WB_CubeSourceDataSourceRows(): WB_CubeSourceDataSourceRow[] {
        return getHasManyProperty(this, 'DataSources')
    }

    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

}

export class WB_CubeSourceDimensionRow
    extends ESRecord
    implements RowIF.IwbCubeSourceDimension {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbCubeSourceDimension {
        return this
    }

    get WB_CubeSourceRow(): WB_CubeSourceRow {
        return getBelongsToProperty(this, 'CubeSource')
    }

    set WB_CubeSourceRow(value: WB_CubeSourceRow) {
        setBelongsToProperty(this, 'CubeSource', value)
    }

    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

}

export class WB_CubeSourceDataSourceRow
    extends ESRecord
    implements RowIF.IwbCubeSourceDataSource {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbCubeSourceDataSource {
        return this
    }

    get WB_CubeSourceRow(): WB_CubeSourceRow {
        return getBelongsToProperty(this, 'CubeSource')
    }

    set WB_CubeSourceRow(value: WB_CubeSourceRow) {
        setBelongsToProperty(this, 'CubeSource', value)
    }

    get WB_DataObjectRow(): WB_DataObjectRow {
        return getBelongsToProperty(this, 'DataObject')
    }

    set WB_DataObjectRow(value: WB_DataObjectRow) {
        setBelongsToProperty(this, 'DataObject', value)
    }

    get WB_CubeSourceDataSourceDimensionRows(): WB_CubeSourceDataSourceDimensionRow[] {
        return getHasManyProperty(this, 'DataSourceDimensions')
    }

    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

}

export class WB_CubeSourceDataSourceDimensionRow
    extends ESRecord
    implements RowIF.IwbCubeSourceDataSourceDimension {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbCubeSourceDataSourceDimension {
        return this
    }

    get WB_CubeSourceDataSourceRow(): WB_CubeSourceDataSourceRow {
        return getBelongsToProperty(this, 'DataSource')
    }

    set WB_CubeSourceDataSourceRow(value: WB_CubeSourceDataSourceRow) {
        setBelongsToProperty(this, 'DataSource', value)
    }

    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

}

//</editor-fold>

export class WB_TimingRow
    extends ESRecord
    implements RowIF.IwbTiming {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.WB_AUTHUSR_ID = defaultRowValues.CurrentUserWbId()
    }

    get cif(): RowIF.IwbTiming {
        return this
    }

}

//<editor-fold desc="Report Specification">

export class WB_ReportRow
    extends ESRecord
    implements RowIF.IwbReport {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.REPORT_NAME = 'New Report'
    }

    get cif(): RowIF.IwbReport {
        return this
    }

    get WB_ReportMetricRows(): WB_ReportMetricRow[] {
        return getHasManyProperty(this, 'ReportMetrics')
    }

    get WB_CompanyRow(): WB_CompanyRow {
        return getBelongsToProperty(this, 'Company')
    }

    set WB_CompanyRow(value) {
        setBelongsToProperty(this, 'Company', value)
    }

    get WB_ScheduleRow(): WB_ScheduleRow {
        return getBelongsToProperty(this, 'Schedule')
    }

    set WB_ScheduleRow(value) {
        setBelongsToProperty(this, 'Schedule', value)
    }
}

export class WB_ReportMetricRow
    extends ESRecord
    implements RowIF.IwbReportMetric {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbReportMetric {
        return this
    }


    get WB_ReportRow(): WB_ReportRow {
        return getBelongsToProperty(this, 'Report')
    }

    get WB_MetricDefinitionRow(): WB_MetricDefinitionRow {
        return getBelongsToProperty(this, 'MetricDefinition')
    }

    set WB_ReportRow(value) {
        setBelongsToProperty(this, 'Report', value)
    }

    set WB_MetricDefinitionRow(value) {
        setBelongsToProperty(this, 'MetricDefinition', value)
    }

}

export class WB_ReportExportRow
    extends ESRecord
    implements RowIF.IwbReportExport {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbReportExport {
        return this
    }
}

//</editor-fold>


//<editor-fold desc="Model">
// Model - Master Data
export class WB_ModelPredictorRow
    extends ESRecord
    implements RowIF.IwbModelPredictor {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbModelPredictor {
        return this
    }


    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    set CreatedDtTs(value: Date) {
        setBWDateTsProperty(this, "CreatedDtTs", 'CREATED_DTTS', value);
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    set ModifiedDtTs(value: Date) {
        setBWDateTsProperty(this, "ModifiedDtTs", 'MODIFIED_DTTS', value);
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

    set DeletedDt(value: Date) {
        setBWDateProperty(this, 'DeletedDt', 'DELETED_DT', value)
    }

    get WB_TagRow(): WB_TagRow {
        return getBelongsToProperty(this, 'Tag')
    }

    set WB_TagRow(value: WB_TagRow) {
        setBelongsToProperty(this, 'Tag', value)
    }
}

export class WB_ModelInputRow
    extends ESRecord
    implements RowIF.IwbModelInput {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbModelInput {
        return this
    }

    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    set CreatedDtTs(value: Date) {
        setBWDateTsProperty(this, "CreatedDtTs", 'CREATED_DTTS', value);
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    set ModifiedDtTs(value: Date) {
        setBWDateTsProperty(this, "ModifiedDtTs", 'MODIFIED_DTTS', value);
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

    set DeletedDt(value: Date) {
        setBWDateProperty(this, 'DeletedDt', 'DELETED_DT', value)
    }


}

export class WB_ModelFunctionRow
    extends ESRecord
    implements RowIF.IwbModelFunction {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.RENDER_OPTIONS = '{"src": "img_url"}'
        this.cif.COEFFICIENT_COUNT = 0
        this.cif.INPUT_COUNT = 0
        this.cif.PREDICTOR_COUNT = 0
        this.cif.TAG_COUNT = 0
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODEL_FUNCTION_ID = (this.cif.WB_MODEL_FUNCTION_ID).toString()

    }

    get cif(): RowIF.IwbModelFunction {
        return this
    }

    get RenderOptions(): any {
        return JSONUtils.parse(this.cif.RENDER_OPTIONS, {});
    }

    get WB_ModelTermRow(): WB_ModelTermRow {
        return getBelongsToProperty(this, 'Term')
    }

}


export class WB_ModelVolumeComponentRow
    extends ESRecord
    implements RowIF.IwbModelVolumeComponent {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbModelVolumeComponent {
        return this
    }

}

// Model BO
export class WB_ModelRow
    extends ESRecord
    implements RowIF.IwbModel {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.WB_AUTHUSR_ID_CREATEDBY = defaultRowValues.CurrentUserWbId()
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbModel {
        return this
    }

    get WB_ModelCannibalizationRelationshipRows(): WB_ModelCannibalizationRelationshipRow[] {
        return getHasManyProperty(this, 'ModelCannRels')
    }

    get WB_ModelTermRelationshipRows(): WB_ModelTermRelationshipRow[] {
        return getHasManyProperty(this, 'ModelTermRels')
    }

    get WB_ModelPredictorRelationshipRows(): WB_ModelPredictorRelationshipRow[] {
        return getHasManyProperty(this, 'ModelPredictorRels');
    }

    get WB_ModelTagRelationshipRows(): WB_ModelTagRelationshipRow[] {
        return getHasManyProperty(this, 'ModelTagRels')
    }

    get WB_ModelVolumeComponentRelationshipRows(): WB_ModelVolumeComponentRelationshipRow[] {
        return getHasManyProperty(this, 'ModelVolumeComponentRels')
    }

    get WB_CreatorRow(): WB_UserRow {
        return getBelongsToProperty(this, "Creator")
    }

    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    set CreatedDtTs(value: Date) {
        setBWDateTsProperty(this, "CreatedDtTs", 'CREATED_DTTS', value);
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    set ModifiedDtTs(value: Date) {
        setBWDateTsProperty(this, "ModifiedDtTs", 'MODIFIED_DTTS', value);
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

    set DeletedDt(value: Date) {
        setBWDateProperty(this, 'DeletedDt', 'DELETED_DT', value)
    }
}


export class WB_ModelConstantRow
    extends ESRecord
    implements RowIF.IwbModelConstant {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CONSTANT_ID = "New Constant"
        this.cif.CONSTANT_NAME = "Unnamed Constant"
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbModelConstant {
        return this
    }

    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    set CreatedDtTs(value: Date) {
        setBWDateTsProperty(this, "CreatedDtTs", 'CREATED_DTTS', value);
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    set ModifiedDtTs(value: Date) {
        setBWDateTsProperty(this, "ModifiedDtTs", 'MODIFIED_DTTS', value);
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

    set DeletedDt(value: Date) {
        setBWDateProperty(this, 'DeletedDt', 'DELETED_DT', value)
    }

}

export class WB_ModelTermRow
    extends ESRecord
    implements RowIF.IwbModelTerm {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.TERM_ID = "New Term"
        this.cif.TERM_NAME = "Unnamed Term"
        this.cif.WB_MODEL_PREDICTOR_ID = 0
        this.cif.WB_MODEL_PREDICTOR_ID2 = 0
        this.cif.WB_MODEL_PREDICTOR_ID3 = 0
        this.cif.WB_MODEL_PREDICTOR_ID4 = 0
        this.cif.WB_MODEL_COEFFICIENT_ID = 0
        this.cif.WB_MODEL_COEFFICIENT_ID2 = 0
        this.cif.WB_MODEL_COEFFICIENT_ID3 = 0
        this.cif.WB_MODEL_COEFFICIENT_ID4 = 0
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbModelTerm {
        return this
    }

    get WB_ModelFunctionRow(): WB_ModelFunctionRow {
        return getBelongsToProperty(this, 'ModelFunction')
    }

    set WB_ModelFunctionRow(value) {
        setBelongsToProperty(this, 'ModelFunction', value)
    }

    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    set CreatedDtTs(value: Date) {
        setBWDateTsProperty(this, "CreatedDtTs", 'CREATED_DTTS', value);
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    set ModifiedDtTs(value: Date) {
        setBWDateTsProperty(this, "ModifiedDtTs", 'MODIFIED_DTTS', value);
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

    set DeletedDt(value: Date) {
        setBWDateProperty(this, 'DeletedDt', 'DELETED_DT', value)
    }

}

export class WB_ModelTermRelationshipRow
    extends ESRecord
    implements RowIF.IwbModelTermR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbModelTermR {
        return this
    }

    get WB_ModelRow(): WB_ModelRow {
        return getBelongsToProperty(this, 'Model')
    }

    set WB_ModelRow(value) {
        setBelongsToProperty(this, 'Model', value)
    }

    get WB_ModelTermRow(): WB_ModelTermRow {
        return getBelongsToProperty(this, 'ModelTerm')
    }

    set WB_ModelTermRow(value) {
        setBelongsToProperty(this, 'ModelTerm', value)
    }

    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    set CreatedDtTs(value: Date) {
        setBWDateTsProperty(this, "CreatedDtTs", 'CREATED_DTTS', value);
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    set ModifiedDtTs(value: Date) {
        setBWDateTsProperty(this, "ModifiedDtTs", 'MODIFIED_DTTS', value);
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

    set DeletedDt(value: Date) {
        setBWDateProperty(this, 'DeletedDt', 'DELETED_DT', value)
    }

}


export class WB_ModelCompareRow
    extends ESRecord
    implements RowIF.IwbModelCompare {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    async afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this
        // Set the Defaults for the Domain Values
        let dbContext: PAdbContext = <any>self.dataStore()

        if (_.isEmpty(dbContext)) {
            return
        }

        self.setDefaults()
        let newKey: number = <any>(await dbContext.getNewId(self._mapper().name))
        let sNewId = TextUtils.padStart(newKey.toString(36), 12, '0').toUpperCase()
        self.cif.MODEL_COMPARE_ID = sNewId
        self.cif.MODEL_COMPARE_NAME = "New Model Compare"
    }

    get cif(): RowIF.IwbModelCompare {
        return this
    }

    get WB_ModelCompareRRows(): WB_ModelCompareRelationshipRow[] {
        return getHasManyProperty(this, 'ModelCompareRs')
    }

    get WB_CustomerHierarchyRow(): WB_CustomerHierarchyRow {
        return getBelongsToProperty(this, 'CustomerHierarchy')
    }

    set WB_CustomerHierarchyRow(value) {
        setBelongsToProperty(this, 'CustomerHierarchy', value)
    }

    get WB_ProductHierarchyRow(): WB_ProductHierarchyRow {
        return getBelongsToProperty(this, 'ProductHierarchy')
    }

    set WB_ProductHierarchyRow(value) {
        setBelongsToProperty(this, 'ProductHierarchy', value)
    }

    get WB_PeriodHierarchyRow(): WB_PeriodHierarchyRow {
        return getBelongsToProperty(this, 'PeriodHierarchy');
    }

    set WB_PeriodHierarchyRow(value: WB_PeriodHierarchyRow) {
        setBelongsToProperty(this, 'PeriodHierarchy', value);
    }

    get WB_PeriodTypeRow(): WB_PeriodTypeRow {
        return getBelongsToProperty(this, 'PeriodType');
    }

    set WB_PeriodTypeRow(value: WB_PeriodTypeRow) {
        setBelongsToProperty(this, 'PeriodType', value);
    }
}

export class WB_ModelCompareRelationshipRow
    extends ESRecord
    implements RowIF.IwbModelCompareR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbModelCompareR {
        return this
    }

    get WB_ModelingSessionRow(): WB_ModelingSessionRow {
        return getBelongsToProperty(this, 'ModelingSession')
    }

    set WB_ModelingSessionRow(value) {
        setBelongsToProperty(this, 'ModelingSession', value)
    }

}


export class WB_ModelCannibalizationTypeRow
    extends ESRecord
    implements RowIF.IwbModelCannibalizationM {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    async afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this
        // Set the Defaults for the Domain Values
        let dbContext: PAdbContext = <any>self.dataStore()

        if (_.isEmpty(dbContext)) {
            return
        }

        self.setDefaults()
        let newKey: number = <any>(await dbContext.getNewId(self._mapper().name))
        let sNewId = TextUtils.padStart(newKey.toString(36), 12, '0').toUpperCase()
        self.cif.CANNIBALIZATION_TYPE_ID = sNewId
        self.cif.CANNIBALIZATION_TYPE_NAME = "New Cannibalization Type"

        self.cif.CUSTOMER_CANN_METHOD = (<any>await Domain_getDefaultOrFirstItem(dbContext, ['CustomerCannibalizationMethod'], true)) || ''
        self.cif.PRODUCT_CANN_METHOD = (<any>await Domain_getDefaultOrFirstItem(dbContext, ['ProductCannibalizationMethod'], true)) || ''
        self.cif.TIME_CANN_METHOD = (<any>await Domain_getDefaultOrFirstItem(dbContext, ['TimeCannibalizationMethod'], true)) || ''
    }

    get cif(): RowIF.IwbModelCannibalizationM {
        return this
    }

    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    set CreatedDtTs(value: Date) {
        setBWDateTsProperty(this, "CreatedDtTs", 'CREATED_DTTS', value);
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    set ModifiedDtTs(value: Date) {
        setBWDateTsProperty(this, "ModifiedDtTs", 'MODIFIED_DTTS', value);
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

    set DeletedDt(value: Date) {
        setBWDateProperty(this, 'DeletedDt', 'DELETED_DT', value)
    }

    get WB_AffinitySetRows(): WB_AffinitySetRow[] {
        return getHasManyProperty(this, 'AffinitySet')
    }

    get WB_Model_Volume_ComponentRow(): WB_ModelVolumeComponentRow {
        return getBelongsToProperty(this, 'ModelVolumeComponent')
    }

    set WB_Model_Volume_ComponentRow(value) {
        setBelongsToProperty(this, 'ModelVolumeComponent', value)
    }

    get bIsStockPiling(): boolean {
        if (_.isEmpty(this))
            return false

        return (this.cif.TIME_CANN_METHOD == "AcrossPeriods")
    }

}

export class WB_ModelCannibalizationRelationshipRow
    extends ESRecord
    implements RowIF.IwbModelCannR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    get cif(): RowIF.IwbModelCannR {
        return this
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get WB_ModelRow(): WB_ModelRow {
        return getBelongsToProperty(this, 'Model')
    }

    set WB_ModelRow(value) {
        setBelongsToProperty(this, 'Model', value)
    }

    get WB_ModelFunctionRow(): WB_ModelFunctionRow {
        return getBelongsToProperty(this, 'ModelFunction')
    }

    set WB_ModelFunctionRow(value) {
        setBelongsToProperty(this, 'ModelFunction', value)
    }

    get WB_ModelCoefficientRow(): WB_ModelCoefficientRow {
        return getBelongsToProperty(this, 'ModelCoeff1')
    }

    set WB_ModelCoefficientRow(value) {
        setBelongsToProperty(this, 'ModelCoeff1', value)
    }

    get WB_ModelCoefficient2Row(): WB_ModelCoefficientRow {
        return getBelongsToProperty(this, 'ModelCoeff2')
    }

    set WB_ModelCoefficient2Row(value) {
        setBelongsToProperty(this, 'ModelCoeff2', value)
    }

    get WB_ModelCannibalizationTypeRow(): WB_ModelCannibalizationTypeRow {
        return getBelongsToProperty(this, 'CannType')
    }

    set WB_ModelCannibalizationTypeRow(value) {
        setBelongsToProperty(this, 'CannType', value)
    }

    get WB_PowerMetricRow(): WB_PowerMetricRow {
        return getBelongsToProperty(this, 'PowerMetric')
    }

    set WB_PowerMetricRow(value) {
        setBelongsToProperty(this, 'PowerMetric', value)
    }


    get WB_ModelCannibalizationTermRelationshipRows(): WB_ModelCannibalizationTermRelationshipRow[] {
        return getHasManyProperty(this, 'CannTermRels')
    }

    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    set CreatedDtTs(value: Date) {
        setBWDateTsProperty(this, "CreatedDtTs", 'CREATED_DTTS', value);
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    set ModifiedDtTs(value: Date) {
        setBWDateTsProperty(this, "ModifiedDtTs", 'MODIFIED_DTTS', value);
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

    set DeletedDt(value: Date) {
        setBWDateProperty(this, 'DeletedDt', 'DELETED_DT', value)
    }

    get WB_ModelFunctionDecayRow(): WB_ModelFunctionRow {
        return getBelongsToProperty(this, 'ModelFunctionDecay')
    }

    set WB_ModelFunctionDecayRow(value) {
        setBelongsToProperty(this, 'ModelFunctionDecay', value)
    }

}

export class WB_ModelCannibalizationTermRelationshipRow
    extends ESRecord
    implements RowIF.IwbModelCannTermR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbModelCannTermR {
        return this
    }

    get WB_ModelTermRow(): WB_ModelTermRow {
        return getBelongsToProperty(this, 'ModelTerm')
    }

    set WB_ModelTermRow(value) {
        setBelongsToProperty(this, 'ModelTerm', value)
    }

    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    set CreatedDtTs(value: Date) {
        setBWDateTsProperty(this, "CreatedDtTs", 'CREATED_DTTS', value);
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    set ModifiedDtTs(value: Date) {
        setBWDateTsProperty(this, "ModifiedDtTs", 'MODIFIED_DTTS', value);
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

    set DeletedDt(value: Date) {
        setBWDateProperty(this, 'DeletedDt', 'DELETED_DT', value)
    }

}

export class WB_ModelPredictorRelationshipRow
    extends ESRecord
    implements RowIF.IwbModelPredictorR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbModelPredictorR {
        return this
    }

    get WB_ModelRow(): WB_ModelRow {
        return getBelongsToProperty(this, 'Model')
    }

    set WB_ModelRow(value) {
        setBelongsToProperty(this, 'Model', value)
    }

    get WB_ModelPredictorRow(): WB_ModelPredictorRow {
        return getBelongsToProperty(this, 'ModelPredictor')
    }

    set WB_ModelPredictorRow(value) {
        setBelongsToProperty(this, 'ModelPredictor', value)
    }


    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    set CreatedDtTs(value: Date) {
        setBWDateTsProperty(this, "CreatedDtTs", 'CREATED_DTTS', value);
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    set ModifiedDtTs(value: Date) {
        setBWDateTsProperty(this, "ModifiedDtTs", 'MODIFIED_DTTS', value);
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

    set DeletedDt(value: Date) {
        setBWDateProperty(this, 'DeletedDt', 'DELETED_DT', value)
    }


}


export class WB_ModelTagRelationshipRow
    extends ESRecord
    implements RowIF.IwbModelTagR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbModelTagR {
        return this
    }

    get WB_ModelRow(): WB_ModelRow {
        return getBelongsToProperty(this, 'Model')
    }

    set WB_ModelRow(value) {
        setBelongsToProperty(this, 'Model', value)
    }

    get WB_TagRow(): WB_TagRow {
        return getBelongsToProperty(this, 'Tag')
    }

    set WB_TagRow(value) {
        setBelongsToProperty(this, 'Tag', value)
    }

    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    set CreatedDtTs(value: Date) {
        setBWDateTsProperty(this, "CreatedDtTs", 'CREATED_DTTS', value);
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    set ModifiedDtTs(value: Date) {
        setBWDateTsProperty(this, "ModifiedDtTs", 'MODIFIED_DTTS', value);
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

    set DeletedDt(value: Date) {
        setBWDateProperty(this, 'DeletedDt', 'DELETED_DT', value)
    }

}


export class WB_ModelVolumeComponentRelationshipRow
    extends ESRecord
    implements RowIF.IwbModelVolumeComponentR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbModelVolumeComponentR {
        return this
    }

    get WB_ModelRow(): WB_ModelRow {
        return getBelongsToProperty(this, 'Model')
    }

    set WB_ModelRow(value) {
        setBelongsToProperty(this, 'Model', value)
    }

    get WB_ModelVolumeComponentRow(): WB_ModelVolumeComponentRow {
        return getBelongsToProperty(this, 'ModelVolumeComponent')
    }

    set WB_ModelVolumeComponentRow(value) {
        setBelongsToProperty(this, 'ModelVolumeComponent', value)
    }

    get WB_ModelVolumeComponentItemRows(): WB_ModelVolumeComponentItemRow[] {
        return getHasManyProperty(this, 'Items')
    }

}

export class WB_ModelVolumeComponentItemRow
    extends ESRecord
    implements RowIF.IwbModelVolumeComponentItemR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbModelVolumeComponentItemR {
        return this
    }

    get WB_ModelVolumeComponentRelationshipRow(): WB_ModelVolumeComponentRelationshipRow {
        return getBelongsToProperty(this, 'ModelVolumeComponentRel')
    }

    set WB_ModelVolumeComponentRelationshipRow(value) {
        setBelongsToProperty(this, 'ModelVolumeComponentRel', value)
    }

}


//</editor-fold>


//<editor-fold desc="Model Coefficient">
// Model Coefficient
export class WB_ModelCoefficientRow
    extends ESRecord
    implements RowIF.IwbModelCoefficient {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbModelCoefficient {
        return this
    }

    async afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this
        // Set the Defaults for the Domain Values
        let dbContext: PAdbContext = <any>self.dataStore()

        if (_.isEmpty(dbContext)) {
            return
        }

        self.setDefaults()

        self.cif.MODEL_COEFFICIENT_TYPE = (<any>await Domain_getDefaultOrFirstItem(dbContext, ['ModelCoefficientType'], true)) || ''
        self.cif.NUMBER_TYPE = (<any>await Domain_getDefaultOrFirstItem(dbContext, ['PredictorNumberType'], true)) || ''

    }

    get CreatedDtTs() {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    set CreatedDtTs(value: Date) {
        setBWDateTsProperty(this, 'CreatedDtTs', 'CREATED_DTTS', value)
    }

    get ModifiedDtTs() {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    set ModifiedDtTs(value: Date) {
        setBWDateTsProperty(this, 'ModifiedDtTs', 'MODIFIED_DTTS', value)
    }

    get DeletedDt() {
        return getBWDateProperty(this, 'DELETED_DT')
    }

    set DeletedDt(value: Date) {
        setBWDateProperty(this, 'DeletedDt', 'DELETED_DT', value)
    }
}

// Model Coefficient Set
export class WB_ModelCoefficientSetRow
    extends ESRecord
    implements RowIF.IwbModelCoefficientSet {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.MODEL_COEFF_SET_NAME = "New Coefficient Set"
        this.cif.WB_AUTHUSR_ID_CREATEDBY = defaultRowValues.CurrentUserWbId()
        this.cif.SOURCE_ID = "WB"
        this.cif.WB_MODELING_SESSION_ID = 0
        this.cif.WB_MODELING_SESSION_TRIAL_ID = 0
        this.cif.COEFFICIENT_SET_RANK = 0
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this
        return new Promise<void>((resolve, error) => {

            // Set the Defaults for the Domain Values
            let dbContext: PAdbContext = <any>self.dataStore()

            if (_.isEmpty(dbContext)) {
                resolve()
                return
            }

            async function setAsyncDefaults() {
                self.setDefaults()

                let newKey: number = <any>(await dbContext.getNewId(self._mapper().name))
                let sNewId = TextUtils.padStart(newKey.toString(36), 12, '0').toUpperCase()
                self.cif.MODEL_COEFF_SET_ID = sNewId
                resolve()
            }

            setAsyncDefaults()
        })
    }

    get cif(): RowIF.IwbModelCoefficientSet {
        return this
    }

    get WB_ModelRow(): WB_ModelRow {
        return getBelongsToProperty(this, 'Model')
    }

    set WB_ModelRow(value) {
        setBelongsToProperty(this, 'Model', value)
    }


    get WB_ModelCoefficientSetRRows(): WB_ModelCoefficientSetRRow[] {
        return getHasManyProperty(this, 'ModelCoeffSetR')
    }

    get WB_ModelCoefficientSetRuleRows(): WB_ModelCoefficientSetRuleRow[] {
        return getHasManyProperty(this, 'ModelCoeffSetRules')
    }

    get WB_ModelingSessionRow(): WB_ModelingSessionRow {
        return getBelongsToProperty(this, 'ModelingSession');
    }

    set WB_ModelingSessionRow(value) {
        setBelongsToProperty(this, 'ModelingSession', value)
    }

    get WB_ModelingSessionTrialRow(): WB_ModelingSessionTrialRow {
        return getBelongsToProperty(this, 'ModelingSessionTrial');
    }

    set WB_ModelingSessionTrialRow(value) {
        setBelongsToProperty(this, 'ModelingSessionTrial', value)
    }

    get WB_ModelCoefficientSetCRRows(): WB_ModelCoefficientSetCRRow[] {
        return getHasManyProperty(this, 'ModelCoeffSetCR')
    }

    get WB_ModelCoefficientSetRRRows(): WB_ModelCoefficientSetRRRow[] {
        return getHasManyProperty(this, 'RefValues')
    }

    get WB_ModelCoefficientSetTRRows(): WB_ModelCoefficientSetTRRow[] {
        return getHasManyProperty(this, 'ModelCoeffSetTR')
    }

    get WB_ModelCoeffSetConstRRows(): WB_ModelCoeffSetConstRRow[] {
        return getHasManyProperty(this, 'ModelCoeffSetConstR')
    }

}

export class WB_ModelCoefficientSetRuleRow
    extends ESRecord
    implements RowIF.IwbModelCoefficientSetRule {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbModelCoefficientSetRule {
        return this
    }

    get WB_ModelCoefficientRow(): WB_ModelCoefficientSetRow {
        return getBelongsToProperty(this, 'ModelCoeffSet')
    }

    set WB_ModelCoefficientRow(value) {
        setBelongsToProperty(this, 'ModelCoeffSet', value)
    }

}

export class WB_ModelCoefficientSetRRow
    extends ESRecord
    implements RowIF.IwbModelCoefficientSetRR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbModelCoefficientSetRR {
        return this
    }

    get WB_ModelCoefficientSetRow(): WB_ModelCoefficientSetRow {
        return getBelongsToProperty(this, 'ModelCoeffSet')
    }

    set WB_ModelCoefficientSetRow(value) {
        setBelongsToProperty(this, 'ModelCoeffSet', value)
    }

    get WB_CustomerRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Customer')
    }

    set WB_CustomerRow(value) {
        setBelongsToProperty(this, 'Customer', value)
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup')
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value)
    }

    get WB_FinishedProductRow(): WB_FinishedProductRow {
        return getBelongsToProperty(this, 'Product')
    }

    set WB_FinishedProductRow(value) {
        setBelongsToProperty(this, 'Product', value)
    }

}

export class WB_ModelCoefficientSetTRRow
    extends ESRecord
    implements RowIF.IwbModelCoefficientSetTR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbModelCoefficientSetTR {
        return this
    }

    get WB_ModelCoefficientSetRow(): WB_ModelCoefficientSetRow {
        return getBelongsToProperty(this, 'ModelCoeffSet')
    }

    set WB_ModelCoefficientSetRow(value) {
        setBelongsToProperty(this, 'ModelCoeffSet', value)
    }

    get WB_CustomerRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Customer')
    }

    set WB_CustomerRow(value) {
        setBelongsToProperty(this, 'Customer', value)
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup')
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value)
    }

    get WB_FinishedProductRow(): WB_FinishedProductRow {
        return getBelongsToProperty(this, 'Product')
    }

    set WB_FinishedProductRow(value) {
        setBelongsToProperty(this, 'Product', value)
    }

    get WB_ModelTermRow(): WB_ModelTermRow {
        return getBelongsToProperty(this, 'ModelTerm')
    }

    set WB_ModelTermRow(value) {
        setBelongsToProperty(this, 'ModelTerm', value)
    }

}

export class WB_ModelCoefficientSetCRRow
    extends ESRecord
    implements RowIF.IwbModelCoefficientSetCR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbModelCoefficientSetR {
        return this
    }

    get WB_ModelCoefficientSetRow(): WB_ModelCoefficientSetRow {
        return getBelongsToProperty(this, 'ModelCoeffSet')
    }

    set WB_ModelCoefficientSetRow(value) {
        setBelongsToProperty(this, 'ModelCoeffSet', value)
    }

    get WB_ModelCannibalizationTypeRow(): WB_ModelCannibalizationTypeRow {
        return getBelongsToProperty(this, 'ModelCannibalizationType')
    }

    set WB_ModelCannibalizationTypeRow(value) {
        setBelongsToProperty(this, 'ModelCannibalizationType', value)
    }

    get WB_AggressorGroupRow(): WB_AffinityGroupRow {
        return getBelongsToProperty(this, 'AggressorGroup')
    }

    set WB_AggressorGroupRow(value) {
        setBelongsToProperty(this, 'AggressorGroup', value)
    }

    get WB_VictimGroupRow(): WB_AffinityGroupRow {
        return getBelongsToProperty(this, 'VictimGroup')
    }

    set WB_VictimGroupRow(value) {
        setBelongsToProperty(this, 'VictimGroup', value)
    }

}


export class WB_ModelCoefficientSetASRRow
    extends ESRecord
    implements RowIF.IwbModelCoeffSetASR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbModelCoeffSetASR {
        return this
    }

    get WB_ModelCoefficientSetRow(): WB_ModelCoefficientSetRow {
        return getBelongsToProperty(this, 'ModelCoeffSet')
    }

    set WB_ModelCoefficientSetRow(value) {
        setBelongsToProperty(this, 'ModelCoeffSet', value)
    }

    get WB_AffinitySetRow(): WB_AffinitySetRow {
        return getBelongsToProperty(this, 'AffinitySet')
    }

    set WB_AffinitySetRow(value) {
        setBelongsToProperty(this, 'AffinitySet', value)
    }

}


export class WB_ModelCoefficientSetPMRRow
    extends ESRecord
    implements RowIF.IwbModelCoeffSetPMR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbModelCoeffSetPMR {
        return this
    }

    get WB_ModelCoefficientSetRow(): WB_ModelCoefficientSetRow {
        return getBelongsToProperty(this, 'ModelCoeffSet')
    }

    set WB_ModelCoefficientSetRow(value) {
        setBelongsToProperty(this, 'ModelCoeffSet', value)
    }

    get WB_ModelCannibalizationTypeRow(): WB_ModelCannibalizationTypeRow {
        return getBelongsToProperty(this, 'ModelCannibalizationType')
    }

    set WB_ModelCannibalizationTypeRow(value) {
        setBelongsToProperty(this, 'ModelCannibalizationType', value)
    }

}


export class WB_ModelCoefficientSetRRRow
    extends ESRecord
    implements RowIF.IwbModelCoefficientSetRR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbModelCoefficientSetRR {
        return this
    }

    get WB_ModelCoefficientSetRow(): WB_ModelCoefficientSetRow {
        return getBelongsToProperty(this, 'ModelCoeffSet')
    }

    set WB_ModelCoefficientSetRow(value) {
        setBelongsToProperty(this, 'ModelCoeffSet', value)
    }

    get WB_CustomerRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Customer')
    }

    set WB_CustomerRow(value) {
        setBelongsToProperty(this, 'Customer', value)
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup')
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value)
    }

    get WB_FinishedProductRow(): WB_FinishedProductRow {
        return getBelongsToProperty(this, 'Product')
    }

    set WB_FinishedProductRow(value) {
        setBelongsToProperty(this, 'Product', value)
    }

    get WB_ModelPredictorRow(): WB_ModelPredictorRow {
        return getBelongsToProperty(this, 'ModelPredictor')
    }

    set WB_ModelPredictorRow(value) {
        setBelongsToProperty(this, 'ModelPredictor', value)
    }
}

//</editor-fold>


//<editor-fold desc="Modeling Session">
// Modelling Session
export class WB_ModelingSessionRow
    extends ESRecord
    implements RowIF.IwbModelingSession {

    private _SessionDateRange: DateRangePropertyBW

    constructor(props: any, opts: any) {
        super(props, opts);
        this._SessionDateRange = new DateRangePropertyBW(this, 'InStore', 'START_DT', 'END_DT')
    }

    setDefaults(): void {
        this.cif.WB_AUTHUSR_ID_CREATEDBY = defaultRowValues.CurrentUserWbId()
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.STOP_TRIAL_HRS_IND = '1'
        this.cif.CNVG_SSE_IND = '1'
        this.cif.CNVG_SSE_PCNT = 0.00001
        this.cif.CNVG_SSE_NOI = 1000
        this.cif.STOP_TRIAL_HRS = 1
        this.cif.STOP_SUBTRIAL_NOI_IND = '1'
        this.cif.STOP_SUBTRIAL_NOI = 3000
        this.cif.STOP_SUBTRIAL_CANN_NOI = 1000
        this.cif.STOP_MAX_REFINEMENT_NOI = 25
        this.cif.CNVG_R2_CANNREF_PCNT = 0.01
        this.cif.STOP_SUBTRIAL_HRS = 0.0333
        this.cif.CNVG_R2_CANNREF_NOI = 5
        this.cif.ELASTICITY_NUM_STEPS = 1
        this.cif.ELASTICITY_NEIGHBORHOOD_PCT = 0.10
        this.cif.INTERCEPT_MAX_CONSTRAINT_PCT = 2
        this.cif.INTERCEPT_CALC_ACCURACY_PCT = 0.0001
        this.cif.INTERCEPT_THRESHOLD_BASE_PCT = 0.5
        this.cif.OBJECTIVE_FCN_ID = 'SSE'
    }

    async afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this
        // Set the Defaults for the Domain Values
        let dbContext: PAdbContext = <any>self.dataStore()

        if (_.isEmpty(dbContext)) {
            return
        }

        self.setDefaults()
        let newKey: number = <any>(await dbContext.getNewId(self._mapper().name))
        let sNewId = TextUtils.padStart(newKey.toString(36), 12, '0').toUpperCase()
        self.cif.MODELING_SESSION_ID = sNewId
        self.cif.MODELING_SESSION_NAME = "New Modeling Session"
    }

    get cif(): RowIF.IwbModelingSession {
        return this
    }

    get SessionDate(): DateRangePropertyBW {
        return this._SessionDateRange
    }

    get WB_ModelRow(): WB_ModelRow {
        return getBelongsToProperty(this, 'Model')
    }

    set WB_ModelRow(value) {
        setBelongsToProperty(this, 'Model', value)
    }

    get WB_UserRow(): WB_UserRow {
        return getBelongsToProperty(this, 'Creator')
    }

    set WB_UserRow(value) {
        setBelongsToProperty(this, 'Creator', value)
    }

    get WB_ModelingSessionCustRRows(): WB_ModelingSessionCustRRow[] {
        return getHasManyProperty(this, 'Customers')
    }

    get WB_ModelingSessionProdRRows(): WB_ModelingSessionProdRRow[] {
        return getHasManyProperty(this, 'Products')
    }

    get WB_ModelingSessionRangeRows(): WB_ModelingSessionRangeRow[] {
        return getHasManyProperty(this, 'Ranges')
    }

    get WB_ModelingSessionTrialRows(): WB_ModelingSessionTrialRow[] {
        return getHasManyProperty(this, 'Trials')
    }

    set WB_ModelingSessionTrialRows(values: WB_ModelingSessionTrialRow[]) {
        setHasOneProperty(this, 'Trials', values)
    }

    get WB_ModelingSessionTagRuleRRows(): WB_ModelingSessionTagRuleRRow[] {
        return getHasManyProperty(this, 'ModelingSessionTagRuleR')
    }

    get WB_ModelingSessionCoeffRuleRows(): WB_ModelingSessionCoeffRuleRow[] {
        return getHasManyProperty(this, 'ModelingSessionCoeffRule')
    }

    get WB_ModelingSessionObservationRows(): WB_ModelingSessionObservationRow[] {
        return getHasManyProperty(this, 'ModelingSessionObservations')
    }

    get WB_ModelingSessionRefPredictorRRows(): WB_ModelingSessionRefPredictorRRow[] {
        return getHasManyProperty(this, 'ModelingSessionRefPredRel')
    }

    get WB_ModelingSessionRefRRows(): WB_ModelingSessionRefRRow[] {
        return getHasManyProperty(this, 'ModelingSessionRefRel')
    }

    get WB_ModelingSessionCannTypeRelRows(): WB_ModelingSessionCannMRRow[] {
        return getHasManyProperty(this, 'ModelingSessionCannTypeRel')
    }

    get WB_ModelingSessionLogRows(): WB_ModelingSessionLogRow [] {
        return getHasManyProperty(this, 'ModelingSessionLogs')
    }

    get WB_ModelingSessionElRows(): WB_ModelingSessionElRow[] {
        return getHasManyProperty(this, 'ModelingSessionEls')
    }

    get WB_ModelingSessionElRRows(): WB_ModelingSessionElRRow[] {
        return getHasManyProperty(this, 'ModelingSessionElRs')
    }

    get WB_ModelingSessionElCRRows(): WB_ModelingSessionElCRRow[] {
        return getHasManyProperty(this, 'ModelingSessionElCRs')
    }

    get WB_ModelingSessionTermRRows(): WB_ModelingSessionTermRRow[] {
        return getHasManyProperty(this, 'ModelingSessionTermRs')
    }

    get WB_ModelingSessionPRRows(): WB_ModelingSessionPRRow[] {
        return getHasManyProperty(this, 'ModelingSessionPRs')
    }

    get WB_ModelingSessionCoeffGrpRows(): WB_ModelingSessionCoeffGrpRow[] {
        return getHasManyProperty(this, 'ModelingSessionCoeffGrps')
    }

    get WB_ModelingSessionConstantRRows(): WB_ModelingSessionConstantRRow[] {
        return getHasManyProperty(this, 'ModelingSessionConstantRs')
    }

    get WB_ModelingSessionConstantFRRows(): WB_ModelingSessionConstantFRRow[] {
        return getHasManyProperty(this, 'ModelingSessionConstantFRs')
    }

    get STOP_TRIAL_HRS_MINS(): number {
        return this.cif.STOP_TRIAL_HRS * 60
    }

    set STOP_TRIAL_HRS_MINS(value: number) {
        this.cif.STOP_TRIAL_HRS = _.toNumber(value) / 60
    }

    get STOP_SUBTRIAL_HRS_MINS(): number {
        return Math.round(this.cif.STOP_SUBTRIAL_HRS * 60)
    }

    set STOP_SUBTRIAL_HRS_MINS(value: number) {
        this.cif.STOP_SUBTRIAL_HRS = _.toNumber(value) / 60
    }

    get ELASTICITY_NEIGHBORHOOD_PCT_BASE_100(): number {
        return this.cif.ELASTICITY_NEIGHBORHOOD_PCT * 100
    }

    set ELASTICITY_NEIGHBORHOOD_PCT_BASE_100(value: number) {
        this.cif.ELASTICITY_NEIGHBORHOOD_PCT = _.toNumber(value) / 100
    }

    get bIntelligentInterceptEnabled(): boolean {
        return getBooleanIndicator(this, 'INTELLIGENT_INTERCEPT')
    }

    set bIntelligentInterceptEnabled(value) {
        setBooleanIndicator(this, 'bIntelligentInterceptEnabled', 'INTELLIGENT_INTERCEPT', value)
    }

    get INTERCEPT_MAX_CONSTRAINT_PCT_BASE_100(): number {
        return this.cif.INTERCEPT_MAX_CONSTRAINT_PCT * 100
    }

    set INTERCEPT_MAX_CONSTRAINT_PCT_BASE_100(value: number) {
        this.cif.INTERCEPT_MAX_CONSTRAINT_PCT = _.toNumber(value) / 100
    }

    get INTERCEPT_CALC_ACCURACY_PCT_BASE_100(): number {
        return this.cif.INTERCEPT_CALC_ACCURACY_PCT * 100
    }

    set INTERCEPT_CALC_ACCURACY_PCT_BASE_100(value: number) {
        this.cif.INTERCEPT_CALC_ACCURACY_PCT = _.toNumber(value) / 100
    }

    get INTERCEPT_THRESHOLD_BASE_PCT_BASE_100(): number {
        return this.cif.INTERCEPT_THRESHOLD_BASE_PCT * 100
    }

    set INTERCEPT_THRESHOLD_BASE_PCT_BASE_100(value: number) {
        this.cif.INTERCEPT_THRESHOLD_BASE_PCT = _.toNumber(value) / 100
    }


}

export class WB_ModelingSessionCustRRow
    extends ESRecord
    implements RowIF.IwbModelingSessionCustR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbModelingSessionCustR {
        return this
    }

    get WB_ModelingSessionRow(): WB_ModelingSessionRow {
        return getBelongsToProperty(this, 'ModelingSession')
    }

    set WB_ModelingSessionRow(value) {
        setBelongsToProperty(this, 'ModelingSession', value)
    }

    get WB_CustomerRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Customer')
    }

    set WB_CustomerRow(value) {
        setBelongsToProperty(this, 'Customer', value)
    }

}

//Modeling Session Coeff Rule
export class WB_ModelingSessionCoeffRuleRow
    extends ESRecord
    implements RowIF.IwbModelingSessionCoeffRule {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbModelingSessionCoeffRule {
        return this
    }

    get WB_ModelingSessionRow(): WB_ModelingSessionRow {
        return getBelongsToProperty(this, 'ModelingSession')
    }

    set WB_ModelingSessionRow(value) {
        setBelongsToProperty(this, 'ModelingSession', value)
    }

    get WB_ModelCoefficientRow(): WB_ModelCoefficientRow {
        return getBelongsToProperty(this, 'ModelCoefficient')
    }

    set WB_ModelCoefficientRow(value) {
        setBelongsToProperty(this, 'ModelCoefficient', value)
    }

    get WB_ModelingSessionCoeffRuleRRows(): WB_ModelingSessionCoeffRuleRRow[] {
        return getHasManyProperty(this, 'ModelingSessionCoeffRuleRs')
    }
}

//Modeling Session Coeff RuleR
export class WB_ModelingSessionCoeffRuleRRow
    extends ESRecord
    implements RowIF.IwbModelingSessionCoeffRuleR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbModelingSessionCoeffRule {
        return this
    }

    get WB_ModelingSessionCoeffRuleRow(): WB_ModelingSessionCoeffRuleRow {
        return getBelongsToProperty(this, 'ModelingSessionCoeffRule')
    }

    set WB_ModelingSessionCoeffRuleRow(value) {
        setBelongsToProperty(this, 'ModelingSessionCoeffRule', value)
    }

    get WB_CustomerRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Customer')
    }

    set WB_CustomerRow(value) {
        setBelongsToProperty(this, 'Customer', value)
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup')
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value)
    }

    get WB_ProductRow(): WB_FinishedProductRow {
        return getBelongsToProperty(this, 'Product')
    }

    set WB_ProductRow(value) {
        setBelongsToProperty(this, 'Product', value)
    }
}


//Modeling Session Coeff Group Row
export class WB_ModelingSessionCoeffGrpRow
    extends ESRecord
    implements RowIF.IwbModelingSessionCoeffGrp {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbModelingSessionCoeffGrp {
        return this
    }

    get WB_ModelingSessionRow(): WB_ModelingSessionRow {
        return getBelongsToProperty(this, 'ModelingSession')
    }

    set WB_ModelingSessionRow(value) {
        setBelongsToProperty(this, 'ModelingSession', value)
    }

    get WB_ModelCoefficientRow(): WB_ModelCoefficientRow {
        return getBelongsToProperty(this, 'ModelCoefficient')
    }

    set WB_ModelCoefficientRow(value) {
        setBelongsToProperty(this, 'ModelCoefficient', value)
    }

    get WB_ModelingSessionCoeffGrpStRows(): WB_ModelingSessionCoeffGrpStRow[] {
        return getHasManyProperty(this, 'ModelingSessionCoeffGrpSts')
    }
}


//Modeling Session Coeff Group Set Row
export class WB_ModelingSessionCoeffGrpStRow
    extends ESRecord
    implements RowIF.IwbModelingSessionCoeffGrpSt {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.COEFFICIENT_FIXED_VALUE = 0
        this.cif.COEFFICIENT_MIN_VALUE = 0
        this.cif.COEFFICIENT_MAX_VALUE = 0
    }

    get cif(): RowIF.IwbModelingSessionCoeffGrpSt {
        return this
    }

    get WB_ModelingSessionCoeffGrpRow(): WB_ModelingSessionCoeffGrpRow {
        return getBelongsToProperty(this, 'ModelingSessionGrp')
    }

    set WB_ModelingSessionCoeffGrpRow(value) {
        setBelongsToProperty(this, 'ModelingSessionGrp', value)
    }

    get WB_ModelingSessionCoeffGrpStRRows(): WB_ModelingSessionCoeffGrpStRRow[] {
        return getHasManyProperty(this, 'ModelingSessionCoeffGrpStRs')
    }
}


//Modeling Session Coeff Group SetR Row
export class WB_ModelingSessionCoeffGrpStRRow
    extends ESRecord
    implements RowIF.IwbModelingSessionCoeffGrpStR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbModelingSessionCoeffGrpStR {
        return this
    }

    get WB_ModelingSessionCoeffGrpStRow(): WB_ModelingSessionCoeffGrpStRow {
        return getBelongsToProperty(this, 'ModelingSessionGrpSt')
    }

    set WB_ModelingSessionCoeffGrpStRow(value) {
        setBelongsToProperty(this, 'ModelingSessionGrpSt', value)
    }

    get WB_CustomerRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Customer')
    }

    set WB_CustomerRow(value) {
        setBelongsToProperty(this, 'Customer', value)
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup')
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value)
    }

    get WB_ProductRow(): WB_FinishedProductRow {
        return getBelongsToProperty(this, 'Product')
    }

    set WB_ProductRow(value) {
        setBelongsToProperty(this, 'Product', value)
    }
}

export class WB_ModelingSessionProdRRow
    extends ESRecord
    implements RowIF.IwbModelingSessionProdR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbModelingSessionProdR {
        return this
    }

    get WB_ModelingSessionRow(): WB_ModelingSessionRow {
        return getBelongsToProperty(this, 'ModelingSession')
    }

    set WB_ModelingSessionRow(value) {
        setBelongsToProperty(this, 'ModelingSession', value)
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup')
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value)
    }

    get WB_ProductRow(): WB_FinishedProductRow {
        return getBelongsToProperty(this, 'Product')
    }

    set WB_ProductRow(value) {
        setBelongsToProperty(this, 'Product', value)
    }

}

export class WB_ModelingSessionRangeRow
    extends ESRecord
    implements RowIF.IwbModelingSessionRange {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbModelingSessionRange {
        return this
    }

    get WB_ModelingSessionRow(): WB_ModelingSessionRow {
        return getBelongsToProperty(this, 'ModelingSession')
    }

    set WB_ModelingSessionRow(value) {
        setBelongsToProperty(this, 'ModelingSession', value)
    }

    get WB_ModelCoefficientRow(): WB_ModelCoefficientRow {
        return getBelongsToProperty(this, 'ModelCoefficient')
    }

    set WB_ModelCoefficientRow(value) {
        setBelongsToProperty(this, 'ModelCoefficient', value)
    }


    get Precision(): number {
        var min = this.cif.COEFFICIENT_MIN_VALUE
        var max = this.cif.COEFFICIENT_MAX_VALUE
        var interval = this.cif.COEFFICIENT_STEPS
        return (max - min) / interval
    }
}


export class WB_ModelingSessionTrialRow
    extends ESRecord
    implements RowIF.IwbModelingSessionTrial {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this
        return new Promise<void>((resolve, error) => {

            // Set the Defaults for the Domain Values
            let dbContext: PAdbContext = <any>self.dataStore()

            if (_.isEmpty(dbContext)) {
                resolve()
                return
            }

            async function setAsyncDefaults() {
                self.setDefaults()
                let newKey: number = <any>(await dbContext.getNewId(self._mapper().name))
                let sNewId = TextUtils.padStart(newKey.toString(36), 12, '0').toUpperCase()
                self.cif.TRIAL_ID = sNewId
                self.cif.TRIAL_NOTES = "New Trial"
                resolve()
            }

            setAsyncDefaults()
        })
    }

    setDefaults(): void {
        this.cif.WB_MODEL_COEFF_SET_ID = 0
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }


    get cif(): RowIF.IwbModelingSessionTrial {
        return this
    }

    get WB_ModelingSessionRow(): WB_ModelingSessionRow {
        return getBelongsToProperty(this, 'ModelingSession')
    }

    set WB_ModelingSessionRow(value) {
        setBelongsToProperty(this, 'ModelingSession', value)
    }

    get WB_ModelCoefficientSetRow(): WB_ModelCoefficientSetRow {
        return getBelongsToProperty(this, 'ModelCoeffSet')
    }

    set WB_ModelCoefficientSetRow(value) {
        setBelongsToProperty(this, 'ModelCoeffSet', value)
    }


    get WB_ModelingSessionTrialMetricRows(): WB_ModelingSessionTrialMetricRow [] {
        return getHasManyProperty(this, 'Metrics')
    }

    get WB_ModelingSessionTrialResidualMetricRows(): WB_ModelingSessionTrialResidualMetricRow [] {
        return getHasManyProperty(this, 'RsdMetrics')
    }

    get WB_ModelingSessionLogRows(): WB_ModelingSessionLogRow [] {
        return getHasManyProperty(this, 'Logs')
    }

}


export class WB_ModelingSessionTrialMetricRow
    extends ESRecord
    implements RowIF.IwbModelingSessionTrialMetric {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbModelingSessionTrialMetric {
        return this
    }

    get WB_ModelingSessionTrialRow(): WB_ModelingSessionTrialRow {
        return getBelongsToProperty(this, 'ModelingSessionTrial')
    }

    set WB_ModelingSessionTrialRow(value) {
        setBelongsToProperty(this, 'ModelingSessionTrial', value)
    }

    get WB_CustomerRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Customer')
    }

    set WB_CustomerRow(value) {
        setBelongsToProperty(this, 'Customer', value)
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup')
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value)
    }

    get WB_PeriodRow(): WB_PeriodRow {
        return getBelongsToProperty(this, 'Period')
    }

    set WB_PeriodRow(value) {
        setBelongsToProperty(this, 'Period', value)
    }
}


export class WB_ModelingSessionTrialPredictorMetricRow
    extends ESRecord
    implements RowIF.IwbModelingSessionTrialPMt {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbModelingSessionTrialPMt {
        return this
    }

    get WB_ModelingSessionTrialRow(): WB_ModelingSessionTrialRow {
        return getBelongsToProperty(this, 'ModelingSessionTrial')
    }

    set WB_ModelingSessionTrialRow(value) {
        setBelongsToProperty(this, 'ModelingSessionTrial', value)
    }

    get WB_CustomerRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Customer')
    }

    set WB_CustomerRow(value) {
        setBelongsToProperty(this, 'Customer', value)
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup')
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value)
    }

    get WB_PeriodRow(): WB_PeriodRow {
        return getBelongsToProperty(this, 'Period')
    }

    set WB_PeriodRow(value) {
        setBelongsToProperty(this, 'Period', value)
    }
}


export class WB_ModelingSessionTrialPredictorRMetricRow
    extends ESRecord
    implements RowIF.IwbModelingSessionTrialPRMt {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbModelingSessionTrialPRMt {
        return this
    }

    get WB_ModelingSessionTrialRow(): WB_ModelingSessionTrialRow {
        return getBelongsToProperty(this, 'ModelingSessionTrial')
    }

    get WB_ModelPredictorRow_A(): WB_ModelPredictorRow {
        return getBelongsToProperty(this, 'ModelPredictorA')
    }

    get WB_ModelPredictorRow_B(): WB_ModelPredictorRow {
        return getBelongsToProperty(this, 'ModelPredictorB')
    }

    get WB_CustomerRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Customer')
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup')
    }
}


export class WB_ModelingSessionTrialResidualMetricRow
    extends ESRecord
    implements RowIF.IwbModelingSessionTrialRsdMt {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbModelingSessionTrialRsdMt {
        return this
    }

    get WB_ModelingSessionTrialRow(): WB_ModelingSessionTrialRow {
        return getBelongsToProperty(this, 'ModelingSessionTrial')
    }

    set WB_ModelingSessionTrialRow(value) {
        setBelongsToProperty(this, 'ModelingSessionTrial', value)
    }

    get WB_ModelPredictorRow(): WB_ModelPredictorRow {
        return getBelongsToProperty(this, 'ModelPredictor')
    }

    set WB_ModelPredictorRow(value) {
        setBelongsToProperty(this, 'ModelPredictor', value)
    }

    get WB_CustomerRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Customer')
    }

    set WB_CustomerRow(value) {
        setBelongsToProperty(this, 'Customer', value)
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup')
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value)
    }

    get WB_PeriodRow(): WB_PeriodRow {
        return getBelongsToProperty(this, 'Period')
    }

    set WB_PeriodRow(value) {
        setBelongsToProperty(this, 'Period', value)
    }
}

export class WB_ModelingSessionLogRow
    extends ESRecord
    implements RowIF.IwbModelingSessionLog {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
    }

    get cif(): RowIF.IwbModelingSessionLog {
        return this
    }

    get ModelingSessionLogDtts(): Date {
        return getBWDateTsProperty(this, 'LOG_DTTS')
    }

    set ModelingSessionLogDtts(value: Date) {
        setBWDateTsProperty(this, "ModelingSessionLogDtts", 'LOG_DTTS', value);
    }

    get WB_ModelingSessionTrialRow(): WB_ModelingSessionTrialRow {
        return getBelongsToProperty(this, 'ModelingSessionTrial')
    }

    set WB_ModelingSessionTrialRow(value) {
        setBelongsToProperty(this, 'ModelingSessionTrial', value)
    }

    get WB_ModelingSessionRow(): WB_ModelingSessionRow {
        return getBelongsToProperty(this, 'ModelingSession')
    }

    set WB_ModelingSessionRow(value) {
        setBelongsToProperty(this, 'ModelingSession', value)
    }

}


export class WB_ModelingSessionObservationRow
    extends ESRecord
    implements RowIF.IwbModelingSessionObs {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbModelingSessionObs {
        return this
    }

    get WB_ModelingSessionRow(): WB_ModelingSessionRow {
        return getBelongsToProperty(this, 'ModelingSession')
    }

    set WB_ModelingSessionRow(value) {
        setBelongsToProperty(this, 'ModelingSession', value)
    }

    get WB_ModelPredictorRow(): WB_ModelPredictorRow {
        return getBelongsToProperty(this, 'ModelPredictor')
    }

    set WB_ModelPredictorRow(value) {
        setBelongsToProperty(this, 'ModelPredictor', value)
    }

    get WB_CustomerRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Customer')
    }

    set WB_CustomerRow(value) {
        setBelongsToProperty(this, 'Customer', value)
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup')
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value)
    }

    get WB_PeriodRow(): WB_PeriodRow {
        return getBelongsToProperty(this, 'Period')
    }

    set WB_PeriodRow(value) {
        setBelongsToProperty(this, 'Period', value)
    }

    get WB_TagRow(): WB_TagRow {
        return getBelongsToProperty(this, 'Tag')
    }

    set WB_TagRow(value) {
        setBelongsToProperty(this, 'Tag', value)
    }


}


export class WB_ModelingSessionTagRuleRRow
    extends ESRecord
    implements RowIF.IwbModelingSessionTagRuleR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbModelingSessionTagRuleR {
        return this
    }

    get WB_ModelingSessionRow(): WB_ModelingSessionRow {
        return getBelongsToProperty(this, 'ModelingSession')
    }

    set WB_ModelingSessionRow(value) {
        setBelongsToProperty(this, 'ModelingSession', value)
    }

    get WB_TagRow(): WB_TagRow {
        return getBelongsToProperty(this, 'Tag')
    }

    set WB_TagRow(value) {
        setBelongsToProperty(this, 'Tag', value)
    }

}

export class WB_ModelingSessionRefPredictorRRow
    extends ESRecord
    implements RowIF.IwbModelingSessionRefPredictorR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbModelingSessionRefPredictorR {
        return this
    }

    get WB_ModelingSessionRow(): WB_ModelingSessionRow {
        return getBelongsToProperty(this, 'ModelingSession')
    }

    set WB_ModelingSessionRow(value) {
        setBelongsToProperty(this, 'ModelingSession', value)
    }

    get WB_ModelPredictorRow(): WB_ModelPredictorRow {
        return getBelongsToProperty(this, 'ModelPredictor')
    }

    set WB_ModelPredictorRow(value) {
        setBelongsToProperty(this, 'ModelPredictor', value)
    }

}

export class WB_ModelingSessionRefRRow
    extends ESRecord
    implements RowIF.IwbModelingSessionRefR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    get cif(): RowIF.IwbModelingSessionRefR {
        return this
    }

    get WB_ModelingSessionRow(): WB_ModelingSessionRow {
        return getBelongsToProperty(this, 'ModelingSession')
    }

    set WB_ModelingSessionRow(value) {
        setBelongsToProperty(this, 'ModelingSession', value)
    }

    get WB_CustomerRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Customer')
    }

    set WB_CustomerRow(value) {
        setBelongsToProperty(this, 'Customer', value)
    }

    get WB_ProductRow(): WB_FinishedProductRow {
        return getBelongsToProperty(this, 'Product')
    }

    set WB_ProductRow(value) {
        setBelongsToProperty(this, 'Product', value)
    }

    get WB_ModelPredictorRow(): WB_ModelPredictorRow {
        return getBelongsToProperty(this, 'ModelPredictor')
    }

    set WB_ModelPredictorRow(value) {
        setBelongsToProperty(this, 'ModelPredictor', value)
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup')
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value)
    }

}

export class WB_ModelingSessionCannMRRow
    extends ESRecord
    implements RowIF.IwbModelingSessionCannMR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbModelingSessionCannMR {
        return this
    }

    get WB_ModelingSessionRow(): WB_ModelingSessionRow {
        return getBelongsToProperty(this, 'ModelingSession')
    }

    set WB_ModelingSessionRow(value) {
        setBelongsToProperty(this, 'ModelingSession', value)
    }

    get WB_ModelCannibalizationTypeRow(): WB_ModelCannibalizationTypeRow {
        return getBelongsToProperty(this, 'CannibalizationType')
    }

    set WB_ModelCannibalizationTypeRow(value) {
        setBelongsToProperty(this, 'CannibalizationType', value)
    }

    get WB_ModelCannibalizationRelationshipRow(): WB_ModelCannibalizationRelationshipRow {
        return getBelongsToProperty(this, 'ModelCannR')
    }

    set WB_ModelCannibalizationRelationshipRow(value) {
        setBelongsToProperty(this, 'ModelCannR', value)
    }

    get WB_ModelingSessionCannPMRRows(): WB_ModelingSessionCannPMRRow[] {
        return getHasManyProperty(this, 'ModelingSessionCannPMRs')
    }

    get WB_ModelingSessionASRRows(): WB_ModelingSessionASRRow[] {
        return getHasManyProperty(this, 'ModelingSessionASRs')
    }
}


export class WB_ModelingSessionCannPMRRow
    extends ESRecord
    implements RowIF.IwbModelingSessionCannPMR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbModelingSessionCannPMR {
        return this
    }

    get WB_ModelingSessionCannMRRow(): WB_ModelingSessionCannMRRow {
        return getBelongsToProperty(this, 'ModelCannMR')
    }

    set WB_ModelingSessionCannMRRow(value) {
        setBelongsToProperty(this, 'ModelCannMR', value)
    }

    get WB_ModelPredictorRow(): WB_ModelPredictorRow {
        return getBelongsToProperty(this, 'ModelPredictor')
    }

    set WB_ModelPredictorRow(value) {
        setBelongsToProperty(this, 'ModelPredictor', value)
    }
}

export class WB_ModelingSessionASRRow
    extends ESRecord
    implements RowIF.IwbModelingSessionASR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbModelingSessionASR {
        return this
    }

    get WB_AffinitySetRow(): WB_AffinitySetRow {
        return getBelongsToProperty(this, 'AffinitySet')
    }

    set WB_AffinitySetRow(value) {
        setBelongsToProperty(this, 'AffinitySet', value)
    }

    get WB_ModelingSessionCannMRRow(): WB_ModelingSessionCannMRRow {
        return getBelongsToProperty(this, 'ModelCannMR')
    }

    set WB_ModelingSessionCannMRRow(value) {
        setBelongsToProperty(this, 'ModelCannMR', value)
    }

}

export class WB_ModelingSessionPRRow
    extends ESRecord
    implements RowIF.IwbModelingSessionPR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbModelingSessionPR {
        return this
    }

    get WB_ModelingSessionRow(): WB_ModelingSessionRow {
        return getBelongsToProperty(this, 'ModelingSession')
    }

    set WB_ModelingSessionRow(value) {
        setBelongsToProperty(this, 'ModelingSession', value)
    }

    get WB_CustomerRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Customer')
    }

    set WB_CustomerRow(value) {
        setBelongsToProperty(this, 'Customer', value)
    }

    get WB_ProductRow(): WB_FinishedProductRow {
        return getBelongsToProperty(this, 'Product')
    }

    set WB_ProductRow(value) {
        setBelongsToProperty(this, 'Product', value)
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup')
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value)
    }

    get WB_PeriodRow(): WB_PeriodRow {
        return getBelongsToProperty(this, 'Period')
    }

    set WB_PeriodRow(value) {
        setBelongsToProperty(this, 'Period', value)
    }

}

//Modeling Session Elasticity Row
export class WB_ModelingSessionElRow
    extends ESRecord
    implements RowIF.IwbModelingSessionEl {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbModelingSessionEl {
        return this
    }

    get WB_ModelingSessionRow(): WB_ModelingSessionRow {
        return getBelongsToProperty(this, 'ModelingSession')
    }

    set WB_ModelingSessionRow(value) {
        setBelongsToProperty(this, 'ModelingSession', value)
    }

    get WB_ModelVolumeComponentRow(): WB_ModelVolumeComponentRow {
        return getBelongsToProperty(this, 'ModelVolumeComponent')
    }

    set WB_ModelVolumeComponentRow(value) {
        setBelongsToProperty(this, 'ModelVolumeComponent', value)
    }

    get WB_ModelPredictorRow(): WB_ModelPredictorRow {
        return getBelongsToProperty(this, 'ModelPredictor')
    }

    set WB_ModelPredictorRow(value) {
        setBelongsToProperty(this, 'ModelPredictor', value)
    }

    get bCalcInd(): boolean {
        return getBooleanIndicator(this, 'CALC_IND')
    }

    get CALC_VALUE_UPPERBOUND_PCT_BASE_100(): number {
        return this.cif.CALC_VALUE_UPPERBOUND_PCT * 100
    }

    set CALC_VALUE_UPPERBOUND_PCT_BASE_100(value: number) {
        this.cif.CALC_VALUE_UPPERBOUND_PCT = _.toNumber(value) / 100
    }

    get CALC_VALUE_LOWERBOUND_PCT_BASE_100(): number {
        return this.cif.CALC_VALUE_LOWERBOUND_PCT * 100
    }

    set CALC_VALUE_LOWERBOUND_PCT_BASE_100(value: number) {
        this.cif.CALC_VALUE_LOWERBOUND_PCT = _.toNumber(value) / 100
    }

}

//Modeling Session Elasticity R Row
export class WB_ModelingSessionElRRow
    extends ESRecord
    implements RowIF.IwbModelingSessionElR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbModelingSessionElR {
        return this
    }

    get WB_ModelingSessionRow(): WB_ModelingSessionRow {
        return getBelongsToProperty(this, 'ModelingSession')
    }

    set WB_ModelingSessionRow(value) {
        setBelongsToProperty(this, 'ModelingSession', value)
    }

    get WB_ModelPredictorRow(): WB_ModelPredictorRow {
        return getBelongsToProperty(this, 'ModelPredictor')
    }

    set WB_ModelPredictorRow(value) {
        setBelongsToProperty(this, 'ModelPredictor', value)
    }

    get WB_CustomerRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Customer')
    }

    set WB_CustomerRow(value) {
        setBelongsToProperty(this, 'Customer', value)
    }

    get WB_ProductRow(): WB_FinishedProductRow {
        return getBelongsToProperty(this, 'Product')
    }

    set WB_ProductRow(value) {
        setBelongsToProperty(this, 'Product', value)
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup')
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value)
    }

}


//Modeling Session Elasticity CR Row
export class WB_ModelingSessionElCRRow
    extends ESRecord
    implements RowIF.IwbModelingSessionElCR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbModelingSessionElCR {
        return this
    }

    get WB_ModelingSessionRow(): WB_ModelingSessionRow {
        return getBelongsToProperty(this, 'ModelingSession')
    }

    set WB_ModelingSessionRow(value) {
        setBelongsToProperty(this, 'ModelingSession', value)
    }

    get WB_ModelPredictorRow(): WB_ModelPredictorRow {
        return getBelongsToProperty(this, 'ModelPredictor')
    }

    set WB_ModelPredictorRow(value) {
        setBelongsToProperty(this, 'ModelPredictor', value)
    }

    get WB_CustomerRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Customer')
    }

    set WB_CustomerRow(value) {
        setBelongsToProperty(this, 'Customer', value)
    }

    get WB_ProductRow(): WB_FinishedProductRow {
        return getBelongsToProperty(this, 'Product')
    }

    set WB_ProductRow(value) {
        setBelongsToProperty(this, 'Product', value)
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup')
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value)
    }

}

//Modeling Session Term R Row
export class WB_ModelingSessionTermRRow
    extends ESRecord
    implements RowIF.IwbModelingSessionTermR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbModelingSessionTermR {
        return this
    }

    get WB_ModelingSessionRow(): WB_ModelingSessionRow {
        return getBelongsToProperty(this, 'ModelingSession')
    }

    set WB_ModelingSessionRow(value) {
        setBelongsToProperty(this, 'ModelingSession', value)
    }

    get WB_ModelTermRow(): WB_ModelTermRow {
        return getBelongsToProperty(this, 'ModelTerm')
    }

    set WB_ModelTermRow(value) {
        setBelongsToProperty(this, 'ModelTerm', value)
    }

    get WB_CustomerRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Customer')
    }

    set WB_CustomerRow(value) {
        setBelongsToProperty(this, 'Customer', value)
    }

    get WB_ProductRow(): WB_FinishedProductRow {
        return getBelongsToProperty(this, 'Product')
    }

    set WB_ProductRow(value) {
        setBelongsToProperty(this, 'Product', value)
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup')
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value)
    }

}

//Modeling Session Constant R Row
export class WB_ModelingSessionConstantRRow
    extends ESRecord
    implements RowIF.IwbModelingSessionConstantR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbModelingSessionConstantR {
        return this
    }

    get WB_ModelingSessionRow(): WB_ModelingSessionRow {
        return getBelongsToProperty(this, 'ModelingSession')
    }

    set WB_ModelingSessionRow(value) {
        setBelongsToProperty(this, 'ModelingSession', value)
    }

    get WB_ModelConstantRow(): WB_ModelConstantRow {
        return getBelongsToProperty(this, 'ModelTerm')
    }

    set WB_ModelConstantRow(value) {
        setBelongsToProperty(this, 'ModelConstant', value)
    }

    get WB_CustomerRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Customer')
    }

    set WB_CustomerRow(value) {
        setBelongsToProperty(this, 'Customer', value)
    }

    get WB_ProductRow(): WB_FinishedProductRow {
        return getBelongsToProperty(this, 'Product')
    }

    set WB_ProductRow(value) {
        setBelongsToProperty(this, 'Product', value)
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup')
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value)
    }

    get WB_PeriodRow(): WB_PeriodRow {
        return getBelongsToProperty(this, 'Period')
    }

    set WB_PeriodRow(value) {
        setBelongsToProperty(this, 'Period', value)
    }

}

//Modeling Session Constant FR Row
export class WB_ModelingSessionConstantFRRow
    extends ESRecord
    implements RowIF.IwbModelingSessionConstantFR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbModelingSessionConstantFR {
        return this
    }

    get WB_ModelingSessionRow(): WB_ModelingSessionRow {
        return getBelongsToProperty(this, 'ModelingSession')
    }

    set WB_ModelingSessionRow(value) {
        setBelongsToProperty(this, 'ModelingSession', value)
    }

    get WB_ModelConstantRow(): WB_ModelConstantRow {
        return getBelongsToProperty(this, 'ModelConstant')
    }

    set WB_ModelConstantRow(value) {
        setBelongsToProperty(this, 'ModelConstant', value)
    }

}

//Modeling Session Seasonality Metrics Row
export class WB_ModelingSessionSeasonalityMtRow
    extends ESRecord
    implements RowIF.IwbModelingSessionSeasonalityMt {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbModelingSessionSeasonalityMt {
        return this
    }

    get WB_ModelingSessionRow(): WB_ModelingSessionRow {
        return getBelongsToProperty(this, 'ModelingSession')
    }

    set WB_ModelingSessionRow(value) {
        setBelongsToProperty(this, 'ModelingSession', value)
    }

    get WB_CustomerRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Customer')
    }

    set WB_CustomerRow(value) {
        setBelongsToProperty(this, 'Customer', value)
    }

    get WB_ProductRow(): WB_FinishedProductRow {
        return getBelongsToProperty(this, 'Product')
    }

    set WB_ProductRow(value) {
        setBelongsToProperty(this, 'Product', value)
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup')
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value)
    }

}

//Modeling Session Seasonality De-promoted Metrics Row
export class WB_ModelingSessionSeasonalityDepMtRow
    extends ESRecord
    implements RowIF.IwbModelingSessionSeasonalityDepMt {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbModelingSessionSeasonalityDepMt {
        return this
    }

    get WB_ModelingSessionRow(): WB_ModelingSessionRow {
        return getBelongsToProperty(this, 'ModelingSession')
    }

    set WB_ModelingSessionRow(value) {
        setBelongsToProperty(this, 'ModelingSession', value)
    }

    get WB_CustomerRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Customer')
    }

    set WB_CustomerRow(value) {
        setBelongsToProperty(this, 'Customer', value)
    }

    get WB_ProductRow(): WB_FinishedProductRow {
        return getBelongsToProperty(this, 'Product')
    }

    set WB_ProductRow(value) {
        setBelongsToProperty(this, 'Product', value)
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup')
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value)
    }

    get WB_PeriodRow(): WB_PeriodRow {
        return getBelongsToProperty(this, 'Period')
    }

    set WB_PeriodRow(value) {
        setBelongsToProperty(this, 'Period', value)
    }

}

//Modeling Session Seasonality Coefficient Row
export class WB_ModelingSessionSeasonalityCoeffRow
    extends ESRecord
    implements RowIF.IwbModelingSessionSeasonalityCoeff {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbModelingSessionSeasonalityCoeff {
        return this
    }

    get WB_ModelingSessionRow(): WB_ModelingSessionRow {
        return getBelongsToProperty(this, 'ModelingSession')
    }

    set WB_ModelingSessionRow(value) {
        setBelongsToProperty(this, 'ModelingSession', value)
    }

    get WB_ModelCoefficientRow(): WB_ModelCoefficientRow {
        return getBelongsToProperty(this, 'ModelTerm')
    }

    set WB_ModelCoefficientRow(value) {
        setBelongsToProperty(this, 'ModelCoefficient', value)
    }

    get WB_CustomerRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Customer')
    }

    set WB_CustomerRow(value) {
        setBelongsToProperty(this, 'Customer', value)
    }

    get WB_ProductRow(): WB_FinishedProductRow {
        return getBelongsToProperty(this, 'Product')
    }

    set WB_ProductRow(value) {
        setBelongsToProperty(this, 'Product', value)
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup')
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value)
    }

}

//Model Coefficient Set Constant Row
export class WB_ModelCoeffSetConstRRow
    extends ESRecord
    implements RowIF.IwbModelCoeffSetConstR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbModelCoeffSetConstR {
        return this
    }

    get WB_ModelCoefficientSetRow(): WB_ModelCoefficientSetRow {
        return getBelongsToProperty(this, 'ModelTerm')
    }

    set WB_ModelCoefficientSetRow(value) {
        setBelongsToProperty(this, 'ModelCoefficient', value)
    }

    get WB_CustomerRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Customer')
    }

    set WB_CustomerRow(value) {
        setBelongsToProperty(this, 'Customer', value)
    }

    get WB_ProductRow(): WB_FinishedProductRow {
        return getBelongsToProperty(this, 'Product')
    }

    set WB_ProductRow(value) {
        setBelongsToProperty(this, 'Product', value)
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup')
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value)
    }

    get WB_ModelConstantRow(): WB_ModelConstantRow {
        return getBelongsToProperty(this, 'ModelConstant')
    }

    set WB_ModelConstantRow(value) {
        setBelongsToProperty(this, 'ModelConstant', value)
    }

}

//</editor-fold>

// Model Datasource
export class WB_ModelDataSourceRow
    extends ESRecord
    implements RowIF.IwbModelDataSource {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs();
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind();
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt();
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs();

    }

    get cif(): RowIF.IwbModelDataSource {
        return this
    }

    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    set CreatedDtTs(value: Date) {
        setBWDateTsProperty(this, "CreatedDtTs", 'CREATED_DTTS', value);
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    set ModifiedDtTs(value: Date) {
        setBWDateTsProperty(this, "ModifiedDtTs", 'MODIFIED_DTTS', value);
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

    set DeletedDt(value: Date) {
        setBWDateProperty(this, 'DeletedDt', 'DELETED_DT', value)
    }
}

//</editor-fold>


//<editor-fold desc="Busines Simulator Scenatio">
// Scenario Reference
export class WB_ScenarioTypeRow
    extends ESRecord
    implements RowIF.IwbScenarioType {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbScenarioType {
        return this
    }

    get WB_ModelRow(): WB_ModelRow {
        return getBelongsToProperty(this, 'Model')
    }

    set WB_ModelRow(value) {
        setBelongsToProperty(this, 'Model', value)
    }

    get WB_ScenarioTypeInputRows(): WB_ScenarioTypeInputRow[] {
        return getHasManyProperty(this, "ScenarioTypeInputs")
    }

}

export class WB_ScenarioTypeInputRow
    extends ESRecord
    implements RowIF.IwbScenarioTypeInput {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbScenarioTypeInput {
        return this
    }

    get WB_ScenarioTypeRow(): WB_ScenarioTypeRow {
        return getBelongsToProperty(this, 'ScenarioType')
    }

    set WB_ScenarioTypeRow(value) {
        setBelongsToProperty(this, 'ScenarioType', value)
    }

    get WB_ModelInputRow(): WB_ModelInputRow {
        return getBelongsToProperty(this, 'ModelInput')
    }

    set WB_ModelInputRow(value) {
        setBelongsToProperty(this, 'ModelInput', value)
    }


}


export class WB_ScenarioSpendMethodRow
    extends ESRecord
    implements RowIF.IwbScenarioSpendMethod {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbScenarioSpendMethod {
        return this
    }

    get WB_ScenarioSpendMethodTermRows(): WB_ScenarioSpendMethodTermRow[] {
        return getHasManyProperty(this, 'ScenarioSpendMethodTerm')
    }

    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    set CreatedDtTs(value: Date) {
        setBWDateTsProperty(this, "CreatedDtTs", 'CREATED_DTTS', value);
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    set ModifiedDtTs(value: Date) {
        setBWDateTsProperty(this, "ModifiedDtTs", 'MODIFIED_DTTS', value);
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

    set DeletedDt(value: Date) {
        setBWDateProperty(this, 'DeletedDt', 'DELETED_DT', value)
    }

}

export class WB_ScenarioSpendMethodTermRow
    extends ESRecord
    implements RowIF.IwbScenarioSpendMethodTerm {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbScenarioSpendMethodTerm {
        return this
    }

    get WB_ScenarioSpendMethodRow(): WB_ScenarioSpendMethodRow {
        return getBelongsToProperty(this, 'ScenarioSpendMethod')
    }


    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    set CreatedDtTs(value: Date) {
        setBWDateTsProperty(this, "CreatedDtTs", 'CREATED_DTTS', value);
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    set ModifiedDtTs(value: Date) {
        setBWDateTsProperty(this, "ModifiedDtTs", 'MODIFIED_DTTS', value);
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

    set DeletedDt(value: Date) {
        setBWDateProperty(this, 'DeletedDt', 'DELETED_DT', value)
    }


}


// Scenario BO
export class WB_ScenarioRow
    extends ESRecord
    implements RowIF.IwbScenario {

    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    async afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this
        // Set the Defaults for the Domain Values
        let dbContext: PAdbContext = <any>self.dataStore()

        if (_.isEmpty(dbContext)) {
            return
        }

        self.setDefaults()
        let newKey: number = <any>(await dbContext.getNewId(self._mapper().name))
        let sNewId = TextUtils.padStart(newKey.toString(36), 12, '0').toUpperCase()
        self.cif.SCENARIO_ID = sNewId
        self.cif.SCENARIO_NAME = "New Scenario"
        self.cif.WB_AUTHUSR_ID_CREATEDBY = defaultRowValues.CurrentUserWbId()
    }

    get cif(): RowIF.IwbScenario {
        return this
    }

    get WB_ScenarioPredictorRows(): WB_ScenarioPredictorRow[] {
        return getHasManyProperty(this, 'ScenarioPredictors')
    }

    get WB_ScenarioInputRows(): WB_ScenarioInputRow[] {
        return getHasManyProperty(this, 'ScenarioInputs')
    }

    get WB_ScenarioSpendRows(): WB_ScenarioSpendRow[] {
        return getHasManyProperty(this, 'ScenarioSpends')
    }

    get WB_ScenarioMetricDfnRRows(): WB_ScenarioMetricDfnRRow[] {
        return getHasManyProperty(this, 'ScenarioMetricDfns')
    }

    get WB_ScenarioTypeRow(): WB_ScenarioTypeRow {
        return getBelongsToProperty(this, 'ScenarioType')
    }

    set WB_ScenarioTypeRow(value) {
        setBelongsToProperty(this, 'ScenarioType', value)
    }

    get WB_CustomerRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Customer')
    }

    set WB_CustomerRow(value) {
        setBelongsToProperty(this, 'Customer', value)
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup')
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value)
    }

    get WB_PeriodRow(): WB_PeriodRow {
        return getBelongsToProperty(this, 'Period')
    }

    set WB_PeriodRow(value) {
        setBelongsToProperty(this, 'Period', value)
    }

    get WB_ModelCoefficientSetRow(): WB_ModelCoefficientSetRow {
        return getBelongsToProperty(this, 'ModelCoeffSet')
    }

    set WB_ModelCoefficientSetRow(value) {
        setBelongsToProperty(this, 'ModelCoeffSet', value)
    }

    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    set CreatedDtTs(value: Date) {
        setBWDateTsProperty(this, "CreatedDtTs", 'CREATED_DTTS', value);
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    set ModifiedDtTs(value: Date) {
        setBWDateTsProperty(this, "ModifiedDtTs", 'MODIFIED_DTTS', value);
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

    set DeletedDt(value: Date) {
        setBWDateProperty(this, 'DeletedDt', 'DELETED_DT', value)
    }


}

export class WB_ScenarioPredictorRow
    extends ESRecord
    implements RowIF.IwbScenarioPredictor {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.BASE_PRICE = 0
        this.cif.COMPETITIVE_PRICE = 0
        this.cif.DISPLAY_ACV = 0
        this.cif.DISPLAY_PRICE = 0
        this.cif.DISPLAY_WEEKS = 0
        this.cif.FEATURE_ACV = 0
        this.cif.FEATURE_PRICE = 0
        this.cif.FEATURE_WEEKS = 0
        this.cif.TPR_ACV = 0
        this.cif.TPR_PRICE = 0
        this.cif.TPR_WEEKS = 0
        this.cif.FEATUREDISPLAY_ACV = 0
        this.cif.FEATUREDISPLAY_PRICE = 0
        this.cif.FEATUREDISPLAY_WEEKS = 0
        this.cif.WEEKLY_BASE = 0
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbScenarioPredictor {
        return this
    }

    get WB_ScenarioRow(): WB_ScenarioRow {
        return getBelongsToProperty(this, 'Scenario')
    }

    set WB_ScenarioRow(value) {
        setBelongsToProperty(this, 'Scenario', value)
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup')
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value)
    }

    get WB_PeriodRow(): WB_PeriodRow {
        return getBelongsToProperty(this, 'Period')
    }

    set WB_PeriodRow(value) {
        setBelongsToProperty(this, 'Period', value)
    }

    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    set CreatedDtTs(value: Date) {
        setBWDateTsProperty(this, "CreatedDtTs", 'CREATED_DTTS', value);
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    set ModifiedDtTs(value: Date) {
        setBWDateTsProperty(this, "ModifiedDtTs", 'MODIFIED_DTTS', value);
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

    set DeletedDt(value: Date) {
        setBWDateProperty(this, 'DeletedDt', 'DELETED_DT', value)
    }

}

export class WB_ScenarioInputRow
    extends ESRecord
    implements RowIF.IwbScenarioInput {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.LIST_PRICE = 0
        this.cif.VCM = 0
        this.cif.TPR_ACV_PY = 0
        this.cif.TPR_PRICE_PY = 0
        this.cif.FEATURE_ACV_PY = 0
        this.cif.FEATURE_PRICE_PY = 0
        this.cif.FEATUREDISPLAY_ACV_PY = 0
        this.cif.FEATUREDISPLAY_PRICE_PY = 0
        this.cif.DISPLAY_ACV_PY = 0
        this.cif.DISPLAY_PRICE_PY = 0
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbScenarioInput {
        return this
    }

    get WB_ScenarioRow(): WB_ScenarioRow {
        return getBelongsToProperty(this, 'Scenario')
    }

    set WB_ScenarioRow(value) {
        setBelongsToProperty(this, 'Scenario', value)
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup')
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value)
    }

    get WB_PeriodRow(): WB_PeriodRow {
        return getBelongsToProperty(this, 'Period')
    }

    set WB_PeriodRow(value) {
        setBelongsToProperty(this, 'Period', value)
    }

    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    set CreatedDtTs(value: Date) {
        setBWDateTsProperty(this, "CreatedDtTs", 'CREATED_DTTS', value);
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    set ModifiedDtTs(value: Date) {
        setBWDateTsProperty(this, "ModifiedDtTs", 'MODIFIED_DTTS', value);
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

    set DeletedDt(value: Date) {
        setBWDateProperty(this, 'DeletedDt', 'DELETED_DT', value)
    }

}

export class WB_ScenarioSpendRow
    extends ESRecord
    implements RowIF.IwbScenarioSpend {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbScenarioSpend {
        return this
    }

    get WB_ScenarioSpendMethodRow(): WB_ScenarioSpendMethodRow {
        return getBelongsToProperty(this, 'ScenarioSpendMethod')
    }

    set WB_ScenarioSpendMethodRow(value) {
        setBelongsToProperty(this, 'ScenarioSpendMethod', value)
    }

    get WB_ScenarioRow(): WB_ScenarioRow {
        return getBelongsToProperty(this, 'Scenario')
    }

    set WB_ScenarioRow(value) {
        setBelongsToProperty(this, 'Scenario', value)
    }

    get WB_ModelPredictorRow(): WB_ModelPredictorRow {
        return getBelongsToProperty(this, 'ModelPredictor')
    }

    set WB_ModelPredictorRow(value) {
        setBelongsToProperty(this, 'ModelPredictor', value)
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup')
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value)
    }

    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    set CreatedDtTs(value: Date) {
        setBWDateTsProperty(this, "CreatedDtTs", 'CREATED_DTTS', value);
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    set ModifiedDtTs(value: Date) {
        setBWDateTsProperty(this, "ModifiedDtTs", 'MODIFIED_DTTS', value);
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

    set DeletedDt(value: Date) {
        setBWDateProperty(this, 'DeletedDt', 'DELETED_DT', value)
    }

}

export class WB_ScenarioMetricRow
    extends ESRecord
    implements RowIF.IwbScenarioMetric {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs();
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind();
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs();
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt();
        this.cif.SUMMARY_ID = "";
        this.cif.WB_PRDGRP_ID = 0;
        this.cif.WB_PERIOD_ID = 0;
        this.cif.WB_SCENARIO_ID = 0;

        this.cif.BASE_UNITS = 0;
        this.cif.BASE_GRSLSTSLS = 0;
        this.cif.BASE_NETLSTSLS = 0;
        this.cif.BASE_PRFT = 0;

        this.cif.INCR_UNITS = 0;
        this.cif.INCR_GRSLSTSLS = 0;
        this.cif.INCR_NETLSTSLS = 0;
        this.cif.INCR_PRFT = 0;

        this.cif.TOTAL_UNITS = 0;
        this.cif.TOTAL_GRSLSTSLS = 0;
        this.cif.TOTAL_NETLSTSLS = 0;
        this.cif.TOTAL_PRFT = 0;

        this.cif.BASE_RTLSLS = 0;
        this.cif.INCR_RTLSLS = 0;
        this.cif.TOTAL_RTLSLS = 0;

        this.cif.PROMOTED_UNITS = 0;
        this.cif.PROMOTED_RTLSLS = 0;
        this.cif.PROMOTED_STAT = 0;
        this.cif.PROMOTED_GRSLSTSLS = 0;
        this.cif.PROMOTED_NETLSTSLS = 0;
        this.cif.PROMOTED_PRFT = 0;
        this.cif.PROMOTED_WT = 0;
        this.cif.TPR_INCR_UNITS = 0;
        this.cif.TPR_INCR_RTLSLS = 0;
        this.cif.TPR_INCR_STAT = 0;
        this.cif.TPR_INCR_GRSLSTSLS = 0;
        this.cif.TPR_INCR_NETLSTSLS = 0;
        this.cif.TPR_INCR_PRFT = 0;
        this.cif.TPR_INCR_WT = 0;
        this.cif.FEATURE_INCR_UNITS = 0;
        this.cif.FEATURE_INCR_RTLSLS = 0;
        this.cif.FEATURE_INCR_STAT = 0;
        this.cif.FEATURE_INCR_GRSLSTSLS = 0;
        this.cif.FEATURE_INCR_NETLSTSLS = 0;
        this.cif.FEATURE_INCR_PRFT = 0;
        this.cif.FEATURE_INCR_WT = 0;
        this.cif.DISPLAY_INCR_UNITS = 0;
        this.cif.DISPLAY_INCR_RTLSLS = 0;
        this.cif.DISPLAY_INCR_STAT = 0;
        this.cif.DISPLAY_INCR_GRSLSTSLS = 0;
        this.cif.DISPLAY_INCR_NETLSTSLS = 0;
        this.cif.DISPLAY_INCR_PRFT = 0;
        this.cif.DISPLAY_INCR_WT = 0;
        this.cif.FEATDISP_INCR_UNITS = 0;
        this.cif.FEATDISP_INCR_RTLSLS = 0;
        this.cif.FEATDISP_INCR_STAT = 0;
        this.cif.FEATDISP_INCR_GRSLSTSLS = 0;
        this.cif.FEATDISP_INCR_NETLSTSLS = 0;
        this.cif.FEATDISP_INCR_PRFT = 0;
        this.cif.FEATDISP_INCR_WT = 0;

    }

    get cif(): RowIF.IwbScenarioMetric {
        return this
    }


    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    set CreatedDtTs(value: Date) {
        setBWDateTsProperty(this, "CreatedDtTs", 'CREATED_DTTS', value);
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    set ModifiedDtTs(value: Date) {
        setBWDateTsProperty(this, "ModifiedDtTs", 'MODIFIED_DTTS', value);
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

    set DeletedDt(value: Date) {
        setBWDateProperty(this, 'DeletedDt', 'DELETED_DT', value)
    }

}

export class WB_ScenarioMetricDfnRRow
    extends ESRecord
    implements RowIF.IwbScenarioMetricDfnR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbScenarioMetricDfnR {
        return this
    }


    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    set CreatedDtTs(value: Date) {
        setBWDateTsProperty(this, "CreatedDtTs", 'CREATED_DTTS', value);
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    set ModifiedDtTs(value: Date) {
        setBWDateTsProperty(this, "ModifiedDtTs", 'MODIFIED_DTTS', value);
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

    set DeletedDt(value: Date) {
        setBWDateProperty(this, 'DeletedDt', 'DELETED_DT', value)
    }

}


export class WB_Published_ModelRow
    extends ESRecord
    implements RowIF.IwbPublishedModel {

    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbPublishedModel {
        return this
    }


    get CreatedDtTs(): Date {
        return getBWDateTsProperty(this, 'CREATED_DTTS')
    }

    set CreatedDtTs(value: Date) {
        setBWDateTsProperty(this, "CreatedDtTs", 'CREATED_DTTS', value);
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    set ModifiedDtTs(value: Date) {
        setBWDateTsProperty(this, "ModifiedDtTs", 'MODIFIED_DTTS', value);
    }

    get EffectiveStartDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_START_DT')
    }

    set EffectiveStartDt(value: Date) {
        setBWDateProperty(this, 'EffectiveStartDt', 'EFFECTIVE_START_DT', value)
    }

    get EffectiveEndDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_END_DT')
    }

    set EffectiveEndDt(value: Date) {
        setBWDateProperty(this, 'EffectiveEndDt', 'EFFECTIVE_END_DT', value)
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

    set DeletedDt(value: Date) {
        setBWDateProperty(this, 'DeletedDt', 'DELETED_DT', value)
    }

    get WB_ModelRow(): WB_ModelRow {
        return getBelongsToProperty(this, 'Model');
    }

    set WB_ModelRow(value) {
        setBelongsToProperty(this, 'Model', value)
    }

    get WB_ModelCoeffSetRow(): WB_ModelCoefficientSetRow {
        return getBelongsToProperty(this, 'ModelCoeffSet');
    }

    set WB_ModelCoeffSetRow(value) {
        setBelongsToProperty(this, 'ModelCoeffSet', value)
    }

    get WB_UserRow_CreatedBy(): WB_UserRow {
        return getBelongsToProperty(this, 'UserCreatedBy');
    }

    set WB_UserRow_CreatedBy(value) {
        setBelongsToProperty(this, 'UserCreatedBy', value)
    }
}

export class WB_AffinitySetRow
    extends ESRecord
    implements RowIF.IwbAffinitySet {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.AFFINITYSET_NAME = "New Affinity Set"
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Deleted_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    async afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this

        let dbContext: PAdbContext = <any>self.dataStore()
        if (_.isEmpty(dbContext))
            return

        self.setDefaults()
        let newKey: number = self.cif.WB_AFFINITYSET_ID
        let sNewId = TextUtils.padStart(newKey.toString(36), 12, '0').toUpperCase()
        self.cif.AFFINITYSET_ID = sNewId
    }


    get cif(): RowIF.IwbAffinitySet {
        return this
    }

    get WB_ModelCannibalizationTypeRow(): WB_ModelCannibalizationTypeRow {
        return getBelongsToProperty(this, 'CannibalizationType')
    }

    set WB_ModelCannibalizationTypeRow(value) {
        setBelongsToProperty(this, 'CannibalizationType', value)
    }

    get WB_CustomerHierarchyRow(): WB_CustomerHierarchyRow {
        return getBelongsToProperty(this, 'CustomerHierarchy')
    }

    set WB_CustomerHierarchyRow(value) {
        setBelongsToProperty(this, 'CustomerHierarchy', value)
    }

    get WB_ProductHierarchyRow(): WB_ProductHierarchyRow {
        return getBelongsToProperty(this, 'ProductHierarchy')
    }

    set WB_ProductHierarchyRow(value) {
        setBelongsToProperty(this, 'ProductHierarchy', value)
    }

    get WB_AffinityGroupRows(): WB_AffinityGroupRow[] {
        return getHasManyProperty(this, 'AffinityGroups')
    }

    get bItemHasCusotmer(): boolean {
        if (_.isEmpty(this?.WB_ModelCannibalizationTypeRow))
            return false

        return this.WB_ModelCannibalizationTypeRow.cif.CUSTOMER_CANN_METHOD != "None"
    }

    get bItemHasProductGroup(): boolean {
        if (_.isEmpty(this?.WB_ModelCannibalizationTypeRow))
            return false

        return (this.cif.PRODUCT_LEVEL_ID != 'Product')
    }

    get bItemHasProduct(): boolean {
        if (_.isEmpty(this?.WB_ModelCannibalizationTypeRow))
            return false

        return (this.cif.PRODUCT_LEVEL_ID == 'Product')
    }

    get WB_ModelingSessionASRRows(): WB_ModelingSessionASRRow[] {
        return getHasManyProperty(this, 'AffinitySetMdlSessionRs')
    }

    get bIsStockPiling(): boolean {
        if (_.isEmpty(this?.WB_ModelCannibalizationTypeRow))
            return false

        return (this.WB_ModelCannibalizationTypeRow.cif.TIME_CANN_METHOD == "AcrossPeriods")
    }


}

export class WB_AffinityGroupRow
    extends ESRecord
    implements RowIF.IwbAffinityGroup {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Deleted_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    async afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this

        let dbContext: PAdbContext = <any>self.dataStore()
        if (_.isEmpty(dbContext))
            return

        self.setDefaults()
        let newKey: number = self.cif.WB_AFFINITYGROUP_ID
        let sNewId = TextUtils.padStart(newKey.toString(36), 12, '0').toUpperCase()
        self.cif.AFFINITYGROUP_ID = sNewId
        self.cif.AFFINITYGROUP_NAME = "New Affinity Group " + sNewId
    }


    get cif(): RowIF.IwbAffinityGroup {
        return this
    }

    get WB_AffinitySetRow(): WB_AffinitySetRow {
        return getBelongsToProperty(this, 'AffinitySet')
    }

    set WB_AffinitySetRow(value) {
        setBelongsToProperty(this, 'AffinitySet', value)
    }

    get WB_AffinityGroupItemRows(): WB_AffinityGroupItemRow[] {
        return getHasManyProperty(this, 'Items')
    }


}


export class WB_AffinityGroupItemRow
    extends ESRecord
    implements RowIF.IwbAffinityGroupItem {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Deleted_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbAffinityGroupItem {
        return this
    }

    get WB_AffinityGroupRow(): WB_AffinityGroupRow {
        return getBelongsToProperty(this, 'AffinityGroup')
    }

    set WB_AffinityGroupRow(value) {
        setBelongsToProperty(this, 'AffinityGroup', value)
    }


    get WB_CustomerRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Customer')
    }

    set WB_CustomerRow(value) {
        setBelongsToProperty(this, 'Customer', value)
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup')
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value)
    }

    get WB_ProductRow(): WB_FinishedProductRow {
        return getBelongsToProperty(this, 'Product')
    }

    set WB_ProductRow(value) {
        setBelongsToProperty(this, 'Product', value)
    }


}


export class WB_SimulationTypeRow
    extends ESRecord
    implements RowIF.IwbSimulationType {
    get cif(): RowIF.IwbSimulationType {
        return this
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get WB_BusinessUnitRow(): WB_BusinessUnitRow {
        return getBelongsToProperty(this, 'BusinessUnit')
    }

    set WB_BusinessUnitRow(value) {
        setBelongsToProperty(this, 'BusinessUnit', value)
    }

    get WB_SimulationTypeInputRelationshipRows(): WB_SimulationTypeInputRelationshipRow[] {
        return getHasManyProperty(this, 'SimulationTypeXrefs')
    }

    get Allow_Send_To_TPM(): boolean {
        return this.cif.ALLOW_SEND_TO_TPM == '1'
    }

    set Allow_Send_To_TPM(value) {
        if (value)
            this.cif.ALLOW_SEND_TO_TPM = '1'
        else
            this.cif.ALLOW_SEND_TO_TPM = '0'
    }
}

export class WB_SimulationInputRow
    extends ESRecord
    implements RowIF.IwbSimulationInput {

    constructor(props: any, opts: any) {
        super(props, opts);

    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbSimulationInput {
        return this
    }

}

export class WB_SimulationTypeInputRelationshipRow
    extends ESRecord
    implements RowIF.IwbSimulationTypeInputXref {

    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbSimulationTypeInputXref {
        return this
    }

    get WB_SimulationTypeRow(): WB_SimulationTypeRow {
        return getBelongsToProperty(this, 'SimulationType')
    }

    set WB_SimulationTypeRow(value) {
        setBelongsToProperty(this, 'SimulationType', value)
    }

    get WB_SimulationInputRow(): WB_SimulationInputRow {
        return getBelongsToProperty(this, 'SimulationInput')
    }

    set WB_SimulationInputRow(value) {
        setBelongsToProperty(this, 'SimulationInput', value)
    }

}

export class WB_SimulationRow
    extends ESRecord
    implements RowIF.IwbSimulation {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.StartDate = DateUtils.today
        this.EndDate = this.StartDate
        let usrCtx: IUsrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
        if (usrCtx && usrCtx.User) {
            this.cif.WB_AUTHUSR_ID_CREATEDBY = usrCtx.User.cif.WB_AUTHUSR_ID
        }
    }

    get cif(): RowIF.IwbSimulation {
        return this
    }

    afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this
        return new Promise<void>((resolve, error) => {

            // Set the Defaults for the Domain Values
            let dbContext: PAdbContext = <any>self.dataStore()

            if (_.isEmpty(dbContext)) {
                resolve()
                return
            }

            async function setAsyncDefaults() {
                self.setDefaults()

                let newKey: number = <any>(await dbContext.getNewId(self._mapper().name))
                let sNewId = TextUtils.padStart(newKey.toString(36), 12, '0').toUpperCase()
                self.cif.SIMULATION_ID = sNewId
                self.cif.SIMULATION_NAME = "New Simulation " + sNewId

                resolve()
            }

            setAsyncDefaults()
        })
    }


    get WB_SimulationTypeRow(): WB_SimulationTypeRow {
        return getBelongsToProperty(this, 'SimulationType')
    }

    set WB_SimulationTypeRow(value) {
        setBelongsToProperty(this, 'SimulationType', value)
    }

    get WB_PublishedModelRow(): WB_Published_ModelRow {
        return getBelongsToProperty(this, 'PublishedModel')
    }

    set WB_PublishedModelRow(value) {
        setBelongsToProperty(this, 'PublishedModel', value)
    }

    get WB_CustomerRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Customer')
    }

    set WB_CustomerRow(value) {
        setBelongsToProperty(this, 'Customer', value)
    }

    get WB_SimulationInputRelationshipRows(): WB_SimulationInputRelationshipRow[] {
        return getHasManyProperty(this, 'Inputs')
    }

    get WB_SimulationPredictorRelationshipRows(): WB_SimulationPredictorRelationshipRow[] {
        return getHasManyProperty(this, 'Predictors')
    }

    get WB_SimulationProductRows(): WB_SimulationProductRow[] {
        return getHasManyProperty(this, 'Products')
    }

    get WB_SimulationRelationshipRows(): WB_SimulationRelationshipRow[] {
        return getHasManyProperty(this, 'SimulationRels')
    }


    get WB_SimulationMetricRows(): WB_SimulationMetricRow[] {
        return getHasManyProperty(this, 'Metrics')
    }

    get StartDate(): Date {
        return getBWDateProperty(this, 'START_DT')
    }

    set StartDate(value: Date) {
        let duration = this.Duration
        setBWDateProperty(this, 'StartDate', 'START_DT', value)
        //re-setting the end date according to the start date and duration values
        let result = new Date(value);
        result.setDate(result.getDate() + (parseInt(duration) * 7 - 1));

        this.EndDate = result
    }

    get EndDate(): Date {
        return getBWDateProperty(this, 'END_DT')
    }

    set EndDate(value: Date) {
        setBWDateProperty(this, 'EndDate', 'END_DT', value)
    }

    get LastCalc(): Date {
        return getBWDateTsProperty(this, 'LAST_CALC_DTTS')
    }

    set LastCalc(value: Date) {
        setBWDateTsProperty(this, 'LastCalc', 'LAST_CALC_DTTS', value)
    }

    get Duration(): string {
        // @ts-ignore
        let dateDiff = Math.ceil(Math.abs(getBWDateProperty(this, 'END_DT') - getBWDateProperty(this, 'START_DT')) / (1000 * 60 * 60 * 24)) + 1
        let weeks = Math.trunc(dateDiff / 7)

        return weeks.toString()
    }

    set Duration(value) {
        let result = new Date(this.StartDate);
        result.setDate(result.getDate() + (parseInt(value) * 7 - 1));

        this.EndDate = result
    }

    get WB_UserRow_CreatedBy(): WB_UserRow {
        return getBelongsToProperty(this, 'UserCreatedBy');
    }

    set WB_UserRow_CreatedBy(value) {
        setBelongsToProperty(this, 'UserCreatedBy', value)
    }

    get CompareTableOptions(): IHRTableModelOptions {
        let dflt: IHRTableModelOptions = {
            MetricPlacement: DimensionPlacement.OnRows,
            DimensionOptions: {
                [DimensionType.PromotionPlan]: {
                    DimensionType: DimensionType.PromotionPlan,
                    Placement: DimensionPlacement.OnColumns, bShowIds: false
                }
            },
            ColumnDimensionKeyOrder: [DimensionType.PromotionPlan],
            RowDimensionKeyOrder: [],
            MetricOrder: [],
            PageByDimensionKeyOrder: [],
            PageByDimensionSelected: {},
            PageByMetricSelected: undefined,
            MetricUOMVisible: false
        }

        return <any>getJSONProperty(this, "COMPARE_TABLE_OPTIONS", dflt)
    }

    set CompareTableOptions(newValue: IHRTableModelOptions) {
        setJSONProperty(this, "CompareTableOptions", "COMPARE_TABLE_OPTIONS", newValue)
    }

    get ComparePerspectiveOptions(): ICubePerspectiveOptions {
        let dflt: ICubePerspectiveOptions = {
            Dimensions: {[DimensionType.PromotionPlan]: {LevelId: "Simulation"}},
            MetricIds: ['Total_Spend']
        }
        // Metric defaults are set into the Simulation BO, Create New
        return <any>getJSONProperty(this, "COMPARE_PERSPECTIVE_OPTIONS", dflt)
    }

    set ComparePerspectiveOptions(newValue: ICubePerspectiveOptions) {
        setJSONProperty(this, "ComparePerspectiveOptions", "COMPARE_PERSPECTIVE_OPTIONS", newValue)
    }

}

export class WB_SimulationRelationshipRow
    extends ESRecord
    implements RowIF.IwbSimulationRel {

    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbSimulationRel {
        return this
    }

    get WB_SimulationRow(): WB_SimulationRow {
        return getBelongsToProperty(this, 'Simulation')
    }

    set WB_SimulationRow(value) {
        setBelongsToProperty(this, 'Simulation', value)
    }

    get WB_SimulationRow_Rel(): WB_SimulationRow {
        return getBelongsToProperty(this, 'SimulationRel')
    }

    set WB_SimulationRow_Rel(value) {
        setBelongsToProperty(this, 'SimulationRel', value)
    }

}


export class WB_SimulationInputRelationshipRow
    extends ESRecord
    implements RowIF.IwbSimulationInputXref {

    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbSimulationInputXref {
        return this
    }

    get WB_SimulationRow(): WB_SimulationRow {
        return getBelongsToProperty(this, 'Simulation')
    }

    set WB_SimulationRow(value) {
        setBelongsToProperty(this, 'Simulation', value)
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup')
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value)
    }

    get WB_PeriodRow(): WB_PeriodRow {
        return getBelongsToProperty(this, 'Period')
    }

    set WB_PeriodRow(value) {
        setBelongsToProperty(this, 'Period', value)
    }

    get WB_SimulationInputRow(): WB_SimulationInputRow {
        return getBelongsToProperty(this, 'SimulationInput')
    }

    get LastCalc(): Date {
        return getBWDateTsProperty(this, 'LAST_CALC_DTTS')
    }
}


export class WB_SimulationPredictorRelationshipRow
    extends ESRecord
    implements RowIF.IwbSimulationPredictorXref {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbSimulationPredictorXref {
        return this
    }

    get WB_SimulationRow(): WB_SimulationRow {
        return getBelongsToProperty(this, 'Simulation')
    }

    set WB_SimulationRow(value) {
        setBelongsToProperty(this, 'Simulation', value)
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup')
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value)
    }

    get WB_PeriodRow(): WB_PeriodRow {
        return getBelongsToProperty(this, 'Period')
    }

    set WB_PeriodRow(value) {
        setBelongsToProperty(this, 'Period', value)
    }
}

export class WB_SimulationMetricRow
    extends ESRecord
    implements RowIF.IwbSimulationMetric {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbSimulationMetric {
        return this
    }

    get WB_SimulationRow(): WB_SimulationRow {
        return getBelongsToProperty(this, 'Simulation')
    }

    set WB_SimulationRow(value) {
        setBelongsToProperty(this, 'Simulation', value)
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup')
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value)
    }

    get WB_PeriodRow(): WB_PeriodRow {
        return getBelongsToProperty(this, 'Period')
    }

    set WB_PeriodRow(value) {
        setBelongsToProperty(this, 'Period', value)
    }
}

export class WB_SimulationProductRow
    extends ESRecord
    implements RowIF.IwbSimulationProduct {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbSimulationProduct {
        return this
    }

    get WB_SimulationRow(): WB_SimulationRow {
        return getBelongsToProperty(this, 'Simulation')
    }

    set WB_SimulationRow(value) {
        setBelongsToProperty(this, 'Simulation', value)
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'SimulationProductGroup')
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'SimulationProductGroup', value)
    }

    get WB_ProductRow(): WB_FinishedProductRow {
        return getBelongsToProperty(this, 'SimulationProduct')
    }

    set WB_ProductRow(value) {
        setBelongsToProperty(this, 'SimulationProduct', value)
    }
}

export class WB_ModelAPILogRow
    extends ESRecord
    implements RowIF.IwbModelAPILog {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.STATUS = ""
        this.cif.REQUEST_RECEIVE_DTTS = defaultRowValues.Created_DtTs()
        this.cif.WB_PUBLISHED_MODEL_ID = 0
        this.cif.PROCESS_START_DTTS = defaultRowValues.Created_DtTs()
        this.cif.PROCESS_END_DTTS = defaultRowValues.Created_DtTs()
        this.cif.PROCESS_DURATION = 0
        this.cif.REQUEST_JSON = ""
        this.cif.RESPONSE_JSON = ""
        this.cif.CLIENT_CONFIG_JSON = ""
        this.cif.JAVA_RESPONSE_JSON = ""
        this.cif.HYPERFORCE_PAYLOAD_JSON = ""
    }

    get cif(): RowIF.IwbModelAPILog {
        return this
    }
}


export class WB_CBORow
    extends ESRecord
    implements RowIF.IwbCBO {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.WB_AUTHUSR_ID_CREATEDBY = 0
        let usrCtx: IUsrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
        if (usrCtx && usrCtx.User) {
            this.cif.WB_AUTHUSR_ID_CREATEDBY = usrCtx.User.cif.WB_AUTHUSR_ID
        }
    }

    get cif(): RowIF.IwbCBO {
        return this
    }

    afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this
        return new Promise<void>((resolve, error) => {

            // Set the Defaults for the Domain Values
            let dbContext: PAdbContext = <any>self.dataStore()

            if (_.isEmpty(dbContext)) {
                resolve()
                return
            }

            async function setAsyncDefaults() {
                self.setDefaults()

                let newKey: number = <any>(await dbContext.getNewId(self._mapper().name))
                let sNewId = TextUtils.padStart(newKey.toString(36), 12, '0').toUpperCase()
                self.cif.CBO_ID = sNewId
                self.cif.CBO_NAME = "New CBO " + sNewId

                resolve()
            }

            setAsyncDefaults()
        })
    }


    get WB_SimulationTypeRow(): WB_SimulationTypeRow {
        return getBelongsToProperty(this, 'CBOSimulationType')
    }

    set WB_SimulationTypeRow(value) {
        setBelongsToProperty(this, 'CBOSimulationType', value)
    }

    get WB_PublishedModelRow(): WB_Published_ModelRow {
        return getBelongsToProperty(this, 'CBOPublishedModel')
    }

    set WB_PublishedModelRow(value) {
        setBelongsToProperty(this, 'CBOPublishedModel', value)
    }

    get WB_CustomerRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Customer')
    }

    set WB_CustomerRow(value) {
        setBelongsToProperty(this, 'Customer', value)
    }

    get WB_CBOInputRelationshipRows(): WB_CBOInputRelationshipRow[] {
        return getHasManyProperty(this, 'CBOInputs')
    }

    get WB_CBOPredictorDiscreteSetRows(): WB_CBOPredictorDiscreteSetRow[] {
        return getHasManyProperty(this, 'CBODiscreteSets')
    }

    get WB_CBOPredictorRelationshipRows(): WB_CBOPredictorRelationshipRow[] {
        return getHasManyProperty(this, 'CBOPredictors')
    }

    get WB_CBOPredictorRangeRows(): WB_CBOPredictorRangeRow[] {
        return getHasManyProperty(this, 'CBOPredictorRanges')
    }

    get WB_CBOProductRows(): WB_CBOProductRow[] {
        return getHasManyProperty(this, 'CBOProducts')
    }

    get WB_CBOMetricRows(): WB_CBOMetricRow[] {
        return getHasManyProperty(this, 'CBOMetrics')
    }

    get WB_CBOConstraintRows(): WB_CBOConstraintRow[] {
        return getHasManyProperty(this, 'CBOConstraints')
    }

    get WB_SpendFunctionXrefRows(): WB_SpendFunctionRelationshipRow[] {
        return getHasManyProperty(this, 'CBOSpendFunctions')
    }

    get StartDate(): Date {
        return getBWDateProperty(this, 'START_DT')
    }

    set StartDate(value: Date) {
        setBWDateProperty(this, 'StartDate', 'START_DT', value)
    }

    get EndDate(): Date {
        return getBWDateProperty(this, 'END_DT')
    }

    set EndDate(value: Date) {
        setBWDateProperty(this, 'EndDate', 'END_DT', value)
    }

    get LastCalc(): Date {
        return getBWDateTsProperty(this, 'LAST_CALC_DTTS')
    }

    get Duration(): string {
        // @ts-ignore
        let dateDiff = Math.ceil(Math.abs(getBWDateProperty(this, 'END_DT') - getBWDateProperty(this, 'START_DT')) / (1000 * 60 * 60 * 24)) + 1
        let weeks = Math.trunc(dateDiff / 7)

        return weeks.toString()
    }

    set Duration(value) {
        let result = new Date(this.StartDate);
        result.setDate(result.getDate() + (parseInt(value) * 7 - 1));

        this.EndDate = result
    }

    get forwardBuyPCT(): string {
        return Number((this.cif.CNS_FORWARD_BUY_PCNT * 100).toFixed(2)).toLocaleString() + "%"
    }

    get filteredSimulationTypeMainRows(): WB_SimulationTypeInputRelationshipRow[] {
        let relArr = _.filter(this.WB_SimulationTypeRow.WB_SimulationTypeInputRelationshipRows, (relRow: WB_SimulationTypeInputRelationshipRow) => {
            return (relRow.cif.PLACEMENT === 'Main' && relRow.cif.DELETED_IND !== '1')
        })
        return relArr
    }

    get WB_UserRow_CreatedBy(): WB_UserRow {
        return getBelongsToProperty(this, 'UserCreatedBy');
    }

    set WB_UserRow_CreatedBy(value) {
        setBelongsToProperty(this, 'UserCreatedBy', value)
    }

    get LocalTS() {
        if (this.cif.LAST_CALC_DTTS) {
            return DateUtils.convertToLocalTS(DateUtils.convertFromSAPBWTs(this.cif.LAST_CALC_DTTS))
        }

    }


}

export class WB_CBOInputRelationshipRow
    extends ESRecord
    implements RowIF.IwbCBOInputXref {

    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbCBOInputXref {
        return this
    }

    get WB_CBORow(): WB_CBORow {
        return getBelongsToProperty(this, 'CBO')
    }

    set WB_CBORow(value) {
        setBelongsToProperty(this, 'CBO', value)
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup')
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value)
    }


}


export class WB_CBOPredictorRelationshipRow
    extends ESRecord
    implements RowIF.IwbCBOPredictorXref {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbCBOPredictorXref {
        return this
    }

    get WB_CBORow(): WB_CBORow {
        return getBelongsToProperty(this, 'CBO')
    }

    set WB_CBORow(value) {
        setBelongsToProperty(this, 'CBO', value)
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup')
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value)
    }

}

export class WB_CBOPredictorDiscreteSetRow
    extends ESRecord
    implements RowIF.IwbCBOPredictorDS {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbCBOPredictorDS {
        return this
    }

    get WB_CBORow(): WB_CBORow {
        return getBelongsToProperty(this, 'CBO')
    }

    set WB_CBORow(value) {
        setBelongsToProperty(this, 'CBO', value)
    }

}

export class WB_CBOPredictorRangeRow
    extends ESRecord
    implements RowIF.IwbCBOPredictorRange {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbCBOPredictorRange {
        return this
    }

    get WB_CBORow(): WB_CBORow {
        return getBelongsToProperty(this, 'CBO')
    }

    set WB_CBORow(value) {
        setBelongsToProperty(this, 'CBO', value)
    }

    get WB_ModelPredictorRow(): WB_ModelPredictorRow {
        return getBelongsToProperty(this, 'ModelPredictor')
    }

    set WB_ModelPredictorRow(value) {
        setBelongsToProperty(this, 'ModelPredictor', value)
    }

}

export class WB_CBOMetricRow
    extends ESRecord
    implements RowIF.IwbCBOMetric {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbCBOMetric {
        return this
    }

    get WB_CBORow(): WB_CBORow {
        return getBelongsToProperty(this, 'CBO')
    }

    set WB_CBORow(value) {
        setBelongsToProperty(this, 'CBO', value)
    }

    get WB_CBOMetricPredictorRow(): WB_CBOMetricPredictorRow {
        return getBelongsToProperty(this, 'CBOMetricPredictor')
    }

    get ROI(): number {
        return this.cif.SPEND_TOTAL != 0 ? (this.cif.CNS_INCR_PRFTCNTRB / this.cif.SPEND_TOTAL * 100) : 0
    }


    get NET_FUNDING_IMPACT(): number {
        return this.cif.SHIP_FNDAMT - this.cif.SPEND_TOTAL
    }

    get LIFT_PCT(): number {
        return this.cif.CNS_BASE_UNITS != 0 ? this.cif.CNS_INCR_UNITS / this.cif.CNS_BASE_UNITS * 100 : 0
    }

    get NET_REVENUE(): number {
        return this.cif.SHIP_NETLISTSLS - this.cif.SPEND_TOTAL
    }

    get COST_INCR_PER_CASE(): number {
        return this.cif.CNS_INCR_STAT != 0 ? this.cif.SPEND_TOTAL / this.cif.CNS_INCR_UNITS : 0
    }

    get RETAILER_MARGIN(): number {
        return this.cif.CNS_TOTAL_RTLSLS - this.cif.CNS_TOTAL_NETLISTSLS + this.cif.SPEND_TOTAL
    }

    get RETAILER_MARGIN_PCT(): number {
        return this.cif.CNS_TOTAL_RTLSLS != 0 ? (this.cif.CNS_TOTAL_RTLSLS - this.cif.CNS_TOTAL_NETLISTSLS + this.cif.SPEND_TOTAL) / this.cif.CNS_TOTAL_RTLSLS * 100 : 0
    }

    get RETAILER_MARGIN_NO_FIX_SPEND(): number {
        return this.cif.CNS_TOTAL_RTLSLS != 0 ? (this.cif.CNS_TOTAL_RTLSLS - this.cif.CNS_TOTAL_NETLISTSLS + this.cif.SPEND_TOTAL - this.cif.SPEND_FIXED) / this.cif.CNS_TOTAL_RTLSLS * 100 : 0
    }

    get T_S_RATIO(): number {
        return this.cif.SHIP_NETLISTSLS != 0 ? this.cif.SPEND_TOTAL / this.cif.SHIP_NETLISTSLS * 100 : 0
    }

    get SHELF_DISCOUNT(): number {

        return this.cif.CNS_BASE_RTLSLS != 0 ? (this.cif.CNS_BASE_RTLSLS - this.cif.CNS_TOTAL_RTLSLS) / this.cif.CNS_BASE_RTLSLS * 100 : 0
    }

}

export class WB_CBOMetricPredictorRow
    extends ESRecord
    implements RowIF.IwbCBOMetricPredictor {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbCBOMetricPredictor {
        return this
    }

    get WB_CBOMetricRow(): WB_CBOMetricRow {
        return getBelongsToProperty(this, 'CBOMetric')
    }

    set WB_CBOMetricRow(value) {
        setBelongsToProperty(this, 'CBOMetric', value)
    }

}

export class WB_CBOConstraintRow
    extends ESRecord
    implements RowIF.IwbCBOConstraint {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbCBOConstraint {
        return this
    }

    get WB_CBORow(): WB_CBORow {
        return getBelongsToProperty(this, 'CBO')
    }

    set WB_CBORow(value) {
        setBelongsToProperty(this, 'CBO', value)
    }

    get bActiveInd(): boolean {
        return getBooleanIndicator(this, 'ACTIVE_IND')
    }

    set bActiveInd(value: boolean) {
        setBooleanIndicator(this, 'bActiveInd', 'ACTIVE_IND', value)
    }


}

export class WB_CBOProductRow
    extends ESRecord
    implements RowIF.IwbCBOProduct {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
    }

    get cif(): RowIF.IwbCBOProduct {
        return this
    }

    get WB_CBORow(): WB_CBORow {
        return getBelongsToProperty(this, 'CBO')
    }

    set WB_CBORow(value) {
        setBelongsToProperty(this, 'CBO', value)
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'CBOProductGroup')
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'CBOProductGroup', value)
    }

    get WB_ProductRow(): WB_FinishedProductRow {
        return getBelongsToProperty(this, 'CBOProduct')
    }

    set WB_ProductRow(value) {
        setBelongsToProperty(this, 'CBOProduct', value)
    }
}

export class WB_SpendFunctionRow
    extends ESRecord
    implements RowIF.IwbSpendFunction {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbSpendFunction {
        return this
    }

    get WB_SpendFunctionInputRelationshipRows(): WB_SpendFunctionInputRelationshipRow[] {
        return getHasManyProperty(this, 'SpendFunctionInputRels')
    }

    get WB_SpendFunctionTermRelationshipRows(): WB_SpendFunctionTermRelationshipRow[] {
        return getHasManyProperty(this, 'SpendFunctionTermRels')
    }

}

export class WB_SpendFunctionRelationshipRow
    extends ESRecord
    implements RowIF.IwbSpendFunctionRelationship {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbSpendFunctionRelationship {
        return this
    }

    get WB_CBORow(): WB_CBORow {
        return getBelongsToProperty(this, 'CBO')
    }

    set WB_CBORow(value: WB_CBORow) {
        setBelongsToProperty(this, 'CBO', value)
    }

    get WB_SpendFunctionRow(): WB_SpendFunctionRow {
        return getBelongsToProperty(this, 'SpendFunction')
    }

    set WB_SpendFunctionRow(value: WB_SpendFunctionRow) {
        setBelongsToProperty(this, 'SpendFunction', value)
    }

    get WB_SimulationInputRow(): WB_SimulationInputRow {
        return getBelongsToProperty(this, 'SimulationInput')
    }

    set WB_SimulationInputRow(value: WB_SimulationInputRow) {
        setBelongsToProperty(this, 'SimulationInput', value)
    }

}

export class WB_SpendFunctionInputRelationshipRow
    extends ESRecord
    implements RowIF.IwbSpendFunctionInputRelationship {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.INPUT_SEQ = 1
    }

    get cif(): RowIF.IwbSpendFunctionInputRelationship {
        return this
    }

    get WB_SpendFunctionRow(): WB_SpendFunctionRow {
        return getBelongsToProperty(this, 'SpendFunction')
    }

    set WB_SpendFunctionRow(value) {
        setBelongsToProperty(this, 'SpendFunction', value)
    }

    get WB_SimulationInputRow(): WB_SimulationInputRow {
        return getBelongsToProperty(this, 'SimulationInput')
    }
}

export class WB_SpendFunctionTermRelationshipRow
    extends ESRecord
    implements RowIF.IwbSpendFunctionTermRelationship {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.TERM_SEQ = 1
    }

    get cif(): RowIF.IwbSpendFunctionTermRelationship {
        return this
    }

    get WB_SpendFunctionRow(): WB_SpendFunctionRow {
        return getBelongsToProperty(this, 'SpendFunction')
    }

    set WB_SpendFunctionRow(value) {
        setBelongsToProperty(this, 'SpendFunction', value)
    }

}


//

//new UI
export class WB_UIAppSuiteTypeRow
    extends ESRecord
    implements RowIF.IwbUIAppSuiteType {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MANUAL_IND = "1"
    }

    get cif(): RowIF.IwbUIAppSuiteType {
        return this
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

    set DeletedDt(value: Date) {
        setBWDateProperty(this, 'DeletedDt', 'DELETED_DT', value)
    }

    get IconName(): string {
        let returnVal = ""
        if (this.cif.UI5_ICON.indexOf("sap-icon://") > -1)
            returnVal = this.cif.UI5_ICON.substring("sap-icon://".length)
        else {
            let sPos = this.cif.UI5_ICON.lastIndexOf("\\")
            let ePos = this.cif.UI5_ICON.lastIndexOf(".")
            returnVal = this.cif.UI5_ICON.substring(sPos + 1, ePos)
        }
        return returnVal
    }
}

export class WB_UIApplicationRow
    extends ESRecord
    implements RowIF.IwbUIApplication {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MANUAL_IND = "1"
        this.cif.VIEW_ROLES = "Application_User"
        this.cif.LAUNCH_POLICY = LaunchPolicy.MultiInstances
        this.cif.MODULE_BAR_POLICY = ModulebarPolicy.Show
        this.cif.TASK_BAR_POLICY = TaskbarPolicy.Show
        this.cif.APPFINDER_POLICY = AppFinderPolicy.Show
        this.cif.STARTUP_POLICY = StartupPolicy.None

    }

    get cif(): RowIF.IwbUIApplication {
        return this
    }

    get WB_UIAppReportRows(): WB_UIAppReportRow[] {
        return getHasManyProperty(this, "ReportTiles")
    }

    get WB_UIAppModuleRows(): WB_UIAppModuleRow[] {
        return getHasManyProperty(this, "Modules")
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

    set DeletedDt(value: Date) {
        setBWDateProperty(this, 'DeletedDt', 'DELETED_DT', value)
    }

    get IconName(): string {
        let returnVal = ""
        if (this.cif.UI5_ICON.indexOf("sap-icon://") > -1)
            returnVal = this.cif.UI5_ICON.substring("sap-icon://".length)
        else {
            let sPos = this.cif.UI5_ICON.lastIndexOf("\\")
            let ePos = this.cif.UI5_ICON.lastIndexOf(".")
            returnVal = this.cif.UI5_ICON.substring(sPos + 1, ePos)
        }
        return returnVal
    }

}


export class WB_UIAppSuiteRow
    extends ESRecord
    implements RowIF.IwbUIAppSuite {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MANUAL_IND = "1"
    }

    get WB_UIAppSuiteAppRelationshipRows(): WB_UIAppSuiteAppRelationshipRow[] {
        return getHasManyProperty(this, 'AppSuiteRels')
    }

    get WB_UIAppSuiteTypeRow(): WB_UIAppSuiteTypeRow {
        return getBelongsToProperty(this, 'AppSuiteType')
    }

    set WB_UIAppSuiteTypeRow(value: WB_UIAppSuiteTypeRow) {
        setBelongsToProperty(this, 'AppSuiteType', value)
    }

    get WB_UIProfileRow(): WB_UIProfileRow {
        return getBelongsToProperty(this, 'Profile')
    }

    set WB_UIProfileRow(value: WB_UIProfileRow) {
        setBelongsToProperty(this, 'Profile', value)
    }

    get cif(): RowIF.IwbUIAppSuite {
        return this
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

    set DeletedDt(value: Date) {
        setBWDateProperty(this, 'DeletedDt', 'DELETED_DT', value)
    }

    get IconName(): string {
        let returnVal = ""
        if (this.cif.UI5_ICON.indexOf("sap-icon://") > -1)
            returnVal = this.cif.UI5_ICON.substring("sap-icon://".length)
        else {
            let sPos = this.cif.UI5_ICON.lastIndexOf("\\")
            let ePos = this.cif.UI5_ICON.lastIndexOf(".")
            returnVal = this.cif.UI5_ICON.substring(sPos + 1, ePos)
        }
        return returnVal
    }

}

export class WB_UIAppSuiteAppRelationshipRow
    extends ESRecord
    implements RowIF.IwbUIAppSuiteRelationship {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MANUAL_IND = "1"
    }

    get WB_UIAppSuiteRow(): WB_UIAppSuiteRow {
        return getBelongsToProperty(this, 'PA-AppSuite')
    }

    set WB_UIAppSuiteRow(value: WB_UIAppSuiteRow) {
        setBelongsToProperty(this, 'PA-AppSuite', value)
    }

    get WB_UIApplicationRow(): WB_UIApplicationRow {
        return getBelongsToProperty(this, 'Application')
    }

    set WB_UIApplicationRow(value: WB_UIApplicationRow) {
        setBelongsToProperty(this, 'Application', value)
    }

    get cif(): RowIF.IwbUIAppSuiteRelationship {
        return this
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

    set DeletedDt(value: Date) {
        setBWDateProperty(this, 'DeletedDt', 'DELETED_DT', value)
    }

    get IconName(): string {
        let returnVal = ""
        if (this.cif.UI5_ICON_OVRD.indexOf("sap-icon://") > -1)
            returnVal = this.cif.UI5_ICON_OVRD.substring("sap-icon://".length)
        else {
            let sPos = this.cif.UI5_ICON_OVRD.lastIndexOf("\\")
            let ePos = this.cif.UI5_ICON_OVRD.lastIndexOf(".")
            returnVal = this.cif.UI5_ICON_OVRD.substring(sPos + 1, ePos)
        }
        return returnVal
    }


}

export class WB_UIAppExecutableRow
    extends ESRecord
    implements RowIF.IwbUIAppExec {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MANUAL_IND = "1"
        this.cif.FOOTERBAR_SHOW_IND = "0"
        this.cif.HEADERBAR_SHOW_IND = "0"
        this.cif.TB_CLOSE_SHOW_IND = "0"
        this.cif.TB_COPY_SHOW_IND = "0"
        this.cif.TB_CREATENEW_SHOW_IND = "0"
        this.cif.TB_CREATENOTE_SHOW_IND = "0"
        this.cif.TB_DELETE_SHOW_IND = "0"
        this.cif.TB_FILELIST_SHOW_IND = "0"
        this.cif.TB_RELOAD_SHOW_IND = "0"
        this.cif.TB_SAVE_SHOW_IND = "0"
        this.cif.TB_SEARCH_SHOW_IND = "0"
    }

    get cif(): RowIF.IwbUIAppExec {
        return this
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

    set DeletedDt(value: Date) {
        setBWDateProperty(this, 'DeletedDt', 'DELETED_DT', value)
    }

    get WB_LicenseRows(): WB_LicenseRow[] {
        return getHasManyProperty(this, 'LicAppExecutables')
    }

    get IconName(): string {
        let returnVal = ""
        if (this.cif.UI5_ICON.indexOf("sap-icon://") > -1)
            returnVal = this.cif.UI5_ICON.substring("sap-icon://".length)
        else {
            let sPos = this.cif.UI5_ICON.lastIndexOf("\\")
            let ePos = this.cif.UI5_ICON.lastIndexOf(".")
            returnVal = this.cif.UI5_ICON.substring(sPos + 1, ePos)
        }

        return returnVal
    }
}

export class WB_UIAppModuleRow
    extends ESRecord
    implements RowIF.IwbUIAppModule {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MANUAL_IND = "1"
    }

    get WB_UIApplicationRow(): WB_UIApplicationRow {
        return getBelongsToProperty(this, 'Application')
    }

    set WB_UIApplicationRow(value: WB_UIApplicationRow) {
        setBelongsToProperty(this, 'Application', value)
    }

    get WB_UIAppExecutableRow(): WB_UIAppExecutableRow {
        return getBelongsToProperty(this, 'Executable')
    }

    set WB_UIAppExecutableRow(value: WB_UIAppExecutableRow) {
        setBelongsToProperty(this, 'Executable', value)
    }

    get cif(): RowIF.IwbUIAppModule {
        return this
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    set ModifiedDtTs(value: Date) {
        setBWDateTsProperty(this, "ModifiedDtTs", 'MODIFIED_DTTS', value);
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

    set DeletedDt(value: Date) {
        setBWDateProperty(this, 'DeletedDt', 'DELETED_DT', value)
    }

    get IconName(): string {
        let returnVal = ""
        if (this.cif.UI5_ICON.indexOf("sap-icon://") > -1)
            returnVal = this.cif.UI5_ICON.substring("sap-icon://".length)
        else {
            let sPos = this.cif.UI5_ICON.lastIndexOf("\\")
            let ePos = this.cif.UI5_ICON.lastIndexOf(".")
            returnVal = this.cif.UI5_ICON.substring(sPos + 1, ePos)
        }
        return returnVal
    }


}

export class WB_UIAppReportRow
    extends ESRecord
    implements RowIF.IwbUIAppReport {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MANUAL_IND = "1"
    }

    get WB_UIApplicationRow(): WB_UIApplicationRow {
        return getBelongsToProperty(this, 'Application')
    }

    set WB_UIApplicationRow(value: WB_UIApplicationRow) {
        setBelongsToProperty(this, 'Application', value)
    }

    get WB_ReportTileRow(): WB_ReportTileRow {
        return getBelongsToProperty(this, 'ReportTile')
    }

    set WB_ReportTileRow(value: WB_ReportTileRow) {
        setBelongsToProperty(this, 'ReportTile', value)
    }

    get cif(): RowIF.IwbUIAppReport {
        return this
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    set ModifiedDtTs(value: Date) {
        setBWDateTsProperty(this, "ModifiedDtTs", 'MODIFIED_DTTS', value);
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

    set DeletedDt(value: Date) {
        setBWDateProperty(this, 'DeletedDt', 'DELETED_DT', value)
    }

}

export class WB_UIProfileRow
    extends ESRecord
    implements RowIF.IwbUIProfile {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MANUAL_IND = "1"
    }

    get cif(): RowIF.IwbUIProfile {
        return this
    }

    get DeletedDt(): Date {
        return getBWDateProperty(this, 'DELETED_DT')
    }

    set DeletedDt(value: Date) {
        setBWDateProperty(this, 'DeletedDt', 'DELETED_DT', value)
    }

}

export class WB_UIUsageRow
    extends ESRecord
    implements RowIF.IwbUIUsage {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get WB_UIApplicationRow(): WB_UIApplicationRow {
        return getBelongsToProperty(this, 'Application')
    }

    set WB_UIApplicationRow(value: WB_UIApplicationRow) {
        setBelongsToProperty(this, 'Application', value)
    }

    get WB_UIAppModuleRow(): WB_UIAppModuleRow {
        return getBelongsToProperty(this, 'Module')
    }

    set WB_UIAppModuleRow(value: WB_UIAppModuleRow) {
        setBelongsToProperty(this, 'Module', value)
    }

    get WB_UserRow(): WB_UserRow {
        return getBelongsToProperty(this, 'User')
    }

    set WB_UserRow(value: WB_UserRow) {
        setBelongsToProperty(this, 'User', value)
    }

    get cif(): RowIF.IwbUIUsage {
        return this
    }

    get ModifiedDtTs(): Date {
        return getBWDateTsProperty(this, 'MODIFIED_DTTS')
    }

    set ModifiedDtTs(value: Date) {
        setBWDateTsProperty(this, "ModifiedDtTs", 'MODIFIED_DTTS', value);
    }


}


//</editor-fold>

//<editor-fold desc="License">
// License
export class WB_LicenseRow
    extends ESRecord
    implements RowIF.IwbLicense {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbLicense {
        return this
    }

    // get WB_BusinessUnitRow(): WB_BusinessUnitRow {
    //     return getBelongsToProperty(this, 'BusinessUnit');
    // }

    get WB_ReportTileRow(): WB_ReportTileRow {
        return getBelongsToProperty(this, 'ReportTile')
    }

    get WB_UIAppExecutableRow(): WB_UIAppExecutableRow {
        return getBelongsToProperty(this, 'Executable')
    }

}

//</editor-fold>


//<editor-fold desc="Benchmark">
// Benchmark
export class WB_BenchmarkRow
    extends ESRecord
    implements RowIF.IwbBenchmark {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.EFFECTIVE_START_DT = defaultRowValues.Min_Dt();
        this.cif.EFFECTIVE_END_DT = defaultRowValues.Min_Dt();
    }

    get cif(): RowIF.IwbBenchmark {
        return this
    }

    set WB_SalesOrgRow(value: any) {
        setBelongsToProperty(this, 'SalesOrg', value)
    }

    get EffectiveStartDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_START_DT')
    }

    set EffectiveStartDt(value: Date) {
        setBWDateProperty(this, 'EffectiveStartDt', 'EFFECTIVE_START_DT', value)
    }

    get EffectiveEndDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_END_DT')
    }

    set EffectiveEndDt(value: Date) {
        setBWDateProperty(this, 'EffectiveEndDt', 'EFFECTIVE_END_DT', value)
    }

}


//</editor-fold>


//<editor-fold desc="Partition">
// Partition
export class WB_PartitionRow
    extends ESRecord
    implements RowIF.IwbPartition {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }


    afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this
        return new Promise<void>((resolve, error) => {

            // Set the Defaults for the Domain Values
            let dbContext: PAdbContext = <any>self.dataStore()

            if (_.isEmpty(dbContext)) {
                resolve()
                return
            }

            async function setAsyncDefaults() {
                self.setDefaults()

                let newKey: number = <any>(await dbContext.getNewId(self._mapper().name))
                let sNewId = TextUtils.padStart(newKey.toString(36), 12, '0').toUpperCase()
                self.cif.PARTITION_ID = sNewId
                self.cif.PARTITION_NAME = "New Partition " + sNewId

                resolve()
            }

            setAsyncDefaults()
        })
    }

    get cif(): RowIF.IwbPartition {
        return this
    }

    get WB_BusinessUnitRow(): WB_BusinessUnitRow {
        return getBelongsToProperty(this, 'BusinessUnit');
    }

    get WB_PartitionRRows(): WB_PartitionRRow[] {
        return getHasManyProperty(this, 'PartitionRs')
    }

    get WB_CustomerHierarchyRow(): WB_CustomerHierarchyRow {
        return getBelongsToProperty(this, 'CustomerHierarchy');
    }

    get WB_ProductGroupHierarchyRow(): WB_ProductHierarchyRow {
        return getBelongsToProperty(this, 'ProductGroupHierarchy');
    }

    get WB_PeriodHierarchyRow(): WB_PeriodHierarchyRow {
        return getBelongsToProperty(this, 'PeriodHierarchy');
    }

    get bHasPartitions(): boolean {
        if (this.WB_PartitionRRows.length == 0)
            return false
        else
            return true
    }

}


export class WB_PartitionRRow
    extends ESRecord
    implements RowIF.IwbPartitionR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbPartitionR {
        return this
    }

    get WB_PartitionRow(): WB_PartitionRow {
        return getBelongsToProperty(this, 'Partition');
    }

    get WB_CustomerRow(): WB_CustomerRow {
        return getBelongsToProperty(this, 'Customer');
    }

    set WB_CustomerRow(value) {
        setBelongsToProperty(this, 'Customer', value);
    }

    get WB_ProductGroupRow(): WB_ProductGroupRow {
        return getBelongsToProperty(this, 'ProductGroup');
    }

    set WB_ProductGroupRow(value) {
        setBelongsToProperty(this, 'ProductGroup', value);
    }

    get WB_PeriodRow(): WB_PeriodRow {
        return getBelongsToProperty(this, 'Period');
    }

    set WB_PeriodRow(value) {
        setBelongsToProperty(this, 'Period', value);
    }

    get WB_SourceRow(): WB_SourceRow {
        return getBelongsToProperty(this, 'Source');
    }

    set WB_SourceRow(value) {
        setBelongsToProperty(this, 'Source', value);
    }

}

//</editor-fold>


//<editor-fold desc="Control Point Type">
// Control Point Type
export class WB_ControlPointTypeRow
    extends ESRecord
    implements RowIF.IwbControlPointType {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.MANUAL_IND = defaultRowValues.True_Ind()
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    async afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this

        let dbContext: PAdbContext = <any>self.dataStore()
        if (_.isEmpty(dbContext))
            return

        self.setDefaults()
        self.cif.ENTERPRISE_POLICY = (<any>await Domain_getDefaultOrFirstItem(dbContext, ['ControlPointEnterprisePolicy'], true)) || ''

    }


    get cif(): RowIF.IwbControlPointType {
        return this
    }

    get WB_ControlPointTypeProcessRows(): WB_ControlPointTypeProcessRow[] {
        return getHasManyProperty(this, 'Processes')
    }

}

export class WB_ControlPointTypeProcessRow
    extends ESRecord
    implements RowIF.IwbControlPointTypeProcess {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.MANUAL_IND = defaultRowValues.True_Ind()
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbControlPointTypeProcess {
        return this
    }

    get WB_ControlPointTypeProcessInputRows(): WB_ControlPointTypeProcessInputRow[] {
        return getHasManyProperty(this, 'ProcessInputs')
    }

    get WB_ControlPointTypeRow(): WB_ControlPointTypeRow {
        return getBelongsToProperty(this, 'ControlPointType');
    }

    set WB_ControlPointTypeRow(value) {
        setBelongsToProperty(this, 'ControlPointType', value);
    }


}

export class WB_ControlPointTypeProcessInputRow
    extends ESRecord
    implements RowIF.IwbControlPointTypeProcessInput {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.MANUAL_IND = defaultRowValues.True_Ind()
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbControlPointTypeProcessInput {
        return this
    }

    get WB_ControlPointTypeProcessRow(): WB_ControlPointTypeProcessRow {
        return getBelongsToProperty(this, 'Process');
    }


}


//</editor-fold>

//<editor-fold desc="Control Point">
// Control Point

export class WB_ControlPointRow
    extends ESRecord
    implements RowIF.IwbControlPoint {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CONTROL_POINT_NAME = "New Control Point"
        this.cif.MANUAL_IND = defaultRowValues.True_Ind()
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    async afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this

        let dbContext: PAdbContext = <any>self.dataStore()
        if (_.isEmpty(dbContext))
            return

        self.setDefaults()
        let newKey: number = self.cif.WB_CONTROL_POINT_ID
        let sNewId = TextUtils.padStart(newKey.toString(36), 12, '0').toUpperCase()
        self.cif.CONTROL_POINT_ID = sNewId
    }


    get cif(): RowIF.IwbControlPoint {
        return this
    }

    get WB_ControlPointPartitionRows(): WB_ControlPointPartitionRow[] {
        return getHasManyProperty(this, 'Partitions')
    }

    get WB_ControlPointTypeRow(): WB_ControlPointTypeRow {
        return getBelongsToProperty(this, 'ControlPointType');
    }

    set WB_ControlPointTypeRow(value) {
        setBelongsToProperty(this, 'ControlPointType', value);
    }

}

export class WB_ControlPointPartitionRow
    extends ESRecord
    implements RowIF.IwbControlPointPartition {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.MANUAL_IND = defaultRowValues.True_Ind()
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbControlPointPartition {
        return this
    }

    get WB_ControlPointPartitionInputRows(): WB_ControlPointPartitionInputRow[] {
        return getHasManyProperty(this, 'PartitionInputs')
    }

}

export class WB_ControlPointPartitionInputRow
    extends ESRecord
    implements RowIF.IwbControlPointPartitionInput {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.MANUAL_IND = defaultRowValues.True_Ind()
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbControlPointPartitionInput {
        return this
    }

    get WB_ControlPointPartitionRow(): WB_ControlPointPartitionRow {
        return getBelongsToProperty(this, 'ControlPointPartition');
    }

    get WB_ControlPointTypeProcessInputRow(): WB_ControlPointTypeProcessInputRow {
        return getBelongsToProperty(this, 'ProcessInput');
    }

    set WB_ControlPointTypeProcessInputRow(value) {
        setBelongsToProperty(this, 'ProcessInput', value);
    }
}

//</editor-fold>

//<editor-fold desc="LE Spend">
// LE Spend

export class WB_LESpendRow
    extends ESRecord
    implements RowIF.IwbLESpend {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CONTROL_POINT_NAME = "New Control Point"
        this.cif.MANUAL_IND = defaultRowValues.True_Ind()
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.WB_AUTHUSR_ID_CREATEDBY = defaultRowValues.CurrentUserWbId()
    }

    async afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this

        let dbContext: PAdbContext = <any>self.dataStore()
        if (_.isEmpty(dbContext))
            return

        self.setDefaults()
        let newKey: number = self.cif.WB_LE_SPEND_ID
        let sNewId = TextUtils.padStart(newKey.toString(36), 12, '0').toUpperCase()
        self.cif.CONTROL_POINT_ID = sNewId
    }


    get cif(): RowIF.IwbLESpend {
        return this
    }

    get WB_LESpendPartitionRows(): WB_LESpendPartitionRow[] {
        return getHasManyProperty(this, 'Partitions')
    }

    get WB_MasterDataSetRow(): WB_MasterDataSetRow {
        return getBelongsToProperty(this, 'MDSet');
    }

    set WB_MasterDataSetRow(value) {
        setBelongsToProperty(this, 'MDSet', value);
    }


}

export class WB_LESpendPartitionRow
    extends ESRecord
    implements RowIF.IwbLESpendPartition {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.MANUAL_IND = defaultRowValues.True_Ind()
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbLESpendPartition {
        return this
    }

    get WB_LESpendRow(): WB_LESpendRow {
        return getBelongsToProperty(this, 'LESpend');
    }

    set WB_LESpendRow(value) {
        setBelongsToProperty(this, 'LESpend', value);
    }

    get WB_LESpendPartitionInputRows(): WB_LESpendPartitionInputRow[] {
        return getHasManyProperty(this, 'PartitionInputs')
    }


}

export class WB_LESpendPartitionInputRow
    extends ESRecord
    implements RowIF.IwbLESpendPartitionInput {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.MANUAL_IND = defaultRowValues.True_Ind()
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    async afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this

        let dbContext: PAdbContext = <any>self.dataStore()
        if (_.isEmpty(dbContext))
            return

        self.setDefaults()
        self.cif.CALC_PROCESS_ID = '' + await Domain_getDefaultOrFirstItem(dbContext, ["LE_Spend_CalcProcess"], true)
        self.cif.STARTING_METRIC_POLICY = '' + await Domain_getDefaultOrFirstItem(dbContext, ["LE_Spend_StartingMetricPolicy"], true)

        self.cif.ACTUAL_USAGE_POLICY = '' + await Domain_getDefaultOrFirstItem(dbContext, ["LE_Spend_ActualUsagePolicy"], true)
        self.cif.PAID_IN_FULL_POLICY = '' + await Domain_getDefaultOrFirstItem(dbContext, ["LE_Spend_PaidInFullPolicy"], true)
        self.cif.PRODUCT_ALLOCATION = '' + await Domain_getDefaultOrFirstItem(dbContext, ["LE_Spend_ProductAllocationPolicy"], true)
        self.cif.TIME_ALLOCATION = '' + await Domain_getDefaultOrFirstItem(dbContext, ["LE_Spend_TimeAllocationPolicy"], true)

    }

    get cif(): RowIF.IwbLESpendPartitionInput {
        return this
    }

    get WB_LESpendPartitionRow(): WB_LESpendPartitionRow {
        return getBelongsToProperty(this, 'LESpendPartition');
    }

    set WB_LESpendPartitionRow(value) {
        setBelongsToProperty(this, 'LESpendPartition', value);
    }

}

//</editor-fold>

//<editor-fold desc="Act Spend">
// Act Spend

export class WB_ActSpendRow
    extends ESRecord
    implements RowIF.IwbActSpend {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CONTROL_POINT_NAME = "New Control Point"
        this.cif.MANUAL_IND = defaultRowValues.True_Ind()
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    async afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this

        let dbContext: PAdbContext = <any>self.dataStore()
        if (_.isEmpty(dbContext))
            return

        self.setDefaults()
        let newKey: number = self.cif.WB_ACT_SPEND_ID
        let sNewId = TextUtils.padStart(newKey.toString(36), 12, '0').toUpperCase()
        self.cif.CONTROL_POINT_ID = sNewId
    }


    get cif(): RowIF.IwbActSpend {
        return this
    }

    get WB_ActSpendPartitionRows(): WB_ActSpendPartitionRow[] {
        return getHasManyProperty(this, 'Partitions')
    }

    get WB_MasterDataSetRow(): WB_MasterDataSetRow {
        return getBelongsToProperty(this, 'MDSet');
    }

    set WB_MasterDataSetRow(value) {
        setBelongsToProperty(this, 'MDSet', value);
    }


}

export class WB_ActSpendPartitionRow
    extends ESRecord
    implements RowIF.IwbActSpendPartition {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.MANUAL_IND = defaultRowValues.True_Ind()
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbActSpendPartition {
        return this
    }

    get WB_ActSpendRow(): WB_ActSpendRow {
        return getBelongsToProperty(this, 'ActSpend');
    }

    set WB_ActSpendRow(value) {
        setBelongsToProperty(this, 'ActSpend', value);
    }

    get WB_ActSpendPartitionInputRows(): WB_ActSpendPartitionInputRow[] {
        return getHasManyProperty(this, 'PartitionInputs')
    }


}

export class WB_ActSpendPartitionInputRow
    extends ESRecord
    implements RowIF.IwbActSpendPartitionInput {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.MANUAL_IND = defaultRowValues.True_Ind()
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    async afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this

        let dbContext: PAdbContext = <any>self.dataStore()
        if (_.isEmpty(dbContext))
            return

        self.setDefaults()
        self.cif.CALC_PROCESS_ID = '' + await Domain_getDefaultOrFirstItem(dbContext, ["LE_Spend_CalcProcess"], true)
        self.cif.ALLOCATION_BASIS = '' + await Domain_getDefaultOrFirstItem(dbContext, ["LE_Spend_StartingMetricPolicy"], true)

        self.cif.TIME_ALLOCATION = '' + await Domain_getDefaultOrFirstItem(dbContext, ["LE_Spend_TimeAllocationPolicy"], true)

    }

    get cif(): RowIF.IwbActSpendPartitionInput {
        return this
    }

    get WB_ActSpendPartitionRow(): WB_ActSpendPartitionRow {
        return getBelongsToProperty(this, 'ActSpendPartition');
    }

    set WB_ActSpendPartitionRow(value) {
        setBelongsToProperty(this, 'ActSpendPartition', value);
    }

}

//</editor-fold>

//<editor-fold desc="Classification">
// Classification

export class WB_ClassificationRow
    extends ESRecord
    implements RowIF.IwbClassification {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.MANUAL_IND = defaultRowValues.True_Ind()
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    async afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this

        let dbContext: PAdbContext = <any>self.dataStore()
        if (_.isEmpty(dbContext))
            return

        self.setDefaults()
        let newKey: number = self.cif.WB_CLASSIFICATION_ID
        let sNewId = TextUtils.padStart(newKey.toString(36), 12, '0').toUpperCase()
        self.cif.CLASSIFICATION_ID = sNewId
    }

    get cif(): RowIF.IwbClassification {
        return this
    }

    get WB_ClassificationStepRows(): WB_ClassificationStepRow[] {
        return getHasManyProperty(this, 'ClassificationSteps')
    }
}

//<editor-fold desc="Classification Step">
// Classification Step

export class WB_ClassificationStepRow
    extends ESRecord
    implements RowIF.IwbClassificationStep {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.MANUAL_IND = defaultRowValues.True_Ind()
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbClassificationStep {
        return this
    }

    get WB_ClassificationRow(): WB_ClassificationRow {
        return getBelongsToProperty(this, 'Classification');
    }

    set WB_ClassificationRow(value) {
        setBelongsToProperty(this, 'Classification', value);
    }

    get WB_TagRow(): WB_TagRow {
        return getBelongsToProperty(this, 'Tag');
    }

    set WB_TagRow(value) {
        setBelongsToProperty(this, 'Tag', value);
    }

    get WB_ClassificationStepRRows(): WB_ClassificationStepRRow[] {
        return getHasManyProperty(this, 'ClassificationStepRs')
    }
}

//<editor-fold desc="Classification StepR">
// Classification Step

export class WB_ClassificationStepRRow
    extends ESRecord
    implements RowIF.IwbClassificationStepR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.MANUAL_IND = defaultRowValues.True_Ind()
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbClassificationStepR {
        return this
    }

    get WB_ClassificationStepRow(): WB_ClassificationStepRow {
        return getBelongsToProperty(this, 'ClassificationStep');
    }

    set WB_ClassificationStepRow(value) {
        setBelongsToProperty(this, 'ClassificationStep', value);
    }

    get WB_AttributeTypeRow(): WB_AttributeTypeRow {
        return getBelongsToProperty(this, 'AttributeType');
    }

    set WB_AttributeTypeRow(value) {
        setBelongsToProperty(this, 'AttributeType', value);
    }
}

//<editor-fold desc="Classification Control">
// Classification Control

export class WB_ClassificationControlRow
    extends ESRecord
    implements RowIF.IwbClassificationControl {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CONTROL_POINT_NAME = "New Classification Control"
        this.cif.MANUAL_IND = defaultRowValues.True_Ind()
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    async afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this

        let dbContext: PAdbContext = <any>self.dataStore()
        if (_.isEmpty(dbContext))
            return

        self.setDefaults()
        let newKey: number = self.cif.WB_CLASSIFICATION_CONTROL_ID
        let sNewId = TextUtils.padStart(newKey.toString(36), 12, '0').toUpperCase()
        self.cif.CONTROL_POINT_ID = sNewId
    }


    get cif(): RowIF.IwbClassificationControl {
        return this
    }

    get WB_ClassificationControlPartitionRows(): WB_ClassificationControlPartitionRow[] {
        return getHasManyProperty(this, 'Partitions')
    }

    // get WB_MasterDataSetRow(): WB_MasterDataSetRow {
    //     return getBelongsToProperty(this, 'MDSet');
    // }
    //
    // set WB_MasterDataSetRow(value) {
    //     setBelongsToProperty(this, 'MDSet', value);
    // }

    // get WB_SalesOrgRow(): WB_SalesOrgRow {
    //     return getHasManyProperty(this, 'SalesOrg')
    // }
    //
    // set WB_SalesOrgRow(value) {
    //     setBelongsToProperty(this, "SalesOrg", value)
    // }
}


export class WB_ClassificationControlPartitionRow
    extends ESRecord
    implements RowIF.IwbClassificationControlPartition {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.MANUAL_IND = defaultRowValues.True_Ind()
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbClassificationControlPartition {
        return this
    }

    get WB_ClassificationControlRow(): WB_ClassificationControlRow {
        return getBelongsToProperty(this, 'ClassificationControl');
    }

    set WB_ClassificationControlRow(value) {
        setBelongsToProperty(this, 'ClassificationControl', value);
    }

    // get WB_Partition(): WB_PartitionRow {
    //     return getBelongsToProperty(this, 'Partition');
    // }
    //
    // set WB_Partition(value) {
    //     setBelongsToProperty(this, 'Partition', value);
    // }

}

//</editor-fold>


//<editor-fold desc="Power Metric">


export class WB_PowerMetricRow
    extends ESRecord
    implements RowIF.IwbPowerMetric {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.MANUAL_IND = defaultRowValues.True_Ind()
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }


    afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this
        return new Promise<void>((resolve, error) => {

            // Set the Defaults for the Domain Values
            let dbContext: PAdbContext = <any>self.dataStore()

            if (_.isEmpty(dbContext)) {
                resolve()
                return
            }

            async function setAsyncDefaults() {
                self.setDefaults()

                let newKey: number = <any>(await dbContext.getNewId(self._mapper().name))
                let sNewId = TextUtils.padStart(newKey.toString(36), 12, '0').toUpperCase()
                self.cif.POWERMETRIC_ID = sNewId
                resolve()
            }

            setAsyncDefaults()
        })
    }

    get cif(): RowIF.IwbPowerMetric {
        return this
    }

    get WB_PowerMetricRelationshipRows(): WB_PowerMetricRelationshipRow[] {
        return getHasManyProperty(this, 'PowerMetricRels');
    }


}

export class WB_PowerMetricRelationshipRow
    extends ESRecord
    implements RowIF.IwbPowerMetricRelationship {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.MANUAL_IND = defaultRowValues.True_Ind()
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.DEFAULT_WEIGHT = 0.00
    }

    get cif(): RowIF.IwbPowerMetricRelationship {
        return this
    }

    get WB_PowerMetricRow(): WB_PowerMetricRow {
        return getBelongsToProperty(this, 'PowerMetric');
    }

    get WB_ModelFunctionRow(): WB_ModelFunctionRow {
        return getBelongsToProperty(this, 'ModelFunction');
    }

    set WB_ModelFunctionRow(value) {
        setBelongsToProperty(this, 'ModelFunction', value);
    }

    get WB_ModelPredictorRow(): WB_ModelPredictorRow {
        return getBelongsToProperty(this, 'ModelPredictor');
    }

    set WB_ModelPredictorRow(value) {
        setBelongsToProperty(this, 'ModelPredictor', value);
    }

    get DefaultWeightPct(): string {
        return Number((this.cif.DEFAULT_WEIGHT * 100).toFixed(2)).toLocaleString() + "%"
    }

}

//WB_Schedule


export class WB_ScheduleRow
    extends ESRecord
    implements RowIF.IwbSchedule {
    private _schedule: string
    private _frequency: string

    constructor(props: any, opts: any) {
        super(props, opts);
        this._schedule = ""
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.PROCESSED_START_DTTS = 0
        this.cif.PROCESSED_END_DTTS = 0
        this.cif.PROCESS_STATUS = ''
        this.cif.SCHEDULE_TYPE = 'recurring'
    }

    get cif(): RowIF.IwbSchedule {
        return this
    }


    get isRecurring(): boolean {
        return this.cif.SCHEDULE_TYPE === 'recurring';
    }

    get ScheduleStartDtTs(): Date {
        return getBWDateTsProperty(this, 'SCHEDULE_START_DTTS')
    }

    set ScheduleStartDtTs(value: Date) {
        setBWDateTsProperty(this, "ScheduleStartDtTs", 'SCHEDULE_START_DTTS', value);
    }

    set ScheduleEndDtTs(value: Date) {
        setBWDateTsProperty(this, "ScheduleEndDtTs", 'SCHEDULE_END_DTTS', value);
    }

    get ScheduleEndDtTs(): Date {
        return getBWDateTsProperty(this, 'SCHEDULE_END_DTTS')
    }

    get AutoRunEnabled(): boolean {
        return !_.isEmpty(this.cif.RULE_FREQUENCY) && !_.isEmpty(this.cif.RULE_WEEK_DAYS) && this.cif.RULE_FREQUENCY != 'Hourly'
    }

    set Schedule(value: string) {
        this._schedule = value
    }

    get Schedule(): string {
        return this._schedule
    }

    set Frequency(value: string) {
        this._frequency = value
    }

    get Frequency(): string {
        return this._frequency
    }
}

//WB_SEARCH
export class WB_SearchRow
    extends ESRecord
    implements RowIF.IwbSearch {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    async afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this
        // Set the Defaults for the Domain Values
        let dbContext: PAdbContext = <any>self.dataStore()

        if (_.isEmpty(dbContext)) {
            return
        }

        self.setDefaults()
        let newKey: number = <any>(await dbContext.getNewId(self._mapper().name))
        let sNewId = TextUtils.padStart(newKey.toString(36), 12, '0').toUpperCase()
        self.cif.SEARCH_ID = sNewId

    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbSearch {
        return this
    }

    get WB_SearchProfileRows(): WB_SearchProfileRow[] {
        return getHasManyProperty(this, 'SearchProfiles');
    }

}

//WB_SEARCH_PROFILE
export class WB_SearchProfileRow
    extends ESRecord
    implements RowIF.IwbSearchProfile {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    async afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this
        // Set the Defaults for the Domain Values
        let dbContext: PAdbContext = <any>self.dataStore()

        if (_.isEmpty(dbContext)) {
            return
        }

        self.setDefaults()
        let newKey: number = <any>(await dbContext.getNewId(self._mapper().name))
        let sNewId = TextUtils.padStart(newKey.toString(36), 12, '0').toUpperCase()
        self.cif.PROFILE_ID = sNewId

    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbSearchProfile {
        return this
    }

    get WB_Search(): WB_SearchRow {
        return getBelongsToProperty(this, 'Search');
    }

    set WB_Search(value) {
        setBelongsToProperty(this, 'Search', value);
    }

    get WB_SearchProfileCRRows(): WB_SearchProfileCRRow[] {
        return getHasManyProperty(this, 'SearchProfileCRs');
    }

    get WB_SearchProfileFCRRows(): WB_SearchProfileFCRRow[] {
        return getHasManyProperty(this, 'SearchProfileFCRs');
    }

    get WB_SearchProfileGCRRows(): WB_SearchProfileGCRRow[] {
        return getHasManyProperty(this, 'SearchProfileGCRs');
    }

}

//WB_SEARCH_PROFILECR
export class WB_SearchProfileCRRow
    extends ESRecord
    implements RowIF.IwbSearchProfileCR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbSearchProfileCR {
        return this
    }

    get WB_SearchProfile(): WB_SearchProfileRow {
        return getBelongsToProperty(this, 'SearchProfile');
    }

    set WB_SearchProfile(value) {
        setBelongsToProperty(this, 'SearchProfile', value);
    }

}

//WB_SEARCH_PROFILECR
export class WB_SearchProfileFCRRow
    extends ESRecord
    implements RowIF.IwbSearchProfileFCR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbSearchProfileFCR {
        return this
    }

    get WB_SearchProfile(): WB_SearchProfileRow {
        return getBelongsToProperty(this, 'SearchProfile');
    }

    set WB_SearchProfile(value) {
        setBelongsToProperty(this, 'SearchProfile', value);
    }

}

//WB_SEARCH_PROFILECR
export class WB_SearchProfileGCRRow
    extends ESRecord
    implements RowIF.IwbSearchProfileGCR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbSearchProfileGCR {
        return this
    }

    get WB_SearchProfile(): WB_SearchProfileRow {
        return getBelongsToProperty(this, 'SearchProfile');
    }

    set WB_SearchProfile(value) {
        setBelongsToProperty(this, 'SearchProfile', value);
    }

}

//WB_HIERARCHY
export class WB_HierarchyRow
    extends ESRecord
    implements RowIF.IwbHierarchy {
    constructor(props: any, opts: any) {
        super(props, opts);
        this.setupDependents("KeySets", ["ENTITY_DIMENSION"])
        this.setupDependents("NODE_WB_SET_ID", ["ENTITY_DIMENSION"])
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
        this.cif.HIERARCHY_WORKFLOW_MODE = "LandingZone"
    }

    get cif(): RowIF.IwbHierarchy {
        return this
    }

    get bIncludesEnterpriseNodes(): boolean {
        return getBooleanIndicator(this, "ENTERPRISE_NODES_IND", false)
    }

    set bIncludesEnterpriseNodes(value: boolean) {
        setBooleanIndicator(this, "bIncludesEnterpriseEntities", "ENTERPRISE_NODES_IND", value)
    }

    get WB_HierarchyLevelRows(): WB_HierarchyLevelRow[] {
        return getHasManyProperty(this, 'HierarchyLevels');
    }

    get WB_HierarchySalesAreaRows(): WB_HierarchySalesAreaRow[] {
        return getHasManyProperty(this, 'HierarchySalesAreas');
    }


    get WB_HierarchyPeriodRows(): WB_HierarchyPeriodRow[] {
        return getHasManyProperty(this, 'HierarchyPeriods');
    }

    get WB_HierarchyAttributeRows(): WB_HierarchyAttributeGenerationRow[] {
        return getHasManyProperty(this, 'HierarchyAttributes');
    }

    get WB_HierarchyEntityRows(): WB_HierarchyEntityGenerationRow[] {
        return getHasManyProperty(this, 'HierarchyEntities');
    }

    get WB_HierarchyIntelligentKeyRows(): WB_HierarchyIntelligentKeyRow[] {
        return getHasManyProperty(this, 'HierarchyIntelligentKeys');
    }

    get WB_ScheduleRow(): WB_ScheduleRow {
        return getBelongsToProperty(this, 'HierarchySchedule')
    }

    set WB_ScheduleRow(value: WB_ScheduleRow) {
        setBelongsToProperty(this, "HierarchySchedule", value)
    }

    get KeySets(): string[] {
        switch (this.cif.ENTITY_DIMENSION) {
            case "Customer":
                return ["Customer", "Vendor"];
            case "Product":
                return ["ProductGroup"];
            case "Period":
                return ["Period"];
            case "Enterprise":
                return ["Enterprise"]
            default:
                return []
        }

    }

    get bIncludeInactiveInd(): boolean {
        return getBooleanIndicator(this, "INCLUDE_INACTIVE_IND", false)
    }

    get bSkipLeafEnterpriseScopeInd(): boolean {
        return getBooleanIndicator(this, "SKIP_LEAF_ES_SCOPE_IND", false)
    }

    async afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this
        // Set the Defaults for the Domain Values
        let dbContext: PAdbContext = <any>self.dataStore()

        if (_.isEmpty(dbContext)) {
            return
        }

        self.setDefaults()
        let domainRow = await dbContext.findAll(esWB_Domain, {
            where: {
                DELETED_IND: {neq: '1'},
                DOMAIN_ID: 'ENTITY_DIMENSION'
            }
        }, {with: [esWB_Domain_Item]})
        if (!_.isEmpty(domainRow)) {
            let defaultItem = _.first(_.orderBy(_.filter(domainRow[0].WB_DomainItemRows, aRow => aRow.isActive && aRow.cif.DOMAIN_ITEM_SUBCODE == 'Hierarchy'), 'DOMAIN_ITEM_SORT', 'asc'))
            self.cif.ENTITY_DIMENSION = defaultItem.cif.DOMAIN_ITEM_ID
        }

        self.cif.UNBALANCED_ERROR_POLICY = <any>await Domain_getDefaultOrFirstItem(dbContext, ['HierarchyBuilderValidations'], true)
        self.cif.RAGGED_ERROR_POLICY = <any>await Domain_getDefaultOrFirstItem(dbContext, ['HierarchyBuilderValidations'], true)
        self.cif.ENTITY_TYPING_POLICY = <any>await Domain_getDefaultOrFirstItem(dbContext, ['HierarchyBuilderValidations'], true)

    }
}

export class WB_HierarchyLevelRow
    extends ESRecord
    implements RowIF.IwbHierarchyLevel {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbHierarchyLevel {
        return this
    }

    get WB_HierarchyRow(): WB_HierarchyRow {
        return getBelongsToProperty(this, 'Hierarchy');
    }

    set WB_HierarchyRow(value: WB_HierarchyRow) {
        setBelongsToProperty(this, 'Hierarchy', value);
    }

    get WB_EntityRow(): WB_EntityRow {
        return getBelongsToProperty(this, 'Entity');
    }

    set WB_EntityRow(value: WB_EntityRow) {
        setBelongsToProperty(this, 'Entity', value);
    }

    get WB_EntityEnterpriseRow(): WB_EntityRow {
        return getBelongsToProperty(this, 'EntityEnterprise');
    }

    set WB_EntityEnterpriseRow(value: WB_EntityRow) {
        setBelongsToProperty(this, 'EntityEnterprise', value);
    }

    get WB_AttributeTypeRow(): WB_AttributeTypeRow {
        return getBelongsToProperty(this, 'AttributeType');
    }

    set WB_AttributeTypeRow(value: WB_AttributeTypeRow) {
        setBelongsToProperty(this, 'AttributeType', value);
    }

    get bUnique(): boolean {
        return getBooleanIndicator(this, "UNIQUE_IND", false)
    }

    set bUnique(value: boolean) {
        setBooleanIndicator(this, "bUnique", "UNIQUE_IND", value)
    }
}

export class WB_HierarchyPeriodRow
    extends ESRecord
    implements RowIF.IwbHierarchyPeriod {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbHierarchyPeriod {
        return this
    }

    get PeriodStartDt(): Date {
        return getBWDateProperty(this, 'PERIOD_START_DT')
    }

    set PeriodStartDt(value: Date) {
        setBWDateProperty(this, 'PeriodStartDt', 'PERIOD_START_DT', value)
    }

    get PeriodEndDt(): Date {
        return getBWDateProperty(this, 'PERIOD_END_DT')
    }

    set PeriodEndDt(value: Date) {
        setBWDateProperty(this, 'PeriodEndDt', 'PERIOD_END_DT', value)
    }

}

export class WB_HierarchySalesAreaRow
    extends ESRecord
    implements RowIF.IwbHierarchySalesArea {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbHierarchySalesArea {
        return this
    }

    get WB_SalesAreaRow(): WB_SalesAreaRow {
        return getBelongsToProperty(this, 'SalesArea');
    }

    set WB_SalesAreaRow(value: WB_SalesAreaRow) {
        setBelongsToProperty(this, 'SalesArea', value);
    }
}


export class WB_HierarchyAttributeGenerationRow extends ESRecord
    implements RowIF.IwbHierarchyAttributeGeneration {

    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbHierarchyAttributeGeneration {
        return this
    }

    get WB_HierarchyRow(): WB_HierarchyRow {
        return getBelongsToProperty(this, 'Hierarchy');
    }

    set WB_HierarchyRow(value: WB_HierarchyRow) {
        setBelongsToProperty(this, 'Hierarchy', value);
    }

    get WB_EntityRow(): WB_EntityRow {
        return getBelongsToProperty(this, 'Entity');
    }

    set WB_EntityRow(value: WB_EntityRow) {
        setBelongsToProperty(this, 'Entity', value);
    }

    get WB_AttributeTypeRow(): WB_AttributeTypeRow {
        return getBelongsToProperty(this, 'AttributeType');
    }

    set WB_AttributeTypeRow(value: WB_AttributeTypeRow) {
        setBelongsToProperty(this, 'AttributeType', value);
    }

    get WB_HierarchyLevelRow(): WB_HierarchyLevelRow {
        return getBelongsToProperty(this, 'HierarchyLevel')
    }

    set WB_HierarchyLevelRow(value: WB_HierarchyLevelRow) {
        setBelongsToProperty(this, "HierarchyLevel", value)
    }

    // get WB_AttributeTypeLevelRow(): WB_AttributeTypeRow {
    //     return getBelongsToProperty(this, 'AttributeTypeLevel');
    // }
    //
    // set WB_AttributeTypeLevelRow(value: WB_AttributeTypeRow) {
    //     setBelongsToProperty(this, 'AttributeTypeLevel', value);
    // }
}


export class WB_HierarchyEntityGenerationRow extends ESRecord
    implements RowIF.IwbHierarchyEntityGeneration {

    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbHierarchyEntityGeneration {
        return this
    }

    get WB_HierarchyRow(): WB_HierarchyRow {
        return getBelongsToProperty(this, 'Hierarchy');
    }

    set WB_HierarchyRow(value: WB_HierarchyRow) {
        setBelongsToProperty(this, 'Hierarchy', value);
    }

    get WB_EntityRow(): WB_EntityRow {
        return getBelongsToProperty(this, 'Entity');
    }

    set WB_EntityRow(value: WB_EntityRow) {
        setBelongsToProperty(this, 'Entity', value);
    }
}

export class WB_HierarchyIntelligentKeyRow extends ESRecord
    implements RowIF.IwbHierarchyIntelligentKey {

    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbHierarchyIntelligentKey {
        return this
    }

    get WB_HierarchyRow(): WB_HierarchyRow {
        return getBelongsToProperty(this, 'Hierarchy');
    }

    set WB_HierarchyRow(value: WB_HierarchyRow) {
        setBelongsToProperty(this, 'Hierarchy', value);
    }

    get WB_EntityRow(): WB_EntityRow {
        return getBelongsToProperty(this, 'Entity');
    }

    set WB_EntityRow(value: WB_EntityRow) {
        setBelongsToProperty(this, 'Entity', value);
    }
}


export class WB_HierarchyExportRow extends ESRecord
    implements RowIF.IwbHierarchyExport {

    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbHierarchyExport {
        return this
    }

    get WB_HierarchyRow(): WB_HierarchyRow {
        return getBelongsToProperty(this, 'Hierarchy');
    }

    set WB_HierarchyRow(value: WB_HierarchyRow) {
        setBelongsToProperty(this, 'Hierarchy', value);
    }


}

export class WB_PolicyAreaRow
    extends ESRecord
    implements RowIF.IwbPolicyArea {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbPolicyArea {
        return this
    }

    get bShowProcedureTab(): boolean {
        return getBooleanIndicator(this, 'USE_PROCEDURE_IND', false)
    }

    set bShowProcedureTab(value: boolean) {
        setBooleanIndicator(this, 'bShowProcedureTab', 'USE_PROCEDURE_IND', value)
    }


    get bShowCubeTab(): boolean {
        switch (this.cif.POLICYAREA_ID?.toLowerCase()) {
            case 'target':
                return false;
            default:
                return true;
        }
    }

    get bShowTransformationTab(): boolean {
        switch (this.cif.POLICYAREA_ID?.toLowerCase()) {
            case 'target':
                return false;
            default:
                return true;
        }
    }

    async afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this
        // Set the Defaults for the Domain Values
        let dbContext: PAdbContext = <any>self.dataStore()

        if (_.isEmpty(dbContext)) {
            return
        }

        self.setDefaults()
        let newKey: number = <any>(await dbContext.getNewId(self._mapper().name))
        let sNewId = TextUtils.padStart(newKey.toString(36), 12, '0').toUpperCase()
        self.cif.POLICYAREA_ID = sNewId
    }

    get WB_PolicyTermTypeRows(): WB_PolicyTermTypeRow[] {
        return getHasManyProperty(this, 'PolicyTermTypes')
    }

}

export class WB_PolicyTermTypeRow
    extends ESRecord
    implements RowIF.IwbPolicyTermType {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbPolicyTermType {
        return this
    }

    get bBold(): boolean {
        return getBooleanIndicator(this, "BOLD_IND", false)
    }

    set bBold(value: boolean) {
        setBooleanIndicator(this, "bBold", "BOLD_IND", value)
    }

    get bIndent(): boolean {
        return getBooleanIndicator(this, "INDENT_IND", false)
    }

    set bIndent(value: boolean) {
        setBooleanIndicator(this, "bIndent", "INDENT_IND", value)
    }

    get bShowConcurrentRates(): boolean {
        return (this.cif.TIME_MODE == 'RunTime')
    }

    get bShowInheritBOMComp(): boolean {
        return (this.cif.TIME_MODE == 'RunTime') || (this.cif.INPUT_STORAGE_TYPE == 'ConditionType')
    }

}


export class WB_PolicyRow
    extends ESRecord
    implements RowIF.IwbPolicy {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbPolicy {
        return this
    }

    get WB_PolicyAreaRow(): WB_PolicyAreaRow {
        return getBelongsToProperty(this, 'PolicyArea');
    }

    set WB_PolicyAreaRow(value: WB_PolicyAreaRow) {
        setBelongsToProperty(this, 'PolicyArea', value);
    }

    get WB_SalesOrgRow(): WB_SalesOrgRow {
        return getBelongsToProperty(this, 'SalesOrg');
    }

    set WB_SalesOrgRow(value: WB_SalesOrgRow) {
        setBelongsToProperty(this, 'SalesOrg', value);
    }

    get WB_MDSetRow(): WB_MasterDataSetRow {
        return getBelongsToProperty(this, 'MDSet');
    }

    set WB_MDSetRow(value: WB_MasterDataSetRow) {
        setBelongsToProperty(this, 'MDSet', value);
    }

    get WB_PolicySalesAreaRows(): WB_PolicySalesAreaRow[] {
        return getHasManyProperty(this, 'PolicySalesAreas');
    }

    get WB_PolicyTermRows(): WB_PolicyTermRow[] {
        return getHasManyProperty(this, 'PolicyTerms');
    }

    get WB_PolicyProcedureRows(): WB_PolicyProcedureRow[] {
        return getHasManyProperty(this, 'PolicyProcedures');
    }

    get WB_PolicyCubeRows(): WB_PolicyCubeRow[] {
        return getHasManyProperty(this, 'PolicyCubes');
    }

    get WB_PolicySpendTypeTermRRows(): WB_PolicySpendTypeTermRRow[] {
        return getHasManyProperty(this, 'PolicySpendTypeTermRs');
    }

    async afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this
        // Set the Defaults for the Domain Values
        let dbContext: PAdbContext = <any>self.dataStore()

        if (_.isEmpty(dbContext)) {
            return
        }

        self.setDefaults()
        let newKey: number = <any>(await dbContext.getNewId(self._mapper().name))
        let sNewId = TextUtils.padStart(newKey.toString(36), 12, '0').toUpperCase()
        self.cif.POLICY_ID = sNewId
    }
}


export class WB_PolicySalesAreaRow
    extends ESRecord
    implements RowIF.IwbPolicySAR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbPolicySAR {
        return this
    }

    get WB_SalesAreaRow(): WB_SalesAreaRow {
        return getBelongsToProperty(this, 'SalesArea');
    }

    set WB_SalesAreaRow(value) {
        setBelongsToProperty(this, 'SalesArea', value);
    }

    get WB_PolicyRow(): WB_PolicyRow {
        return getBelongsToProperty(this, "Policy")
    }

    set WB_PolicyRow(value: WB_PolicyRow) {
        setBelongsToProperty(this, "Policy", value)
    }

}

export class WB_PolicyTermRow
    extends ESRecord
    implements RowIF.IwbPolicyTerm {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbPolicyTerm {
        return this
    }

    get WB_PolicyRow(): WB_PolicyRow {
        return getBelongsToProperty(this, "Policy")
    }

    set WB_PolicyRow(value: WB_PolicyRow) {
        setBelongsToProperty(this, "Policy", value)
    }

    get WB_PolicyTermTypeRow(): WB_PolicyTermTypeRow {
        return getBelongsToProperty(this, "PolicyTermType")
    }

    set WB_PolicyTermTypeRow(value: WB_PolicyTermTypeRow) {
        setBelongsToProperty(this, "PolicyTermType", value)
    }

    get WB_ProductConditionTypeRow(): WB_ProductConditionTypeRow {
        return getBelongsToProperty(this, "ProductConditionType")
    }

    set WB_ProductConditionTypeRow(value: WB_ProductConditionTypeRow) {
        setBelongsToProperty(this, "ProductConditionType", value)
    }


}


export class WB_PolicyProcedureRow
    extends ESRecord
    implements RowIF.IwbPolicyPLR
{
    constructor(props: any, opts: any) {
        super(props, opts);

    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbPolicyPLR {
        return this
    }

    get Step(): number {
        return Number(this.cif.LINE_ID)
    }

    set Step(value: number) {
        this.cif.LINE_ID = value.toString()
    }

    get WB_PolicyRow(): WB_PolicyRow {
        return getBelongsToProperty(this, "Policy")
    }

    set WB_PolicyRow(value: WB_PolicyRow) {
        setBelongsToProperty(this, "Policy", value)
    }

    get bInheritBOMCompValues(): boolean {
        return this.cif.INHERIT_BOM_IND === "1";
    }

    set bInheritBOMCompValues(value: boolean) {
        this.cif.INHERIT_BOM_IND = value ? "1" : "0";
    }
    get WB_PolicyTermRow(): WB_PolicyTermRow {
        return getBelongsToProperty(this, "PolicyTerm")
    }

    set WB_PolicyTermRow(value: WB_PolicyTermRow) {
        setBelongsToProperty(this, "PolicyTerm", value)
    }

    get bAllowConcurrentRates(): boolean {
        return (this.cif.MULTIPLE_VALUE_POLICY == 'Sum')
    }

    set bAllowConcurrentRates(value: boolean) {
        this.cif.MULTIPLE_VALUE_POLICY = value ? "Sum" : "";
    }

}

export class WB_PolicyCubeRow
    extends ESRecord
    implements RowIF.IwbPolicyCube {

    constructor(props: any, opts: any) {
        super(props, opts);

    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbPolicyCube {
        return this
    }

    get WB_PolicyRow(): WB_PolicyRow {
        return getBelongsToProperty(this, "Policy")
    }

    set WB_PolicyRow(value: WB_PolicyRow) {
        setBelongsToProperty(this, "Policy", value)
    }

    get WB_PolicyCubeProcessRow(): WB_PolicyCubeProcessRow {
        return getBelongsToProperty(this, "PolicyCubeProcess")
    }

    set WB_PolicyCubeProcessRow(value: WB_PolicyCubeProcessRow) {
        setBelongsToProperty(this, "PolicyCubeProcess", value)
    }

    get WB_PolicyCubeTermRows(): WB_PolicyCubeTermRow[] {
        return getHasManyProperty(this, "PolicyCubeTerms")
    }


    get bIsTransformedCube(): boolean {
        return (this.cif.CUBE_TYPE == 'Transformed')
    }

}

export class WB_PolicyCubeTermRow
    extends ESRecord
    implements RowIF.IwbPolicyCubeTR {

    constructor(props: any, opts: any) {
        super(props, opts);

    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbPolicyCubeTR {
        return this
    }

    get WB_PolicyCubeRow(): WB_PolicyCubeRow {
        return getBelongsToProperty(this, "PolicyCube")
    }

    set WB_PolicyCubeRow(value: WB_PolicyCubeRow) {
        setBelongsToProperty(this, "PolicyCube", value)
    }

    get WB_PolicyTermRow(): WB_PolicyTermRow {
        return getBelongsToProperty(this, "PolicyTerm")
    }

    set WB_PolicyTermRow(value: WB_PolicyTermRow) {
        setBelongsToProperty(this, "PolicyProcedure", value)
    }

    get WB_ProductConditionTypeRow(): WB_ProductConditionTypeRow {
        return getBelongsToProperty(this, "ProductConditionType")
    }

    set WB_ProductConditionTypeRow(value: WB_ProductConditionTypeRow) {
        setBelongsToProperty(this, "ProductConditionType", value);
    }


}


export class WB_PolicyCubeProcessRow
    extends ESRecord
    implements RowIF.IwbPolicyCubeProcess {


    constructor(props: any, opts: any) {
        super(props, opts);

    }

    async afterCreateRecordWithKey(pr: any, o: any): Promise<void> {
        const self = this

        let dbContext: PAdbContext = <any>self.dataStore()
        if (_.isEmpty(dbContext)) {
            return
        }

        self.setDefaults()
        let newKey: number = this.cif.WB_POLICYCUBEPROCESS_ID
        let sNewId = TextUtils.padStart(newKey.toString(36), 12, '0').toUpperCase()
        self.cif.PROCESS_ID = sNewId
        self.cif.PROCESS_NAME = "New Cube Process"
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbPolicyCubeProcess {
        return this
    }

    get WB_SalesOrgRow(): WB_SalesOrgRow {
        return getBelongsToProperty(this, 'SalesOrg');
    }

    set WB_SalesOrgRow(value: WB_SalesOrgRow) {
        setBelongsToProperty(this, 'SalesOrg', value);
    }

    get WB_MDSetRow(): WB_MasterDataSetRow {
        return getBelongsToProperty(this, 'MDSet');
    }

    set WB_MDSetRow(value: WB_MasterDataSetRow) {
        setBelongsToProperty(this, 'MDSet', value);
    }

    get WB_EntityCustomerSourceRow(): WB_EntityRow {
        return getBelongsToProperty(this, 'CustomerSource');
    }

    set WB_EntityCustomerSourceRow(value: WB_EntityRow) {
        setBelongsToProperty(this, 'CustomerSource', value);
    }

    get WB_EntityCustomerTargetRow(): WB_EntityRow {
        return getBelongsToProperty(this, 'CustomerTarget');
    }

    set WB_EntityCustomerTargetRow(value: WB_EntityRow) {
        setBelongsToProperty(this, 'CustomerTarget', value);
    }

    get WB_EntityProductSourceRow(): WB_EntityRow {
        return getBelongsToProperty(this, 'ProductSource');
    }

    set WB_EntityProductSourceRow(value: WB_EntityRow) {
        setBelongsToProperty(this, 'ProductSource', value);
    }

    get WB_EntityProductTargetRow(): WB_EntityRow {
        return getBelongsToProperty(this, 'ProductTarget');
    }

    set WB_EntityProductTargetRow(value: WB_EntityRow) {
        setBelongsToProperty(this, 'ProductTarget', value);
    }

    get WB_EntityPeriodSourceRow(): WB_EntityRow {
        return getBelongsToProperty(this, 'PeriodSource');
    }

    set WB_EntityPeriodSourceRow(value: WB_EntityRow) {
        setBelongsToProperty(this, 'PeriodSource', value);
    }

    get WB_EntityPeriodTargetRow(): WB_EntityRow {
        return getBelongsToProperty(this, 'PeriodTarget');
    }

    set WB_EntityPeriodTargetRow(value: WB_EntityRow) {
        setBelongsToProperty(this, 'PeriodTarget', value);
    }

    get WB_PolicyCubeProcessRRows(): WB_PolicyCubeProcessRRow[] {
        return getHasManyProperty(this, "PolicyCubeProcessRels")
    }

}

export class WB_PolicyCubeProcessRRow
    extends ESRecord
    implements RowIF.IwbPolicyCubeProcessR {


    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbPolicyCubeProcessR {
        return this
    }

    get WB_PolicyCubeProcessRow(): WB_PolicyCubeProcessRow {
        return getBelongsToProperty(this, 'PolicyCubeProcess');
    }

    set WB_PolicyCubeProcessRow(value: WB_PolicyCubeProcessRow) {
        setBelongsToProperty(this, 'PolicyCubeProcess', value);
    }

}

export class WB_PolicyTermValueRow
    extends ESRecord
    implements RowIF.IwbPolicyTermValue {


    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbPolicyTermValue {
        return this
    }


    get EffectiveStartDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_START_DT')
    }

    set EffectiveStartDt(value: Date) {
        setBWDateProperty(this, 'EffectiveStartDt', 'EFFECTIVE_START_DT', value)
    }

    get EffectiveEndDt(): Date {
        return getBWDateProperty(this, 'EFFECTIVE_END_DT')
    }

    set EffectiveEndDt(value: Date) {
        setBWDateProperty(this, 'EffectiveEndDt', 'EFFECTIVE_END_DT', value)
    }

}


export class WB_PolicySpendTypeTermRRow
    extends ESRecord
    implements RowIF.IwbPolicySpendTypeTermR {
    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
        this.cif.CREATED_DTTS = defaultRowValues.Created_DtTs()
        this.cif.DELETED_IND = defaultRowValues.Deleted_Ind()
        this.cif.DELETED_DT = defaultRowValues.Blank_Dt()
        this.cif.MODIFIED_DTTS = defaultRowValues.Modified_DtTs()
    }

    get cif(): RowIF.IwbPolicySpendTypeTermR {
        return this
    }
    get WB_PolicyRow(): WB_PolicyRow {
        return getBelongsToProperty(this, "Policy")
    }

    set WB_PolicyRow(value: WB_PolicyRow) {
        setBelongsToProperty(this, "Policy", value)
    }

}


export class WB_ProductConditionTypeTextRow
    extends ESRecord
    implements RowIF.IwbProductConditionTypeText {

    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbProductConditionTypeText {
        return this
    }
}

export class WB_GeneralLedgerAccountTextRow
    extends ESRecord
    implements RowIF.IwbGeneralLedgerAccountText {

    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbGeneralLedgerAccountText {
        return this
    }
}

export class WB_ProductGroupTextRow
    extends ESRecord
    implements RowIF.IwbProductGroupText {

    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbProductGroupText {
        return this
    }
}

export class WB_FinishedProductTextRow
    extends ESRecord
    implements RowIF.IwbFinishedProductText {

    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbFinishedProductText {
        return this
    }
}

export class WB_UOMTextRow
    extends ESRecord
    implements RowIF.IwbUOMText {

    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbUOMText {
        return this
    }
}

export class WB_ProductHierarchyTextRow
    extends ESRecord
    implements RowIF.IwbProductHierarchyText {

    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbProductHierarchyText {
        return this
    }
}

export class WB_CustomerHierarchyTextRow
    extends ESRecord
    implements RowIF.IwbCustomerHierarchyText {

    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbCustomerHierarchyText {
        return this
    }
}

export class WB_CustomerCRRow
    extends ESRecord
    implements RowIF.IwbCustomerCR {

    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbCustomerCR {
        return this
    }
}

export class WB_CustomerSARRow
    extends ESRecord
    implements RowIF.IwbCustomerSAR {

    constructor(props: any, opts: any) {
        super(props, opts);
    }

    setDefaults(): void {
    }

    get cif(): RowIF.IwbCustomerSAR {
        return this
    }
}


//</editor-fold>
